/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 14);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(6);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 1 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(21);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 4 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(17);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(0);
var normalizeHeaderName = __webpack_require__(45);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(10);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(10);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var settle = __webpack_require__(46);
var buildURL = __webpack_require__(7);
var buildFullPath = __webpack_require__(48);
var parseHeaders = __webpack_require__(51);
var isURLSameOrigin = __webpack_require__(52);
var createError = __webpack_require__(11);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(53);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(47);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(15);
module.exports = __webpack_require__(20);


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(16).enable();
  window.Promise = __webpack_require__(18);
}

// fetch() polyfill for making API calls.
__webpack_require__(19);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(2);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(5);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(5);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(27);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */],null),document.getElementById('root'));

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var h=__webpack_require__(2),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113;n&&Symbol.for("react.suspense_list");
var z=n?Symbol.for("react.memo"):60115,aa=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");n&&Symbol.for("react.scope");var A="function"===typeof Symbol&&Symbol.iterator;
function B(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(B(85));this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}var H=G.prototype=new F;
H.constructor=G;h(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,l=null;if(null!=b)for(e in void 0!==b.ref&&(l=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var k=Array(f),m=0;m<f;m++)k[m]=arguments[m+2];d.children=k}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:l,props:d,_owner:J.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,c,e){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var l=0;l<a.length;l++){d=a[l];var f=b+T(d,l);g+=S(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),l=
0;!(d=a.next()).done;)d=d.value,f=b+T(d,l++),g+=S(d,f,c,e);else if("object"===d)throw c=""+a,Error(B(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function U(a,b,c){return null==a?0:S(a,"",b,c)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,e,c,function(a){return a}):null!=a&&(N(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+c)),e.push(a))}function V(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(O,"$&/")+"/");b=Q(b,g,e,d);U(a,da,b);R(b)}function W(){var a=I.current;if(null===a)throw Error(B(321));return a}
var X={Children:{map:function(a,b,c){if(null==a)return a;var e=[];V(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=Q(null,null,b,c);U(a,ca,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw Error(B(143));return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:aa,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,c){return W().useImperativeHandle(a,b,c)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,c){return W().useReducer(a,b,c)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,createElement:M,cloneElement:function(a,b,c){if(null===a||void 0===a)throw Error(B(267,a));var e=h({},a.props),d=a.key,g=a.ref,l=a._owner;
if(null!=b){void 0!==b.ref&&(g=b.ref,l=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(k in b)K.call(b,k)&&!L.hasOwnProperty(k)&&(e[k]=void 0===b[k]&&void 0!==f?f[k]:b[k])}var k=arguments.length-2;if(1===k)e.children=c;else if(1<k){f=Array(k);for(var m=0;m<k;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,key:d,ref:g,props:e,_owner:l}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.12.0",
__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(23);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(3),n=__webpack_require__(2),q=__webpack_require__(24);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));var ba=null,ca={};
function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!ea[c]){if(!b.extractEvents)throw Error(u(97,a));ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(fa.hasOwnProperty(h))throw Error(u(99,h));fa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],g,h);e=!0}else f.registrationName?(ha(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ha(a,b,c){if(ia[a])throw Error(u(100,a));ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,g,h,k){la=!1;ma=null;ka.apply(pa,arguments)}
function ra(a,b,c,d,e,f,g,h,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw Error(u(198));na||(na=!0,oa=l)}}var sa=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ra(d,b,void 0,a);a.currentTarget=null}function xa(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ba(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a){ya(a,Aa);if(za)throw Error(u(95));if(na)throw a=oa,na=!1,oa=null,a;}}
var Ca={injectEventPluginOrder:function(a){if(ba)throw Error(u(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw Error(u(102,c));ca[c]=d;b=!0}}b&&da()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,b,typeof c));
return c}var Ea=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Ea.hasOwnProperty("ReactCurrentDispatcher")||(Ea.ReactCurrentDispatcher={current:null});Ea.hasOwnProperty("ReactCurrentBatchConfig")||(Ea.ReactCurrentBatchConfig={suspense:null});
var Fa=/^(.*)[\\\/]/,w="function"===typeof Symbol&&Symbol.for,Ga=w?Symbol.for("react.element"):60103,Ha=w?Symbol.for("react.portal"):60106,Ia=w?Symbol.for("react.fragment"):60107,Ja=w?Symbol.for("react.strict_mode"):60108,Ka=w?Symbol.for("react.profiler"):60114,La=w?Symbol.for("react.provider"):60109,Ma=w?Symbol.for("react.context"):60110,Na=w?Symbol.for("react.concurrent_mode"):60111,Oa=w?Symbol.for("react.forward_ref"):60112,Pa=w?Symbol.for("react.suspense"):60113,Qa=w?Symbol.for("react.suspense_list"):
60120,Ra=w?Symbol.for("react.memo"):60115,Sa=w?Symbol.for("react.lazy"):60116;w&&Symbol.for("react.fundamental");w&&Symbol.for("react.responder");w&&Symbol.for("react.scope");var Ta="function"===typeof Symbol&&Symbol.iterator;function Ua(a){if(null===a||"object"!==typeof a)return null;a=Ta&&a[Ta]||a["@@iterator"];return"function"===typeof a?a:null}
function Va(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function Wa(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case Ia:return"Fragment";case Ha:return"Portal";case Ka:return"Profiler";case Ja:return"StrictMode";case Pa:return"Suspense";case Qa:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Ma:return"Context.Consumer";case La:return"Context.Provider";case Oa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case Ra:return Wa(a.type);case Sa:if(a=1===a._status?a._result:null)return Wa(a)}return null}function Xa(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Wa(a.type);c=null;d&&(c=Wa(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Fa,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var Ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),Za=null,$a=null,ab=null;function bb(a){if(a=ua(a)){if("function"!==typeof Za)throw Error(u(280));var b=sa(a.stateNode);Za(a.stateNode,a.type,b)}}function cb(a){$a?ab?ab.push(a):ab=[a]:$a=a}function db(){if($a){var a=$a,b=ab;ab=$a=null;bb(a);if(b)for(a=0;a<b.length;a++)bb(b[a])}}function eb(a,b){return a(b)}function fb(a,b,c,d){return a(b,c,d)}function gb(){}
var hb=eb,ib=!1,jb=!1;function kb(){if(null!==$a||null!==ab)gb(),db()}new Map;var lb=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,mb=Object.prototype.hasOwnProperty,nb={},ob={};
function pb(a){if(mb.call(ob,a))return!0;if(mb.call(nb,a))return!1;if(lb.test(a))return ob[a]=!0;nb[a]=!0;return!1}function qb(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function rb(a,b,c,d){if(null===b||"undefined"===typeof b||qb(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1)});var sb=/[\-:]([a-z])/g;function tb(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(sb,
tb);D[b]=new B(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1)});
D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0)});function ub(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}
function vb(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(rb(b,c,e,d)&&(c=null),d||null===e?pb(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function wb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function xb(a){var b=wb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function yb(a){a._valueTracker||(a._valueTracker=xb(a))}function zb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=wb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Ab(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Bb(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=ub(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cb(a,b){b=b.checked;null!=b&&vb(a,"checked",b,!1)}
function Eb(a,b){Cb(a,b);var c=ub(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Fb(a,b.type,c):b.hasOwnProperty("defaultValue")&&Fb(a,b.type,ub(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Gb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Fb(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Hb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Ib(a,b){a=n({children:void 0},b);if(b=Hb(b.children))a.children=b;return a}
function Jb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+ub(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Kb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Lb(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw Error(u(92));if(Array.isArray(b)){if(!(1>=b.length))throw Error(u(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:ub(c)}}
function Mb(a,b){var c=ub(b.value),d=ub(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Nb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Ob={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Pb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Qb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Pb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Rb,Sb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ob.svg||"innerHTML"in a)a.innerHTML=b;else{Rb=Rb||document.createElement("div");Rb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Rb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Tb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Ub(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Vb={animationend:Ub("Animation","AnimationEnd"),animationiteration:Ub("Animation","AnimationIteration"),animationstart:Ub("Animation","AnimationStart"),transitionend:Ub("Transition","TransitionEnd")},Wb={},Xb={};
Ya&&(Xb=document.createElement("div").style,"AnimationEvent"in window||(delete Vb.animationend.animation,delete Vb.animationiteration.animation,delete Vb.animationstart.animation),"TransitionEvent"in window||delete Vb.transitionend.transition);function Yb(a){if(Wb[a])return Wb[a];if(!Vb[a])return a;var b=Vb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Xb)return Wb[a]=b[c];return a}var Zb=Yb("animationend"),$b=Yb("animationiteration"),ac=Yb("animationstart"),bc=Yb("transitionend"),cc="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" ");
function ec(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function fc(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function gc(a){if(ec(a)!==a)throw Error(u(188));}
function hc(a){var b=a.alternate;if(!b){b=ec(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return gc(e),a;if(f===d)return gc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function ic(a){a=hc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var jc,kc,lc,mc=!1,nc=[],oc=null,pc=null,qc=null,rc=new Map,sc=new Map,tc=[],uc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),vc="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function wc(a){var b=xc(a);uc.forEach(function(c){yc(c,a,b)});vc.forEach(function(c){yc(c,a,b)})}function zc(a,b,c,d){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:d}}function Ac(a,b){switch(a){case "focus":case "blur":oc=null;break;case "dragenter":case "dragleave":pc=null;break;case "mouseover":case "mouseout":qc=null;break;case "pointerover":case "pointerout":rc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":sc.delete(b.pointerId)}}
function Bc(a,b,c,d,e){if(null===a||a.nativeEvent!==e)return a=zc(b,c,d,e),null!==b&&(b=Cc(b),null!==b&&kc(b)),a;a.eventSystemFlags|=d;return a}function Dc(a,b,c,d){switch(b){case "focus":return oc=Bc(oc,a,b,c,d),!0;case "dragenter":return pc=Bc(pc,a,b,c,d),!0;case "mouseover":return qc=Bc(qc,a,b,c,d),!0;case "pointerover":var e=d.pointerId;rc.set(e,Bc(rc.get(e)||null,a,b,c,d));return!0;case "gotpointercapture":return e=d.pointerId,sc.set(e,Bc(sc.get(e)||null,a,b,c,d)),!0}return!1}
function Ec(a){var b=Fc(a.target);if(null!==b){var c=ec(b);if(null!==c)if(b=c.tag,13===b){if(b=fc(c),null!==b){a.blockedOn=b;q.unstable_runWithPriority(a.priority,function(){lc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Gc(a){if(null!==a.blockedOn)return!1;var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);if(null!==b){var c=Cc(b);null!==c&&kc(c);a.blockedOn=b;return!1}return!0}
function Ic(a,b,c){Gc(a)&&c.delete(b)}function Jc(){for(mc=!1;0<nc.length;){var a=nc[0];if(null!==a.blockedOn){a=Cc(a.blockedOn);null!==a&&jc(a);break}var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);null!==b?a.blockedOn=b:nc.shift()}null!==oc&&Gc(oc)&&(oc=null);null!==pc&&Gc(pc)&&(pc=null);null!==qc&&Gc(qc)&&(qc=null);rc.forEach(Ic);sc.forEach(Ic)}function Kc(a,b){a.blockedOn===b&&(a.blockedOn=null,mc||(mc=!0,q.unstable_scheduleCallback(q.unstable_NormalPriority,Jc)))}
function Lc(a){function b(b){return Kc(b,a)}if(0<nc.length){Kc(nc[0],a);for(var c=1;c<nc.length;c++){var d=nc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==oc&&Kc(oc,a);null!==pc&&Kc(pc,a);null!==qc&&Kc(qc,a);rc.forEach(b);sc.forEach(b);for(c=0;c<tc.length;c++)d=tc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<tc.length&&(c=tc[0],null===c.blockedOn);)Ec(c),null===c.blockedOn&&tc.shift()}
function Mc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Nc(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Oc(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Pc(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Nc(b);for(b=c.length;0<b--;)Oc(c[b],"captured",a);for(b=0;b<c.length;b++)Oc(c[b],"bubbled",a)}}function Qc(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Rc(a){a&&a.dispatchConfig.registrationName&&Qc(a._targetInst,null,a)}
function Sc(a){ya(a,Pc)}function Tc(){return!0}function Uc(){return!1}function E(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?Tc:Uc;this.isPropagationStopped=Uc;return this}
n(E.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=Tc)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=Tc)},persist:function(){this.isPersistent=Tc},isPersistent:Uc,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=Uc;this._dispatchInstances=this._dispatchListeners=null}});E.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
E.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;Vc(c);return c};Vc(E);function Wc(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Xc(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Vc(a){a.eventPool=[];a.getPooled=Wc;a.release=Xc}var Yc=E.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Zc=E.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),$c=E.extend({view:null,detail:null}),ad=$c.extend({relatedTarget:null});
function bd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var cd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},dd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ed={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function gd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=ed[a])?!!b[a]:!1}function hd(){return gd}
var id=$c.extend({key:function(a){if(a.key){var b=cd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=bd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?dd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:hd,charCode:function(a){return"keypress"===a.type?bd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?bd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),jd=0,kd=0,ld=!1,md=!1,nd=$c.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:hd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=jd;jd=a.screenX;return ld?"mousemove"===a.type?a.screenX-
b:0:(ld=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;var b=kd;kd=a.screenY;return md?"mousemove"===a.type?a.screenY-b:0:(md=!0,0)}}),od=nd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),pd=nd.extend({dataTransfer:null}),qd=$c.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:hd}),rd=E.extend({propertyName:null,
elapsedTime:null,pseudoElement:null}),sd=nd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",
0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",
0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",
2],[Zb,"animationEnd",2],[$b,"animationIteration",2],[ac,"animationStart",2],["canplay","canPlay",2],["canplaythrough","canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress",
"progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",2],[bc,"transitionEnd",2],["waiting","waiting",2]],ud={},vd={},wd=0;for(;wd<td.length;wd++){var yd=td[wd],zd=yd[0],Ad=yd[1],Bd=yd[2],Cd="on"+(Ad[0].toUpperCase()+Ad.slice(1)),Dd={phasedRegistrationNames:{bubbled:Cd,captured:Cd+"Capture"},dependencies:[zd],eventPriority:Bd};ud[Ad]=Dd;vd[zd]=Dd}
var Ed={eventTypes:ud,getEventPriority:function(a){a=vd[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===bd(c))return null;case "keydown":case "keyup":a=id;break;case "blur":case "focus":a=ad;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=nd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Zb:case $b:case ac:a=Yc;break;case bc:a=rd;break;case "scroll":a=$c;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=Zc;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=od;break;default:a=E}b=a.getPooled(e,b,c,d);Sc(b);return b}},Fd=q.unstable_UserBlockingPriority,
Gd=q.unstable_runWithPriority,Hd=Ed.getEventPriority,Id=10,Jd=[];
function Kd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=Fc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Mc(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=a.eventSystemFlags,h=null,k=0;k<ea.length;k++){var l=ea[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=xa(h,l))}Ba(h)}}
var Ld=!0;function F(a,b){Md(b,a,!1)}function Md(a,b,c){switch(Hd(b)){case 0:var d=Nd.bind(null,b,1);break;case 1:d=Od.bind(null,b,1);break;default:d=Pd.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Nd(a,b,c){ib||gb();var d=Pd,e=ib;ib=!0;try{fb(d,a,b,c)}finally{(ib=e)||kb()}}function Od(a,b,c){Gd(Fd,Pd.bind(null,a,b,c))}
function Qd(a,b,c,d){if(Jd.length){var e=Jd.pop();e.topLevelType=a;e.eventSystemFlags=b;e.nativeEvent=c;e.targetInst=d;a=e}else a={topLevelType:a,eventSystemFlags:b,nativeEvent:c,targetInst:d,ancestors:[]};try{if(b=Kd,c=a,jb)b(c,void 0);else{jb=!0;try{hb(b,c,void 0)}finally{jb=!1,kb()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,Jd.length<Id&&Jd.push(a)}}
function Pd(a,b,c){if(Ld)if(0<nc.length&&-1<uc.indexOf(a))a=zc(null,a,b,c),nc.push(a);else{var d=Hc(a,b,c);null===d?Ac(a,c):-1<uc.indexOf(a)?(a=zc(d,a,b,c),nc.push(a)):Dc(d,a,b,c)||(Ac(a,c),Qd(a,b,c,null))}}function Hc(a,b,c){var d=Mc(c);d=Fc(d);if(null!==d){var e=ec(d);if(null===e)d=null;else{var f=e.tag;if(13===f){d=fc(e);if(null!==d)return d;d=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;d=null}else e!==d&&(d=null)}}Qd(a,b,c,d);return null}
function Rd(a){if(!Ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var Sd=new ("function"===typeof WeakMap?WeakMap:Map);function xc(a){var b=Sd.get(a);void 0===b&&(b=new Set,Sd.set(a,b));return b}
function yc(a,b,c){if(!c.has(a)){switch(a){case "scroll":Md(b,"scroll",!0);break;case "focus":case "blur":Md(b,"focus",!0);Md(b,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Rd(a)&&Md(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===cc.indexOf(a)&&F(a,b)}c.add(a)}}
var Td={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ud=["Webkit","ms","Moz","O"];Object.keys(Td).forEach(function(a){Ud.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Td[b]=Td[a]})});function Vd(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||Td.hasOwnProperty(a)&&Td[a]?(""+b).trim():b+"px"}
function Wd(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=Vd(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Xd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Yd(a,b){if(b){if(Xd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function Zd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function $d(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=xc(a);b=ja[b];for(var d=0;d<b.length;d++)yc(b[d],a,c)}function ae(){}
function be(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ce(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function de(a,b){var c=ce(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ce(c)}}
function ee(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?ee(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function fe(){for(var a=window,b=be();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=be(a.document)}return b}
function ge(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var he="$",ie="/$",je="$?",ke="$!",le=null,me=null;function ne(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function oe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var pe="function"===typeof setTimeout?setTimeout:void 0,qe="function"===typeof clearTimeout?clearTimeout:void 0;function re(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function se(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===he||c===ke||c===je){if(0===b)return a;b--}else c===ie&&b++}a=a.previousSibling}return null}var te=Math.random().toString(36).slice(2),ue="__reactInternalInstance$"+te,ve="__reactEventHandlers$"+te,we="__reactContainere$"+te;
function Fc(a){var b=a[ue];if(b)return b;for(var c=a.parentNode;c;){if(b=c[we]||c[ue]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=se(a);null!==a;){if(c=a[ue])return c;a=se(a)}return b}a=c;c=a.parentNode}return null}function Cc(a){a=a[ue]||a[we];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function xe(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function ye(a){return a[ve]||null}var ze=null,Ae=null,Be=null;
function Ce(){if(Be)return Be;var a,b=Ae,c=b.length,d,e="value"in ze?ze.value:ze.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return Be=e.slice(a,1<d?1-d:void 0)}var De=E.extend({data:null}),Ee=E.extend({data:null}),Fe=[9,13,27,32],Ge=Ya&&"CompositionEvent"in window,He=null;Ya&&"documentMode"in document&&(He=document.documentMode);
var Ie=Ya&&"TextEvent"in window&&!He,Je=Ya&&(!Ge||He&&8<He&&11>=He),Ke=String.fromCharCode(32),Le={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Me=!1;
function Ne(a,b){switch(a){case "keyup":return-1!==Fe.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Oe(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Pe=!1;function Qe(a,b){switch(a){case "compositionend":return Oe(b);case "keypress":if(32!==b.which)return null;Me=!0;return Ke;case "textInput":return a=b.data,a===Ke&&Me?null:a;default:return null}}
function Re(a,b){if(Pe)return"compositionend"===a||!Ge&&Ne(a,b)?(a=Ce(),Be=Ae=ze=null,Pe=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return Je&&"ko"!==b.locale?null:b.data;default:return null}}
var Se={eventTypes:Le,extractEvents:function(a,b,c,d){var e;if(Ge)b:{switch(a){case "compositionstart":var f=Le.compositionStart;break b;case "compositionend":f=Le.compositionEnd;break b;case "compositionupdate":f=Le.compositionUpdate;break b}f=void 0}else Pe?Ne(a,c)&&(f=Le.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=Le.compositionStart);f?(Je&&"ko"!==c.locale&&(Pe||f!==Le.compositionStart?f===Le.compositionEnd&&Pe&&(e=Ce()):(ze=d,Ae="value"in ze?ze.value:ze.textContent,Pe=!0)),f=De.getPooled(f,
b,c,d),e?f.data=e:(e=Oe(c),null!==e&&(f.data=e)),Sc(f),e=f):e=null;(a=Ie?Qe(a,c):Re(a,c))?(b=Ee.getPooled(Le.beforeInput,b,c,d),b.data=a,Sc(b)):b=null;return null===e?b:null===b?e:[e,b]}},Te={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Ue(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Te[a.type]:"textarea"===b?!0:!1}
var Ve={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function We(a,b,c){a=E.getPooled(Ve.change,a,b,c);a.type="change";cb(c);Sc(a);return a}var Xe=null,Ye=null;function Ze(a){Ba(a)}function $e(a){var b=xe(a);if(zb(b))return a}function af(a,b){if("change"===a)return b}var bf=!1;Ya&&(bf=Rd("input")&&(!document.documentMode||9<document.documentMode));
function cf(){Xe&&(Xe.detachEvent("onpropertychange",df),Ye=Xe=null)}function df(a){if("value"===a.propertyName&&$e(Ye))if(a=We(Ye,a,Mc(a)),ib)Ba(a);else{ib=!0;try{eb(Ze,a)}finally{ib=!1,kb()}}}function ef(a,b,c){"focus"===a?(cf(),Xe=b,Ye=c,Xe.attachEvent("onpropertychange",df)):"blur"===a&&cf()}function ff(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return $e(Ye)}function gf(a,b){if("click"===a)return $e(b)}function hf(a,b){if("input"===a||"change"===a)return $e(b)}
var jf={eventTypes:Ve,_isInputEventSupported:bf,extractEvents:function(a,b,c,d){var e=b?xe(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=af;else if(Ue(e))if(bf)g=hf;else{g=ff;var h=ef}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=gf);if(g&&(g=g(a,b)))return We(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Fb(e,"number",e.value)}},kf={mouseEnter:{registrationName:"onMouseEnter",
dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},lf,mf={eventTypes:kf,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;
e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?Fc(b):null,null!==b&&(f=ec(b),b!==f||5!==b.tag&&6!==b.tag))b=null}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===a){var h=nd;var k=kf.mouseLeave;var l=kf.mouseEnter;var m="mouse"}else if("pointerout"===a||"pointerover"===a)h=od,k=kf.pointerLeave,l=kf.pointerEnter,m="pointer";a=null==g?e:xe(g);e=null==b?e:xe(b);k=h.getPooled(k,g,c,d);k.type=m+"leave";k.target=
a;k.relatedTarget=e;d=h.getPooled(l,b,c,d);d.type=m+"enter";d.target=e;d.relatedTarget=a;h=g;m=b;if(h&&m)a:{l=h;a=m;g=0;for(b=l;b;b=Nc(b))g++;b=0;for(e=a;e;e=Nc(e))b++;for(;0<g-b;)l=Nc(l),g--;for(;0<b-g;)a=Nc(a),b--;for(;g--;){if(l===a||l===a.alternate)break a;l=Nc(l);a=Nc(a)}l=null}else l=null;a=l;for(l=[];h&&h!==a;){g=h.alternate;if(null!==g&&g===a)break;l.push(h);h=Nc(h)}for(h=[];m&&m!==a;){g=m.alternate;if(null!==g&&g===a)break;h.push(m);m=Nc(m)}for(m=0;m<l.length;m++)Qc(l[m],"bubbled",k);for(m=
h.length;0<m--;)Qc(h[m],"captured",d);if(c===lf)return lf=null,[k];lf=c;return[k,d]}};function nf(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var of="function"===typeof Object.is?Object.is:nf,pf=Object.prototype.hasOwnProperty;function qf(a,b){if(of(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!pf.call(b,c[d])||!of(a[c[d]],b[c[d]]))return!1;return!0}
var rf=Ya&&"documentMode"in document&&11>=document.documentMode,sf={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},tf=null,uf=null,vf=null,wf=!1;
function xf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(wf||null==tf||tf!==be(c))return null;c=tf;"selectionStart"in c&&ge(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return vf&&qf(vf,c)?null:(vf=c,a=E.getPooled(sf.select,uf,a,b),a.type="select",a.target=tf,Sc(a),a)}
var yf={eventTypes:sf,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=xc(e);f=ja.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?xe(b):window;switch(a){case "focus":if(Ue(e)||"true"===e.contentEditable)tf=e,uf=b,vf=null;break;case "blur":vf=uf=tf=null;break;case "mousedown":wf=!0;break;case "contextmenu":case "mouseup":case "dragend":return wf=!1,xf(c,d);case "selectionchange":if(rf)break;
case "keydown":case "keyup":return xf(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));var zf=Cc;sa=ye;ua=zf;va=xe;Ca.injectEventPluginsByName({SimpleEventPlugin:Ed,EnterLeaveEventPlugin:mf,ChangeEventPlugin:jf,SelectEventPlugin:yf,BeforeInputEventPlugin:Se});new Set;var Af=[],Bf=-1;function G(a){0>Bf||(a.current=Af[Bf],Af[Bf]=null,Bf--)}
function I(a,b){Bf++;Af[Bf]=a.current;a.current=b}var Cf={},J={current:Cf},K={current:!1},Df=Cf;function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Ff(a){G(K,a);G(J,a)}function Gf(a){G(K,a);G(J,a)}function Hf(a,b,c){if(J.current!==Cf)throw Error(u(168));I(J,b,a);I(K,c,a)}function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,Wa(b)||"Unknown",e));return n({},c,{},d)}function Jf(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Cf;Df=J.current;I(J,b,a);I(K,K.current,a);return!0}
function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(b=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=b,G(K,a),G(J,a),I(J,b,a)):G(K,a);I(K,c,a)}
var Lf=q.unstable_runWithPriority,Mf=q.unstable_scheduleCallback,Nf=q.unstable_cancelCallback,Of=q.unstable_shouldYield,Pf=q.unstable_requestPaint,Qf=q.unstable_now,Rf=q.unstable_getCurrentPriorityLevel,Sf=q.unstable_ImmediatePriority,Tf=q.unstable_UserBlockingPriority,Uf=q.unstable_NormalPriority,Vf=q.unstable_LowPriority,Wf=q.unstable_IdlePriority,Xf={},Yf=void 0!==Pf?Pf:function(){},Zf=null,$f=null,ag=!1,bg=Qf(),cg=1E4>bg?Qf:function(){return Qf()-bg};
function dg(){switch(Rf()){case Sf:return 99;case Tf:return 98;case Uf:return 97;case Vf:return 96;case Wf:return 95;default:throw Error(u(332));}}function eg(a){switch(a){case 99:return Sf;case 98:return Tf;case 97:return Uf;case 96:return Vf;case 95:return Wf;default:throw Error(u(332));}}function fg(a,b){a=eg(a);return Lf(a,b)}function gg(a,b,c){a=eg(a);return Mf(a,b,c)}function hg(a){null===Zf?(Zf=[a],$f=Mf(Sf,ig)):Zf.push(a);return Xf}function jg(){if(null!==$f){var a=$f;$f=null;Nf(a)}ig()}
function ig(){if(!ag&&null!==Zf){ag=!0;var a=0;try{var b=Zf;fg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Zf=null}catch(c){throw null!==Zf&&(Zf=Zf.slice(a+1)),Mf(Sf,jg),c;}finally{ag=!1}}}var kg=3;function lg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function mg(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var ng={current:null},og=null,pg=null,qg=null;function rg(){qg=pg=og=null}
function sg(a,b){var c=a.type._context;I(ng,c._currentValue,a);c._currentValue=b}function tg(a){var b=ng.current;G(ng,a);a.type._context._currentValue=b}function ug(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
function vg(a,b){og=a;qg=pg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(wg=!0),a.firstContext=null)}function xg(a,b){if(qg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)qg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===pg){if(null===og)throw Error(u(308));pg=b;og.dependencies={expirationTime:0,firstContext:b,responders:null}}else pg=pg.next=b}return a._currentValue}var yg=!1;
function zg(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Ag(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Bg(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Cg(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function Dg(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=zg(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=zg(a.memoizedState),e=c.updateQueue=zg(c.memoizedState)):d=a.updateQueue=Ag(e):null===e&&(e=c.updateQueue=Ag(d));null===e||d===e?Cg(d,b):null===d.lastUpdate||null===e.lastUpdate?(Cg(d,b),Cg(e,b)):(Cg(d,b),e.lastUpdate=b)}
function Eg(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=zg(a.memoizedState):Fg(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Fg(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Ag(b));return b}
function Gg(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-4097|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:yg=!0}return d}
function Hg(a,b,c,d,e){yg=!1;b=Fg(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(Ig(m,k.suspenseConfig),l=Gg(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var C=k.expirationTime;C<e?(null===m&&(m=k,null===g&&(f=l)),h<C&&(h=C)):(l=Gg(a,b,k,l,c,d),null!==
k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;Jg(h);a.expirationTime=h;a.memoizedState=l}
function Kg(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Lg(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Lg(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Lg(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw Error(u(191,c));c.call(d)}a=a.nextEffect}}
var Mg=Ea.ReactCurrentBatchConfig,Ng=(new aa.Component).refs;function Og(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Sg={isMounted:function(a){return(a=a._reactInternalFiber)?ec(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Pg(),d=Mg.suspense;
c=Qg(c,a,d);d=Bg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Dg(a,d);Rg(a,c)}};function Tg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!qf(c,d)||!qf(e,f):!0}
function Ug(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=xg(f):(e=L(b)?Df:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Sg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Vg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Sg.enqueueReplaceState(b,b.state,null)}
function Wg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Ng;var f=b.contextType;"object"===typeof f&&null!==f?e.context=xg(f):(f=L(b)?Df:J.current,e.context=Ef(a,f));f=a.updateQueue;null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Og(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Sg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Xg=Array.isArray;
function Yg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Ng&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Zg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function $g(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ah(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=bh(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Yg(a,b,c),d.return=a,d;d=ch(c.type,c.key,c.props,null,a.mode,d);d.ref=Yg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=dh(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=eh(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function C(a,b,c){if("string"===typeof b||"number"===typeof b)return b=bh(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Ga:return c=ch(b.type,b.key,b.props,null,a.mode,c),c.ref=Yg(a,null,b),c.return=a,c;case Ha:return b=dh(b,a.mode,c),b.return=a,b}if(Xg(b)||
Ua(b))return b=eh(b,a.mode,c,null),b.return=a,b;Zg(a,b)}return null}function y(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ga:return c.key===e?c.type===Ia?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case Ha:return c.key===e?l(a,b,c,d):null}if(Xg(c)||Ua(c))return null!==e?null:m(a,b,c,d,null);Zg(a,c)}return null}function H(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Ga:return a=a.get(null===d.key?c:d.key)||null,d.type===Ia?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case Ha:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Xg(d)||Ua(d))return a=a.get(c)||null,m(b,a,d,e,null);Zg(b,d)}return null}function z(e,g,h,k){for(var l=null,m=null,r=g,x=g=0,A=null;null!==r&&x<h.length;x++){r.index>x?(A=r,r=null):A=r.sibling;var p=y(e,r,h[x],k);if(null===p){null===r&&(r=A);break}a&&
r&&null===p.alternate&&b(e,r);g=f(p,g,x);null===m?l=p:m.sibling=p;m=p;r=A}if(x===h.length)return c(e,r),l;if(null===r){for(;x<h.length;x++)r=C(e,h[x],k),null!==r&&(g=f(r,g,x),null===m?l=r:m.sibling=r,m=r);return l}for(r=d(e,r);x<h.length;x++)A=H(r,e,x,h[x],k),null!==A&&(a&&null!==A.alternate&&r.delete(null===A.key?x:A.key),g=f(A,g,x),null===m?l=A:m.sibling=A,m=A);a&&r.forEach(function(a){return b(e,a)});return l}function ta(e,g,h,k){var l=Ua(h);if("function"!==typeof l)throw Error(u(150));h=l.call(h);
if(null==h)throw Error(u(151));for(var m=l=null,r=g,x=g=0,A=null,p=h.next();null!==r&&!p.done;x++,p=h.next()){r.index>x?(A=r,r=null):A=r.sibling;var z=y(e,r,p.value,k);if(null===z){null===r&&(r=A);break}a&&r&&null===z.alternate&&b(e,r);g=f(z,g,x);null===m?l=z:m.sibling=z;m=z;r=A}if(p.done)return c(e,r),l;if(null===r){for(;!p.done;x++,p=h.next())p=C(e,p.value,k),null!==p&&(g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);return l}for(r=d(e,r);!p.done;x++,p=h.next())p=H(r,e,x,p.value,k),null!==p&&(a&&null!==
p.alternate&&r.delete(null===p.key?x:p.key),g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);a&&r.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Ia&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Ga:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Ia:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Ia?f.props.children:f.props,h);d.ref=Yg(a,k,f);d.return=a;a=d;break a}else{c(a,
k);break}else b(a,k);k=k.sibling}f.type===Ia?(d=eh(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=ch(f.type,f.key,f.props,null,a.mode,h),h.ref=Yg(a,d,f),h.return=a,a=h)}return g(a);case Ha:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=dh(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===
typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=bh(f,a.mode,h),d.return=a,a=d),g(a);if(Xg(f))return z(a,d,f,h);if(Ua(f))return ta(a,d,f,h);l&&Zg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var fh=$g(!0),gh=$g(!1),hh={},ih={current:hh},jh={current:hh},kh={current:hh};function lh(a){if(a===hh)throw Error(u(174));return a}
function mh(a,b){I(kh,b,a);I(jh,a,a);I(ih,hh,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Qb(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Qb(b,c)}G(ih,a);I(ih,b,a)}function nh(a){G(ih,a);G(jh,a);G(kh,a)}function oh(a){lh(kh.current);var b=lh(ih.current);var c=Qb(b,a.type);b!==c&&(I(jh,a,a),I(ih,c,a))}function ph(a){jh.current===a&&(G(ih,a),G(jh,a))}var M={current:0};
function qh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===je||c.data===ke))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function rh(a,b){return{responder:a,props:b}}
var sh=Ea.ReactCurrentDispatcher,N=Ea.ReactCurrentBatchConfig,th=0,uh=null,O=null,vh=null,wh=null,P=null,xh=null,yh=0,zh=null,Ah=0,Bh=!1,Ch=null,Gh=0;function Q(){throw Error(u(321));}function Hh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!of(a[c],b[c]))return!1;return!0}
function Ih(a,b,c,d,e,f){th=f;uh=b;vh=null!==a?a.memoizedState:null;sh.current=null===vh?Jh:Kh;b=c(d,e);if(Bh){do Bh=!1,Gh+=1,vh=null!==a?a.memoizedState:null,xh=wh,zh=P=O=null,sh.current=Kh,b=c(d,e);while(Bh);Ch=null;Gh=0}sh.current=Lh;a=uh;a.memoizedState=wh;a.expirationTime=yh;a.updateQueue=zh;a.effectTag|=Ah;a=null!==O&&null!==O.next;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;if(a)throw Error(u(300));return b}
function Mh(){sh.current=Lh;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;Bh=!1;Ch=null;Gh=0}function Nh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===P?wh=P=a:P=P.next=a;return P}function Oh(){if(null!==xh)P=xh,xh=P.next,O=vh,vh=null!==O?O.next:null;else{if(null===vh)throw Error(u(310));O=vh;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};P=null===P?wh=a:P.next=a;vh=O.next}return P}
function Ph(a,b){return"function"===typeof b?b(a):b}
function Qh(a){var b=Oh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;if(0<Gh){var d=c.dispatch;if(null!==Ch){var e=Ch.get(c);if(void 0!==e){Ch.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,k=d,l=!1;do{var m=k.expirationTime;m<th?(l||(l=!0,h=g,e=f),m>yh&&(yh=m,Jg(yh))):(Ig(m,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));g=k;k=k.next}while(null!==k&&k!==d);l||(h=g,e=f);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function Rh(a){var b=Nh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,lastRenderedReducer:Ph,lastRenderedState:a};a=a.dispatch=Sh.bind(null,uh,a);return[b.memoizedState,a]}function Th(a){return Qh(Ph,a)}function Uh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===zh?(zh={lastEffect:null},zh.lastEffect=a.next=a):(b=zh.lastEffect,null===b?zh.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,zh.lastEffect=a));return a}
function Vh(a,b,c,d){var e=Nh();Ah|=a;e.memoizedState=Uh(b,c,void 0,void 0===d?null:d)}function Wh(a,b,c,d){var e=Oh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&Hh(d,g.deps)){Uh(0,c,f,d);return}}Ah|=a;e.memoizedState=Uh(b,c,f,d)}function Xh(a,b){return Vh(516,192,a,b)}function Yh(a,b){return Wh(516,192,a,b)}
function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function $h(){}function ai(a,b){Nh().memoizedState=[a,void 0===b?null:b];return a}function bi(a,b){var c=Oh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Sh(a,b,c){if(!(25>Gh))throw Error(u(301));var d=a.alternate;if(a===uh||null!==d&&d===uh)if(Bh=!0,a={expirationTime:th,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===Ch&&(Ch=new Map),c=Ch.get(b),void 0===c)Ch.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=Pg(),f=Mg.suspense;e=Qg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&
(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(of(l,k))return}catch(m){}finally{}Rg(a,e)}}
var Lh={readContext:xg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},Jh={readContext:xg,useCallback:ai,useContext:xg,useEffect:Xh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Vh(4,36,a,b)},useMemo:function(a,b){var c=Nh();b=void 0===b?null:b;a=a();c.memoizedState=
[a,b];return a},useReducer:function(a,b,c){var d=Nh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Sh.bind(null,uh,a);return[d.memoizedState,a]},useRef:function(a){var b=Nh();a={current:a};return b.memoizedState=a},useState:Rh,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Rh(a),d=c[0],e=c[1];Xh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=
c}})},[a,b]);return d},useTransition:function(a){var b=Rh(!1),c=b[0],d=b[1];return[ai(function(b){d(!0);q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},Kh={readContext:xg,useCallback:bi,useContext:xg,useEffect:Yh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Wh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Wh(4,36,a,b)},useMemo:function(a,b){var c=Oh();b=void 0===b?
null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:Qh,useRef:function(){return Oh().memoizedState},useState:Th,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Th(a),d=c[0],e=c[1];Yh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=c}})},[a,b]);return d},useTransition:function(a){var b=Th(!1),c=b[0],d=b[1];return[bi(function(b){d(!0);q.unstable_next(function(){var c=
N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},ci=null,di=null,ei=!1;function fi(a,b){var c=gi(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function hi(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function ii(a){if(ei){var b=di;if(b){var c=b;if(!hi(a,b)){b=re(c.nextSibling);if(!b||!hi(a,b)){a.effectTag=a.effectTag&-1025|2;ei=!1;ci=a;return}fi(ci,c)}ci=a;di=re(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,ei=!1,ci=a}}function ji(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;ci=a}
function ki(a){if(a!==ci)return!1;if(!ei)return ji(a),ei=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!oe(b,a.memoizedProps))for(b=di;b;)fi(a,b),b=re(b.nextSibling);ji(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===ie){if(0===b){di=re(a.nextSibling);break a}b--}else c!==he&&c!==ke&&c!==je||b++}a=a.nextSibling}di=null}}else di=ci?re(a.stateNode.nextSibling):null;return!0}
function li(){di=ci=null;ei=!1}var mi=Ea.ReactCurrentOwner,wg=!1;function R(a,b,c,d){b.child=null===a?gh(b,null,c,d):fh(b,a.child,c,d)}function ni(a,b,c,d,e){c=c.render;var f=b.ref;vg(b,e);d=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function pi(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!qi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ri(a,b,g,d,e,f);a=ch(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:qf,c(e,d)&&a.ref===b.ref))return oi(a,b,f);b.effectTag|=1;a=ah(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function ri(a,b,c,d,e,f){return null!==a&&qf(a.memoizedProps,d)&&a.ref===b.ref&&(wg=!1,e<f)?oi(a,b,f):si(a,b,c,d,f)}function ti(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function si(a,b,c,d,e){var f=L(c)?Df:J.current;f=Ef(b,f);vg(b,e);c=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function ui(a,b,c,d,e){if(L(c)){var f=!0;Jf(b)}else f=!1;vg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Ug(b,c,d,e),Wg(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l));var m=c.getDerivedStateFromProps,C="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;C||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l);yg=!1;var y=b.memoizedState;k=g.state=y;var H=b.updateQueue;null!==H&&(Hg(b,H,d,g,e),k=b.memoizedState);h!==d||y!==k||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),k=b.memoizedState),(h=yg||Tg(b,c,h,d,y,k,l))?(C||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:mg(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l)),m=c.getDerivedStateFromProps,(C=
"function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l),yg=!1,k=b.memoizedState,y=g.state=k,H=b.updateQueue,null!==H&&(Hg(b,H,d,g,e),y=b.memoizedState),h!==d||k!==y||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),y=b.memoizedState),(m=yg||Tg(b,c,h,d,k,y,l))?(C||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,y,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,y,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=y),g.props=d,g.state=y,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return vi(a,b,c,d,f,e)}
function vi(a,b,c,d,e,f){ti(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Kf(b,c,!1),oi(a,b,f);d=b.stateNode;mi.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=fh(b,a.child,null,f),b.child=fh(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function wi(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);mh(a,b.containerInfo)}
var xi={dehydrated:null,retryTime:0};
function yi(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1,b);if(null===a){void 0!==e.fallback&&ii(b);if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=xi;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=gh(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=ah(a,a.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=ah(d,e,d.expirationTime);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=xi;b.child=c;return d}c=fh(b,a.child,e.children,c);b.memoizedState=
null;return b.child=c}a=a.child;if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=xi;b.child=e;return c}b.memoizedState=null;return b.child=fh(b,a,e.children,c)}
function zi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);ug(a.return,b)}function Ai(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function Bi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&zi(a,c);else if(19===a.tag)zi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d,b);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===qh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Ai(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===qh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}Ai(b,!0,c,null,f,b.lastEffect);break;case "together":Ai(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function oi(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Jg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=ah(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ah(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}function Ci(a){a.effectTag|=4}var Hi,Ii,Ji,Ki;
Hi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ii=function(){};
Ji=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;lh(ih.current);a=null;switch(c){case "input":f=Ab(g,f);d=Ab(g,d);a=[];break;case "option":f=Ib(g,f);d=Ib(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Kb(g,f);d=Kb(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ae)}Yd(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,""+l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(ia.hasOwnProperty(h)?(null!=l&&$d(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;(b.updateQueue=e)&&Ci(b)}};Ki=function(a,b,c,d){c!==d&&Ci(b)};
function Li(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function Mi(a){switch(a.tag){case 1:L(a.type)&&Ff(a);var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:nh(a);Gf(a);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return ph(a),null;case 13:return G(M,a),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return G(M,a),null;case 4:return nh(a),null;case 10:return tg(a),null;default:return null}}function Ni(a,b){return{value:a,source:b,stack:Xa(b)}}
var Oi="function"===typeof WeakSet?WeakSet:Set;function Pi(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Xa(c));null!==c&&Wa(c.type);b=b.value;null!==a&&1===a.tag&&Wa(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Qi(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ri(a,c)}}function Si(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ri(a,c)}else b.current=null}
function Ti(a,b){switch(b.tag){case 0:case 11:case 15:Ui(2,0,b);break;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:mg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:case 17:break;default:throw Error(u(163));}}
function Ui(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if(0!==(d.tag&a)){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}0!==(d.tag&b)&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function Vi(a,b,c){"function"===typeof Wi&&Wi(b);switch(b.tag){case 0:case 11:case 14:case 15:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;fg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ri(g,h)}}a=a.next}while(a!==d)})}break;case 1:Si(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Qi(b,c);break;case 5:Si(b);break;case 4:Xi(a,b,c)}}
function Yi(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;null!==b&&Yi(b)}function Zi(a){return 5===a.tag||3===a.tag||4===a.tag}
function $i(a){a:{for(var b=a.return;null!==b;){if(Zi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Tb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Zi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f){var g=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var h=g;g=c;8===f.nodeType?f.parentNode.insertBefore(h,g):f.insertBefore(h,g)}else b.insertBefore(g,c);else d?(h=b,8===h.nodeType?(f=h.parentNode,f.insertBefore(g,h)):(f=h,f.appendChild(g)),h=h._reactRootContainer,null!==h&&void 0!==h||null!==f.onclick||(f.onclick=ae)):b.appendChild(g)}else if(4!==
e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Xi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Vi(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Vi(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function aj(a,b){switch(b.tag){case 0:case 11:case 14:case 15:Ui(4,8,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[ve]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cb(c,d);Zd(a,e);b=Zd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?Wd(c,h):"dangerouslySetInnerHTML"===g?Sb(c,h):"children"===g?Tb(c,h):vb(c,g,h,b)}switch(a){case "input":Eb(c,d);break;case "textarea":Mb(c,
d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Jb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Jb(c,!!d.multiple,d.defaultValue,!0):Jb(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Lc(b.containerInfo));break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,bj=cg());
if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=Vd("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=
a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}cj(b);break;case 19:cj(b);break;case 17:break;case 20:break;case 21:break;default:throw Error(u(163));}}function cj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Oi);b.forEach(function(b){var d=dj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var ej="function"===typeof WeakMap?WeakMap:Map;
function fj(a,b,c){c=Bg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gj||(gj=!0,hj=d);Pi(a,b)};return c}
function ij(a,b,c){c=Bg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Pi(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===jj?jj=new Set([this]):jj.add(this),Pi(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var kj=Math.ceil,lj=Ea.ReactCurrentDispatcher,mj=Ea.ReactCurrentOwner,S=0,nj=8,oj=16,pj=32,qj=0,rj=1,sj=2,tj=3,uj=4,vj=5,T=S,U=null,V=null,W=0,X=qj,wj=null,xj=1073741823,yj=1073741823,zj=null,Aj=0,Bj=!1,bj=0,Cj=500,Y=null,gj=!1,hj=null,jj=null,Dj=!1,Ej=null,Fj=90,Gj=null,Hj=0,Ij=null,Jj=0;function Pg(){return(T&(oj|pj))!==S?1073741821-(cg()/10|0):0!==Jj?Jj:Jj=1073741821-(cg()/10|0)}
function Qg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=dg();if(0===(b&4))return 99===d?1073741823:1073741822;if((T&oj)!==S)return W;if(null!==c)a=lg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=lg(a,150,100);break;case 97:case 96:a=lg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==U&&a===W&&--a;return a}
function Rg(a,b){if(50<Hj)throw Hj=0,Ij=null,Error(u(185));a=Kj(a,b);if(null!==a){var c=dg();1073741823===b?(T&nj)!==S&&(T&(oj|pj))===S?Lj(a):(Z(a),T===S&&jg()):Z(a);(T&4)===S||98!==c&&99!==c||(null===Gj?Gj=new Map([[a,b]]):(c=Gj.get(a),(void 0===c||c>b)&&Gj.set(a,b)))}}
function Kj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(U===e&&(Jg(b),X===uj&&Mj(e,W)),Nj(e,b));return e}
function Oj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Pj(a,b))return b;b=a.lastPingedTime;a=a.nextKnownPendingLevel;return b>a?b:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=hg(Lj.bind(null,a));else{var b=Oj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Pg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Xf&&Nf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?hg(Lj.bind(null,a)):gg(d,Qj.bind(null,a),{timeout:10*(1073741821-b)-cg()});a.callbackNode=b}}}
function Qj(a,b){Jj=0;if(b)return b=Pg(),Rj(a,b),Z(a),null;var c=Oj(a);if(0!==c){b=a.callbackNode;if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&c===W||Tj(a,c);if(null!==V){var d=T;T|=oj;var e=Uj(a);do try{Vj();break}catch(h){Wj(a,h)}while(1);rg();T=d;lj.current=e;if(X===rj)throw b=wj,Tj(a,c),Mj(a,c),Z(a),b;if(null===V)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=X,U=null,d){case qj:case rj:throw Error(u(345));case sj:Rj(a,2<c?2:c);break;case tj:Mj(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Xj(e));if(1073741823===xj&&(e=bj+Cj-cg(),10<e)){if(Bj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Tj(a,c);break}}f=Oj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=pe(Yj.bind(null,a),e);break}Yj(a);break;case uj:Mj(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Xj(e));if(Bj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Tj(a,c);break}e=Oj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==yj?d=10*(1073741821-yj)-cg():1073741823===xj?d=0:(d=10*(1073741821-xj)-5E3,e=cg(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*kj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=pe(Yj.bind(null,a),d);break}Yj(a);break;case vj:if(1073741823!==xj&&null!==zj){f=xj;var g=zj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=cg()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){Mj(a,c);a.timeoutHandle=
pe(Yj.bind(null,a),d);break}}Yj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Qj.bind(null,a)}}return null}
function Lj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if(a.finishedExpirationTime===b)Yj(a);else{if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&b===W||Tj(a,b);if(null!==V){var c=T;T|=oj;var d=Uj(a);do try{Zj();break}catch(e){Wj(a,e)}while(1);rg();T=c;lj.current=d;if(X===rj)throw c=wj,Tj(a,b),Mj(a,b),Z(a),c;if(null!==V)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;U=null;Yj(a);Z(a)}}return null}
function ak(){if(null!==Gj){var a=Gj;Gj=null;a.forEach(function(a,c){Rj(c,a);Z(c)});jg()}}function bk(a,b){var c=T;T|=1;try{return a(b)}finally{T=c,T===S&&jg()}}function ck(a,b){var c=T;T&=-2;T|=nj;try{return a(b)}finally{T=c,T===S&&jg()}}
function Tj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,qe(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&Ff(d);break;case 3:nh(d);Gf(d);break;case 5:ph(d);break;case 4:nh(d);break;case 13:G(M,d);break;case 19:G(M,d);break;case 10:tg(d)}c=c.return}U=a;V=ah(a.current,null,b);W=b;X=qj;wj=null;yj=xj=1073741823;zj=null;Aj=0;Bj=!1}
function Wj(a,b){do{try{rg();Mh();if(null===V||null===V.return)return X=rj,wj=b,null;a:{var c=a,d=V.return,e=V,f=b;b=W;e.effectTag|=2048;e.firstEffect=e.lastEffect=null;if(null!==f&&"object"===typeof f&&"function"===typeof f.then){var g=f,h=0!==(M.current&1),k=d;do{var l;if(l=13===k.tag){var m=k.memoizedState;if(null!==m)l=null!==m.dehydrated?!0:!1;else{var C=k.memoizedProps;l=void 0===C.fallback?!1:!0!==C.unstable_avoidThisFallback?!0:h?!1:!0}}if(l){var y=k.updateQueue;if(null===y){var H=new Set;
H.add(g);k.updateQueue=H}else y.add(g);if(0===(k.mode&2)){k.effectTag|=64;e.effectTag&=-2981;if(1===e.tag)if(null===e.alternate)e.tag=17;else{var z=Bg(1073741823,null);z.tag=2;Dg(e,z)}e.expirationTime=1073741823;break a}f=void 0;e=b;var ta=c.pingCache;null===ta?(ta=c.pingCache=new ej,f=new Set,ta.set(g,f)):(f=ta.get(g),void 0===f&&(f=new Set,ta.set(g,f)));if(!f.has(e)){f.add(e);var r=dk.bind(null,c,g,e);g.then(r,r)}k.effectTag|=4096;k.expirationTime=b;break a}k=k.return}while(null!==k);f=Error((Wa(e.type)||
"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Xa(e))}X!==vj&&(X=sj);f=Ni(f,e);k=d;do{switch(k.tag){case 3:g=f;k.effectTag|=4096;k.expirationTime=b;var x=fj(k,g,b);Eg(k,x);break a;case 1:g=f;var A=k.type,p=k.stateNode;if(0===(k.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==p&&"function"===typeof p.componentDidCatch&&
(null===jj||!jj.has(p)))){k.effectTag|=4096;k.expirationTime=b;var t=ij(k,g,b);Eg(k,t);break a}}k=k.return}while(null!==k)}V=ek(V)}catch(v){b=v;continue}break}while(1)}function Uj(){var a=lj.current;lj.current=Lh;return null===a?Lh:a}function Ig(a,b){a<xj&&2<a&&(xj=a);null!==b&&a<yj&&2<a&&(yj=a,zj=b)}function Jg(a){a>Aj&&(Aj=a)}function Zj(){for(;null!==V;)V=fk(V)}function Vj(){for(;null!==V&&!Of();)V=fk(V)}
function fk(a){var b=gk(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=ek(a));mj.current=null;return b}
function ek(a){V=a;do{var b=V.alternate;a=V.return;if(0===(V.effectTag&2048)){a:{var c=b;b=V;var d=W;var e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:L(b.type)&&Ff(b);break;case 3:nh(b);Gf(b);e=b.stateNode;e.pendingContext&&(e.context=e.pendingContext,e.pendingContext=null);(null===c||null===c.child)&&ki(b)&&Ci(b);Ii(b);break;case 5:ph(b);d=lh(kh.current);var f=b.type;if(null!==c&&null!=b.stateNode)Ji(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var g=
lh(ih.current);if(ki(b)){e=b;var h=e.stateNode;c=e.type;var k=e.memoizedProps,l=d;h[ue]=e;h[ve]=k;f=void 0;d=h;switch(c){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(h=0;h<cc.length;h++)F(cc[h],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Bb(d,k);F("invalid",d);$d(l,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!k.multiple};F("invalid",d);$d(l,"onChange");break;case "textarea":Lb(d,k),F("invalid",d),$d(l,"onChange")}Yd(c,k);h=null;for(f in k)k.hasOwnProperty(f)&&(g=k[f],"children"===f?"string"===typeof g?d.textContent!==g&&(h=["children",g]):"number"===typeof g&&d.textContent!==""+g&&(h=["children",""+g]):ia.hasOwnProperty(f)&&null!=g&&$d(l,f));switch(c){case "input":yb(d);Gb(d,k,!0);break;case "textarea":yb(d);Nb(d,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
(d.onclick=ae)}f=h;e.updateQueue=f;e=null!==f?!0:!1;e&&Ci(b)}else{c=b;l=f;k=e;h=9===d.nodeType?d:d.ownerDocument;g===Ob.html&&(g=Pb(l));g===Ob.html?"script"===l?(k=h.createElement("div"),k.innerHTML="<script>\x3c/script>",h=k.removeChild(k.firstChild)):"string"===typeof k.is?h=h.createElement(l,{is:k.is}):(h=h.createElement(l),"select"===l&&(l=h,k.multiple?l.multiple=!0:k.size&&(l.size=k.size))):h=h.createElementNS(g,l);k=h;k[ue]=c;k[ve]=e;Hi(k,b,!1,!1);b.stateNode=k;l=f;c=e;var m=d,C=Zd(l,c);switch(l){case "iframe":case "object":case "embed":F("load",
k);d=c;break;case "video":case "audio":for(d=0;d<cc.length;d++)F(cc[d],k);d=c;break;case "source":F("error",k);d=c;break;case "img":case "image":case "link":F("error",k);F("load",k);d=c;break;case "form":F("reset",k);F("submit",k);d=c;break;case "details":F("toggle",k);d=c;break;case "input":Bb(k,c);d=Ab(k,c);F("invalid",k);$d(m,"onChange");break;case "option":d=Ib(k,c);break;case "select":k._wrapperState={wasMultiple:!!c.multiple};d=n({},c,{value:void 0});F("invalid",k);$d(m,"onChange");break;case "textarea":Lb(k,
c);d=Kb(k,c);F("invalid",k);$d(m,"onChange");break;default:d=c}Yd(l,d);h=void 0;g=l;var y=k,H=d;for(h in H)if(H.hasOwnProperty(h)){var z=H[h];"style"===h?Wd(y,z):"dangerouslySetInnerHTML"===h?(z=z?z.__html:void 0,null!=z&&Sb(y,z)):"children"===h?"string"===typeof z?("textarea"!==g||""!==z)&&Tb(y,z):"number"===typeof z&&Tb(y,""+z):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?null!=z&&$d(m,h):null!=z&&vb(y,h,z,C))}switch(l){case "input":yb(k);
Gb(k,c,!1);break;case "textarea":yb(k);Nb(k,c);break;case "option":null!=c.value&&k.setAttribute("value",""+ub(c.value));break;case "select":d=k;d.multiple=!!c.multiple;k=c.value;null!=k?Jb(d,!!c.multiple,k,!1):null!=c.defaultValue&&Jb(d,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof d.onClick&&(k.onclick=ae)}(e=ne(f,e))&&Ci(b)}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw Error(u(166));break;case 6:if(c&&null!=b.stateNode)Ki(c,b,c.memoizedProps,e);else{if("string"!==
typeof e&&null===b.stateNode)throw Error(u(166));d=lh(kh.current);lh(ih.current);ki(b)?(e=b,f=e.stateNode,d=e.memoizedProps,f[ue]=e,(e=f.nodeValue!==d)&&Ci(b)):(f=b,e=(9===d.nodeType?d:d.ownerDocument).createTextNode(e),e[ue]=f,b.stateNode=e)}break;case 11:break;case 13:G(M,b);e=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=d;break a}e=null!==e;f=!1;null===c?void 0!==b.memoizedProps.fallback&&ki(b):(d=c.memoizedState,f=null!==d,e||null===d||(d=c.child.sibling,null!==d&&(k=b.firstEffect,
null!==k?(b.firstEffect=d,d.nextEffect=k):(b.firstEffect=b.lastEffect=d,d.nextEffect=null),d.effectTag=8)));if(e&&!f&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))X===qj&&(X=tj);else{if(X===qj||X===tj)X=uj;0!==Aj&&null!==U&&(Mj(U,W),Nj(U,Aj))}if(e||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:nh(b);Ii(b);break;case 10:tg(b);break;case 9:break;case 14:break;case 17:L(b.type)&&Ff(b);break;case 19:G(M,b);e=b.memoizedState;if(null===
e)break;f=0!==(b.effectTag&64);k=e.rendering;if(null===k)if(f)Li(e,!1);else{if(X!==qj||null!==c&&0!==(c.effectTag&64))for(c=b.child;null!==c;){k=qh(c);if(null!==k){b.effectTag|=64;Li(e,!1);f=k.updateQueue;null!==f&&(b.updateQueue=f,b.effectTag|=4);null===e.lastEffect&&(b.firstEffect=null);b.lastEffect=e.lastEffect;e=d;for(f=b.child;null!==f;)d=f,c=e,d.effectTag&=2,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null,k=d.alternate,null===k?(d.childExpirationTime=0,d.expirationTime=c,d.child=null,
d.memoizedProps=null,d.memoizedState=null,d.updateQueue=null,d.dependencies=null):(d.childExpirationTime=k.childExpirationTime,d.expirationTime=k.expirationTime,d.child=k.child,d.memoizedProps=k.memoizedProps,d.memoizedState=k.memoizedState,d.updateQueue=k.updateQueue,c=k.dependencies,d.dependencies=null===c?null:{expirationTime:c.expirationTime,firstContext:c.firstContext,responders:c.responders}),f=f.sibling;I(M,M.current&1|2,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=qh(k),null!==c){if(b.effectTag|=
64,f=!0,d=c.updateQueue,null!==d&&(b.updateQueue=d,b.effectTag|=4),Li(e,!0),null===e.tail&&"hidden"===e.tailMode&&!k.alternate){b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else cg()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,Li(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(k.sibling=b.child,b.child=k):(d=e.last,null!==d?d.sibling=k:b.child=k,e.last=k)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=cg()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;
e.lastEffect=b.lastEffect;d.sibling=null;e=M.current;e=f?e&1|2:e&1;I(M,e,b);b=d;break a}break;case 20:break;case 21:break;default:throw Error(u(156,b.tag));}b=null}e=V;if(1===W||1!==e.childExpirationTime){f=0;for(d=e.child;null!==d;)c=d.expirationTime,k=d.childExpirationTime,c>f&&(f=c),k>f&&(f=k),d=d.sibling;e.childExpirationTime=f}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=
V.firstEffect),a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=V:a.firstEffect=V,a.lastEffect=V))}else{b=Mi(V,W);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===qj&&(X=vj);return null}function Xj(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Yj(a){var b=dg();fg(99,ik.bind(null,a,b));return null}
function ik(a,b){do Sj();while(null!==Ej);if((T&(oj|pj))!==S)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Xj(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===U&&(V=U=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=T;T|=pj;mj.current=null;le=Ld;var g=fe();if(ge(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(Db){h=null;break a}var C=0,y=-1,H=-1,z=0,ta=0,r=g,x=null;b:for(;;){for(var A;;){r!==h||0!==l&&3!==r.nodeType||(y=C+l);r!==m||0!==k&&3!==r.nodeType||(H=C+k);3===r.nodeType&&(C+=r.nodeValue.length);if(null===(A=r.firstChild))break;x=r;r=A}for(;;){if(r===g)break b;x===h&&++z===l&&(y=C);x===m&&++ta===k&&(H=C);if(null!==(A=r.nextSibling))break;r=x;x=r.parentNode}r=A}h=-1===y||-1===H?null:{start:y,end:H}}else h=null}h=h||{start:0,end:0}}else h=
null;me={focusedElem:g,selectionRange:h};Ld=!1;Y=e;do try{jk()}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var p=Y.effectTag;p&16&&Tb(Y.stateNode,"");if(p&128){var t=Y.alternate;if(null!==t){var v=t.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(p&1038){case 2:$i(Y);Y.effectTag&=-3;break;case 6:$i(Y);Y.effectTag&=-3;aj(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=-1025;aj(Y.alternate,
Y);break;case 4:aj(Y.alternate,Y);break;case 8:l=Y,Xi(g,l,h),Yi(l)}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);v=me;t=fe();p=v.focusedElem;h=v.selectionRange;if(t!==p&&p&&p.ownerDocument&&ee(p.ownerDocument.documentElement,p)){null!==h&&ge(p)&&(t=h.start,v=h.end,void 0===v&&(v=t),"selectionStart"in p?(p.selectionStart=t,p.selectionEnd=Math.min(v,p.value.length)):(v=(t=p.ownerDocument||document)&&t.defaultView||window,v.getSelection&&(v=v.getSelection(),
l=p.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!v.extend&&g>h&&(l=h,h=g,g=l),l=de(p,g),m=de(p,h),l&&m&&(1!==v.rangeCount||v.anchorNode!==l.node||v.anchorOffset!==l.offset||v.focusNode!==m.node||v.focusOffset!==m.offset)&&(t=t.createRange(),t.setStart(l.node,l.offset),v.removeAllRanges(),g>h?(v.addRange(t),v.extend(m.node,m.offset)):(t.setEnd(m.node,m.offset),v.addRange(t))))));t=[];for(v=p;v=v.parentNode;)1===v.nodeType&&t.push({element:v,left:v.scrollLeft,top:v.scrollTop});
"function"===typeof p.focus&&p.focus();for(p=0;p<t.length;p++)v=t[p],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}me=null;Ld=!!le;le=null;a.current=c;Y=e;do try{for(p=d;null!==Y;){var Dh=Y.effectTag;if(Dh&36){var dc=Y.alternate;t=Y;v=p;switch(t.tag){case 0:case 11:case 15:Ui(16,32,t);break;case 1:var fd=t.stateNode;if(t.effectTag&4)if(null===dc)fd.componentDidMount();else{var hk=t.elementType===t.type?dc.memoizedProps:mg(t.type,dc.memoizedProps);fd.componentDidUpdate(hk,dc.memoizedState,
fd.__reactInternalSnapshotBeforeUpdate)}var Eh=t.updateQueue;null!==Eh&&Kg(t,Eh,fd,v);break;case 3:var Fh=t.updateQueue;if(null!==Fh){g=null;if(null!==t.child)switch(t.child.tag){case 5:g=t.child.stateNode;break;case 1:g=t.child.stateNode}Kg(t,Fh,g,v)}break;case 5:var xk=t.stateNode;null===dc&&t.effectTag&4&&ne(t.type,t.memoizedProps)&&xk.focus();break;case 6:break;case 4:break;case 12:break;case 13:if(null===t.memoizedState){var Di=t.alternate;if(null!==Di){var Ei=Di.memoizedState;if(null!==Ei){var Fi=
Ei.dehydrated;null!==Fi&&Lc(Fi)}}}break;case 19:case 17:case 20:case 21:break;default:throw Error(u(163));}}if(Dh&128){t=void 0;var xd=Y.ref;if(null!==xd){var Gi=Y.stateNode;switch(Y.tag){case 5:t=Gi;break;default:t=Gi}"function"===typeof xd?xd(t):xd.current=t}}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=null;Yf();T=f}else a.current=c;if(Dj)Dj=!1,Ej=a,Fj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&
(jj=null);1073741823===b?a===Ij?Hj++:(Hj=0,Ij=a):Hj=0;"function"===typeof kk&&kk(c.stateNode,d);Z(a);if(gj)throw gj=!1,a=hj,hj=null,a;if((T&nj)!==S)return null;jg();return null}function jk(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Ti(Y.alternate,Y);0===(a&512)||Dj||(Dj=!0,gg(97,function(){Sj();return null}));Y=Y.nextEffect}}function Sj(){if(90!==Fj){var a=97<Fj?97:Fj;Fj=90;return fg(a,lk)}}
function lk(){if(null===Ej)return!1;var a=Ej;Ej=null;if((T&(oj|pj))!==S)throw Error(u(331));var b=T;T|=pj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:Ui(128,0,c),Ui(0,64,c)}}catch(d){if(null===a)throw Error(u(330));Ri(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}T=b;jg();return!0}function mk(a,b,c){b=Ni(c,b);b=fj(a,b,1073741823);Dg(a,b);a=Kj(a,1073741823);null!==a&&Z(a)}
function Ri(a,b){if(3===a.tag)mk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){mk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===jj||!jj.has(d))){a=Ni(b,a);a=ij(c,a,1073741823);Dg(c,a);c=Kj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function dk(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);U===a&&W===c?X===uj||X===tj&&1073741823===xj&&cg()-bj<Cj?Tj(a,W):Bj=!0:Pj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),Z(a)))}function dj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Pg(),b=Qg(b,a,null));a=Kj(a,b);null!==a&&Z(a)}var gk;
gk=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)wg=!0;else{if(d<c){wg=!1;switch(b.tag){case 3:wi(b);li();break;case 5:oh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Jf(b);break;case 4:mh(b,b.stateNode.containerInfo);break;case 10:sg(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return yi(a,b,c);I(M,M.current&
1,b);b=oi(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1,b);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return Bi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current,b);if(!d)return null}return oi(a,b,c)}wg=!1}}else wg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Ef(b,J.current);vg(b,c);e=Ih(null,b,d,a,e,c);b.effectTag|=1;if("object"===
typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;Mh();if(L(d)){var f=!0;Jf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Og(b,d,g,a);e.updater=Sg;b.stateNode=e;e._reactInternalFiber=b;Wg(b,d,a,c);b=vi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;Va(e);if(1!==e._status)throw e._result;
e=e._result;b.type=e;f=b.tag=nk(e);a=mg(e,a);switch(f){case 0:b=si(null,b,e,a,c);break;case 1:b=ui(null,b,e,a,c);break;case 11:b=ni(null,b,e,a,c);break;case 14:b=pi(null,b,e,mg(e.type,a),d,c);break;default:throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),si(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ui(a,b,d,e,c);case 3:wi(b);d=b.updateQueue;if(null===d)throw Error(u(282));e=b.memoizedState;e=null!==e?e.element:
null;Hg(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)li(),b=oi(a,b,c);else{if(e=b.stateNode.hydrate)di=re(b.stateNode.containerInfo.firstChild),ci=b,e=ei=!0;if(e)for(c=gh(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),li();b=b.child}return b;case 5:return oh(b),null===a&&ii(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,oe(d,e)?g=null:null!==f&&oe(d,f)&&(b.effectTag|=16),ti(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=
b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&ii(b),null;case 13:return yi(a,b,c);case 4:return mh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=fh(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ni(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;
e=b.pendingProps;g=b.memoizedProps;f=e.value;sg(b,f);if(null!==g){var h=g.value;f=of(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!K.current){b=oi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=Bg(c,null),l.tag=2,Dg(h,l));h.expirationTime<c&&(h.expirationTime=
c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);ug(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,vg(b,c),e=xg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;
case 14:return e=b.type,f=mg(e,b.pendingProps),f=mg(e.type,f),pi(a,b,e,f,d,c);case 15:return ri(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Jf(b)):a=!1,vg(b,c),Ug(b,d,e,c),Wg(b,d,e,c),vi(null,b,d,!0,a,c);case 19:return Bi(a,b,c)}throw Error(u(156,b.tag));};var kk=null,Wi=null;
function ok(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);kk=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Wi=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function pk(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function gi(a,b,c,d){return new pk(a,b,c,d)}
function qi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function nk(a){if("function"===typeof a)return qi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Oa)return 11;if(a===Ra)return 14}return 2}
function ah(a,b){var c=a.alternate;null===c?(c=gi(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function ch(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)qi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Ia:return eh(c.children,e,f,b);case Na:g=8;e|=7;break;case Ja:g=8;e|=1;break;case Ka:return a=gi(12,c,b,e|8),a.elementType=Ka,a.type=Ka,a.expirationTime=f,a;case Pa:return a=gi(13,c,b,e),a.type=Pa,a.elementType=Pa,a.expirationTime=f,a;case Qa:return a=gi(19,c,b,e),a.elementType=Qa,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case La:g=
10;break a;case Ma:g=9;break a;case Oa:g=11;break a;case Ra:g=14;break a;case Sa:g=16;d=null;break a}throw Error(u(130,null==a?a:typeof a,""));}b=gi(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function eh(a,b,c,d){a=gi(7,a,d,b);a.expirationTime=c;return a}function bh(a,b,c){a=gi(6,a,null,b);a.expirationTime=c;return a}
function dh(a,b,c){b=gi(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function qk(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Pj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function Mj(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function Nj(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Rj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function rk(a,b,c,d){var e=b.current,f=Pg(),g=Mg.suspense;f=Qg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(ec(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=If(c,k,h);break a}}c=h}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=Bg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);Dg(e,b);Rg(e,f);return f}function sk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function tk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function uk(a,b){tk(a,b);(a=a.alternate)&&tk(a,b)}
function vk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new qk(a,b,c),e=gi(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;a[we]=d.current;c&&0!==b&&wc(9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}vk.prototype.render=function(a,b){rk(a,this._internalRoot,null,void 0===b?null:b)};vk.prototype.unmount=function(a){var b=this._internalRoot,c=void 0===a?null:a,d=b.containerInfo;rk(null,b,null,function(){d[we]=null;null!==c&&c()})};
function wk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function yk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new vk(a,0,b?{hydrate:!0}:void 0)}
function zk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=sk(g);h.call(a)}}rk(b,g,a,e)}else{f=c._reactRootContainer=yk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=sk(g);k.call(a)}}ck(function(){rk(b,g,a,e)})}return sk(g)}function Ak(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ha,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
jc=function(a){if(13===a.tag){var b=lg(Pg(),150,100);Rg(a,b);uk(a,b)}};kc=function(a){if(13===a.tag){Pg();var b=kg++;Rg(a,b);uk(a,b)}};lc=function(a){if(13===a.tag){var b=Pg();b=Qg(b,a,null);Rg(a,b);uk(a,b)}};
Za=function(a,b,c){switch(b){case "input":Eb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=ye(d);if(!e)throw Error(u(90));zb(d);Eb(d,e)}}}break;case "textarea":Mb(a,c);break;case "select":b=c.value,null!=b&&Jb(a,!!c.multiple,b,!1)}};eb=bk;
fb=function(a,b,c,d){var e=T;T|=4;try{return fg(98,a.bind(null,b,c,d))}finally{T=e,T===S&&jg()}};gb=function(){(T&(1|oj|pj))===S&&(ak(),Sj())};hb=function(a,b){var c=T;T|=2;try{return a(b)}finally{T=c,T===S&&jg()}};function Bk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!wk(b))throw Error(u(200));return Ak(a,b,null,c)}
var Ck={createPortal:Bk,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=ic(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!0,c)},render:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!wk(c))throw Error(u(200));
if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return zk(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!wk(a))throw Error(u(40));return a._reactRootContainer?(ck(function(){zk(null,null,a,!1,function(){a._reactRootContainer=null;a[we]=null})}),!0):!1},unstable_createPortal:function(){return Bk.apply(void 0,arguments)},unstable_batchedUpdates:bk,flushSync:function(a,b){if((T&(oj|pj))!==S)throw Error(u(187));var c=T;T|=1;try{return fg(99,a.bind(null,b))}finally{T=c,jg()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Cc,
xe,ye,Ca.injectEventPluginsByName,fa,Sc,function(a){ya(a,Rc)},cb,db,Pd,Ba,Sj,{current:!1}]}};
(function(a){var b=a.findFiberByHostInstance;return ok(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Ea.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=ic(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Fc,bundleType:0,version:"16.12.0",
rendererPackageName:"react-dom"});var Dk={default:Ck},Ek=Dk&&Ck||Dk;module.exports=Ek.default||Ek;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(25);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.18.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=Math.floor((c-1)/2),e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};exports.unstable_cancelCallback=function(a){a.callback=null};
exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_requestPaint=Z;exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_Profiling=null;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chat_box_rt__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configs_rt_pro__ = __webpack_require__(58);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_chat_box_rt__["a" /* default */],{config:__WEBPACK_IMPORTED_MODULE_2__configs_rt_pro__["a" /* default */]}));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate, process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_domain__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_domain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_domain__);




/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var axios = __webpack_require__(39).default;
var getConfig = function (stage, apiKey) {
    return axios.get("https://channel-" + stage + ".rational-touch.com/channel/desktop/bot/config", { params: { apiKey: apiKey } });
};
var getBotList = function (stage) {
    var config = {
        url: "https://api-" + stage + ".rational-touch.com/proxy/bot/config/bots",
        method: 'get',
        headers: { 'x-api-key': '4LSsOjlCJK360d5CIyX638H8EjXltT8y9CslBNi2' }
    };
    return axios(config);
};

/*!
 * Font Awesome Free 5.15.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */
var faCommentDots = {
  prefix: 'fas',
  iconName: 'comment-dots',
  icon: [512, 512, [], "f4ad", "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"]
};
var faThumbsUp = {
  prefix: 'fas',
  iconName: 'thumbs-up',
  icon: [512, 512, [], "f164", "M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"]
};
var faTimesCircle = {
  prefix: 'fas',
  iconName: 'times-circle',
  icon: [512, 512, [], "f057", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"]
};

/*!
 * Font Awesome Free 5.15.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var noop = function noop() {};

var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
  mark: noop,
  measure: noop
};

try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}

var _ref = _WINDOW.navigator || {},
    _ref$userAgent = _ref.userAgent,
    userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;

var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var PERFORMANCE = _PERFORMANCE;
var IS_BROWSER = !!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var DEFAULT_FAMILY_PREFIX = 'fa';
var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var DATA_FA_I2SVG = 'data-fa-i2svg';
var PRODUCTION = function () {
  try {
    return "production" === 'production';
  } catch (e) {
    return false;
  }
}();
var DUOTONE_CLASSES = {
  GROUP: 'group',
  SWAP_OPACITY: 'swap-opacity',
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};

var initial = WINDOW.FontAwesomeConfig || {};

function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector('script[' + attr + ']');

  if (element) {
    return element.getAttribute(attr);
  }
}

function coerce(val) {
  // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
  // We'll assume that this is an indication that it should be toggled to true
  // For example <script data-search-pseudo-elements src="..."></script>
  if (val === '') return true;
  if (val === 'false') return false;
  if (val === 'true') return true;
  return val;
}

if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
  var attrs = [['data-family-prefix', 'familyPrefix'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-mutate-approach', 'mutateApproach'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
  attrs.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        attr = _ref2[0],
        key = _ref2[1];

    var val = coerce(getAttrConfig(attr));

    if (val !== undefined && val !== null) {
      initial[key] = val;
    }
  });
}

var _default = {
  familyPrefix: DEFAULT_FAMILY_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: 'async',
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
};

var _config = _objectSpread({}, _default, initial);

if (!_config.autoReplaceSvg) _config.observeMutations = false;

var config = _objectSpread({}, _config);

WINDOW.FontAwesomeConfig = config;

var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];

var functions = [];

var listener = function listener() {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions.map(function (fn) {
    return fn();
  });
};

var loaded = false;

if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}

var isNode = typeof global !== 'undefined' && typeof global.process !== 'undefined' && typeof global.process.emit === 'function';
var asyncSetTimer = typeof setImmediate === 'undefined' ? setTimeout : setImmediate;
var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};
function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }

  var style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;

  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || '').toUpperCase();

    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }

  DOCUMENT.head.insertBefore(style, beforeChild);
  return css;
}
var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function nextUniqueId() {
  var size = 12;
  var id = '';

  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }

  return id;
}
function htmlEscape(str) {
  return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
  }, '').trim();
}
function joinStyles(styles) {
  return Object.keys(styles || {}).reduce(function (acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles[styleName], ";");
  }, '');
}
function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref) {
  var transform = _ref.transform,
      containerWidth = _ref.containerWidth,
      iconWidth = _ref.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  var inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer: outer,
    inner: inner,
    path: path
  };
}

var ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};

function fillBlack(abstract) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (abstract.attributes && (abstract.attributes.fill || force)) {
    abstract.attributes.fill = 'black';
  }

  return abstract;
}

function deGroup(abstract) {
  if (abstract.tag === 'g') {
    return abstract.children;
  } else {
    return [abstract];
  }
}

function makeIconMasking (_ref) {
  var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      mask = _ref.mask,
      explicitMaskId = _ref.maskId,
      transform = _ref.transform;
  var mainWidth = main.width,
      mainPath = main.icon;
  var maskWidth = mask.width,
      maskPath = mask.icon;
  var trans = transformForSvg({
    transform: transform,
    containerWidth: maskWidth,
    iconWidth: mainWidth
  });
  var maskRect = {
    tag: 'rect',
    attributes: _objectSpread({}, ALL_SPACE, {
      fill: 'white'
    })
  };
  var maskInnerGroupChildrenMixin = mainPath.children ? {
    children: mainPath.children.map(fillBlack)
  } : {};
  var maskInnerGroup = {
    tag: 'g',
    attributes: _objectSpread({}, trans.inner),
    children: [fillBlack(_objectSpread({
      tag: mainPath.tag,
      attributes: _objectSpread({}, mainPath.attributes, trans.path)
    }, maskInnerGroupChildrenMixin))]
  };
  var maskOuterGroup = {
    tag: 'g',
    attributes: _objectSpread({}, trans.outer),
    children: [maskInnerGroup]
  };
  var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
  var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
  var maskTag = {
    tag: 'mask',
    attributes: _objectSpread({}, ALL_SPACE, {
      id: maskId,
      maskUnits: 'userSpaceOnUse',
      maskContentUnits: 'userSpaceOnUse'
    }),
    children: [maskRect, maskOuterGroup]
  };
  var defs = {
    tag: 'defs',
    children: [{
      tag: 'clipPath',
      attributes: {
        id: clipId
      },
      children: deGroup(maskPath)
    }, maskTag]
  };
  children.push(defs, {
    tag: 'rect',
    attributes: _objectSpread({
      fill: 'currentColor',
      'clip-path': "url(#".concat(clipId, ")"),
      mask: "url(#".concat(maskId, ")")
    }, ALL_SPACE)
  });
  return {
    children: children,
    attributes: attributes
  };
}

function makeIconStandard (_ref) {
  var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      transform = _ref.transform,
      styles = _ref.styles;
  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  if (transformIsMeaningful(transform)) {
    var trans = transformForSvg({
      transform: transform,
      containerWidth: main.width,
      iconWidth: main.width
    });
    children.push({
      tag: 'g',
      attributes: _objectSpread({}, trans.outer),
      children: [{
        tag: 'g',
        attributes: _objectSpread({}, trans.inner),
        children: [{
          tag: main.icon.tag,
          children: main.icon.children,
          attributes: _objectSpread({}, main.icon.attributes, trans.path)
        }]
      }]
    });
  } else {
    children.push(main.icon);
  }

  return {
    children: children,
    attributes: attributes
  };
}

function asIcon (_ref) {
  var children = _ref.children,
      main = _ref.main,
      mask = _ref.mask,
      attributes = _ref.attributes,
      styles = _ref.styles,
      transform = _ref.transform;

  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
        height = main.height;
    var offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_objectSpread({}, styles, {
      'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
    }));
  }

  return [{
    tag: 'svg',
    attributes: attributes,
    children: children
  }];
}

function asSymbol (_ref) {
  var prefix = _ref.prefix,
      iconName = _ref.iconName,
      children = _ref.children,
      attributes = _ref.attributes,
      symbol = _ref.symbol;
  var id = symbol === true ? "".concat(prefix, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _objectSpread({}, attributes, {
        id: id
      }),
      children: children
    }]
  }];
}

function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
      main = _params$icons.main,
      mask = _params$icons.mask,
      prefix = params.prefix,
      iconName = params.iconName,
      transform = params.transform,
      symbol = params.symbol,
      title = params.title,
      maskId = params.maskId,
      titleId = params.titleId,
      extra = params.extra,
      _params$watchable = params.watchable,
      watchable = _params$watchable === void 0 ? false : _params$watchable;

  var _ref = mask.found ? mask : main,
      width = _ref.width,
      height = _ref.height;

  var isUploadedIcon = prefix === 'fak';
  var widthClass = isUploadedIcon ? '' : "fa-w-".concat(Math.ceil(width / height * 16));
  var attrClass = [config.replacementClass, iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : '', widthClass].filter(function (c) {
    return extra.classes.indexOf(c) === -1;
  }).filter(function (c) {
    return c !== '' || !!c;
  }).concat(extra.classes).join(' ');
  var content = {
    children: [],
    attributes: _objectSpread({}, extra.attributes, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': extra.attributes.role || 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': "0 0 ".concat(width, " ").concat(height)
    })
  };
  var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
    width: "".concat(width / height * 16 * 0.0625, "em")
  } : {};

  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }

  if (title) content.children.push({
    tag: 'title',
    attributes: {
      id: content.attributes['aria-labelledby'] || "title-".concat(titleId || nextUniqueId())
    },
    children: [title]
  });

  var args = _objectSpread({}, content, {
    prefix: prefix,
    iconName: iconName,
    main: main,
    mask: mask,
    maskId: maskId,
    transform: transform,
    symbol: symbol,
    styles: _objectSpread({}, uploadedIconWidthStyle, extra.styles)
  });

  var _ref2 = mask.found && main.found ? makeIconMasking(args) : makeIconStandard(args),
      children = _ref2.children,
      attributes = _ref2.attributes;

  args.children = children;
  args.attributes = attributes;

  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}

var noop$1 = function noop() {};

var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
};

/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */

var bindInternal4 = function bindInternal4(func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};

/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */


var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
      length = keys.length,
      iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
      i,
      key,
      result;

  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  } else {
    i = 0;
    result = initialValue;
  }

  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }

  return result;
};

function defineIcons(prefix, icons) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _params$skipHooks = params.skipHooks,
      skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
  var normalized = Object.keys(icons).reduce(function (acc, iconName) {
    var icon = icons[iconName];
    var expanded = !!icon.icon;

    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }

    return acc;
  }, {});

  if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
    namespace.hooks.addPack(prefix, normalized);
  } else {
    namespace.styles[prefix] = _objectSpread({}, namespace.styles[prefix] || {}, normalized);
  }
  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll easy the upgrade process for our users by automatically defining
   * this as well.
   */


  if (prefix === 'fas') {
    defineIcons('fa', icons);
  }
}

var styles = namespace.styles,
    shims = namespace.shims;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};
var build = function build() {
  var lookup = function lookup(reducer) {
    return reduce(styles, function (o, style, prefix) {
      o[prefix] = reduce(style, reducer, {});
      return o;
    }, {});
  };

  _byUnicode = lookup(function (acc, icon, iconName) {
    if (icon[3]) {
      acc[icon[3]] = iconName;
    }

    return acc;
  });
  _byLigature = lookup(function (acc, icon, iconName) {
    var ligatures = icon[2];
    acc[iconName] = iconName;
    ligatures.forEach(function (ligature) {
      acc[ligature] = iconName;
    });
    return acc;
  });
  var hasRegular = 'far' in styles;
  _byOldName = reduce(shims, function (acc, shim) {
    var oldName = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];

    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }

    acc[oldName] = {
      prefix: prefix,
      iconName: iconName
    };
    return acc;
  }, {});
};
build();

var styles$1 = namespace.styles;
function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix: prefix,
      iconName: iconName,
      icon: mapping[prefix][iconName]
    };
  }
}

function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
      _abstractNodes$attrib = abstractNodes.attributes,
      attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
      _abstractNodes$childr = abstractNodes.children,
      children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;

  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
  }
}

var parseTransformString = function parseTransformString(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };

  if (!transformString) {
    return transform;
  } else {
    return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
      var parts = n.toLowerCase().split('-');
      var first = parts[0];
      var rest = parts.slice(1).join('-');

      if (first && rest === 'h') {
        acc.flipX = true;
        return acc;
      }

      if (first && rest === 'v') {
        acc.flipY = true;
        return acc;
      }

      rest = parseFloat(rest);

      if (isNaN(rest)) {
        return acc;
      }

      switch (first) {
        case 'grow':
          acc.size = acc.size + rest;
          break;

        case 'shrink':
          acc.size = acc.size - rest;
          break;

        case 'left':
          acc.x = acc.x - rest;
          break;

        case 'right':
          acc.x = acc.x + rest;
          break;

        case 'up':
          acc.y = acc.y - rest;
          break;

        case 'down':
          acc.y = acc.y + rest;
          break;

        case 'rotate':
          acc.rotate = acc.rotate + rest;
          break;
      }

      return acc;
    }, transform);
  }
};

function MissingIcon(error) {
  this.name = 'MissingIcon';
  this.message = error || 'Icon unavailable';
  this.stack = new Error().stack;
}
MissingIcon.prototype = Object.create(Error.prototype);
MissingIcon.prototype.constructor = MissingIcon;

var FILL = {
  fill: 'currentColor'
};
var ANIMATION_BASE = {
  attributeType: 'XML',
  repeatCount: 'indefinite',
  dur: '2s'
};
var RING = {
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
  })
};

var OPACITY_ANIMATE = _objectSpread({}, ANIMATION_BASE, {
  attributeName: 'opacity'
});

var DOT = {
  tag: 'circle',
  attributes: _objectSpread({}, FILL, {
    cx: '256',
    cy: '364',
    r: '28'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, ANIMATION_BASE, {
      attributeName: 'r',
      values: '28;14;28;28;14;28;'
    })
  }, {
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '1;0;1;1;0;1;'
    })
  }]
};
var QUESTION = {
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    opacity: '1',
    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '1;0;0;0;0;1;'
    })
  }]
};
var EXCLAMATION = {
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    opacity: '0',
    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '0;0;1;1;0;0;'
    })
  }]
};

var styles$2 = namespace.styles;
function asFoundIcon(icon) {
  var width = icon[0];
  var height = icon[1];

  var _icon$slice = icon.slice(4),
      _icon$slice2 = _slicedToArray(_icon$slice, 1),
      vectorData = _icon$slice2[0];

  var element = null;

  if (Array.isArray(vectorData)) {
    element = {
      tag: 'g',
      attributes: {
        class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: 'path',
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: 'currentColor',
          d: vectorData[0]
        }
      }, {
        tag: 'path',
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: 'currentColor',
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: 'path',
      attributes: {
        fill: 'currentColor',
        d: vectorData
      }
    };
  }

  return {
    found: true,
    width: width,
    height: height,
    icon: element
  };
}

var styles$3 = namespace.styles;

var baseStyles = "svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}";

function css () {
  var dfp = DEFAULT_FAMILY_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.familyPrefix;
  var rc = config.replacementClass;
  var s = baseStyles;

  if (fp !== dfp || rc !== drc) {
    var dPatt = new RegExp("\\.".concat(dfp, "\\-"), 'g');
    var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), 'g');
    var rPatt = new RegExp("\\.".concat(drc), 'g');
    s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }

  return s;
}

var Library =
/*#__PURE__*/
function () {
  function Library() {
    _classCallCheck(this, Library);

    this.definitions = {};
  }

  _createClass(Library, [{
    key: "add",
    value: function add() {
      var _this = this;

      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }

      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _objectSpread({}, _this.definitions[key] || {}, additions[key]);
        defineIcons(key, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
            prefix = _normalized$key.prefix,
            iconName = _normalized$key.iconName,
            icon = _normalized$key.icon;
        if (!additions[prefix]) additions[prefix] = {};
        additions[prefix][iconName] = icon;
      });
      return additions;
    }
  }]);

  return Library;
}();

function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());

    _cssInserted = true;
  }
}

function apiObject(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });
  Object.defineProperty(val, 'html', {
    get: function get() {
      return val.abstract.map(function (a) {
        return toHtml(a);
      });
    }
  });
  Object.defineProperty(val, 'node', {
    get: function get() {
      if (!IS_DOM) return;
      var container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}

function findIconDefinition(iconLookup) {
  var _iconLookup$prefix = iconLookup.prefix,
      prefix = _iconLookup$prefix === void 0 ? 'fa' : _iconLookup$prefix,
      iconName = iconLookup.iconName;
  if (!iconName) return;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}

function resolveIcons(next) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;

    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }

    return next(iconDefinition, _objectSpread({}, params, {
      mask: mask
    }));
  };
}

var library = new Library();
var _cssInserted = false;
var parse = {
  transform: function transform(transformString) {
    return parseTransformString(transformString);
  }
};
var icon = resolveIcons(function (iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform = params.transform,
      transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
      _params$symbol = params.symbol,
      symbol = _params$symbol === void 0 ? false : _params$symbol,
      _params$mask = params.mask,
      mask = _params$mask === void 0 ? null : _params$mask,
      _params$maskId = params.maskId,
      maskId = _params$maskId === void 0 ? null : _params$maskId,
      _params$title = params.title,
      title = _params$title === void 0 ? null : _params$title,
      _params$titleId = params.titleId,
      titleId = _params$titleId === void 0 ? null : _params$titleId,
      _params$classes = params.classes,
      classes = _params$classes === void 0 ? [] : _params$classes,
      _params$attributes = params.attributes,
      attributes = _params$attributes === void 0 ? {} : _params$attributes,
      _params$styles = params.styles,
      styles = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition) return;
  var prefix = iconDefinition.prefix,
      iconName = iconDefinition.iconName,
      icon = iconDefinition.icon;
  return apiObject(_objectSpread({
    type: 'icon'
  }, iconDefinition), function () {
    ensureCss();

    if (config.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        attributes['aria-hidden'] = 'true';
        attributes['focusable'] = 'false';
      }
    }

    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix: prefix,
      iconName: iconName,
      transform: _objectSpread({}, meaninglessTransform, transform),
      symbol: symbol,
      title: title,
      maskId: maskId,
      titleId: titleId,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: classes
      }
    });
  });
});

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// Get CSS class list from a props object
function classList(props) {
  var _classes;

  var spin = props.spin,
      pulse = props.pulse,
      fixedWidth = props.fixedWidth,
      inverse = props.inverse,
      border = props.border,
      listItem = props.listItem,
      flip = props.flip,
      size = props.size,
      rotation = props.rotation,
      pull = props.pull; // map of CSS class names to properties

  var classes = (_classes = {
    'fa-spin': spin,
    'fa-pulse': pulse,
    'fa-fw': fixedWidth,
    'fa-inverse': inverse,
    'fa-border': border,
    'fa-li': listItem,
    'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
    'fa-flip-vertical': flip === 'vertical' || flip === 'both'
  }, _defineProperty$1(_classes, "fa-".concat(size), typeof size !== 'undefined' && size !== null), _defineProperty$1(_classes, "fa-rotate-".concat(rotation), typeof rotation !== 'undefined' && rotation !== null && rotation !== 0), _defineProperty$1(_classes, "fa-pull-".concat(pull), typeof pull !== 'undefined' && pull !== null), _defineProperty$1(_classes, 'fa-swap-opacity', props.swapOpacity), _classes); // map over all the keys in the classes object
  // return an array of the keys where the value for the key is not null

  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
}

// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function _isNumerical(obj) {
  obj = obj - 0; // eslint-disable-next-line no-self-compare

  return obj === obj;
}

function camelize(string) {
  if (_isNumerical(string)) {
    return string;
  } // eslint-disable-next-line no-useless-escape


  string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
    return chr ? chr.toUpperCase() : '';
  }); // Ensure 1st char is always lowercase

  return string.substr(0, 1).toLowerCase() + string.substr(1);
}

function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}

function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(':');
    var prop = camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();
    prop.startsWith('webkit') ? acc[capitalize(prop)] = value : acc[prop] = value;
    return acc;
  }, {});
}

function convert(createElement, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (typeof element === 'string') {
    return element;
  }

  var children = (element.children || []).map(function (child) {
    return convert(createElement, child);
  });
  /* eslint-disable dot-notation */

  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];

    switch (key) {
      case 'class':
        acc.attrs['className'] = val;
        delete element.attributes['class'];
        break;

      case 'style':
        acc.attrs['style'] = styleToObject(val);
        break;

      default:
        if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[camelize(key)] = val;
        }

    }

    return acc;
  }, {
    attrs: {}
  });

  var _extraProps$style = extraProps.style,
      existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style,
      remaining = _objectWithoutProperties(extraProps, ["style"]);

  mixins.attrs['style'] = _objectSpread2({}, mixins.attrs['style'], {}, existingStyle);
  /* eslint-enable */

  return createElement.apply(void 0, [element.tag, _objectSpread2({}, mixins.attrs, {}, remaining)].concat(_toConsumableArray(children)));
}

var PRODUCTION$1 = false;

try {
  PRODUCTION$1 = "production" === 'production';
} catch (e) {}

function log () {
  if (!PRODUCTION$1 && console && typeof console.error === 'function') {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
}

function normalizeIconArgs(icon) {
  if (parse.icon) {
    return parse.icon(icon);
  } // if the icon is null, there's nothing to do


  if (icon === null) {
    return null;
  } // if the icon is an object and has a prefix and an icon name, return it


  if (_typeof(icon) === 'object' && icon.prefix && icon.iconName) {
    return icon;
  } // if it's an array with length of two


  if (Array.isArray(icon) && icon.length === 2) {
    // use the first item as prefix, second as icon name
    return {
      prefix: icon[0],
      iconName: icon[1]
    };
  } // if it's a string, use it as the icon name


  if (typeof icon === 'string') {
    return {
      prefix: 'fas',
      iconName: icon
    };
  }
}

// creates an object with a key of key
// and a value of value
// if certain conditions are met
function objectWithKey(key, value) {
  // if the value is a non-empty array
  // or it's not an array but it is truthy
  // then create the object with the key and the value
  // if not, return an empty array
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty$1({}, key, value) : {};
}

function FontAwesomeIcon(_ref) {
  var forwardedRef = _ref.forwardedRef,
      props = _objectWithoutProperties(_ref, ["forwardedRef"]);

  var iconArgs = props.icon,
      maskArgs = props.mask,
      symbol = props.symbol,
      className = props.className,
      title = props.title,
      titleId = props.titleId;
  var iconLookup = normalizeIconArgs(iconArgs);
  var classes = objectWithKey('classes', [].concat(_toConsumableArray(classList(props)), _toConsumableArray(className.split(' '))));
  var transform = objectWithKey('transform', typeof props.transform === 'string' ? parse.transform(props.transform) : props.transform);
  var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
  var renderedIcon = icon(iconLookup, _objectSpread2({}, classes, {}, transform, {}, mask, {
    symbol: symbol,
    title: title,
    titleId: titleId
  }));

  if (!renderedIcon) {
    log('Could not find icon', iconLookup);
    return null;
  }

  var abstract = renderedIcon.abstract;
  var extraProps = {
    ref: forwardedRef
  };
  Object.keys(props).forEach(function (key) {
    // eslint-disable-next-line no-prototype-builtins
    if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
      extraProps[key] = props[key];
    }
  });
  return convertCurry(abstract[0], extraProps);
}
FontAwesomeIcon.displayName = 'FontAwesomeIcon';
FontAwesomeIcon.propTypes = {
  border: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  mask: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  fixedWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inverse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  flip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['horizontal', 'vertical', 'both']),
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  listItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  pull: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['right', 'left']),
  pulse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  rotation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([0, 90, 180, 270]),
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['lg', 'xs', 'sm', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
  spin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  symbol: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  transform: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  swapOpacity: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
FontAwesomeIcon.defaultProps = {
  border: false,
  className: '',
  mask: null,
  fixedWidth: false,
  inverse: false,
  flip: null,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  rotation: null,
  size: null,
  spin: false,
  symbol: false,
  title: '',
  transform: null,
  swapOpacity: false
};
var convertCurry = convert.bind(null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement);

function hash(str) {
  var hash = 5381,
      i    = str.length;

  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }

  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */
  return hash >>> 0;
}

var stringHash = hash;

var domain; // The domain module is executed on demand
var hasSetImmediate = typeof setImmediate === "function";

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including network IO events in Node.js.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
var raw = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Avoids a function call
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory excaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

rawAsap.requestFlush = requestFlush;
function requestFlush() {
    // Ensure flushing is not bound to any domain.
    // It is not sufficient to exit the domain, because domains exist on a stack.
    // To execute code outside of any domain, the following dance is necessary.
    var parentDomain = process.domain;
    if (parentDomain) {
        if (!domain) {
            // Lazy execute the domain module.
            // Only employed if the user elects to use domains.
            domain = __WEBPACK_IMPORTED_MODULE_2_domain___default.a;
        }
        domain.active = process.domain = null;
    }

    // `setImmediate` is slower that `process.nextTick`, but `process.nextTick`
    // cannot handle recursion.
    // `requestFlush` will only be called recursively from `asap.js`, to resume
    // flushing after an error is thrown into a domain.
    // Conveniently, `setImmediate` was introduced in the same version
    // `process.nextTick` started throwing recursion errors.
    if (flushing && hasSetImmediate) {
        setImmediate(flush);
    } else {
        process.nextTick(flush);
    }

    if (parentDomain) {
        domain.active = process.domain = parentDomain;
    }
}

var freeTasks = [];

/**
 * Calls a task as soon as possible after returning, in its own event, with
 * priority over IO events. An exception thrown in a task can be handled by
 * `process.on("uncaughtException") or `domain.on("error")`, but will otherwise
 * crash the process. If the error is handled, all subsequent tasks will
 * resume.
 *
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
var asap_1 = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawTask.domain = process.domain;
    raw(rawTask);
}

function RawTask() {
    this.task = null;
    this.domain = null;
}

RawTask.prototype.call = function () {
    if (this.domain) {
        this.domain.enter();
    }
    var threw = true;
    try {
        this.task.call();
        threw = false;
        // If the task throws an exception (presumably) Node.js restores the
        // domain stack for the next event.
        if (this.domain) {
            this.domain.exit();
        }
    } finally {
        // We use try/finally and a threw flag to avoid messing up stack traces
        // when we catch and release errors.
        if (threw) {
            // In Node.js, uncaught exceptions are considered fatal errors.
            // Re-throw them to interrupt flushing!
            // Ensure that flushing continues if an uncaught exception is
            // suppressed listening process.on("uncaughtException") or
            // domain.on("error").
            raw.requestFlush();
        }
        // If the task threw an error, we do not want to exit the domain here.
        // Exiting the domain would prevent the domain from catching the error.
        this.task = null;
        this.domain = null;
        freeTasks.push(this);
    }
};

function _typeof$1(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof$1 = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$1(obj);
}

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty$2(target, key, source[key]);
    });
  }

  return target;
}

function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _nonIterableSpread$1();
}

function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray$1(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

/* @flow */
/* ::
type ObjectMap = { [id:string]: any };
*/

var UPPERCASE_RE = /([A-Z])/g;

var UPPERCASE_RE_TO_KEBAB = function UPPERCASE_RE_TO_KEBAB(match
/* : string */
) {
  return (
    /* : string */
    "-".concat(match.toLowerCase())
  );
};

var kebabifyStyleName = function kebabifyStyleName(string
/* : string */
)
/* : string */
{
  var result = string.replace(UPPERCASE_RE, UPPERCASE_RE_TO_KEBAB);

  if (result[0] === 'm' && result[1] === 's' && result[2] === '-') {
    return "-".concat(result);
  }

  return result;
};
/**
 * CSS properties which accept numbers but are not in units of "px".
 * Taken from React's CSSProperty.js
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};
/**
 * Taken from React's CSSProperty.js
 *
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */

function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}
/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 * Taken from React's CSSProperty.js
 */


var prefixes = ['Webkit', 'ms', 'Moz', 'O']; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
// Taken from React's CSSProperty.js

Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});
var stringifyValue = function stringifyValue(key
/* : string */
, prop
/* : any */
)
/* : string */
{
  if (typeof prop === "number") {
    if (isUnitlessNumber[key]) {
      return "" + prop;
    } else {
      return prop + "px";
    }
  } else {
    return '' + prop;
  }
};
var stringifyAndImportantifyValue = function stringifyAndImportantifyValue(key
/* : string */
, prop
/* : any */
) {
  return (
    /* : string */
    importantify(stringifyValue(key, prop))
  );
}; // Turn a string into a hash string of base-36 values (using letters and numbers)
// eslint-disable-next-line no-unused-vars

var hashString = function hashString(string
/* : string */
, key
/* : ?string */
) {
  return (
    /* string */
    stringHash(string).toString(36)
  );
}; // Hash a javascript object using JSON.stringify. This is very fast, about 3
// microseconds on my computer for a sample object:
// http://jsperf.com/test-hashfnv32a-hash/5
//
// Note that this uses JSON.stringify to stringify the objects so in order for
// this to produce consistent hashes browsers need to have a consistent
// ordering of objects. Ben Alpert says that Facebook depends on this, so we
// can probably depend on this too.

var hashObject = function hashObject(object
/* : ObjectMap */
) {
  return (
    /* : string */
    hashString(JSON.stringify(object))
  );
}; // Given a single style value string like the "b" from "a: b;", adds !important
// to generate "b !important".

var importantify = function importantify(string
/* : string */
) {
  return (
    /* : string */
    // Bracket string character access is very fast, and in the default case we
    // normally don't expect there to be "!important" at the end of the string
    // so we can use this simple check to take an optimized path. If there
    // happens to be a "!" in this position, we follow up with a more thorough
    // check.
    string[string.length - 10] === '!' && string.slice(-11) === ' !important' ? string : "".concat(string, " !important")
  );
};

/* @flow */
var MAP_EXISTS = typeof Map !== 'undefined';

var OrderedElements =
/*#__PURE__*/
function () {
  /* ::
  elements: {[string]: any};
  keyOrder: string[];
  */
  function OrderedElements() {
    this.elements = {};
    this.keyOrder = [];
  }

  var _proto = OrderedElements.prototype;

  _proto.forEach = function forEach(callback
  /* : (string, any) => void */
  ) {
    for (var i = 0; i < this.keyOrder.length; i++) {
      // (value, key) to match Map's API
      callback(this.elements[this.keyOrder[i]], this.keyOrder[i]);
    }
  };

  _proto.set = function set(key
  /* : string */
  , value
  /* : any */
  , shouldReorder
  /* : ?boolean */
  ) {
    if (!this.elements.hasOwnProperty(key)) {
      this.keyOrder.push(key);
    } else if (shouldReorder) {
      var index = this.keyOrder.indexOf(key);
      this.keyOrder.splice(index, 1);
      this.keyOrder.push(key);
    }

    if (value == null) {
      this.elements[key] = value;
      return;
    }

    if (MAP_EXISTS && value instanceof Map || value instanceof OrderedElements) {
      // We have found a nested Map, so we need to recurse so that all
      // of the nested objects and Maps are merged properly.
      var nested = this.elements.hasOwnProperty(key) ? this.elements[key] : new OrderedElements();
      value.forEach(function (value, key) {
        nested.set(key, value, shouldReorder);
      });
      this.elements[key] = nested;
      return;
    }

    if (!Array.isArray(value) && _typeof$1(value) === 'object') {
      // We have found a nested object, so we need to recurse so that all
      // of the nested objects and Maps are merged properly.
      var _nested = this.elements.hasOwnProperty(key) ? this.elements[key] : new OrderedElements();

      var keys = Object.keys(value);

      for (var i = 0; i < keys.length; i += 1) {
        _nested.set(keys[i], value[keys[i]], shouldReorder);
      }

      this.elements[key] = _nested;
      return;
    }

    this.elements[key] = value;
  };

  _proto.get = function get(key
  /* : string */
  )
  /* : any */
  {
    return this.elements[key];
  };

  _proto.has = function has(key
  /* : string */
  )
  /* : boolean */
  {
    return this.elements.hasOwnProperty(key);
  };

  _proto.addStyleType = function addStyleType(styleType
  /* : any */
  )
  /* : void */
  {
    var _this = this;

    if (MAP_EXISTS && styleType instanceof Map || styleType instanceof OrderedElements) {
      styleType.forEach(function (value, key) {
        _this.set(key, value, true);
      });
    } else {
      var keys = Object.keys(styleType);

      for (var i = 0; i < keys.length; i++) {
        this.set(keys[i], styleType[keys[i]], true);
      }
    }
  };

  return OrderedElements;
}();

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x.default : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n.default || n;
}

var capitalizeString_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
});

unwrapExports(capitalizeString_1);

var prefixProperty_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixProperty;



var _capitalizeString2 = _interopRequireDefault(capitalizeString_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var newStyle = {};
    var requiredPrefixes = prefixProperties[property];
    var capitalizedProperty = (0, _capitalizeString2.default)(property);
    var keys = Object.keys(style);
    for (var i = 0; i < keys.length; i++) {
      var styleProperty = keys[i];
      if (styleProperty === property) {
        for (var j = 0; j < requiredPrefixes.length; j++) {
          newStyle[requiredPrefixes[j] + capitalizedProperty] = style[property];
        }
      }
      newStyle[styleProperty] = style[styleProperty];
    }
    return newStyle;
  }
  return style;
}
});

unwrapExports(prefixProperty_1);

var prefixValue_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixValue;
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}
});

unwrapExports(prefixValue_1);

var addNewValuesOnly_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addNewValuesOnly;
function addIfNew(list, value) {
  if (list.indexOf(value) === -1) {
    list.push(value);
  }
}

function addNewValuesOnly(list, values) {
  if (Array.isArray(values)) {
    for (var i = 0, len = values.length; i < len; ++i) {
      addIfNew(list, values[i]);
    }
  } else {
    addIfNew(list, values);
  }
}
});

unwrapExports(addNewValuesOnly_1);

var isObject_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObject;
function isObject(value) {
  return value instanceof Object && !Array.isArray(value);
}
});

unwrapExports(isObject_1);

var createPrefixer_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPrefixer;



var _prefixProperty2 = _interopRequireDefault(prefixProperty_1);



var _prefixValue2 = _interopRequireDefault(prefixValue_1);



var _addNewValuesOnly2 = _interopRequireDefault(addNewValuesOnly_1);



var _isObject2 = _interopRequireDefault(isObject_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;

  return function prefix(style) {
    for (var property in style) {
      var value = style[property];

      // handle nested objects
      if ((0, _isObject2.default)(value)) {
        style[property] = prefix(value);
        // handle array values
      } else if (Array.isArray(value)) {
        var combinedValue = [];

        for (var i = 0, len = value.length; i < len; ++i) {
          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
        }

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (combinedValue.length > 0) {
          style[property] = combinedValue;
        }
      } else {
        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (_processedValue) {
          style[property] = _processedValue;
        }

        style = (0, _prefixProperty2.default)(prefixMap, property, style);
      }
    }

    return style;
  };
}
});

var createPrefixer = unwrapExports(createPrefixer_1);

var backgroundClip_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = backgroundClip;

// https://developer.mozilla.org/en-US/docs/Web/CSS/background-clip#Browser_compatibility
function backgroundClip(property, value) {
  if (typeof value === 'string' && value === 'text') {
    return ['-webkit-text', 'text'];
  }
}
});

var backgroundClip = unwrapExports(backgroundClip_1);

var isPrefixedValue_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];
});

unwrapExports(isPrefixedValue_1);

var calc_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];
function calc(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/calc\(/g, prefix + 'calc(');
    });
  }
}
});

var calc = unwrapExports(calc_1);

var crossFade_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = crossFade;



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#search=cross-fade
var prefixes = ['-webkit-', ''];
function crossFade(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
    });
  }
}
});

var crossFade = unwrapExports(crossFade_1);

var cursor_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursor;
var prefixes = ['-webkit-', '-moz-', ''];

var values = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
});

var cursor = unwrapExports(cursor_1);

var filter_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filter;



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-filter-function
var prefixes = ['-webkit-', ''];
function filter(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/filter\(/g, prefix + 'filter(');
    });
  }
}
});

var filter = unwrapExports(filter_1);

var flex_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && values.hasOwnProperty(value)) {
    return values[value];
  }
}
});

var flex = unwrapExports(flex_1);

var flexboxIE_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;
var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msFlexPreferredSize'
  // Full expanded syntax is flex-grow | flex-shrink | flex-basis.
};var flexShorthandMappings = {
  auto: '1 1 auto',
  inherit: 'inherit',
  initial: '0 1 auto',
  none: '0 0 auto',
  unset: 'unset'
};
var isUnitlessNumber = /^\d+(\.\d+)?$/;

function flexboxIE(property, value, style) {
  if (Object.prototype.hasOwnProperty.call(alternativeProps, property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
  if (property === 'flex') {
    // For certain values we can do straight mappings based on the spec
    // for the expansions.
    if (Object.prototype.hasOwnProperty.call(flexShorthandMappings, value)) {
      style.msFlex = flexShorthandMappings[value];
      return;
    }
    // Here we have no direct mapping, so we favor looking for a
    // unitless positive number as that will be the most common use-case.
    if (isUnitlessNumber.test(value)) {
      style.msFlex = value + ' 1 0%';
      return;
    }

    // The next thing we can look for is if there are multiple values.
    var flexValues = value.split(/\s/);
    // If we only have a single value that wasn't a positive unitless
    // or a pre-mapped value, then we can assume it is a unit value.
    switch (flexValues.length) {
      case 1:
        style.msFlex = '1 1 ' + value;
        return;
      case 2:
        // If we have 2 units, then we expect that the first will
        // always be a unitless number and represents flex-grow.
        // The second unit will represent flex-shrink for a unitless
        // value, or flex-basis otherwise.
        if (isUnitlessNumber.test(flexValues[1])) {
          style.msFlex = flexValues[0] + ' ' + flexValues[1] + ' 0%';
        } else {
          style.msFlex = flexValues[0] + ' 1 ' + flexValues[1];
        }
        return;
      default:
        style.msFlex = value;
    }
  }
}
});

var flexboxIE = unwrapExports(flexboxIE_1);

var flexboxOld_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines',
  flexGrow: 'WebkitBoxFlex'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
});

var flexboxOld = unwrapExports(flexboxOld_1);

var gradient_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/gi;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
    return prefixes.map(function (prefix) {
      return value.replace(values, function (grad) {
        return prefix + grad;
      });
    });
  }
}
});

var gradient = unwrapExports(gradient_1);

var grid_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = grid;
function isSimplePositionValue(value) {
  return typeof value === 'number' && !isNaN(value);
}

var alignmentValues = ['center', 'end', 'start', 'stretch'];

var displayValues = {
  'inline-grid': ['-ms-inline-grid', 'inline-grid'],
  grid: ['-ms-grid', 'grid']
};

var propertyConverters = {
  alignSelf: function alignSelf(value, style) {
    if (alignmentValues.indexOf(value) > -1) {
      style.msGridRowAlign = value;
    }
  },

  gridColumn: function gridColumn(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridColumn = value;
    } else {
      var _value$split$map = value.split('/').map(function (position) {
        return +position;
      }),
          _value$split$map2 = _slicedToArray(_value$split$map, 2),
          start = _value$split$map2[0],
          end = _value$split$map2[1];

      propertyConverters.gridColumnStart(start, style);
      propertyConverters.gridColumnEnd(end, style);
    }
  },

  gridColumnEnd: function gridColumnEnd(value, style) {
    var msGridColumn = style.msGridColumn;

    if (isSimplePositionValue(value) && isSimplePositionValue(msGridColumn)) {
      style.msGridColumnSpan = value - msGridColumn;
    }
  },

  gridColumnStart: function gridColumnStart(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridColumn = value;
    }
  },

  gridRow: function gridRow(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridRow = value;
    } else {
      var _value$split$map3 = value.split('/').map(function (position) {
        return +position;
      }),
          _value$split$map4 = _slicedToArray(_value$split$map3, 2),
          start = _value$split$map4[0],
          end = _value$split$map4[1];

      propertyConverters.gridRowStart(start, style);
      propertyConverters.gridRowEnd(end, style);
    }
  },

  gridRowEnd: function gridRowEnd(value, style) {
    var msGridRow = style.msGridRow;

    if (isSimplePositionValue(value) && isSimplePositionValue(msGridRow)) {
      style.msGridRowSpan = value - msGridRow;
    }
  },

  gridRowStart: function gridRowStart(value, style) {
    if (isSimplePositionValue(value)) {
      style.msGridRow = value;
    }
  },

  gridTemplateColumns: function gridTemplateColumns(value, style) {
    style.msGridColumns = value;
  },

  gridTemplateRows: function gridTemplateRows(value, style) {
    style.msGridRows = value;
  },

  justifySelf: function justifySelf(value, style) {
    if (alignmentValues.indexOf(value) > -1) {
      style.msGridColumnAlign = value;
    }
  }
};

function grid(property, value, style) {
  if (property === 'display' && value in displayValues) {
    return displayValues[value];
  }

  if (property in propertyConverters) {
    var propertyConverter = propertyConverters[property];
    propertyConverter(value, style);
  }
}
});

var grid = unwrapExports(grid_1);

var imageSet_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = imageSet;



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-image-set
var prefixes = ['-webkit-', ''];
function imageSet(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/image-set\(/g, prefix + 'image-set(');
    });
  }
}
});

var imageSet = unwrapExports(imageSet_1);

var logical_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = logical;
var alternativeProps = {
  marginBlockStart: ['WebkitMarginBefore'],
  marginBlockEnd: ['WebkitMarginAfter'],
  marginInlineStart: ['WebkitMarginStart', 'MozMarginStart'],
  marginInlineEnd: ['WebkitMarginEnd', 'MozMarginEnd'],
  paddingBlockStart: ['WebkitPaddingBefore'],
  paddingBlockEnd: ['WebkitPaddingAfter'],
  paddingInlineStart: ['WebkitPaddingStart', 'MozPaddingStart'],
  paddingInlineEnd: ['WebkitPaddingEnd', 'MozPaddingEnd'],
  borderBlockStart: ['WebkitBorderBefore'],
  borderBlockStartColor: ['WebkitBorderBeforeColor'],
  borderBlockStartStyle: ['WebkitBorderBeforeStyle'],
  borderBlockStartWidth: ['WebkitBorderBeforeWidth'],
  borderBlockEnd: ['WebkitBorderAfter'],
  borderBlockEndColor: ['WebkitBorderAfterColor'],
  borderBlockEndStyle: ['WebkitBorderAfterStyle'],
  borderBlockEndWidth: ['WebkitBorderAfterWidth'],
  borderInlineStart: ['WebkitBorderStart', 'MozBorderStart'],
  borderInlineStartColor: ['WebkitBorderStartColor', 'MozBorderStartColor'],
  borderInlineStartStyle: ['WebkitBorderStartStyle', 'MozBorderStartStyle'],
  borderInlineStartWidth: ['WebkitBorderStartWidth', 'MozBorderStartWidth'],
  borderInlineEnd: ['WebkitBorderEnd', 'MozBorderEnd'],
  borderInlineEndColor: ['WebkitBorderEndColor', 'MozBorderEndColor'],
  borderInlineEndStyle: ['WebkitBorderEndStyle', 'MozBorderEndStyle'],
  borderInlineEndWidth: ['WebkitBorderEndWidth', 'MozBorderEndWidth']
};

function logical(property, value, style) {
  if (Object.prototype.hasOwnProperty.call(alternativeProps, property)) {
    var alternativePropList = alternativeProps[property];
    for (var i = 0, len = alternativePropList.length; i < len; ++i) {
      style[alternativePropList[i]] = value;
    }
  }
}
});

var logical = unwrapExports(logical_1);

var position_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;
function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return ['-webkit-sticky', 'sticky'];
  }
}
});

var position = unwrapExports(position_1);

var sizing_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;
var prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
});

var sizing = unwrapExports(sizing_1);

/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower);
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

var hyphenateStyleName$1 = /*#__PURE__*/Object.freeze({
  default: hyphenateStyleName
});

var _hyphenateStyleName = getCjsExportFromNamespace(hyphenateStyleName$1);

var hyphenateProperty_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;



var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];
});

unwrapExports(hyphenateProperty_1);

var transition_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;



var _hyphenateProperty2 = _interopRequireDefault(hyphenateProperty_1);



var _isPrefixedValue2 = _interopRequireDefault(isPrefixedValue_1);



var _capitalizeString2 = _interopRequireDefault(capitalizeString_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function prefixValue(value, propertyPrefixMap) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
    return outputValue;
  }
}
});

var transition = unwrapExports(transition_1);

var w$1 = ["Webkit"];
var m = ["Moz"];
var ms = ["ms"];
var wm = ["Webkit", "Moz"];
var wms = ["Webkit", "ms"];
var wmms = ["Webkit", "Moz", "ms"];
var staticData = {
  plugins: [backgroundClip, calc, crossFade, cursor, filter, flex, flexboxIE, flexboxOld, gradient, grid, imageSet, logical, position, sizing, transition],
  prefixMap: {
    "transform": wms,
    "transformOrigin": wms,
    "transformOriginX": wms,
    "transformOriginY": wms,
    "backfaceVisibility": w$1,
    "perspective": w$1,
    "perspectiveOrigin": w$1,
    "transformStyle": w$1,
    "transformOriginZ": w$1,
    "animation": w$1,
    "animationDelay": w$1,
    "animationDirection": w$1,
    "animationFillMode": w$1,
    "animationDuration": w$1,
    "animationIterationCount": w$1,
    "animationName": w$1,
    "animationPlayState": w$1,
    "animationTimingFunction": w$1,
    "appearance": wm,
    "userSelect": wmms,
    "fontKerning": w$1,
    "textEmphasisPosition": w$1,
    "textEmphasis": w$1,
    "textEmphasisStyle": w$1,
    "textEmphasisColor": w$1,
    "boxDecorationBreak": w$1,
    "clipPath": w$1,
    "maskImage": w$1,
    "maskMode": w$1,
    "maskRepeat": w$1,
    "maskPosition": w$1,
    "maskClip": w$1,
    "maskOrigin": w$1,
    "maskSize": w$1,
    "maskComposite": w$1,
    "mask": w$1,
    "maskBorderSource": w$1,
    "maskBorderMode": w$1,
    "maskBorderSlice": w$1,
    "maskBorderWidth": w$1,
    "maskBorderOutset": w$1,
    "maskBorderRepeat": w$1,
    "maskBorder": w$1,
    "maskType": w$1,
    "textDecorationStyle": wm,
    "textDecorationSkip": wm,
    "textDecorationLine": wm,
    "textDecorationColor": wm,
    "filter": w$1,
    "fontFeatureSettings": wm,
    "breakAfter": wmms,
    "breakBefore": wmms,
    "breakInside": wmms,
    "columnCount": wm,
    "columnFill": wm,
    "columnGap": wm,
    "columnRule": wm,
    "columnRuleColor": wm,
    "columnRuleStyle": wm,
    "columnRuleWidth": wm,
    "columns": wm,
    "columnSpan": wm,
    "columnWidth": wm,
    "writingMode": wms,
    "flex": wms,
    "flexBasis": w$1,
    "flexDirection": wms,
    "flexGrow": w$1,
    "flexFlow": wms,
    "flexShrink": w$1,
    "flexWrap": wms,
    "alignContent": w$1,
    "alignItems": w$1,
    "alignSelf": w$1,
    "justifyContent": w$1,
    "order": w$1,
    "transitionDelay": w$1,
    "transitionDuration": w$1,
    "transitionProperty": w$1,
    "transitionTimingFunction": w$1,
    "backdropFilter": w$1,
    "scrollSnapType": wms,
    "scrollSnapPointsX": wms,
    "scrollSnapPointsY": wms,
    "scrollSnapDestination": wms,
    "scrollSnapCoordinate": wms,
    "shapeImageThreshold": w$1,
    "shapeImageMargin": w$1,
    "shapeImageOutside": w$1,
    "hyphens": wmms,
    "flowInto": wms,
    "flowFrom": wms,
    "regionFragment": wms,
    "textOrientation": w$1,
    "boxSizing": m,
    "textAlignLast": m,
    "tabSize": m,
    "wrapFlow": ms,
    "wrapThrough": ms,
    "wrapMargin": ms,
    "touchAction": ms,
    "textSizeAdjust": wms,
    "borderImage": w$1,
    "borderImageOutset": w$1,
    "borderImageRepeat": w$1,
    "borderImageSlice": w$1,
    "borderImageSource": w$1,
    "borderImageWidth": w$1
  }
};

var prefixAll = createPrefixer(staticData);
/* ::
import type { SheetDefinition } from './index.js';
type StringHandlers = { [id:string]: Function };
type SelectorCallback = (selector: string) => string[];
export type SelectorHandler = (
    selector: string,
    baseSelector: string,
    callback: SelectorCallback
) => string[] | string | null;
*/

/**
 * `selectorHandlers` are functions which handle special selectors which act
 * differently than normal style definitions. These functions look at the
 * current selector and can generate CSS for the styles in their subtree by
 * calling the callback with a new selector.
 *
 * For example, when generating styles with a base selector of '.foo' and the
 * following styles object:
 *
 *   {
 *     ':nth-child(2n)': {
 *       ':hover': {
 *         color: 'red'
 *       }
 *     }
 *   }
 *
 * when we reach the ':hover' style, we would call our selector handlers like
 *
 *   handler(':hover', '.foo:nth-child(2n)', callback)
 *
 * Since our `pseudoSelectors` handles ':hover' styles, that handler would call
 * the callback like
 *
 *   callback('.foo:nth-child(2n):hover')
 *
 * to generate its subtree `{ color: 'red' }` styles with a
 * '.foo:nth-child(2n):hover' selector. The callback would return an array of CSS
 * rules like
 *
 *   ['.foo:nth-child(2n):hover{color:red !important;}']
 *
 * and the handler would then return that resulting CSS.
 *
 * `defaultSelectorHandlers` is the list of default handlers used in a call to
 * `generateCSS`.
 *
 * @name SelectorHandler
 * @function
 * @param {string} selector: The currently inspected selector. ':hover' in the
 *     example above.
 * @param {string} baseSelector: The selector of the parent styles.
 *     '.foo:nth-child(2n)' in the example above.
 * @param {function} generateSubtreeStyles: A function which can be called to
 *     generate CSS for the subtree of styles corresponding to the selector.
 *     Accepts a new baseSelector to use for generating those styles.
 * @returns {string[] | string | null} The generated CSS for this selector, or
 *     null if we don't handle this selector.
 */

var defaultSelectorHandlers
/* : SelectorHandler[] */
= [// Handle pseudo-selectors, like :hover and :nth-child(3n)
function pseudoSelectors(selector, baseSelector, generateSubtreeStyles) {
  if (selector[0] !== ":") {
    return null;
  }

  return generateSubtreeStyles(baseSelector + selector);
}, // Handle media queries (or font-faces)
function mediaQueries(selector, baseSelector, generateSubtreeStyles) {
  if (selector[0] !== "@") {
    return null;
  } // Generate the styles normally, and then wrap them in the media query.


  var generated = generateSubtreeStyles(baseSelector);
  return ["".concat(selector, "{").concat(generated.join(''), "}")];
}];
/**
 * Generate CSS for a selector and some styles.
 *
 * This function handles the media queries and pseudo selectors that can be used
 * in aphrodite styles.
 *
 * @param {string} selector: A base CSS selector for the styles to be generated
 *     with.
 * @param {Object} styleTypes: A list of properties of the return type of
 *     StyleSheet.create, e.g. [styles.red, styles.blue].
 * @param {Array.<SelectorHandler>} selectorHandlers: A list of selector
 *     handlers to use for handling special selectors. See
 *     `defaultSelectorHandlers`.
 * @param stringHandlers: See `generateCSSRuleset`
 * @param useImportant: See `generateCSSRuleset`
 *
 * To actually generate the CSS special-construct-less styles are passed to
 * `generateCSSRuleset`.
 *
 * For instance, a call to
 *
 *     generateCSS(".foo", [{
 *       color: "red",
 *       "@media screen": {
 *         height: 20,
 *         ":hover": {
 *           backgroundColor: "black"
 *         }
 *       },
 *       ":active": {
 *         fontWeight: "bold"
 *       }
 *     }], defaultSelectorHandlers);
 *
 * with the default `selectorHandlers` will make 5 calls to
 * `generateCSSRuleset`:
 *
 *     generateCSSRuleset(".foo", { color: "red" }, ...)
 *     generateCSSRuleset(".foo:active", { fontWeight: "bold" }, ...)
 *     // These 2 will be wrapped in @media screen {}
 *     generateCSSRuleset(".foo", { height: 20 }, ...)
 *     generateCSSRuleset(".foo:hover", { backgroundColor: "black" }, ...)
 */

var generateCSS = function generateCSS(selector
/* : string */
, styleTypes
/* : SheetDefinition[] */
, selectorHandlers
/* : SelectorHandler[] */
, stringHandlers
/* : StringHandlers */
, useImportant
/* : boolean */
)
/* : string[] */
{
  var merged = new OrderedElements();

  for (var i = 0; i < styleTypes.length; i++) {
    merged.addStyleType(styleTypes[i]);
  }

  var plainDeclarations = new OrderedElements();
  var generatedStyles = []; // TODO(emily): benchmark this to see if a plain for loop would be faster.

  merged.forEach(function (val, key) {
    // For each key, see if one of the selector handlers will handle these
    // styles.
    var foundHandler = selectorHandlers.some(function (handler) {
      var result = handler(key, selector, function (newSelector) {
        return generateCSS(newSelector, [val], selectorHandlers, stringHandlers, useImportant);
      });

      if (result != null) {
        // If the handler returned something, add it to the generated
        // CSS and stop looking for another handler.
        if (Array.isArray(result)) {
          generatedStyles.push.apply(generatedStyles, _toConsumableArray$1(result));
        } else {
          // eslint-disable-next-line
          console.warn('WARNING: Selector handlers should return an array of rules.' + 'Returning a string containing multiple rules is deprecated.', handler);
          generatedStyles.push("@media all {".concat(result, "}"));
        }

        return true;
      }
    }); // If none of the handlers handled it, add it to the list of plain
    // style declarations.

    if (!foundHandler) {
      plainDeclarations.set(key, val, true);
    }
  });
  var generatedRuleset = generateCSSRuleset(selector, plainDeclarations, stringHandlers, useImportant, selectorHandlers);

  if (generatedRuleset) {
    generatedStyles.unshift(generatedRuleset);
  }

  return generatedStyles;
};
/**
 * Helper method of generateCSSRuleset to facilitate custom handling of certain
 * CSS properties. Used for e.g. font families.
 *
 * See generateCSSRuleset for usage and documentation of paramater types.
 */

var runStringHandlers = function runStringHandlers(declarations
/* : OrderedElements */
, stringHandlers
/* : StringHandlers */
, selectorHandlers
/* : SelectorHandler[] */
)
/* : void */
{
  if (!stringHandlers) {
    return;
  }

  var stringHandlerKeys = Object.keys(stringHandlers);

  for (var i = 0; i < stringHandlerKeys.length; i++) {
    var key = stringHandlerKeys[i];

    if (declarations.has(key)) {
      // A declaration exists for this particular string handler, so we
      // need to let the string handler interpret the declaration first
      // before proceeding.
      //
      // TODO(emily): Pass in a callback which generates CSS, similar to
      // how our selector handlers work, instead of passing in
      // `selectorHandlers` and have them make calls to `generateCSS`
      // themselves. Right now, this is impractical because our string
      // handlers are very specialized and do complex things.
      declarations.set(key, stringHandlers[key](declarations.get(key), selectorHandlers), // Preserve order here, since we are really replacing an
      // unprocessed style with a processed style, not overriding an
      // earlier style
      false);
    }
  }
};

var transformRule = function transformRule(key
/* : string */
, value
/* : string */
, transformValue
/* : function */
) {
  return (
    /* : string */
    "".concat(kebabifyStyleName(key), ":").concat(transformValue(key, value), ";")
  );
};

var arrayToObjectKeysReducer = function arrayToObjectKeysReducer(acc, val) {
  acc[val] = true;
  return acc;
};
/**
 * Generate a CSS ruleset with the selector and containing the declarations.
 *
 * This function assumes that the given declarations don't contain any special
 * children (such as media queries, pseudo-selectors, or descendant styles).
 *
 * Note that this method does not deal with nesting used for e.g.
 * psuedo-selectors or media queries. That responsibility is left to  the
 * `generateCSS` function.
 *
 * @param {string} selector: the selector associated with the ruleset
 * @param {Object} declarations: a map from camelCased CSS property name to CSS
 *     property value.
 * @param {Object.<string, function>} stringHandlers: a map from camelCased CSS
 *     property name to a function which will map the given value to the value
 *     that is output.
 * @param {bool} useImportant: A boolean saying whether to append "!important"
 *     to each of the CSS declarations.
 * @returns {string} A string of raw CSS.
 *
 * Examples:
 *
 *    generateCSSRuleset(".blah", { color: "red" })
 *    -> ".blah{color: red !important;}"
 *    generateCSSRuleset(".blah", { color: "red" }, {}, false)
 *    -> ".blah{color: red}"
 *    generateCSSRuleset(".blah", { color: "red" }, {color: c => c.toUpperCase})
 *    -> ".blah{color: RED}"
 *    generateCSSRuleset(".blah:hover", { color: "red" })
 *    -> ".blah:hover{color: red}"
 */


var generateCSSRuleset = function generateCSSRuleset(selector
/* : string */
, declarations
/* : OrderedElements */
, stringHandlers
/* : StringHandlers */
, useImportant
/* : boolean */
, selectorHandlers
/* : SelectorHandler[] */
)
/* : string */
{
  // Mutates declarations
  runStringHandlers(declarations, stringHandlers, selectorHandlers);
  var originalElements = Object.keys(declarations.elements).reduce(arrayToObjectKeysReducer, Object.create(null)); // NOTE(emily): This mutates handledDeclarations.elements.

  var prefixedElements = prefixAll(declarations.elements);
  var elementNames = Object.keys(prefixedElements);

  if (elementNames.length !== declarations.keyOrder.length) {
    // There are some prefixed values, so we need to figure out how to sort
    // them.
    //
    // Loop through prefixedElements, looking for anything that is not in
    // sortOrder, which means it was added by prefixAll. This means that we
    // need to figure out where it should appear in the sortOrder.
    for (var i = 0; i < elementNames.length; i++) {
      if (!originalElements[elementNames[i]]) {
        // This element is not in the sortOrder, which means it is a prefixed
        // value that was added by prefixAll. Let's try to figure out where it
        // goes.
        var originalStyle = void 0;

        if (elementNames[i][0] === 'W') {
          // This is a Webkit-prefixed style, like "WebkitTransition". Let's
          // find its original style's sort order.
          originalStyle = elementNames[i][6].toLowerCase() + elementNames[i].slice(7);
        } else if (elementNames[i][1] === 'o') {
          // This is a Moz-prefixed style, like "MozTransition". We check
          // the second character to avoid colliding with Ms-prefixed
          // styles. Let's find its original style's sort order.
          originalStyle = elementNames[i][3].toLowerCase() + elementNames[i].slice(4);
        } else {
          // if (elementNames[i][1] === 's') {
          // This is a Ms-prefixed style, like "MsTransition".
          originalStyle = elementNames[i][2].toLowerCase() + elementNames[i].slice(3);
        }

        if (originalStyle && originalElements[originalStyle]) {
          var originalIndex = declarations.keyOrder.indexOf(originalStyle);
          declarations.keyOrder.splice(originalIndex, 0, elementNames[i]);
        } else {
          // We don't know what the original style was, so sort it to
          // top. This can happen for styles that are added that don't
          // have the same base name as the original style.
          declarations.keyOrder.unshift(elementNames[i]);
        }
      }
    }
  }

  var transformValue = useImportant === false ? stringifyValue : stringifyAndImportantifyValue;
  var rules = [];

  for (var _i = 0; _i < declarations.keyOrder.length; _i++) {
    var key = declarations.keyOrder[_i];
    var value = prefixedElements[key];

    if (Array.isArray(value)) {
      // inline-style-prefixer returns an array when there should be
      // multiple rules for the same key. Here we flatten to multiple
      // pairs with the same key.
      for (var j = 0; j < value.length; j++) {
        rules.push(transformRule(key, value[j], transformValue));
      }
    } else {
      rules.push(transformRule(key, value, transformValue));
    }
  }

  if (rules.length) {
    return "".concat(selector, "{").concat(rules.join(""), "}");
  } else {
    return "";
  }
};

/* ::
import type { SheetDefinition, SheetDefinitions } from './index.js';
import type { MaybeSheetDefinition } from './exports.js';
import type { SelectorHandler } from './generate.js';
*/
// The current <style> tag we are inserting into, or null if we haven't
// inserted anything yet. We could find this each time using
// `document.querySelector("style[data-aphrodite"])`, but holding onto it is
// faster.

var styleTag
/* : ?HTMLStyleElement */
= null; // Inject a set of rules into a <style> tag in the head of the document. This
// will automatically create a style tag and then continue to use it for
// multiple injections. It will also use a style tag with the `data-aphrodite`
// tag on it if that exists in the DOM. This could be used for e.g. reusing the
// same style tag that server-side rendering inserts.

var injectStyleTag = function injectStyleTag(cssRules
/* : string[] */
) {
  if (styleTag == null) {
    // Try to find a style tag with the `data-aphrodite` attribute first.
    styleTag = document.querySelector("style[data-aphrodite]")
    /* : any */
    ; // If that doesn't work, generate a new style tag.

    if (styleTag == null) {
      // Taken from
      // http://stackoverflow.com/questions/524696/how-to-create-a-style-tag-with-javascript
      var head = document.head || document.getElementsByTagName('head')[0];
      styleTag = document.createElement('style');
      styleTag.type = 'text/css';
      styleTag.setAttribute("data-aphrodite", "");
      head.appendChild(styleTag);
    }
  } // $FlowFixMe


  var sheet = styleTag.styleSheet || styleTag.sheet
  /* : any */
  ;

  if (sheet.insertRule) {
    var numRules = sheet.cssRules.length;
    cssRules.forEach(function (rule) {
      try {
        sheet.insertRule(rule, numRules);
        numRules += 1;
      } catch (e) {// The selector for this rule wasn't compatible with the browser
      }
    });
  } else {
    styleTag.innerText = (styleTag.innerText || '') + cssRules.join('');
  }
}; // Custom handlers for stringifying CSS values that have side effects
// (such as fontFamily, which can cause @font-face rules to be injected)


var stringHandlers = {
  // With fontFamily we look for objects that are passed in and interpret
  // them as @font-face rules that we need to inject. The value of fontFamily
  // can either be a string (as normal), an object (a single font face), or
  // an array of objects and strings.
  fontFamily: function fontFamily(val) {
    if (Array.isArray(val)) {
      var nameMap = {};
      val.forEach(function (v) {
        nameMap[fontFamily(v)] = true;
      });
      return Object.keys(nameMap).join(",");
    } else if (_typeof$1(val) === "object") {
      injectStyleOnce(val.src, "@font-face", [val], false);
      return "\"".concat(val.fontFamily, "\"");
    } else {
      return val;
    }
  },
  // With animationName we look for an object that contains keyframes and
  // inject them as an `@keyframes` block, returning a uniquely generated
  // name. The keyframes object should look like
  //  animationName: {
  //    from: {
  //      left: 0,
  //      top: 0,
  //    },
  //    '50%': {
  //      left: 15,
  //      top: 5,
  //    },
  //    to: {
  //      left: 20,
  //      top: 20,
  //    }
  //  }
  // TODO(emily): `stringHandlers` doesn't let us rename the key, so I have
  // to use `animationName` here. Improve that so we can call this
  // `animation` instead of `animationName`.
  animationName: function animationName(val, selectorHandlers) {
    if (Array.isArray(val)) {
      return val.map(function (v) {
        return animationName(v, selectorHandlers);
      }).join(",");
    } else if (_typeof$1(val) === "object") {
      // Generate a unique name based on the hash of the object. We can't
      // just use the hash because the name can't start with a number.
      // TODO(emily): this probably makes debugging hard, allow a custom
      // name?
      var name = "keyframe_".concat(hashObject(val)); // Since keyframes need 3 layers of nesting, we use `generateCSS` to
      // build the inner layers and wrap it in `@keyframes` ourselves.

      var finalVal = "@keyframes ".concat(name, "{"); // TODO see if we can find a way where checking for OrderedElements
      // here is not necessary. Alternatively, perhaps we should have a
      // utility method that can iterate over either a plain object, an
      // instance of OrderedElements, or a Map, and then use that here and
      // elsewhere.

      if (val instanceof OrderedElements) {
        val.forEach(function (valVal, valKey) {
          finalVal += generateCSS(valKey, [valVal], selectorHandlers, stringHandlers, false).join('');
        });
      } else {
        Object.keys(val).forEach(function (key) {
          finalVal += generateCSS(key, [val[key]], selectorHandlers, stringHandlers, false).join('');
        });
      }

      finalVal += '}';
      injectGeneratedCSSOnce(name, [finalVal]);
      return name;
    } else {
      return val;
    }
  }
}; // This is a map from Aphrodite's generated class names to `true` (acting as a
// set of class names)

var alreadyInjected = {}; // This is the buffer of styles which have not yet been flushed.

var injectionBuffer
/* : string[] */
= []; // A flag to tell if we are already buffering styles. This could happen either
// because we scheduled a flush call already, so newly added styles will
// already be flushed, or because we are statically buffering on the server.

var isBuffering = false;

var injectGeneratedCSSOnce = function injectGeneratedCSSOnce(key, generatedCSS) {
  var _injectionBuffer;

  if (alreadyInjected[key]) {
    return;
  }

  if (!isBuffering) {
    // We should never be automatically buffering on the server (or any
    // place without a document), so guard against that.
    if (typeof document === "undefined") {
      throw new Error("Cannot automatically buffer without a document");
    } // If we're not already buffering, schedule a call to flush the
    // current styles.


    isBuffering = true;
    asap_1(flushToStyleTag);
  }

  (_injectionBuffer = injectionBuffer).push.apply(_injectionBuffer, _toConsumableArray$1(generatedCSS));

  alreadyInjected[key] = true;
};

var injectStyleOnce = function injectStyleOnce(key
/* : string */
, selector
/* : string */
, definitions
/* : SheetDefinition[] */
, useImportant
/* : boolean */
) {
  var selectorHandlers
  /* : SelectorHandler[] */
  = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

  if (alreadyInjected[key]) {
    return;
  }

  var generated = generateCSS(selector, definitions, selectorHandlers, stringHandlers, useImportant);
  injectGeneratedCSSOnce(key, generated);
};
var reset = function reset() {
  injectionBuffer = [];
  alreadyInjected = {};
  isBuffering = false;
  styleTag = null;
};
var resetInjectedStyle = function resetInjectedStyle(key
/* : string */
) {
  delete alreadyInjected[key];
};
var getBufferedStyles = function getBufferedStyles() {
  return injectionBuffer;
};
var startBuffering = function startBuffering() {
  if (isBuffering) {
    throw new Error("Cannot buffer while already buffering");
  }

  isBuffering = true;
};

var flushToArray = function flushToArray() {
  isBuffering = false;
  var ret = injectionBuffer;
  injectionBuffer = [];
  return ret;
};

var flushToString = function flushToString() {
  return flushToArray().join('');
};
var flushToStyleTag = function flushToStyleTag() {
  var cssRules = flushToArray();

  if (cssRules.length > 0) {
    injectStyleTag(cssRules);
  }
};
var getRenderedClassNames = function getRenderedClassNames()
/* : string[] */
{
  return Object.keys(alreadyInjected);
};
var addRenderedClassNames = function addRenderedClassNames(classNames
/* : string[] */
) {
  classNames.forEach(function (className) {
    alreadyInjected[className] = true;
  });
};

var isValidStyleDefinition = function isValidStyleDefinition(def
/* : Object */
) {
  return "_definition" in def && "_name" in def && "_len" in def;
};

var processStyleDefinitions = function processStyleDefinitions(styleDefinitions
/* : any[] */
, classNameBits
/* : string[] */
, definitionBits
/* : Object[] */
, length
/* : number */
)
/* : number */
{
  for (var i = 0; i < styleDefinitions.length; i += 1) {
    // Filter out falsy values from the input, to allow for
    // `css(a, test && c)`
    if (styleDefinitions[i]) {
      if (Array.isArray(styleDefinitions[i])) {
        // We've encountered an array, so let's recurse
        length += processStyleDefinitions(styleDefinitions[i], classNameBits, definitionBits, length);
      } else if (isValidStyleDefinition(styleDefinitions[i])) {
        classNameBits.push(styleDefinitions[i]._name);
        definitionBits.push(styleDefinitions[i]._definition);
        length += styleDefinitions[i]._len;
      } else {
        throw new Error("Invalid Style Definition: Styles should be defined using the StyleSheet.create method.");
      }
    }
  }

  return length;
};
/**
 * Inject styles associated with the passed style definition objects, and return
 * an associated CSS class name.
 *
 * @param {boolean} useImportant If true, will append !important to generated
 *     CSS output. e.g. {color: red} -> "color: red !important".
 * @param {(Object|Object[])[]} styleDefinitions style definition objects, or
 *     arbitrarily nested arrays of them, as returned as properties of the
 *     return value of StyleSheet.create().
 */


var injectAndGetClassName = function injectAndGetClassName(useImportant
/* : boolean */
, styleDefinitions
/* : MaybeSheetDefinition[] */
, selectorHandlers
/* : SelectorHandler[] */
)
/* : string */
{
  var classNameBits = [];
  var definitionBits = []; // Mutates classNameBits and definitionBits and returns a length which we
  // will append to the hash to decrease the chance of hash collisions.

  var length = processStyleDefinitions(styleDefinitions, classNameBits, definitionBits, 0); // Break if there aren't any valid styles.

  if (classNameBits.length === 0) {
    return "";
  }

  var className;

  if (true) {
    className = classNameBits.length === 1 ? "_".concat(classNameBits[0]) : "_".concat(hashString(classNameBits.join())).concat((length % 36).toString(36));
  } else {
    className = classNameBits.join("-o_O-");
  }

  injectStyleOnce(className, ".".concat(className), definitionBits, useImportant, selectorHandlers);
  return className;
};

/* ::
import type { SelectorHandler } from './generate.js';
export type SheetDefinition = { [id:string]: any };
export type SheetDefinitions = SheetDefinition | SheetDefinition[];
type RenderFunction = () => string;
type Extension = {
    selectorHandler: SelectorHandler
};
export type MaybeSheetDefinition = SheetDefinition | false | null | void
*/

var unminifiedHashFn = function unminifiedHashFn(str
/* : string */
, key
/* : string */
) {
  return "".concat(key, "_").concat(hashString(str));
}; // StyleSheet.create is in a hot path so we want to keep as much logic out of it
// as possible. So, we figure out which hash function to use once, and only
// switch it out via minify() as necessary.
//
// This is in an exported function to make it easier to test.


var initialHashFn = function initialHashFn() {
  return  true ? hashString : unminifiedHashFn;
};
var hashFn = initialHashFn();
var StyleSheet = {
  create: function create(sheetDefinition
  /* : SheetDefinition */
  )
  /* : Object */
  {
    var mappedSheetDefinition = {};
    var keys = Object.keys(sheetDefinition);

    for (var i = 0; i < keys.length; i += 1) {
      var key = keys[i];
      var val = sheetDefinition[key];
      var stringVal = JSON.stringify(val);
      mappedSheetDefinition[key] = {
        _len: stringVal.length,
        _name: hashFn(stringVal, key),
        _definition: val
      };
    }

    return mappedSheetDefinition;
  },
  rehydrate: function rehydrate() {
    var renderedClassNames
    /* : string[] */
    = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    addRenderedClassNames(renderedClassNames);
  }
};
/**
 * Utilities for using Aphrodite server-side.
 *
 * This can be minified out in client-only bundles by replacing `typeof window`
 * with `"object"`, e.g. via Webpack's DefinePlugin:
 *
 *   new webpack.DefinePlugin({
 *     "typeof window": JSON.stringify("object")
 *   })
 */

var StyleSheetServer = typeof window !== 'undefined' ? null : {
  renderStatic: function renderStatic(renderFunc
  /* : RenderFunction */
  ) {
    reset();
    startBuffering();
    var html = renderFunc();
    var cssContent = flushToString();
    return {
      html: html,
      css: {
        content: cssContent,
        renderedClassNames: getRenderedClassNames()
      }
    };
  }
};
/**
 * Utilities for using Aphrodite in tests.
 *
 * Not meant to be used in production.
 */

var StyleSheetTestUtils =  true ? null : {
  /**
  * Prevent styles from being injected into the DOM.
  *
  * This is useful in situations where you'd like to test rendering UI
  * components which use Aphrodite without any of the side-effects of
  * Aphrodite happening. Particularly useful for testing the output of
  * components when you have no DOM, e.g. testing in Node without a fake DOM.
  *
  * Should be paired with a subsequent call to
  * clearBufferAndResumeStyleInjection.
  */
  suppressStyleInjection: function suppressStyleInjection() {
    reset();
    startBuffering();
  },

  /**
  * Opposite method of preventStyleInject.
  */
  clearBufferAndResumeStyleInjection: function clearBufferAndResumeStyleInjection() {
    reset();
  },

  /**
  * Returns a string of buffered styles which have not been flushed
  *
  * @returns {string}  Buffer of styles which have not yet been flushed.
  */
  getBufferedStyles: function getBufferedStyles$1() {
    return getBufferedStyles();
  }
};
/**
 * Generate the Aphrodite API exports, with given `selectorHandlers` and
 * `useImportant` state.
 */

function makeExports(useImportant
/* : boolean */
) {
  var selectorHandlers
  /* : SelectorHandler[] */
  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultSelectorHandlers;
  return {
    StyleSheet: _objectSpread$1({}, StyleSheet, {
      /**
       * Returns a version of the exports of Aphrodite (i.e. an object
       * with `css` and `StyleSheet` properties) which have some
       * extensions included.
       *
       * @param {Array.<Object>} extensions: An array of extensions to
       *     add to this instance of Aphrodite. Each object should have a
       *     single property on it, defining which kind of extension to
       *     add.
       * @param {SelectorHandler} [extensions[].selectorHandler]: A
       *     selector handler extension. See `defaultSelectorHandlers` in
       *     generate.js.
       *
       * @returns {Object} An object containing the exports of the new
       *     instance of Aphrodite.
       */
      extend: function extend(extensions
      /* : Extension[] */
      ) {
        var extensionSelectorHandlers = extensions // Pull out extensions with a selectorHandler property
        .map(function (extension) {
          return extension.selectorHandler;
        }) // Remove nulls (i.e. extensions without a selectorHandler property).
        .filter(function (handler) {
          return handler;
        });
        return makeExports(useImportant, selectorHandlers.concat(extensionSelectorHandlers));
      }
    }),
    StyleSheetServer: StyleSheetServer,
    StyleSheetTestUtils: StyleSheetTestUtils,
    minify: function minify(shouldMinify
    /* : boolean */
    ) {
      hashFn = shouldMinify ? hashString : unminifiedHashFn;
    },
    css: function css()
    /* : MaybeSheetDefinition[] */
    {
      for (var _len = arguments.length, styleDefinitions = new Array(_len), _key = 0; _key < _len; _key++) {
        styleDefinitions[_key] = arguments[_key];
      }

      return injectAndGetClassName(useImportant, styleDefinitions, selectorHandlers);
    },
    flushToStyleTag: flushToStyleTag,
    injectAndGetClassName: injectAndGetClassName,
    defaultSelectorHandlers: defaultSelectorHandlers,
    reset: reset,
    resetInjectedStyle: resetInjectedStyle
  };
}

var useImportant = true; // Add !important to all style definitions

var Aphrodite = makeExports(useImportant);
var StyleSheet$1 = Aphrodite.StyleSheet,
    css$1 = Aphrodite.css;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
}

function unwrapExports$1 (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule$1(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var merge_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = merge;


// The default allowed delta for keyframe distance
var keyframeDistance = 10;

var defaultNormalizedFrames = {
  'from': 'from',
  '0%': 'from',
  'to': 'to',
  '100%': 'to'
};

/**
 * Takes an array of strings representing transform values and
 * merges them. Ignores duplicates and 'none'.
 * @param {Array} transforms Array<string>
 * @returns {String} merged
 * @private
 * @example
 * mergeTransforms([
 *   'translateX(10px)',
 *   'rotateX(120deg)',
 *   'translateX(10px)',
 *   'none',
 * ])
 * // -> 'translateX(10px) rotateX(120deg)'
 *
 */
var mergeTransforms = function mergeTransforms(transforms) {
  var filtered = transforms.filter(function (transform, i) {
    return transform !== 'none' && transforms.indexOf(transform) === i;
  });
  return filtered.join(' ');
};

/**
 * Returns whichever value is actually defined
 * @param {String|Number} primary CSSValue
 * @param {String|Number} secondary CSSValue
 * @returns {String|Number} defined CSSValue
 * @private
 */
var getDefined = function getDefined(primary, secondary) {
  return typeof primary !== 'undefined' ? primary : secondary;
};

/**
 * Takes a source animation and the current cache, populating the
 * cache with the normalized keyframes and returning a copy of the
 * source animation with the normalized keyframes as well.
 *
 * It uses keyframeDistance to determine how much it should normalize
 * frames.
 * @param {Object} source Animation
 * @param {Object} cache FrameMap
 * @returns {Object} Animation
 * @private
 */
var normalizeFrames = function normalizeFrames(source, cache) {
  var normalized = {};
  for (var frame in source) {
    var normalizedFrame = defaultNormalizedFrames[frame] || Math.round(parseFloat(frame) / keyframeDistance) * keyframeDistance + '%';
    normalized[normalizedFrame] = source[frame];
    cache[normalizedFrame] = normalizedFrame;
  }
  return normalized;
};

var mergeFrames = function mergeFrames(primaryFrame, secondaryFrame, target) {
  // Walk through all properties in the primary frame
  for (var propertyName in primaryFrame) {
    // Transform is special cased, as we want to combine both
    // transforms when posssible.
    if (propertyName === 'transform') {
      // But we dont need to do anything if theres no other
      // transform to merge.
      if (secondaryFrame[propertyName]) {
        var newTransform = mergeTransforms([primaryFrame[propertyName], secondaryFrame[propertyName]]);
        // We make the assumption that animations use 'transform: none'
        // to terminate the keyframe. If we're combining two animations
        // that may terminate at separte frames, its safest to just
        // ignore this.
        if (newTransform !== 'none') {
          target[propertyName] = newTransform;
        }
      } else {
        var propertyValue = getDefined(primaryFrame[propertyName], secondaryFrame[propertyName]);
        target[propertyName] = propertyValue;
      }
    } else {
      // Use a typeof check so we don't ignore falsy values like 0.
      var _propertyValue = getDefined(primaryFrame[propertyName], secondaryFrame[propertyName]);
      target[propertyName] = _propertyValue;
    }
  }
  // Walk through all properties in the secondary frame.
  // We should be able to assume that any property that
  // needed to be merged has already been merged when we
  // walked the primary frame.
  for (var _propertyName in secondaryFrame) {
    var _propertyValue2 = secondaryFrame[_propertyName];
    // Again, ignore 'transform: none'
    if (_propertyName === 'transform' && _propertyValue2 === 'none') {
      continue;
    }
    target[_propertyName] = target[_propertyName] || _propertyValue2;
  }
};

var populateDefinedFrame = function populateDefinedFrame(primaryFrame, secondaryFrame) {
  var definedFrame = primaryFrame || secondaryFrame;
  var target = {};
  for (var propertyName in definedFrame) {
    var propertyValue = definedFrame[propertyName];
    // Again, ignore 'transform: none'
    if (propertyName === 'transform' && propertyValue === 'none') {
      continue;
    }
    target[propertyName] = propertyValue;
  }
  // Only define a frame if there are actual styles to apply
  if (Object.keys(target).length) {
    return target;
  }
  return null;
};

/**
 * Merge lets you take two Animations and merge them together. It
 * iterates through each animation and merges each keyframe. It
 * special cases the `transform` property and uses string interop.
 * to merge the two transforms.
 *
 * This is *at your own risk* and will not work with animations
 * that are clearly opposites (fadeIn and fadeOut).
 *
 * @param {Object} primary Animation
 * @param {Object} secondary Animation
 * @returns {Object} merged Animation
 * @example
 * import { merge, tada, flip } from 'react-animations';
 * const tadaFlip = merge(tada, flip);
 */
function merge(primary, secondary) {
  // A map used to track the normalized frame value in cases where
  // two animations contain frames that appear closely, but not exactly
  var normalizedFrames = {};

  // We merge each frame into a new object and return it
  var merged = {};

  var normalizedPrimary = normalizeFrames(primary, normalizedFrames);

  var normalizedSecondary = normalizeFrames(secondary, normalizedFrames);

  // Iterate all normalized frames
  for (var frame in normalizedFrames) {
    var primaryFrame = normalizedPrimary[frame];
    var secondaryFrame = normalizedSecondary[frame];
    // Create a new frame object if it doesn't exist.
    var target = merged[frame] || (merged[frame] = {});

    // If both aniatmions define this frame, merge them carefully
    if (primaryFrame && secondaryFrame) {
      mergeFrames(primaryFrame, secondaryFrame, target);
    } else {
      // Otherwise find the defined frime and populate all properties\
      // except for "transform" when the value is none.
      var keyframe = populateDefinedFrame(primaryFrame, secondaryFrame);
      if (keyframe) {
        merged[frame] = keyframe;
      }
    }
  }
  return merged;
}
});

unwrapExports$1(merge_1);

var utils = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Composes a variable number of CSS helper functions.
 * Returns a function that accepts all the original arguments
 * of the functions it composed. If the original function
 * accepted multiple arguments, they must be passed as
 * an array.
 * @example
 * const translateXandRotateY = compose(translateX, rotateY);
 * const cssValue = translateXandRotateY('-5px', '30deg');
 */
var compose = exports.compose = function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, styleArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      styleArgs[_key2] = arguments[_key2];
    }

    var result = funcs.reduce(function (acc, func, i) {
      var arg = styleArgs[i];
      return acc + ' ' + (Array.isArray(arg) ? func.apply(undefined, _toConsumableArray(arg)) : func(arg));
    }, '');
    return result.trim();
  };
};
var cubicBezier = exports.cubicBezier = function cubicBezier(a, b, c, d) {
  return 'cubic-bezier(' + a + ', ' + b + ', ' + c + ', ' + d + ')';
};

var translate3d = exports.translate3d = function translate3d(a, b, c) {
  return 'translate3d(' + a + ', ' + b + ', ' + c + ')';
};

var translateX = exports.translateX = function translateX(a) {
  return 'translateX(' + a + ')';
};

var scale3d = exports.scale3d = function scale3d(a, b, c) {
  return 'scale3d(' + a + ', ' + b + ', ' + c + ')';
};

var scale = exports.scale = function scale(a) {
  return 'scale(' + a + ')';
};

var skewX = exports.skewX = function skewX(deg) {
  return 'skewX(' + deg + 'deg)';
};

var skewY = exports.skewY = function skewY(deg) {
  return 'skewY(' + deg + 'deg)';
};

var skewXY = exports.skewXY = function skewXY(x, y) {
  return skewX(x) + ' ' + skewY(y);
};

var rotateY = exports.rotateY = function rotateY(a) {
  return 'rotateY(' + a + ')';
};

var rotate3d = exports.rotate3d = function rotate3d(a, b, c, d) {
  return 'rotate3d(' + a + ', ' + b + ', ' + c + ', ' + d + 'deg)';
};

var perspective = exports.perspective = function perspective(a) {
  return 'perspective(' + a + ')';
};
});

unwrapExports$1(utils);
var utils_1 = utils.compose;
var utils_2 = utils.cubicBezier;
var utils_3 = utils.translate3d;
var utils_4 = utils.translateX;
var utils_5 = utils.scale3d;
var utils_6 = utils.scale;
var utils_7 = utils.skewX;
var utils_8 = utils.skewY;
var utils_9 = utils.skewXY;
var utils_10 = utils.rotateY;
var utils_11 = utils.rotate3d;
var utils_12 = utils.perspective;

var bounce_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var base = {
  animationTimingFunction: (0, utils.cubicBezier)(0.2125, 0.610, 0.355, 1.000),
  transform: (0, utils.translate3d)(0, 0, 0)
};


var bounce = {
  '0%': base,
  '20%': base,
  '40%': {
    animationTimingFunction: (0, utils.cubicBezier)(0.755, 0.050, 0.855, 0.060),
    transform: (0, utils.translate3d)(0, '-30px', 0)
  },
  '43%': {
    animationTimingFunction: (0, utils.cubicBezier)(0.755, 0.050, 0.855, 0.060),
    transform: (0, utils.translate3d)(0, '-30px', 0)
  },
  '53%': base,
  '70%': {
    animationTimingFunction: (0, utils.cubicBezier)(0.755, 0.050, 0.855, 0.060),
    transform: (0, utils.translate3d)(0, '-50px', 0)
  },
  '80%': base,
  '90%': {
    transform: (0, utils.translate3d)(0, '-4px', 0)
  },
  '100%': base
};

exports.default = bounce;
});

unwrapExports$1(bounce_1);

var flash_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});


var visible = {
  opacity: 1
};


var invisible = {
  opacity: 0
};

var flash = {
  from: visible,
  '25%': invisible,
  '50%': visible,
  '75%': invisible,
  to: visible
};

exports.default = flash;
});

unwrapExports$1(flash_1);

var pulse_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var pulse = {
  from: {
    transform: (0, utils.scale3d)(1, 1, 1)
  },
  '50%': {
    transform: (0, utils.scale3d)(1.05, 1.05, 1.05)
  },
  to: {
    transform: (0, utils.scale3d)(1, 1, 1)
  }
};
exports.default = pulse;
});

unwrapExports$1(pulse_1);

var jello_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var noSkew = {
  transform: 'none'
};


var jello = {
  from: noSkew,
  '11.1%': noSkew,
  '22.2%': {
    transform: (0, utils.skewXY)(-12.5, -12.5)
  },
  '33.3': {
    transform: (0, utils.skewXY)(6.25, 6.25)
  },
  '44.4': {
    transform: (0, utils.skewXY)(-3.125, -3.125)
  },
  '55.5': {
    transform: (0, utils.skewXY)(1.5625, 1.5625)
  },
  '66.6': {
    transform: (0, utils.skewXY)(-0.78125, -0.78125)
  },
  '77.7': {
    transform: (0, utils.skewXY)(0.390625, 0.390625)
  },
  '88.8': {
    transform: (0, utils.skewXY)(-0.1953125, -0.1953125)
  },
  to: noSkew
};

exports.default = jello;
});

unwrapExports$1(jello_1);

var wobble_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var translateAndRotate = (0, utils.compose)(utils.translate3d, utils.rotate3d);


var noWobble = {
  transform: 'none'
};

var wobble = {
  from: noWobble,
  '15%': {
    transform: translateAndRotate(['-25%', 0, 0], [0, 0, 1, -5])
  },
  '30%': {
    transform: translateAndRotate(['20%', 0, 0], [0, 0, 1, -5])
  },
  '45%': {
    transform: translateAndRotate(['-15%', 0, 0], [0, 0, 1, -3])
  },
  '60%': {
    transform: translateAndRotate(['10%', 0, 0], [0, 0, 1, 2])
  },
  '75%': {
    transform: translateAndRotate(['-5%', 0, 0], [0, 0, 1, -1])
  },
  to: noWobble
};

exports.default = wobble;
});

unwrapExports$1(wobble_1);

var headShake_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var translateAndRotate = (0, utils.compose)(utils.translateX, utils.rotateY);


var noShake = {
  transform: (0, utils.translateX)(0)
};

var headShake = {
  '0%': noShake,
  '6.5%': {
    transform: translateAndRotate('-6px', '-9deg')
  },
  '18.5%': {
    transform: translateAndRotate('5px', '7deg')
  },
  '31.5%': {
    transform: translateAndRotate('-3px', '-5deg')
  },
  '43.5%': {
    transform: translateAndRotate('2px', '3deg')
  },
  '50%': noShake
};

exports.default = headShake;
});

unwrapExports$1(headShake_1);

var rubberBand_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var noRubberBanding = {
  transform: (0, utils.scale3d)(1, 1, 1)
};


var rubberBand = {
  from: noRubberBanding,
  '30%': {
    transform: (0, utils.scale3d)(1.25, 0.75, 1)
  },
  '40%': {
    transform: (0, utils.scale3d)(0.75, 1.25, 1)
  },
  '50%': {
    transform: (0, utils.scale3d)(1.15, 0.85, 1)
  },
  '65%': {
    transform: (0, utils.scale3d)(0.95, 1.05, 1)
  },
  '75%': {
    transform: (0, utils.scale3d)(1.05, 0.95, 1)
  },
  to: noRubberBanding
};

exports.default = rubberBand;
});

unwrapExports$1(rubberBand_1);

var shake_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var noShake = {
  transform: (0, utils.translate3d)(0, 0, 0)
};


var downShake = {
  transform: (0, utils.translate3d)('-10px', 0, 0)
};

var upShake = {
  transform: (0, utils.translate3d)('10px', 0, 0)
};

var shake = {
  from: noShake,
  '10%': downShake,
  '20%': upShake,
  '30%': downShake,
  '40%': upShake,
  '50%': downShake,
  '60%': upShake,
  '70%': downShake,
  '80%': upShake,
  '90%': downShake,
  to: noShake
};

exports.default = shake;
});

unwrapExports$1(shake_1);

var swing_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;



var swing = {
  '20%': {
    transform: (0, utils.rotate3d)(0, 0, 1, 15)
  },
  '40%': {
    transform: (0, utils.rotate3d)(0, 0, 1, -10)
  },
  '60%': {
    transform: (0, utils.rotate3d)(0, 0, 1, 5)
  },
  '80%': {
    transform: (0, utils.rotate3d)(0, 0, 1, -5)
  },
  to: {
    transform: (0, utils.rotate3d)(0, 0, 1, 15)
  }
};
var styles = exports.styles = {
  transformOrigin: 'top center'
};

exports.default = swing;
});

unwrapExports$1(swing_1);
var swing_2 = swing_1.styles;

var tada_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var scaleAndRotate = (0, utils.compose)(utils.scale3d, utils.rotate3d);


var noScale = {
  transform: (0, utils.scale3d)(1, 1, 1)
};

var scaleDownNegativeAngle = {
  transform: scaleAndRotate([0.9, 0.9, 0.9], [0, 0, 1, -3])
};

var scaleUpPositiveAngle = {
  transform: scaleAndRotate([1.1, 1.1, 1.1], [0, 0, 1, 3])
};

var scaleUpNegativeAngle = {
  transform: scaleAndRotate([1.1, 1.1, 1.1], [0, 0, 1, -3])
};

var tada = {
  from: noScale,
  '10%': scaleDownNegativeAngle,
  '20%': scaleDownNegativeAngle,
  '30%': scaleUpPositiveAngle,
  '40%': scaleUpNegativeAngle,
  '50%': scaleUpPositiveAngle,
  '60%': scaleUpNegativeAngle,
  '70%': scaleUpPositiveAngle,
  '80%': scaleUpNegativeAngle,
  '90%': scaleUpPositiveAngle,
  to: noScale
};

exports.default = tada;
});

unwrapExports$1(tada_1);

var bounceIn_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var timing = {
  animationTimingFunction: (0, utils.cubicBezier)(0.215, 0.610, 0.355, 1.000)
};

var bounceIn = {
  from: timing,
  '0%': {
    opacity: 0,
    transform: (0, utils.scale3d)(0.3, 0.3, 0.3)
  },
  '20%': _extends({}, timing, {
    transform: (0, utils.scale3d)(1.1, 1.1, 1.1)
  }),
  '40%': _extends({}, timing, {
    transform: (0, utils.scale3d)(0.9, 0.9, 0.9)
  }),
  '60%': _extends({}, timing, {
    opacity: 1,
    transform: (0, utils.scale3d)(1.03, 1.03, 1.03)
  }),
  '80%': _extends({}, timing, {
    transform: (0, utils.scale3d)(0.97, 0.97, 0.97)
  }),
  to: _extends({}, timing, {
    opacity: 1,
    transform: (0, utils.scale3d)(1, 1, 1)
  })
};

exports.default = bounceIn;
});

unwrapExports$1(bounceIn_1);

var bounceInDown_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var timing = {
  animationTimingFunction: (0, utils.cubicBezier)(0.215, 0.610, 0.355, 1.000)
};

var bounceInDown = {
  from: timing,
  '0%': {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '-3000px', 0)
  },
  '60%': _extends({}, timing, {
    opacity: 1,
    transform: (0, utils.translate3d)(0, '25px', 0)
  }),
  '75%': _extends({}, timing, {
    transform: (0, utils.translate3d)(0, '-10px', 0)
  }),
  '90%': _extends({}, timing, {
    transform: (0, utils.translate3d)(0, '5px', 0)
  }),
  to: _extends({}, timing, {
    transform: 'none'
  })
};

exports.default = bounceInDown;
});

unwrapExports$1(bounceInDown_1);

var bounceInLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var timing = {
  animationTimingFunction: (0, utils.cubicBezier)(0.215, 0.610, 0.355, 1.000)
};

var bounceInLeft = {
  from: timing,
  '0%': {
    opacity: 0,
    transform: (0, utils.translate3d)('-3000px', 0, 0)
  },
  '60%': _extends({}, timing, {
    opacity: 1,
    transform: (0, utils.translate3d)('25px', 0, 0)
  }),
  '75%': _extends({}, timing, {
    transform: (0, utils.translate3d)('-10px', 0, 0)
  }),
  '90%': _extends({}, timing, {
    transform: (0, utils.translate3d)('5px', 0, 0)
  }),
  to: _extends({}, timing, {
    transform: 'none'
  })
};

exports.default = bounceInLeft;
});

unwrapExports$1(bounceInLeft_1);

var bounceInRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var timing = {
  animationTimingFunction: (0, utils.cubicBezier)(0.215, 0.610, 0.355, 1.000)
};

var bounceInRight = {
  from: timing,
  '0%': {
    opacity: 0,
    transform: (0, utils.translate3d)('3000px', 0, 0)
  },
  '60%': _extends({}, timing, {
    opacity: 1,
    transform: (0, utils.translate3d)('-25px', 0, 0)
  }),
  '75%': _extends({}, timing, {
    transform: (0, utils.translate3d)('10px', 0, 0)
  }),
  '90%': _extends({}, timing, {
    transform: (0, utils.translate3d)('-5px', 0, 0)
  }),
  to: _extends({}, timing, {
    transform: 'none'
  })
};

exports.default = bounceInRight;
});

unwrapExports$1(bounceInRight_1);

var bounceInUp_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var timing = {
  animationTimingFunction: (0, utils.cubicBezier)(0.215, 0.610, 0.355, 1.000)
};

var bounceInUp = {
  from: timing,
  '0%': {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '3000px', 0)
  },
  '60%': _extends({}, timing, {
    opacity: 1,
    transform: (0, utils.translate3d)(0, '-20px', 0)
  }),
  '75%': _extends({}, timing, {
    transform: (0, utils.translate3d)(0, '10px', 0)
  }),
  '90%': _extends({}, timing, {
    transform: (0, utils.translate3d)(0, '-5px', 0)
  }),
  to: _extends({}, timing, {
    transform: 'none'
  })
};

exports.default = bounceInUp;
});

unwrapExports$1(bounceInUp_1);

var bounceOut_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var bounceOut = {
  '20%': {
    transform: (0, utils.scale3d)(0.9, 0.9, 0.9)
  },
  '50%': {
    transform: (0, utils.scale3d)(1.1, 1.1, 1.1)
  },
  '55%': {
    transform: (0, utils.scale3d)(1.1, 1.1, 1.1)
  },
  to: {
    opacity: 0,
    transform: (0, utils.scale3d)(0.3, 0.3, 0.3)
  }
};
exports.default = bounceOut;
});

unwrapExports$1(bounceOut_1);

var bounceOutDown_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var bounceOutDown = {
  '20%': {
    transform: (0, utils.translate3d)(0, '10px', 0)
  },
  '40%': {
    transform: (0, utils.translate3d)(0, '-20px', 0)
  },
  '45%': {
    transform: (0, utils.translate3d)(0, '-20px', 0)
  },
  to: {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '2000px', 0)
  }
};
exports.default = bounceOutDown;
});

unwrapExports$1(bounceOutDown_1);

var bounceOutLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var bounceOutLeft = {
  '20%': {
    opacity: 1,
    transform: (0, utils.translate3d)('20px', 0, 0)
  },
  to: {
    opacity: 0,
    transform: (0, utils.translate3d)('-2000px', 0, 0)
  }
};
exports.default = bounceOutLeft;
});

unwrapExports$1(bounceOutLeft_1);

var bounceOutRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var bounceOutRight = {
  '20%': {
    opacity: 1,
    transform: (0, utils.translate3d)('-20px', 0, 0)
  },
  to: {
    opacity: 1,
    transform: (0, utils.translate3d)('2000px', 0, 0)
  }
};
exports.default = bounceOutRight;
});

unwrapExports$1(bounceOutRight_1);

var bounceOutUp_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var bounceOutUp = {
  '20%': {
    transform: (0, utils.translate3d)(0, '-10px', 0)
  },
  '40%': {
    opacity: 1,
    transform: (0, utils.translate3d)(0, '20px', 0)
  },
  '45%': {
    opacity: 1,
    transform: (0, utils.translate3d)(0, '20px', 0)
  },
  to: {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '-2000px', 0)
  }
};
exports.default = bounceOutUp;
});

unwrapExports$1(bounceOutUp_1);

var fadeIn_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});


var fadeIn = {
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
};
exports.default = fadeIn;
});

unwrapExports$1(fadeIn_1);

var fadeInDown_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeInDown = {
  from: {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '-100%', 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInDown;
});

unwrapExports$1(fadeInDown_1);

var fadeInDownBig_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeInDownBig = {
  from: {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '-2000px', 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInDownBig;
});

unwrapExports$1(fadeInDownBig_1);

var fadeInLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeInLeft = {
  from: {
    opacity: 0,
    transform: (0, utils.translate3d)('-100%', 0, 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInLeft;
});

unwrapExports$1(fadeInLeft_1);

var fadeInLeftBig_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeInLeftBig = {
  from: {
    opacity: 0,
    transform: (0, utils.translate3d)('-2000px', 0, 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInLeftBig;
});

unwrapExports$1(fadeInLeftBig_1);

var fadeInRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeInRight = {
  from: {
    opacity: 0,
    transform: (0, utils.translate3d)('100%', 0, 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInRight;
});

unwrapExports$1(fadeInRight_1);

var fadeInRightBig_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeInRightBig = {
  from: {
    opacity: 0,
    transform: (0, utils.translate3d)('2000px', 0, 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInRightBig;
});

unwrapExports$1(fadeInRightBig_1);

var fadeInUp_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeInUp = {
  from: {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '100%', 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInUp;
});

unwrapExports$1(fadeInUp_1);

var fadeInUpBig_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeInUpBig = {
  from: {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '2000px', 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInUpBig;
});

unwrapExports$1(fadeInUpBig_1);

var fadeOut_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});


var fadeOut = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0
  }
};
exports.default = fadeOut;
});

unwrapExports$1(fadeOut_1);

var fadeOutDown_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeOutDown = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '100%', 0)
  }
};
exports.default = fadeOutDown;
});

unwrapExports$1(fadeOutDown_1);

var fadeOutDownBig_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeOutDownBig = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '2000px', 0)
  }
};
exports.default = fadeOutDownBig;
});

unwrapExports$1(fadeOutDownBig_1);

var fadeOutLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeOutLeft = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: (0, utils.translate3d)('-100%', 0, 0)
  }
};
exports.default = fadeOutLeft;
});

unwrapExports$1(fadeOutLeft_1);

var fadeOutLeftBig_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeOutLeftBig = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: (0, utils.translate3d)('-2000px', 0, 0)
  }
};
exports.default = fadeOutLeftBig;
});

unwrapExports$1(fadeOutLeftBig_1);

var fadeOutRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeOutRight = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: (0, utils.translate3d)('100%', 0, 0)
  }
};
exports.default = fadeOutRight;
});

unwrapExports$1(fadeOutRight_1);

var fadeOutRightBig_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeOutRightBig = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: (0, utils.translate3d)('2000px', 0, 0)
  }
};
exports.default = fadeOutRightBig;
});

unwrapExports$1(fadeOutRightBig_1);

var fadeOutUp_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeOutUp = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '-100%', 0)
  }
};
exports.default = fadeOutUp;
});

unwrapExports$1(fadeOutUp_1);

var fadeOutUpBig_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var fadeOutUpBig = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: (0, utils.translate3d)(0, '-2000px', 0)
  }
};
exports.default = fadeOutUpBig;
});

unwrapExports$1(fadeOutUpBig_1);

var flip_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var perspectiveAndRotate = (0, utils.compose)(utils.perspective, utils.rotate3d);


var perspectiveAndScale = (0, utils.compose)(utils.perspective, utils.scale3d);

var perspectiveTranslateRotate = (0, utils.compose)(utils.perspective, utils.translate3d, utils.rotate3d);

var flip = {
  from: {
    animationTimingFunction: 'ease-out',
    transform: perspectiveAndRotate('400px', [0, 1, 0, -360])
  },
  '40%': {
    animationTimingFunction: 'ease-out',
    transform: perspectiveTranslateRotate('400px', [0, 0, '150px'], [0, 1, 0, -190])
  },
  '50%': {
    animationTimingFunction: 'ease-in',
    transform: perspectiveTranslateRotate('400px', [0, 0, '150px'], [0, 1, 0, -170])
  },
  '80%': {
    animationTimingFunction: 'ease-in',
    transform: perspectiveAndScale('400px', [0.95, 0.95, 0.95])
  },
  to: {
    animationTimingFunction: 'ease-in',
    transform: (0, utils.perspective)('400px')
  }
};

exports.default = flip;
});

unwrapExports$1(flip_1);

var flipInX_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var perspectiveAndRotate = (0, utils.compose)(utils.perspective, utils.rotate3d);


var flipInX = {
  from: {
    animationTimingFunction: 'ease-out',
    transform: perspectiveAndRotate('400px', [1, 0, 0, 90]),
    opacity: 0
  },
  '40%': {
    animationTimingFunction: 'ease-in',
    transform: perspectiveAndRotate('400px', [1, 0, 0, -20])
  },
  '60%': {
    transform: perspectiveAndRotate('400px', [1, 0, 0, 10])
  },
  '80%': {
    transform: perspectiveAndRotate('400px', [1, 0, 0, -5])
  },
  to: {
    transform: (0, utils.perspective)('400px')
  }
};

exports.default = flipInX;
});

unwrapExports$1(flipInX_1);

var flipInY_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var perspectiveAndRotate = (0, utils.compose)(utils.perspective, utils.rotate3d);


var flipInY = {
  from: {
    animationTimingFunction: 'ease-out',
    transform: perspectiveAndRotate('400px', [0, 1, 0, 90]),
    opacity: 0
  },
  '40%': {
    animationTimingFunction: 'ease-in',
    transform: perspectiveAndRotate('400px', [0, 1, 0, -20])
  },
  '60%': {
    transform: perspectiveAndRotate('400px', [0, 1, 0, 10])
  },
  '80%': {
    transform: perspectiveAndRotate('400px', [0, 1, 0, -5])
  },
  to: {
    transform: (0, utils.perspective)('400px')
  }
};

exports.default = flipInY;
});

unwrapExports$1(flipInY_1);

var flipOutX_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var perspectiveAndRotate = (0, utils.compose)(utils.perspective, utils.rotate3d);


var flipOutX = {
  from: {
    transform: (0, utils.perspective)('400px')
  },
  '30%': {
    transform: perspectiveAndRotate('400px', [1, 0, 0, -20]),
    opacity: 1
  },
  to: {
    transform: perspectiveAndRotate('400px', [1, 0, 0, 90]),
    opacity: 0
  }
};

exports.default = flipOutX;
});

unwrapExports$1(flipOutX_1);

var flipOutY_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var perspectiveAndRotate = (0, utils.compose)(utils.perspective, utils.rotate3d);


var flipOutY = {
  from: {
    transform: (0, utils.perspective)('400px')
  },
  '30%': {
    transform: perspectiveAndRotate('400px', [0, 1, 0, -15]),
    opacity: 1
  },
  to: {
    transform: perspectiveAndRotate('400px', [0, 1, 0, 90]),
    opacity: 0
  }
};

exports.default = flipOutY;
});

unwrapExports$1(flipOutY_1);

var lightSpeedIn_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var translateAndSkew = (0, utils.compose)(utils.translate3d, utils.skewX);

var easeIn = {
  animationTimingFunction: 'ease-out'
};

var lightSpeedIn = {
  from: _extends({}, easeIn, {
    opacity: 0,
    transform: translateAndSkew(['100%', 0, 0], -30)
  }),
  '60%': _extends({}, easeIn, {
    opacity: 1,
    transform: (0, utils.skewX)(20)
  }),
  '80%': _extends({}, easeIn, {
    opacity: 1,
    transform: (0, utils.skewX)(-5)
  }),
  to: _extends({}, easeIn, {
    transform: 'none',
    opacity: 1
  })
};

exports.default = lightSpeedIn;
});

unwrapExports$1(lightSpeedIn_1);

var lightSpeedOut_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var translateAndSkew = (0, utils.compose)(utils.translate3d, utils.skewX);

var easeIn = {
  animationTimingFunction: 'ease-out'
};

var lightSpeedOut = {
  from: _extends({}, easeIn, {
    opacity: 1
  }),
  to: _extends({}, easeIn, {
    transform: translateAndSkew(['100%', 0, 0], 30),
    opacity: 0
  })
};

exports.default = lightSpeedOut;
});

unwrapExports$1(lightSpeedOut_1);

var rotateIn_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var rotateIn = {
  from: {
    transformOrigin: 'center',
    transform: (0, utils.rotate3d)(0, 0, 1, -200),
    opacity: 0
  },
  to: {
    transformOrigin: 'center',
    transform: 'none',
    opacity: 1
  }
};
exports.default = rotateIn;
});

unwrapExports$1(rotateIn_1);

var rotateInDownLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var rotateInDownLeft = {
  from: {
    transformOrigin: 'left bottom',
    transform: (0, utils.rotate3d)(0, 0, 1, -45),
    opacity: 0
  },
  to: {
    transformOrigin: 'left bottom',
    transform: 'none',
    opacity: 1
  }
};
exports.default = rotateInDownLeft;
});

unwrapExports$1(rotateInDownLeft_1);

var rotateInDownRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var rotateInDownRight = {
  from: {
    transformOrigin: 'right bottom',
    transform: (0, utils.rotate3d)(0, 0, 1, 45),
    opacity: 0
  },
  to: {
    transformOrigin: 'right bottom',
    transform: 'none',
    opacity: 1
  }
};
exports.default = rotateInDownRight;
});

unwrapExports$1(rotateInDownRight_1);

var rotateInUpLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var rotateInUpLeft = {
  from: {
    transformOrigin: 'left bottom',
    transform: (0, utils.rotate3d)(0, 0, 1, 45),
    opacity: 0
  },
  to: {
    transformOrigin: 'left bottom',
    transform: 'none',
    opacity: 1
  }
};
exports.default = rotateInUpLeft;
});

unwrapExports$1(rotateInUpLeft_1);

var rotateInUpRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var rotateInUpRight = {
  from: {
    transformOrigin: 'right bottom',
    transform: (0, utils.rotate3d)(0, 0, 1, -90),
    opacity: 0
  },
  to: {
    transformOrigin: 'right bottom',
    transform: 'none',
    opacity: 1
  }
};
exports.default = rotateInUpRight;
});

unwrapExports$1(rotateInUpRight_1);

var rotateOut_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var rotateOut = {
  from: {
    transformOrigin: 'center',
    opacity: 1
  },
  to: {
    transformOrigin: 'center',
    transform: (0, utils.rotate3d)(0, 0, 1, 200),
    opacity: 0
  }
};
exports.default = rotateOut;
});

unwrapExports$1(rotateOut_1);

var rotateOutDownLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var rotateOutDownLeft = {
  from: {
    transformOrigin: 'left bottom',
    opacity: 1
  },
  to: {
    transformOrigin: 'left bottom',
    transform: (0, utils.rotate3d)(0, 0, 1, 45),
    opacity: 0
  }
};
exports.default = rotateOutDownLeft;
});

unwrapExports$1(rotateOutDownLeft_1);

var rotateOutDownRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var rotateOutDownRight = {
  from: {
    transformOrigin: 'right bottom',
    opacity: 1
  },
  to: {
    transformOrigin: 'right bottom',
    transform: (0, utils.rotate3d)(0, 0, 1, -45),
    opacity: 0
  }
};
exports.default = rotateOutDownRight;
});

unwrapExports$1(rotateOutDownRight_1);

var rotateOutUpLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var rotateOutUpLeft = {
  from: {
    transformOrigin: 'left bottom',
    opacity: 1
  },
  to: {
    transformOrigin: 'left bottom',
    transform: (0, utils.rotate3d)(0, 0, 1, -45),
    opacity: 0
  }
};
exports.default = rotateOutUpLeft;
});

unwrapExports$1(rotateOutUpLeft_1);

var rotateOutUpRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var rotateOutUpRight = {
  from: {
    transformOrigin: 'right bottom',
    opacity: 1
  },
  to: {
    transformOrigin: 'right bottom',
    transform: (0, utils.rotate3d)(0, 0, 1, 90),
    opacity: 0
  }
};
exports.default = rotateOutUpRight;
});

unwrapExports$1(rotateOutUpRight_1);

var slideInDown_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var slideInDown = {
  from: {
    transform: (0, utils.translate3d)(0, '-100%', 0),
    visibility: 'visible'
  },
  to: {
    transform: (0, utils.translate3d)(0, 0, 0)
  }
};
exports.default = slideInDown;
});

unwrapExports$1(slideInDown_1);

var slideInLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var slideInLeft = {
  from: {
    transform: (0, utils.translate3d)('-100%', 0, 0),
    visibility: 'visible'
  },
  to: {
    transform: (0, utils.translate3d)(0, 0, 0)
  }
};
exports.default = slideInLeft;
});

unwrapExports$1(slideInLeft_1);

var slideInRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var slideInRight = {
  from: {
    transform: (0, utils.translate3d)('100%', 0, 0),
    visibility: 'visible'
  },
  to: {
    transform: (0, utils.translate3d)(0, 0, 0)
  }
};
exports.default = slideInRight;
});

unwrapExports$1(slideInRight_1);

var slideInUp_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var slideInUp = {
  from: {
    transform: (0, utils.translate3d)(0, '100%', 0),
    visibility: 'visible'
  },
  to: {
    transform: (0, utils.translate3d)(0, 0, 0)
  }
};
exports.default = slideInUp;
});

unwrapExports$1(slideInUp_1);

var slideOutDown_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var slideOutDown = {
  from: {
    transform: (0, utils.translate3d)(0, 0, 0)
  },
  to: {
    visibility: 'hidden',
    transform: (0, utils.translate3d)(0, '100%', 0)
  }
};
exports.default = slideOutDown;
});

unwrapExports$1(slideOutDown_1);

var slideOutLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var slideOutLeft = {
  from: {
    transform: (0, utils.translate3d)(0, 0, 0)
  },
  to: {
    visibility: 'hidden',
    transform: (0, utils.translate3d)('-100%', 0, 0)
  }
};
exports.default = slideOutLeft;
});

unwrapExports$1(slideOutLeft_1);

var slideOutRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var slideOutRight = {
  from: {
    transform: (0, utils.translate3d)(0, 0, 0)
  },
  to: {
    visibility: 'hidden',
    transform: (0, utils.translate3d)('100%', 0, 0)
  }
};
exports.default = slideOutRight;
});

unwrapExports$1(slideOutRight_1);

var slideOutUp_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var slideOutUp = {
  from: {
    transform: (0, utils.translate3d)(0, 0, 0)
  },
  to: {
    visibility: 'hidden',
    transform: (0, utils.translate3d)(0, '-100%', 0)
  }
};
exports.default = slideOutUp;
});

unwrapExports$1(slideOutUp_1);

var hinge_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var hingeUp = {
  transform: (0, utils.rotate3d)(0, 0, 1, 80),
  transformOrigin: 'top left',
  animationTimingFunction: 'ease-in-out'
};


var hingeDown = {
  transform: (0, utils.rotate3d)(0, 0, 1, 60),
  transformOrigin: 'top left',
  animationTimingFunction: 'ease-in-out',
  opacity: 1
};

var hinge = {
  '0%': {
    transformOrigin: 'top left',
    animationTimingFunction: 'ease-in-out'
  },
  '20%': hingeUp,
  '40%': hingeDown,
  '60%': hingeUp,
  '80%': hingeDown,
  to: {
    transform: (0, utils.translate3d)(0, '700px', 0),
    opacity: 0
  }
};

exports.default = hinge;
});

unwrapExports$1(hinge_1);

var rollIn_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var translateAndRotate = (0, utils.compose)(utils.translate3d, utils.rotate3d);


var rollIn = {
  from: {
    opacity: 0,
    transform: translateAndRotate(['-100%', 0, 0], [0, 0, 1, -120])
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};

exports.default = rollIn;
});

unwrapExports$1(rollIn_1);

var rollOut_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var translateAndRotate = (0, utils.compose)(utils.translate3d, utils.rotate3d);


var rollOut = {
  from: {
    opacity: 1
  },
  to: {
    opacity: 0,
    transform: translateAndRotate(['100%', 0, 0], [0, 0, 1, 120])
  }
};

exports.default = rollOut;
});

unwrapExports$1(rollOut_1);

var zoomIn_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var zoomIn = {
  from: {
    opacity: 0,
    transform: (0, utils.scale3d)(0.3, 0.3, 0.3)
  },
  '50%': {
    opacity: 1
  }
};
exports.default = zoomIn;
});

unwrapExports$1(zoomIn_1);

var zoomInDown_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var scaleAndTranslate = (0, utils.compose)(utils.scale3d, utils.translate3d);


var zoomInDown = {
  from: {
    opacity: 0,
    transform: scaleAndTranslate([0.1, 0.1, 0.1], [0, '-1000px', 0]),
    animationTimingFunction: (0, utils.cubicBezier)(0.550, 0.055, 0.675, 0.190)
  },
  '60%': {
    opacity: 1,
    transform: scaleAndTranslate([0.475, 0.475, 0.475], [0, '60px', 0]),
    animationTimingFunction: (0, utils.cubicBezier)(0.175, 0.885, 0.320, 1)
  }
};

exports.default = zoomInDown;
});

unwrapExports$1(zoomInDown_1);

var zoomInLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var scaleAndTranslate = (0, utils.compose)(utils.scale3d, utils.translate3d);


var zoomInLeft = {
  from: {
    opacity: 0,
    transform: scaleAndTranslate([0.1, 0.1, 0.1], ['-1000px', 0, 0]),
    animationTimingFunction: (0, utils.cubicBezier)(0.550, 0.055, 0.675, 0.190)
  },
  '60%': {
    opacity: 1,
    transform: scaleAndTranslate([0.475, 0.475, 0.475], ['10px', 0, 0]),
    animationTimingFunction: (0, utils.cubicBezier)(0.175, 0.885, 0.320, 1)
  }
};

exports.default = zoomInLeft;
});

unwrapExports$1(zoomInLeft_1);

var zoomInRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var scaleAndTranslate = (0, utils.compose)(utils.scale3d, utils.translate3d);


var zoomInRight = {
  from: {
    opacity: 0,
    transform: scaleAndTranslate([0.1, 0.1, 0.1], ['1000px', 0, 0]),
    animationTimingFunction: (0, utils.cubicBezier)(0.550, 0.055, 0.675, 0.190)
  },
  '60%': {
    opacity: 1,
    transform: scaleAndTranslate([0.475, 0.475, 0.475], ['-10px', 0, 0]),
    animationTimingFunction: (0, utils.cubicBezier)(0.175, 0.885, 0.320, 1)
  }
};

exports.default = zoomInRight;
});

unwrapExports$1(zoomInRight_1);

var zoomInUp_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var scaleAndTranslate = (0, utils.compose)(utils.scale3d, utils.translate3d);


var zoomInUp = {
  from: {
    opacity: 0,
    transform: scaleAndTranslate([0.1, 0.1, 0.1], [0, '1000px', 0]),
    animationTimingFunction: (0, utils.cubicBezier)(0.550, 0.055, 0.675, 0.190)
  },
  '60%': {
    opacity: 1,
    transform: scaleAndTranslate([0.475, 0.475, 0.475], [0, '-60px', 0]),
    animationTimingFunction: (0, utils.cubicBezier)(0.175, 0.885, 0.320, 1)
  }
};

exports.default = zoomInUp;
});

unwrapExports$1(zoomInUp_1);

var zoomOut_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var zoomOut = {
  from: {
    opacity: 1
  },
  '50%': {
    opacity: 0,
    transform: (0, utils.scale3d)(0.3, 0.3, 0.3)
  },
  to: {
    opacity: 0
  }
};
exports.default = zoomOut;
});

unwrapExports$1(zoomOut_1);

var zoomOutDown_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var scaleAndTranslate = (0, utils.compose)(utils.scale3d, utils.translate3d);


var zoomOutDown = {
  '40%': {
    opacity: 1,
    transform: scaleAndTranslate([0.475, 0.475, 0.475], [0, '-60px', 0]),
    animationTimingFunction: (0, utils.cubicBezier)(0.550, 0.055, 0.675, 0.190)
  },
  to: {
    opacity: 0,
    transform: scaleAndTranslate([0.1, 0.1, 0.1], [0, '2000px', 0]),
    transformOrigin: 'center bottom',
    animationTimingFunction: (0, utils.cubicBezier)(0.175, 0.885, 0.320, 1)
  }
};

exports.default = zoomOutDown;
});

unwrapExports$1(zoomOutDown_1);

var zoomOutLeft_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var scale3dAndTranslate = (0, utils.compose)(utils.scale3d, utils.translate3d);

var scaleAndTranslate = (0, utils.compose)(utils.scale, utils.translate3d);

var zoomOutLeft = {
  '40%': {
    opacity: 1,
    transform: scale3dAndTranslate([0.475, 0.475, 0.475], ['42px', 0, 0])
  },
  to: {
    opacity: 0,
    transform: scaleAndTranslate(0.1, ['-2000px', 0, 0]),
    transformOrigin: 'left center'
  }
};

exports.default = zoomOutLeft;
});

unwrapExports$1(zoomOutLeft_1);

var zoomOutRight_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var scale3dAndTranslate = (0, utils.compose)(utils.scale3d, utils.translate3d);

var scaleAndTranslate = (0, utils.compose)(utils.scale, utils.translate3d);

var zoomOutRight = {
  '40%': {
    opacity: 1,
    transform: scale3dAndTranslate([0.475, 0.475, 0.475], ['-42px', 0, 0])
  },
  to: {
    opacity: 0,
    transform: scaleAndTranslate(0.1, ['2000px', 0, 0]),
    transformOrigin: 'right center'
  }
};

exports.default = zoomOutRight;
});

unwrapExports$1(zoomOutRight_1);

var zoomOutUp_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var scaleAndTranslate = (0, utils.compose)(utils.scale3d, utils.translate3d);


var zoomOutUp = {
  '40%': {
    opacity: 1,
    transform: scaleAndTranslate([0.475, 0.475, 0.475], [0, '60px', 0]),
    animationTimingFunction: (0, utils.cubicBezier)(0.550, 0.055, 0.675, 0.190)
  },
  to: {
    opacity: 0,
    transform: scaleAndTranslate([0.1, 0.1, 0.1], [0, '-2000px', 0]),
    transformOrigin: 'center bottom',
    animationTimingFunction: (0, utils.cubicBezier)(0.175, 0.885, 0.320, 1)
  }
};

exports.default = zoomOutUp;
});

unwrapExports$1(zoomOutUp_1);

var lib = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zoomOutUp = exports.zoomOutRight = exports.zoomOutLeft = exports.zoomOutDown = exports.zoomOut = exports.zoomInUp = exports.zoomInRight = exports.zoomInLeft = exports.zoomInDown = exports.zoomIn = exports.rollOut = exports.rollIn = exports.hinge = exports.slideOutUp = exports.slideOutRight = exports.slideOutLeft = exports.slideOutDown = exports.slideInUp = exports.slideInRight = exports.slideInLeft = exports.slideInDown = exports.rotateOutUpRight = exports.rotateOutUpLeft = exports.rotateOutDownRight = exports.rotateOutDownLeft = exports.rotateOut = exports.rotateInUpRight = exports.rotateInUpLeft = exports.rotateInDownRight = exports.rotateInDownLeft = exports.rotateIn = exports.lightSpeedOut = exports.lightSpeedIn = exports.flipOutY = exports.flipOutX = exports.flipInY = exports.flipInX = exports.flip = exports.fadeOutUpBig = exports.fadeOutUp = exports.fadeOutRightBig = exports.fadeOutRight = exports.fadeOutLeftBig = exports.fadeOutLeft = exports.fadeOutDownBig = exports.fadeOutDown = exports.fadeOut = exports.fadeInUpBig = exports.fadeInUp = exports.fadeInRightBig = exports.fadeInRight = exports.fadeInLeftBig = exports.fadeInLeft = exports.fadeInDownBig = exports.fadeInDown = exports.fadeIn = exports.bounceOutUp = exports.bounceOutRight = exports.bounceOutLeft = exports.bounceOutDown = exports.bounceOut = exports.bounceInUp = exports.bounceInRight = exports.bounceInLeft = exports.bounceInDown = exports.bounceIn = exports.tada = exports.swing = exports.shake = exports.rubberBand = exports.headShake = exports.wobble = exports.jello = exports.pulse = exports.flash = exports.bounce = exports.merge = undefined;



var _merge3 = _interopRequireDefault(merge_1);



var _bounce3 = _interopRequireDefault(bounce_1);



var _flash3 = _interopRequireDefault(flash_1);



var _pulse3 = _interopRequireDefault(pulse_1);



var _jello3 = _interopRequireDefault(jello_1);



var _wobble3 = _interopRequireDefault(wobble_1);



var _headShake3 = _interopRequireDefault(headShake_1);



var _rubberBand3 = _interopRequireDefault(rubberBand_1);



var _shake3 = _interopRequireDefault(shake_1);



var _swing3 = _interopRequireDefault(swing_1);



var _tada3 = _interopRequireDefault(tada_1);



var _bounceIn3 = _interopRequireDefault(bounceIn_1);



var _bounceInDown3 = _interopRequireDefault(bounceInDown_1);



var _bounceInLeft3 = _interopRequireDefault(bounceInLeft_1);



var _bounceInRight3 = _interopRequireDefault(bounceInRight_1);



var _bounceInUp3 = _interopRequireDefault(bounceInUp_1);



var _bounceOut3 = _interopRequireDefault(bounceOut_1);



var _bounceOutDown3 = _interopRequireDefault(bounceOutDown_1);



var _bounceOutLeft3 = _interopRequireDefault(bounceOutLeft_1);



var _bounceOutRight3 = _interopRequireDefault(bounceOutRight_1);



var _bounceOutUp3 = _interopRequireDefault(bounceOutUp_1);



var _fadeIn3 = _interopRequireDefault(fadeIn_1);



var _fadeInDown3 = _interopRequireDefault(fadeInDown_1);



var _fadeInDownBig3 = _interopRequireDefault(fadeInDownBig_1);



var _fadeInLeft3 = _interopRequireDefault(fadeInLeft_1);



var _fadeInLeftBig3 = _interopRequireDefault(fadeInLeftBig_1);



var _fadeInRight3 = _interopRequireDefault(fadeInRight_1);



var _fadeInRightBig3 = _interopRequireDefault(fadeInRightBig_1);



var _fadeInUp3 = _interopRequireDefault(fadeInUp_1);



var _fadeInUpBig3 = _interopRequireDefault(fadeInUpBig_1);



var _fadeOut3 = _interopRequireDefault(fadeOut_1);



var _fadeOutDown3 = _interopRequireDefault(fadeOutDown_1);



var _fadeOutDownBig3 = _interopRequireDefault(fadeOutDownBig_1);



var _fadeOutLeft3 = _interopRequireDefault(fadeOutLeft_1);



var _fadeOutLeftBig3 = _interopRequireDefault(fadeOutLeftBig_1);



var _fadeOutRight3 = _interopRequireDefault(fadeOutRight_1);



var _fadeOutRightBig3 = _interopRequireDefault(fadeOutRightBig_1);



var _fadeOutUp3 = _interopRequireDefault(fadeOutUp_1);



var _fadeOutUpBig3 = _interopRequireDefault(fadeOutUpBig_1);



var _flip3 = _interopRequireDefault(flip_1);



var _flipInX3 = _interopRequireDefault(flipInX_1);



var _flipInY3 = _interopRequireDefault(flipInY_1);



var _flipOutX3 = _interopRequireDefault(flipOutX_1);



var _flipOutY3 = _interopRequireDefault(flipOutY_1);



var _lightSpeedIn3 = _interopRequireDefault(lightSpeedIn_1);



var _lightSpeedOut3 = _interopRequireDefault(lightSpeedOut_1);



var _rotateIn3 = _interopRequireDefault(rotateIn_1);



var _rotateInDownLeft3 = _interopRequireDefault(rotateInDownLeft_1);



var _rotateInDownRight3 = _interopRequireDefault(rotateInDownRight_1);



var _rotateInUpLeft3 = _interopRequireDefault(rotateInUpLeft_1);



var _rotateInUpRight3 = _interopRequireDefault(rotateInUpRight_1);



var _rotateOut3 = _interopRequireDefault(rotateOut_1);



var _rotateOutDownLeft3 = _interopRequireDefault(rotateOutDownLeft_1);



var _rotateOutDownRight3 = _interopRequireDefault(rotateOutDownRight_1);



var _rotateOutUpLeft3 = _interopRequireDefault(rotateOutUpLeft_1);



var _rotateOutUpRight3 = _interopRequireDefault(rotateOutUpRight_1);



var _slideInDown3 = _interopRequireDefault(slideInDown_1);



var _slideInLeft3 = _interopRequireDefault(slideInLeft_1);



var _slideInRight3 = _interopRequireDefault(slideInRight_1);



var _slideInUp3 = _interopRequireDefault(slideInUp_1);



var _slideOutDown3 = _interopRequireDefault(slideOutDown_1);



var _slideOutLeft3 = _interopRequireDefault(slideOutLeft_1);



var _slideOutRight3 = _interopRequireDefault(slideOutRight_1);



var _slideOutUp3 = _interopRequireDefault(slideOutUp_1);



var _hinge3 = _interopRequireDefault(hinge_1);



var _rollIn3 = _interopRequireDefault(rollIn_1);



var _rollOut3 = _interopRequireDefault(rollOut_1);



var _zoomIn3 = _interopRequireDefault(zoomIn_1);



var _zoomInDown3 = _interopRequireDefault(zoomInDown_1);



var _zoomInLeft3 = _interopRequireDefault(zoomInLeft_1);



var _zoomInRight3 = _interopRequireDefault(zoomInRight_1);



var _zoomInUp3 = _interopRequireDefault(zoomInUp_1);



var _zoomOut3 = _interopRequireDefault(zoomOut_1);



var _zoomOutDown3 = _interopRequireDefault(zoomOutDown_1);



var _zoomOutLeft3 = _interopRequireDefault(zoomOutLeft_1);



var _zoomOutRight3 = _interopRequireDefault(zoomOutRight_1);



var _zoomOutUp3 = _interopRequireDefault(zoomOutUp_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.merge = _merge3.default;

/* Attention seekers */
/* Fun stuff */

exports.bounce = _bounce3.default;
exports.flash = _flash3.default;
exports.pulse = _pulse3.default;
exports.jello = _jello3.default;
exports.wobble = _wobble3.default;
exports.headShake = _headShake3.default;
exports.rubberBand = _rubberBand3.default;
exports.shake = _shake3.default;
exports.swing = _swing3.default;
exports.tada = _tada3.default;

/* Bouncing entrances */

exports.bounceIn = _bounceIn3.default;
exports.bounceInDown = _bounceInDown3.default;
exports.bounceInLeft = _bounceInLeft3.default;
exports.bounceInRight = _bounceInRight3.default;
exports.bounceInUp = _bounceInUp3.default;

/* Bouncing  exits */

exports.bounceOut = _bounceOut3.default;
exports.bounceOutDown = _bounceOutDown3.default;
exports.bounceOutLeft = _bounceOutLeft3.default;
exports.bounceOutRight = _bounceOutRight3.default;
exports.bounceOutUp = _bounceOutUp3.default;

/* Fading entrances */

exports.fadeIn = _fadeIn3.default;
exports.fadeInDown = _fadeInDown3.default;
exports.fadeInDownBig = _fadeInDownBig3.default;
exports.fadeInLeft = _fadeInLeft3.default;
exports.fadeInLeftBig = _fadeInLeftBig3.default;
exports.fadeInRight = _fadeInRight3.default;
exports.fadeInRightBig = _fadeInRightBig3.default;
exports.fadeInUp = _fadeInUp3.default;
exports.fadeInUpBig = _fadeInUpBig3.default;

/* Fading exits */

exports.fadeOut = _fadeOut3.default;
exports.fadeOutDown = _fadeOutDown3.default;
exports.fadeOutDownBig = _fadeOutDownBig3.default;
exports.fadeOutLeft = _fadeOutLeft3.default;
exports.fadeOutLeftBig = _fadeOutLeftBig3.default;
exports.fadeOutRight = _fadeOutRight3.default;
exports.fadeOutRightBig = _fadeOutRightBig3.default;
exports.fadeOutUp = _fadeOutUp3.default;
exports.fadeOutUpBig = _fadeOutUpBig3.default;

/* Flippers */

exports.flip = _flip3.default;
exports.flipInX = _flipInX3.default;
exports.flipInY = _flipInY3.default;
exports.flipOutX = _flipOutX3.default;
exports.flipOutY = _flipOutY3.default;

/* Lightspeed */

exports.lightSpeedIn = _lightSpeedIn3.default;
exports.lightSpeedOut = _lightSpeedOut3.default;

/* Rotating entrances */

exports.rotateIn = _rotateIn3.default;
exports.rotateInDownLeft = _rotateInDownLeft3.default;
exports.rotateInDownRight = _rotateInDownRight3.default;
exports.rotateInUpLeft = _rotateInUpLeft3.default;
exports.rotateInUpRight = _rotateInUpRight3.default;

/* Rotation exits */

exports.rotateOut = _rotateOut3.default;
exports.rotateOutDownLeft = _rotateOutDownLeft3.default;
exports.rotateOutDownRight = _rotateOutDownRight3.default;
exports.rotateOutUpLeft = _rotateOutUpLeft3.default;
exports.rotateOutUpRight = _rotateOutUpRight3.default;

/* Sliding entrances */

exports.slideInDown = _slideInDown3.default;
exports.slideInLeft = _slideInLeft3.default;
exports.slideInRight = _slideInRight3.default;
exports.slideInUp = _slideInUp3.default;

/* Sliding exits */

exports.slideOutDown = _slideOutDown3.default;
exports.slideOutLeft = _slideOutLeft3.default;
exports.slideOutRight = _slideOutRight3.default;
exports.slideOutUp = _slideOutUp3.default;

/* Specials */

exports.hinge = _hinge3.default;
exports.rollIn = _rollIn3.default;
exports.rollOut = _rollOut3.default;

/* Zooming entrances */

exports.zoomIn = _zoomIn3.default;
exports.zoomInDown = _zoomInDown3.default;
exports.zoomInLeft = _zoomInLeft3.default;
exports.zoomInRight = _zoomInRight3.default;
exports.zoomInUp = _zoomInUp3.default;

/* Zooming exits */

exports.zoomOut = _zoomOut3.default;
exports.zoomOutDown = _zoomOutDown3.default;
exports.zoomOutLeft = _zoomOutLeft3.default;
exports.zoomOutRight = _zoomOutRight3.default;
exports.zoomOutUp = _zoomOutUp3.default;
});

unwrapExports$1(lib);
var lib_1 = lib.zoomOutUp;
var lib_2 = lib.zoomOutRight;
var lib_3 = lib.zoomOutLeft;
var lib_4 = lib.zoomOutDown;
var lib_5 = lib.zoomOut;
var lib_6 = lib.zoomInUp;
var lib_7 = lib.zoomInRight;
var lib_8 = lib.zoomInLeft;
var lib_9 = lib.zoomInDown;
var lib_10 = lib.zoomIn;
var lib_11 = lib.rollOut;
var lib_12 = lib.rollIn;
var lib_13 = lib.hinge;
var lib_14 = lib.slideOutUp;
var lib_15 = lib.slideOutRight;
var lib_16 = lib.slideOutLeft;
var lib_17 = lib.slideOutDown;
var lib_18 = lib.slideInUp;
var lib_19 = lib.slideInRight;
var lib_20 = lib.slideInLeft;
var lib_21 = lib.slideInDown;
var lib_22 = lib.rotateOutUpRight;
var lib_23 = lib.rotateOutUpLeft;
var lib_24 = lib.rotateOutDownRight;
var lib_25 = lib.rotateOutDownLeft;
var lib_26 = lib.rotateOut;
var lib_27 = lib.rotateInUpRight;
var lib_28 = lib.rotateInUpLeft;
var lib_29 = lib.rotateInDownRight;
var lib_30 = lib.rotateInDownLeft;
var lib_31 = lib.rotateIn;
var lib_32 = lib.lightSpeedOut;
var lib_33 = lib.lightSpeedIn;
var lib_34 = lib.flipOutY;
var lib_35 = lib.flipOutX;
var lib_36 = lib.flipInY;
var lib_37 = lib.flipInX;
var lib_38 = lib.flip;
var lib_39 = lib.fadeOutUpBig;
var lib_40 = lib.fadeOutUp;
var lib_41 = lib.fadeOutRightBig;
var lib_42 = lib.fadeOutRight;
var lib_43 = lib.fadeOutLeftBig;
var lib_44 = lib.fadeOutLeft;
var lib_45 = lib.fadeOutDownBig;
var lib_46 = lib.fadeOutDown;
var lib_47 = lib.fadeOut;
var lib_48 = lib.fadeInUpBig;
var lib_49 = lib.fadeInUp;
var lib_50 = lib.fadeInRightBig;
var lib_51 = lib.fadeInRight;
var lib_52 = lib.fadeInLeftBig;
var lib_53 = lib.fadeInLeft;
var lib_54 = lib.fadeInDownBig;
var lib_55 = lib.fadeInDown;
var lib_56 = lib.fadeIn;
var lib_57 = lib.bounceOutUp;
var lib_58 = lib.bounceOutRight;
var lib_59 = lib.bounceOutLeft;
var lib_60 = lib.bounceOutDown;
var lib_61 = lib.bounceOut;
var lib_62 = lib.bounceInUp;
var lib_63 = lib.bounceInRight;
var lib_64 = lib.bounceInLeft;
var lib_65 = lib.bounceInDown;
var lib_66 = lib.bounceIn;
var lib_67 = lib.tada;
var lib_68 = lib.swing;
var lib_69 = lib.shake;
var lib_70 = lib.rubberBand;
var lib_71 = lib.headShake;
var lib_72 = lib.wobble;
var lib_73 = lib.jello;
var lib_74 = lib.pulse;
var lib_75 = lib.flash;
var lib_76 = lib.bounce;
var lib_77 = lib.merge;

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css$2 = ".styles_tooltip__1z_Ax {\n\tposition: fixed;\n  bottom: 8em;\n  right: 7em;\n  z-index: 99999;\n  background-color: white;\n  width: 300px;\n  height: auto;\n  border: 1px solid lightgray;\n  border-radius: 20px 20px 0px 20px;\n  box-shadow: 0px 3px 16px 0px rgba(0,0,0,0.1);\n  display: block;\n  font-size: 14px;\n  color: #333;\n  padding: 1em;\n  text-align: center;\n  line-height: initial;\n  font-family: 'Montserrat Light', arial;\n}\n\n.styles_chatCircle__3yoPm {\n  position: absolute;\n  background-color: white;\n  border: 1px solid lightgray;\n  width: 0.5em !important;\n  height: 0.5em !important;\n  border-radius: 50%;\n  padding: 0.8em;\n  cursor: pointer;\n  box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.1), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n  text-align: center;\n  font-size: 1.2em;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.styles_chatCirclePosition__n8oIR {\n  position: fixed;\n  bottom: 4em;\n  right: 4em;\n}\n\n.styles_chatCircleSmall__G17Jm {\n  position: fixed;\n  bottom: 90px;\n  right: 40px;\n  background-color: white;\n  border: 1px solid lightgray;\n  border-radius: 50%;\n  padding: 0.4em;\n  cursor: pointer;\n  box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.1), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n  text-align: center;\n  font-size: 1em;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.styles_speechBubble__GrPCz {\n  position: fixed;\n  background: #999999 none repeat scroll 0% 0%;\n  border-radius: .4em;\n  display: block;\n  padding: 10px;\n  height: auto;\n  text-align: center;\n  max-width: 200px;\n  font-size: 14px;\n  bottom: 110px;\n  right: 10px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 16px 0px, rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px !important;\n  border: 1px solid lightgray;\n}\n\n.styles_speechBubbleOff__3nI9q {\n  position: fixed;\n  background: ivory none repeat scroll 0% 0%;\n  border-radius: .4em;\n  display: block;\n  padding: 10px;\n  height: auto;\n  text-align: center;\n  max-width: 200px;\n  font-size: 14px;\n  bottom: 110px;\n  right: 10px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 16px 0px, rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px !important;\n  border: 1px solid lightgray,\n}\n\n.styles_speechBubbleArrow__3mB7B {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 80%;\n  width: 0;\n  height: 0;\n  border: 20px solid transparent;\n  border-top-color: #999999;\n  border-bottom: 0;\n  border-left: 0;\n  margin-left: -10px;\n  margin-bottom: -20px;\n}\n";
var styles$4 = {"tooltip":"styles_tooltip__1z_Ax","chatCircle":"styles_chatCircle__3yoPm","chatCirclePosition":"styles_chatCirclePosition__n8oIR","chatCircleSmall":"styles_chatCircleSmall__G17Jm","speechBubble":"styles_speechBubble__GrPCz","speechBubbleOff":"styles_speechBubbleOff__3nI9q","speechBubbleArrow":"styles_speechBubbleArrow__3mB7B"};
styleInject(css$2);

var animStyles = StyleSheet$1.create({
    fadeIn: {
        animationName: lib_56,
        animationDuration: '1s',
    },
    fadeOut: {
        animationName: lib_47,
        animationDuration: '1s',
    },
    fadeInLarge: {
        animationName: lib_56,
        animationDuration: '3s',
    },
    wobble: {
        animationName: lib_72,
        animationDuration: '1s'
    },
    bounce: {
        animationName: lib_76,
        animationDuration: '3s'
    },
    pulse: {
        animationName: lib_74,
        animationDuration: '2s'
    }
});
var CircleBtn = /** @class */ (function (_super) {
    __extends(CircleBtn, _super);
    function CircleBtn(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isShown: false,
            colorClass: '',
        };
        return _this;
    }
    CircleBtn.prototype.componentDidMount = function () {
        this.setState({ colorClass: this.props.theme.mainColor });
    };
    CircleBtn.prototype.shouldRenderCircleAnimation = function () {
        var _this = this;
        var _a = this.props, popoverActive = _a.popoverActive, popoverText = _a.popoverText, currentEvent = _a.currentEvent, currentEventType = _a.currentEventType, lang = _a.lang;
        var switchChat = this.props.switchChat;
        // (currentEventType === 'visual_claim') ? (css(animStyles.bounce)) : (css(animStyles.fadeInLarge))
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: this.state.colorClass },
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: styles$4.chatCirclePosition },
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: (currentEventType === 'visual_claim') ? (css$1(animStyles.bounce)) : '' },
                    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: styles$4.chatCircle, onClick: switchChat, onMouseEnter: function () { return _this.setState({ isShown: true }); }, onMouseLeave: function () { return _this.setState({ isShown: false }); } },
                        (this.state.isShown && popoverActive) ? (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: css$1(animStyles.fadeIn) },
                            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: styles$4.tooltip }, popoverText))) : (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null)),
                        (currentEventType === 'popup_claim' || currentEventType === 'popup_claim_off') ? (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: (currentEventType === 'popup_claim') ? css$1(animStyles.fadeIn) : (css$1(animStyles.fadeOut)) },
                            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: styles$4.tooltip }, currentEvent.message[lang]))) : (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null)),
                        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(FontAwesomeIcon, { icon: faCommentDots, size: "1x" }),
                        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { id: "chat-overlay" }))))));
    };
    CircleBtn.prototype.render = function () {
        var _a = this.props, switchChat = _a.switchChat, openedChat = _a.openedChat;
        if (openedChat) {
            return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: this.state.colorClass },
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: css$1(animStyles.fadeInLarge) },
                    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: styles$4.chatCircleSmall, onClick: switchChat },
                        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(FontAwesomeIcon, { icon: faTimesCircle, size: "1x" }),
                        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { id: "chat-overlay" })))));
        }
        else {
            return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", null, this.shouldRenderCircleAnimation()));
        }
    };
    return CircleBtn;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var Base64 = (function () {
    function Base64() {
    }
    Base64.prototype.encode = function (s) {
        return (typeof $ !== 'undefined' && $.base64) ? $.base64.encode(s) : this.stringToBase64(JSON.stringify(s));
    };
    Base64.prototype.decode = function (s) {
        return (typeof $ !== 'undefined' && $.base64) ? $.base64.decode(s) : this.base64ToString(s);
    };
    Base64.prototype.stringToBase64 = function (str) {
        return window.btoa(unescape(encodeURIComponent(str)));
    };
    Base64.prototype.base64ToString = function (str) {
        return decodeURIComponent(escape(window.atob(str)));
    };
    return Base64;
}());

var CookiesManager = (function () {
    function CookiesManager() {
    }
    CookiesManager.getActions = function () {
        var cookiesList = document.cookie.split(';');
        var result = [];
        for (var index = 0; index < cookiesList.length; index++) {
            var cookie = cookiesList[index];
            if (cookie !== '' && cookie.indexOf('$RT_') !== -1) {
                var actionCodeStr = cookie.substring(cookie.indexOf('$RT_') + 5, cookie.length);
                try {
                    var actionCode = JSON.parse(unescape(actionCodeStr));
                    result.push(actionCode);
                }
                catch (error) {
                    
                }
            }
        }
        return result;
    };
    CookiesManager.getWinCtrlCookie = function () {
        var cookieList = document.cookie.split(';');
        var winCtrlCookie = false;
        for (var _i = 0, cookieList_1 = cookieList; _i < cookieList_1.length; _i++) {
            var cookie = cookieList_1[_i];
            if (cookie.indexOf('__WIN_CTRL') !== -1) {
                winCtrlCookie = cookie.substring(cookie.indexOf('__WIN_CTRL') + 11, cookie.length);
            }
        }
        if (winCtrlCookie) {
            return JSON.parse(unescape(winCtrlCookie));
        }
        else {
            return {
                winStack: []
            };
        }
    };
    CookiesManager.setWinControlCookie = function (winStack) {
        var date = new Date();
        var threeMonths = 7890000 * 1000;
        date.setTime(date.getTime() + threeMonths);
        var winStackToCookie = JSON.stringify(winStack);
        var cookieCreated = "__WIN_CTRL=" + escape(winStackToCookie) + ";path=/;domain=" + window.location.hostname + ";secure:'';expires=" + date.toUTCString();
        window.document.cookie = cookieCreated;
    };
    CookiesManager.delWinControlCookie = function () {
        window.document.cookie = "__WIN_CTRL=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=" + window.location.hostname;
    };
    CookiesManager.getRuntimeCookie = function () {
        var cookieList = document.cookie.split(';');
        var runtimeCookie = false;
        for (var _i = 0, cookieList_2 = cookieList; _i < cookieList_2.length; _i++) {
            var cookie = cookieList_2[_i];
            if (cookie.indexOf('__runtime_rt') !== -1) {
                runtimeCookie = cookie.substring(cookie.indexOf('__runtime_rt') + 13, cookie.length);
            }
        }
        if (runtimeCookie) {
            return JSON.parse(unescape(runtimeCookie));
        }
    };
    CookiesManager.setRuntimeCookie = function (restartOnClose) {
        var date = new Date();
        date.setTime(date.getTime() + 5 * 1000);
        var value = JSON.stringify({
            restart_on_close: restartOnClose,
            voice_actived: true
        });
        var runtimeCookie = "__runtime_rt=" + escape(value) + ";path=/;domain=" + window.location.hostname + ";secure:'';expires=" + date.toUTCString();
        window.document.cookie = runtimeCookie;
    };
    CookiesManager.delRuntimeCookie = function () {
        var d = new Date();
        d.setTime(d.getTime() - 1000 * 60 * 60 * 24);
        var expires = 'expires=' + d.toUTCString();
        window.document.cookie = "__runtime_rt=;" + expires;
    };
    CookiesManager.getConfigCookie = function () {
        var cookieList = document.cookie.split(';');
        var configCookie = false;
        for (var _i = 0, cookieList_3 = cookieList; _i < cookieList_3.length; _i++) {
            var cookie = cookieList_3[_i];
            if (cookie.indexOf('__config_rt') !== -1) {
                configCookie = cookie.substring(cookie.indexOf('__config_rt') + 12, cookie.length);
            }
        }
        if (configCookie) {
            var unescapedConfig = unescape(configCookie);
            var parsedConfig = void 0;
            try {
                parsedConfig = JSON.parse(unescapedConfig);
                return parsedConfig;
            }
            catch (error) {
                
            }
        }
    };
    CookiesManager.setConfigCookie = function (config) {
        var date = new Date();
        date.setTime(date.getTime() + 7890000 * 1000);
        var cookieCreated = "__config_rt=" + escape(JSON.stringify(config)) + ";path=/;domain=" + window.location.hostname + ";secure:'';expires=" + date.toUTCString();
        window.document.cookie = cookieCreated;
    };
    CookiesManager.delConfigCookie = function () {
        var d = new Date();
        d.setTime(d.getTime() - 1000 * 60 * 60 * 24);
        var expires = 'expires=' + d.toUTCString();
        window.document.cookie = "__config_rt=;" + expires;
    };
    CookiesManager.set = function (cookie) {
        var cookieName = this.getNameEncoded(cookie.value);
        var cookieCreated = cookieName +
            '=' +
            escape(JSON.stringify(cookie.value)) +
            (cookie.expires ? '; expires=' + cookie.expires : '') +
            (cookie.path ? '; path=' + cookie.path : '') +
            (cookie.domain ? '; domain=' + cookie.domain : '') +
            (cookie.secure ? '; secure' : '');
        window.document.cookie = cookieCreated;
    };
    CookiesManager.del = function (input) {
        var d = new Date();
        d.setTime(d.getTime() - 1000 * 60 * 60 * 24);
        var expires = 'expires=' + d.toUTCString();
        window.document.cookie = this.getNameEncoded(input) + '=' + '; ' + expires;
    };
    CookiesManager.createActionCookie = function (input) {
        var date = new Date();
        date.setTime(date.getTime() + 10 * 1000);
        var cookie = {
            expires: date.toUTCString(),
            value: input
        };
        if (typeof window !== 'undefined') {
            this.set(cookie);
        }
    };
    CookiesManager.getNameEncoded = function (event) {
        var base64Name = this.base64.encode(event);
        var cookieName = base64Name.substring(0, 150) + '$RT_';
        cookieName = cookieName.replace('=', '');
        return cookieName;
    };
    CookiesManager.base64 = new Base64();
    return CookiesManager;
}());

function createRtSdkError(errorScope, errorMessage) {
    var error = new Error(errorMessage);
    error.name = "RtSdk." + errorScope + " Error";
    return error;
}

var GenericEventDispatcher = (function () {
    function GenericEventDispatcher(options) {
        this.actionMappers = options.actionMappers;
        this.handlerAdapters = options.handlerAdapters;
        this.errorMapper = options.errorMapper;
        this.actionExecution = false;
    }
    GenericEventDispatcher.prototype.dispatchAction = function (input, cb) {
        var _this = this;
        this.actionExecution = false;
        for (var i = 0; i <= this.actionMappers.length - 1; i++) {
            var actionMapper = this.actionMappers[i];
            actionMapper.getActionHandlerChain(input, function (error, handlerChain) {
                if (error) {
                    throw new Error(error);
                }
                if (handlerChain) {
                    var handler = handlerChain.getActionHandler();
                    var adapter = void 0;
                    for (var _i = 0, _a = _this.handlerAdapters; _i < _a.length; _i++) {
                        var handlerAdapter = _a[_i];
                        if (handlerAdapter.supports(handler)) {
                            adapter = handlerAdapter;
                            break;
                        }
                    }
                    if (!adapter) {
                        throw createRtSdkError('GenericEventDispatcher', "Unable to find a suitable handler adapter.");
                    }
                    adapter.execute(input, handler, cb);
                    _this.actionExecution = true;
                }
            });
        }
        if (!this.actionExecution && input.type === 'application') {
            this.saveEventToStorage(input);
        }
        else {
            this.removeEventFromStorage(input);
        }
    };
    GenericEventDispatcher.prototype.dispatchError = function (input, error) {
        if (this.errorMapper) {
            this.errorMapper.getErrorHandler(input, error, function (e, handler) {
                if (handler) {
                    return handler.handle(input, error);
                }
            });
        }
        throw error;
    };
    GenericEventDispatcher.prototype.saveEventToStorage = function (input) {
        if (input) {
            CookiesManager.createActionCookie(input);
        }
    };
    GenericEventDispatcher.prototype.removeEventFromStorage = function (input) {
        if (typeof window !== 'undefined') {
            CookiesManager.del(input);
        }
    };
    return GenericEventDispatcher;
}());

var GenericActionHandlerChain = (function () {
    function GenericActionHandlerChain(options) {
        this.actionHandler = options.actionHandler;
    }
    GenericActionHandlerChain.prototype.getActionHandler = function () {
        return this.actionHandler;
    };
    return GenericActionHandlerChain;
}());

var GenericHandlerAdapter = (function () {
    function GenericHandlerAdapter() {
    }
    GenericHandlerAdapter.prototype.supports = function (handler) {
        return ((typeof handler.canHandle === 'function' && typeof handler.handle === 'function') ||
            (typeof handler.handle === 'object' && typeof handler.canHandle === 'function'));
    };
    GenericHandlerAdapter.prototype.execute = function (input, handler, cb) {
        var currentStep = input._step || 0;
        input.next = this.nextAction.bind(this, cb, currentStep, input, handler);
        input.redirect = this.redirect.bind(this, currentStep, input);
        input.context = {};
        if (Array.isArray(handler.handle)) {
            input._num_steps = handler.handle.length - 1;
            delete input._step;
            delete input._num_steps;
            handler.handle[currentStep].call(this, input);
        }
        else {
            return handler.handle(input);
        }
    };
    GenericHandlerAdapter.prototype.redirect = function (currentStep, input, path, passingData) {
        var isPath = path.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/);
        if (isPath && path !== window.location.href) {
            if (input._step) {
                input.context = passingData;
                input._step = currentStep + 1;
                if (input._step !== input._num_steps) {
                    CookiesManager.createActionCookie(input);
                }
            }
            window.location.href = path;
        }
        throw new Error('rt-sdk-js: not valid url or path to redirect');
    };
    GenericHandlerAdapter.prototype.objectValues = function (obj) {
        var res = [];
        for (var i in obj) {
            if (obj.hasOwnProperty(i)) {
                res.push(obj[i]);
            }
        }
        return res;
    };
    GenericHandlerAdapter.prototype.nextAction = function (originalCb, currentStep, input, handler, actionError, passingData) {
        input.context = passingData;
        input._step = currentStep + 1;
        var steps = this.objectValues(handler.handle);
        if (steps[input._step]) {
            this.execute(input, handler, originalCb);
        }
        else {
            return originalCb(actionError, input.context);
        }
    };
    return GenericHandlerAdapter;
}());

var GenericActionMapper = (function () {
    function GenericActionMapper(options) {
        this.actionHandlerChains = options.actionHandlerChains;
    }
    GenericActionMapper.prototype.getActionHandlerChain = function (input, cb) {
        for (var _i = 0, _a = this.actionHandlerChains; _i < _a.length; _i++) {
            var actionHandlerChain = _a[_i];
            var requestHandler = actionHandlerChain.getActionHandler();
            this.callback = cb;
            input.redirect = this.redirect.bind(this, input);
            input.isCurrentUrlIn = this.isCurrentUrlIn;
            input.allow = this.allowHandle.bind(this, actionHandlerChain);
            input.deny = this.denyHandle.bind(this);
            requestHandler.canHandle(input);
        }
    };
    GenericActionMapper.prototype.allowHandle = function (actionHandlerChain) {
        return this.callback(null, actionHandlerChain);
    };
    GenericActionMapper.prototype.denyHandle = function () {
    };
    GenericActionMapper.prototype.redirect = function (input, url) {
        if (window.location.href !== url) {
            CookiesManager.createActionCookie(input);
            window.location.href = url;
        }
    };
    GenericActionMapper.prototype.isCurrentUrlIn = function (domains) {
        if (domains[0] === '*') {
            return true;
        }
        var isDomainMatch = false;
        for (var _i = 0, domains_1 = domains; _i < domains_1.length; _i++) {
            var domain = domains_1[_i];
            var urlToCompare = domain.split('*')[0];
            isDomainMatch = isDomainMatch || window.location.href.indexOf(urlToCompare) !== -1;
        }
        return isDomainMatch;
    };
    return GenericActionMapper;
}());

var GenericErrorMapper = (function () {
    function GenericErrorMapper(options) {
        this.errorHandlers = options.errorHandlers;
    }
    GenericErrorMapper.prototype.getErrorHandler = function (handlerInput, error, cb) {
        return null;
    };
    return GenericErrorMapper;
}());

var RuntimeConfigurationBuilder = (function () {
    function RuntimeConfigurationBuilder() {
        this.actionHandlerChains = [];
        this.errorHandlers = [];
    }
    RuntimeConfigurationBuilder.prototype.addActionHandlers = function () {
        var actionHandlers = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            actionHandlers[_i] = arguments[_i];
        }
        for (var _a = 0, actionHandlers_1 = actionHandlers; _a < actionHandlers_1.length; _a++) {
            var actionHandler = actionHandlers_1[_a];
            this.actionHandlerChains.push(new GenericActionHandlerChain({
                actionHandler: actionHandler
            }));
        }
        return this;
    };
    RuntimeConfigurationBuilder.prototype.addErrorHandlers = function () {
        var _a;
        var errorHandlers = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            errorHandlers[_i] = arguments[_i];
        }
        (_a = this.errorHandlers).push.apply(_a, errorHandlers);
        return this;
    };
    RuntimeConfigurationBuilder.prototype.getRuntimeConfiguration = function () {
        var actionMapper = new GenericActionMapper({
            actionHandlerChains: this.actionHandlerChains
        });
        var errorMapper = this.errorHandlers.length
            ? new GenericErrorMapper({
                errorHandlers: this.errorHandlers
            })
            : undefined;
        return {
            actionMappers: [actionMapper],
            errorMapper: errorMapper,
            handlerAdapters: [new GenericHandlerAdapter()]
        };
    };
    return RuntimeConfigurationBuilder;
}());

function extractVersion(uastring, expr, pos) {
    var match = uastring.match(expr);
    return match && match.length >= pos && parseInt(match[pos], 10);
}
function detectBrowser(window) {
    var navigator = window.navigator;
    var result = { browser: null, version: null };
    if (typeof window === 'undefined' || !window.navigator) {
        result.browser = 'Not a browser.';
        return result;
    }
    if (navigator.mozGetUserMedia) {
        result.browser = 'firefox';
        result.version = extractVersion(navigator.userAgent, /Firefox\/(\d+)\./, 1);
    }
    else if (navigator.webkitGetUserMedia) {
        result.browser = 'chrome';
        result.version = extractVersion(navigator.userAgent, /Chrom(e|ium)\/(\d+)\./, 2);
    }
    else if (navigator.mediaDevices &&
        navigator.userAgent.match(/Edge\/(\d+).(\d+)$/)) {
        result.browser = 'edge';
        result.version = extractVersion(navigator.userAgent, /Edge\/(\d+).(\d+)$/, 2);
    }
    else if (window.RTCPeerConnection &&
        navigator.userAgent.match(/AppleWebKit\/(\d+)\./)) {
        result.browser = 'safari';
        result.version = extractVersion(navigator.userAgent, /AppleWebKit\/(\d+)\./, 1);
    }
    else {
        result.browser = 'Not a supported browser.';
        return result;
    }
    return result;
}

function shimGetUserMedia(window) {
    var _this = this;
    var browserDetails = detectBrowser(window);
    var navigator = window && window.navigator;
    var MediaStreamTrack = window && window.MediaStreamTrack;
    navigator.getUserMedia = function (constraints, onSuccess, onError) {
        navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
    };
    if (!(browserDetails.version > 55 && 'autoGainControl' in navigator.mediaDevices.getSupportedConstraints())) {
        var remap_1 = function (obj, a, b) {
            if (a in obj && !(b in obj)) {
                obj[b] = obj[a];
                delete obj[a];
            }
        };
        var nativeGetUserMedia_1 = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
        navigator.mediaDevices.getUserMedia = function (c) {
            if (typeof c === 'object' && typeof c.audio === 'object') {
                c = JSON.parse(JSON.stringify(c));
                remap_1(c.audio, 'autoGainControl', 'mozAutoGainControl');
                remap_1(c.audio, 'noiseSuppression', 'mozNoiseSuppression');
            }
            return nativeGetUserMedia_1(c);
        };
        if (MediaStreamTrack && MediaStreamTrack.prototype.getSettings) {
            var nativeGetSettings_1 = MediaStreamTrack.prototype.getSettings;
            MediaStreamTrack.prototype.getSettings = function () {
                var obj = nativeGetSettings_1.apply(this, arguments);
                remap_1(obj, 'mozAutoGainControl', 'autoGainControl');
                remap_1(obj, 'mozNoiseSuppression', 'noiseSuppression');
                return obj;
            };
        }
        if (MediaStreamTrack && MediaStreamTrack.prototype.applyConstraints) {
            var nativeApplyConstraints_1 = MediaStreamTrack.prototype.applyConstraints;
            MediaStreamTrack.prototype.applyConstraints = function (c) {
                if (_this.kind === 'audio' && typeof c === 'object') {
                    c = JSON.parse(JSON.stringify(c));
                    remap_1(c, 'autoGainControl', 'mozAutoGainControl');
                    remap_1(c, 'noiseSuppression', 'mozNoiseSuppression');
                }
                return nativeApplyConstraints_1.apply(_this, [c]);
            };
        }
    }
}

var Events = (function () {
    function Events(seatId, channel, apiKey, entryPoint, url, device) {
        this.seatId = seatId;
        this.channel = channel;
        this.apiKey = apiKey;
        this.entryPoint = entryPoint;
        this.url = url;
        this.device = device;
    }
    Events.prototype.startIntent = function (intent) {
        var startIntent = {
            content: {
                actions: {
                    main: {
                        entities: [],
                        intent: intent
                    }
                },
                targetUser: {
                    channel: this.channel,
                    sourceValue: this.seatId
                },
                type: 'run'
            },
            type: 'application'
        };
        return startIntent;
    };
    Events.prototype.restartUserContext = function () {
        var restartUsrContxt = {
            content: {
                actions: {
                    main: {
                        action: 'RestartUserContext',
                        entities: [],
                        intent: ''
                    }
                },
                targetUser: {
                    channel: 'desktop',
                    sourceValue: this.seatId
                },
                type: 'dialogControl'
            },
            type: 'application'
        };
        return restartUsrContxt;
    };
    Events.prototype.desktopTalk = function (text) {
        var desktopTalkMsg = {
            content: {
                actions: {
                    main: {
                        domainName: 'rt/system-actions',
                        entities: [
                            {
                                entity: 'text',
                                value: text
                            },
                        ],
                        intent: 'system_desktop_talk'
                    }
                },
                targetUser: {
                    botName: '',
                    channel: 'desktop',
                    sourceValue: this.seatId
                },
                type: 'run'
            },
            type: 'application'
        };
        return desktopTalkMsg;
    };
    Events.prototype.sendUtterance = function (text, lang) {
        var sendUtteranceMsg = {
            content: {
                language: this.standarizationLang(lang),
                text: text
            },
            source: {
                apiKey: this.apiKey
            },
            type: 'user'
        };
        return sendUtteranceMsg;
    };
    Events.prototype.noUnderstood = function (lang) {
        var noUnderstoodMsg = {
            content: {
                language: this.standarizationLang(lang),
                text: 'not_understood'
            },
            source: {
                apiKey: this.apiKey
            },
            type: 'user'
        };
        return noUnderstoodMsg;
    };
    Events.prototype.initializeWs = function () {
        var msg = {
            apiKey: this.apiKey,
            channel: this.channel,
            entryPoint: this.entryPoint || '',
            events: 'all',
            seatId: this.seatId,
            url: this.url,
            device: this.device
        };
        return msg;
    };
    Events.prototype.initializeTranscriptWs = function (lang, sampleRate) {
        var msg = {
            apiKey: this.apiKey,
            language: this.standarizationLang(lang),
            sampleRate: sampleRate,
            seatId: this.seatId
        };
        return msg;
    };
    Events.prototype.speechRecognition = function (text, event) {
        var msg = {
            content: {
                event: event,
                text: text
            },
            type: 'SpeechRecognition'
        };
        return msg;
    };
    Events.prototype.notSupportedCriticalFeature = function (error, event) {
        var msg = {
            content: {
                event: event,
                error: error
            },
            type: 'notSupportedCriticalFeature'
        };
        return msg;
    };
    Events.prototype.streamingTranscription = function (text, event) {
        var msg = {
            content: {
                event: event,
                text: text
            },
            type: 'StreamingTranscription'
        };
        return msg;
    };
    Events.prototype.connectedToTalkServer = function () {
        var msg = {
            content: {
                event: 'connected',
                text: 'ok'
            },
            type: 'Websockets'
        };
        return msg;
    };
    Events.prototype.keyboard = function () {
        var msg = {
            content: {
                event: {},
                text: {}
            },
            type: 'TargetKeyDown'
        };
        return msg;
    };
    Events.prototype.error = function (error) {
        var msg = {
            content: {
                event: {},
                text: {},
                error: error
            },
            type: 'Error'
        };
        return msg;
    };
    Events.prototype.remoteConfig = function (remoteData) {
        var msg = {
            content: {
                event: remoteData,
                text: {}
            },
            type: 'RemoteConfig'
        };
        return msg;
    };
    Events.prototype.standarizationLang = function (lang) {
        return lang.split('-')[0];
    };
    return Events;
}());

var AudioStreaming = (function () {
    function AudioStreaming(dispatch, options) {
        if (options === void 0) { options = { bufferSize: 0, audio: true }; }
        this.checkSupport();
        shimGetUserMedia(window);
        this.isNotSending = true;
        this._AudioContext = window.AudioContext || window.webkitAudioContext;
        this.emptyChunk = new Int16Array(512);
        this.dispatch = dispatch;
        this.libEvents = new Events('.', '.', '', '.', '', '');
        this.bufferSize = options.bufferSize;
        this.audioSettings = options.audio;
        this.status = 'not_running';
        
        
        
    }
    AudioStreaming.prototype.start = function (connectionManager, callback) {
        var _this = this;
        if (this.status === 'not_running') {
            this.status = 'running';
            this.connectionManager = connectionManager;
            this.connectionManager.openTscWebSocket(function () {
                _this.isNotSending = false;
                navigator.mediaDevices
                    .getUserMedia({ audio: _this.audioSettings })
                    .then(function (stream) {
                    _this.handleSuccess(stream);
                    if (callback && typeof callback === 'function')
                        callback(true);
                })["catch"](function (error) {
                    _this.handleError(error);
                    if (callback && typeof callback === 'function')
                        callback(true);
                });
            });
        }
        else if (this.status === 'iddle') {
            this.status = 'running';
            this.connectionManager.openTscWebSocket(function () {
                _this.audioTrack[0].enabled = true;
                _this.isNotSending = false;
            });
        }
    };
    AudioStreaming.prototype.closeStreaming = function () {
        this.audioTrack[0].enabled = false;
        this.status = 'iddle';
        this.isNotSending = true;
    };
    AudioStreaming.prototype.checkSupport = function () {
        var getUserMedia = navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.mediaDevices.getUserMedia;
        if (!getUserMedia) {
            throw new Error("getUserMedia is not implemented or you are in an insecure environment, make sure you are on https SSL");
        }
        else
            this.isSupported = true;
    };
    AudioStreaming.prototype.handleSuccess = function (stream) {
        this.stream = stream;
        this.audioTrack = this.stream.getAudioTracks();
        
        this.initializeRecorder(this.stream);
    };
    AudioStreaming.prototype.handleError = function (error) {
        
        this.isNotSending = true;
    };
    AudioStreaming.prototype.initializeRecorder = function (stream) {
        this.context = new this._AudioContext();
        var audioInput = this.context.createMediaStreamSource(stream);
        this.recorder = this.context.createScriptProcessor(this.bufferSize, 1, 1);
        this.recorder.onaudioprocess = this.micAudioHandler.bind(this);
        audioInput.connect(this.recorder).connect(this.context.destination);
    };
    AudioStreaming.prototype.micAudioHandler = function (e) {
        if (this.status === 'running') {
            if (this.connectionManager.transport.tscWS.client.readyState === 1) {
                var unprocessedData = e.inputBuffer.getChannelData(0);
                var processedData = this.convertFloat32ToInt16(unprocessedData);
                var i = void 0;
                var j = void 0;
                var chunk = 512;
                for (i = 0, j = processedData.length; i < j; i += chunk) {
                    var chunkedData = Object.assign(this.emptyChunk, processedData.slice(i, i + chunk));
                    this.connectionManager.transport.tscWS.send(chunkedData.buffer);
                }
            }
        }
    };
    AudioStreaming.prototype.convertFloat32ToInt16 = function (buffer) {
        var l = buffer.length;
        var buf = new Int16Array(l);
        while (l--) {
            buf[l] = Math.min(1, buffer[l]) * 0x7fff;
        }
        return buf;
    };
    return AudioStreaming;
}());

var runtimeConfig = {
    api: {
        pro: {
            jsonpSend: 'https://channel-pro.woice.live/channel/desktop/jpae',
            longPollingJP: 'https://channel-pro.woice.live/channel/desktop/jplp',
            tscWs: 'wss://channel-pro.rational-touch.com/channel/voice/transcript',
            wsUrl: 'wss://channel-pro.rational-touch.com/channel/desktop/desktop'
        },
        proShopify: {
            jsonpSend: 'https://channel-pro.woice.live/channel/desktop/jpae',
            longPollingJP: 'https://channel-pro.woice.live/channel/desktop/jplp',
            tscWs: 'wss://channel-pro.rational-touch.com/channel/voice/transcript',
            wsUrl: 'wss://channel-pro.rational-touch.com/channel/desktop/woice/v010/desktop'
        },
        qa: {
            jsonpSend: 'https://channel-qa.woice.live/channel/desktop/jpae',
            longPollingJP: 'https://channel-qa.woice.live/channel/desktop/jplp',
            tscWs: 'wss://channel-qa.rational-touch.com/channel/voice/transcript',
            wsUrl: 'wss://channel-qa.rational-touch.com/channel/desktop/desktop'
        },
        qaShopify: {
            jsonpSend: 'https://channel-qa.woice.live/channel/desktop/jpae',
            longPollingJP: 'https://channel-qa.woice.live/channel/desktop/jplp',
            tscWs: 'wss://channel-qa.rational-touch.com/channel/voice/transcript',
            wsUrl: 'wss://channel-qa.rational-touch.com/channel/desktop/woice/v010/desktop'
        },
        dev: {
            jsonpSend: 'https://channel-dev.woice.live/channel/desktop/jpae',
            longPollingJP: 'https://channel-dev.woice.live/channel/desktop/jplp',
            tscWs: 'wss://channel-dev.rational-touch.com/channel/voice/transcript',
            wsUrl: 'wss://channel-dev.rational-touch.com/channel/desktop/desktop'
        },
        cmadridCita: {
            jsonpSend: 'https://botcita.comunidad.madrid/channel/desktop/jpae',
            longPollingJP: 'https://botcita.comunidad.madrid/channel/desktop/jplp',
            tscWs: 'wss://botcita.comunidad.madrid/channel/voice/transcript',
            wsUrl: 'wss://botcita.comunidad.madrid/channel/desktop/desktop'
        }
    },
    connection: {
        maxRetries: 3,
        timeAfterMaxRetries: 3000000,
        timeBtwRetries: 10000
    }
};

function makeid() {
    var text = '';
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < 12; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
}

var WebSocketHandler = (function () {
    function WebSocketHandler(_a) {
        var seatId = _a.seatId, apikey = _a.apikey, wsUrl = _a.wsUrl, channel = _a.channel, entryPoint = _a.entryPoint, url = _a.url, device = _a.device;
        this.client = new WebSocket(wsUrl);
        this.serverMsgs = new Events(seatId, channel, apikey, entryPoint, url, device);
    }
    WebSocketHandler.prototype.createTransport = function () {
        return { send: this.send.bind(this) };
    };
    WebSocketHandler.prototype.send = function (event) {
        this.client.send(event);
    };
    WebSocketHandler.prototype.close = function () {
        if (this.client.readyState === 1 && this.client.close) {
            this.client.close();
            clearInterval(this.timerKeepAlive);
        }
    };
    WebSocketHandler.prototype.onopen = function (callback) {
        this.client.onopen = callback;
    };
    WebSocketHandler.prototype.onmessage = function (callback) {
        this.client.onmessage = callback;
    };
    WebSocketHandler.prototype.onclose = function (callback) {
        this.client.onclose = callback;
    };
    WebSocketHandler.prototype.onerror = function (callback) {
        this.client.onerror = callback;
    };
    WebSocketHandler.prototype.sendInitial = function () {
        var msg = this.serverMsgs.initializeWs();
        this.client.send(JSON.stringify(msg));
        this.keepAlive();
    };
    WebSocketHandler.prototype.sendInitialTsc = function (language, sampleRate) {
        var msg = this.serverMsgs.initializeTranscriptWs(language, sampleRate);
        this.client.send(JSON.stringify(msg));
    };
    WebSocketHandler.prototype.keepAlive = function () {
        var _this = this;
        var keepAliveMsg = JSON.stringify({
            type: 'keepAlive'
        });
        this.timerKeepAlive = setInterval(function () {
            _this.client.send(keepAliveMsg);
        }, 45000);
    };
    return WebSocketHandler;
}());

var ConnectionManager = (function () {
    function ConnectionManager(dispatch, language, environment, href, device) {
        this.events = 'application';
        this.dispatch = dispatch;
        this.seatId = null;
        this.channel = false;
        this.TIMEOUT = 59;
        this.currentLocation = href;
        this.currentDevice = device;
        this.syncConfig = CookiesManager.getConfigCookie() || {};
        this.supportsWebSockets = 'WebSocket' in window || 'MozWebSocket' in window;
        this.STAGE = environment;
        this.urlLP = runtimeConfig.api[this.STAGE].longPollingJP;
        this.urlSE = runtimeConfig.api[this.STAGE].jsonpSend;
        this.wsUrl = runtimeConfig.api[this.STAGE].wsUrl;
        this.tscWs = runtimeConfig.api[this.STAGE].tscWs;
        this.wsHandler = null;
        this.retriesCounter = 0;
        this.timeBtwRetries = runtimeConfig.connection.timeBtwRetries;
        this.timeAfterMaxRetries = runtimeConfig.connection.timeAfterMaxRetries;
        this.maxRetries = runtimeConfig.connection.maxRetries;
        this.reconnecting = false;
        this.language = language;
        this.autoReconnect = true;
    }
    ConnectionManager.prototype.connect = function (apikey, channel, entryPoint, seatId, callback) {
        if (apikey === void 0) { apikey = this.apiKey; }
        this.apiKey = apikey;
        this.seatId = seatId;
        this.channel = channel;
        this.entryPoint = entryPoint;
        if (callback) {
            this.connectionCallback = callback;
        }
        if (this.supportsWebSockets) {
            this.createConnection();
        }
        else {
            this.dispatch(this.serverMessages.error(new Error('No websockets support')));
        }
    };
    ConnectionManager.prototype.disconnect = function () {
        this.autoReconnect = false;
        clearInterval(this.reconnectTimer);
        return this.wsHandler.close();
    };
    ConnectionManager.prototype.receivedEventFromLongPolling = function (event) {
        if (event.messages && typeof event.messages === 'object') {
            for (var _i = 0, _a = event.messages; _i < _a.length; _i++) {
                var singleEvent = _a[_i];
                var input = singleEvent;
                input.seatId = this.seatId;
                this.dispatch(input, null);
            }
        }
        this.transport.lp(this.urlLP, {
            onSuccess: this.receivedEventFromLongPolling.bind(this),
            onTimeout: this.onTimeOutLongPolling.bind(this),
            timeout: this.TIMEOUT
        });
    };
    ConnectionManager.prototype.onTimeOutLongPolling = function () {
        this.transport.lp(this.urlLP, {
            onSuccess: this.receivedEventFromLongPolling.bind(this),
            onTimeout: this.onTimeOutLongPolling.bind(this),
            timeout: this.TIMEOUT
        });
    };
    ConnectionManager.prototype.returnFromSE = function () {
        return void 0;
    };
    ConnectionManager.prototype.sendStartIntent = function (event) {
        var _event = this.serverMessages.startIntent(event);
        if (this.supportsWebSockets) {
            this.transport.send(JSON.stringify(_event));
        }
        else {
            try {
                this.transport.send(this.urlSE, _event, this.callbackFromSendEventToServer);
            }
            catch (e) {
                
            }
        }
    };
    ConnectionManager.prototype.sendRestartUserContext = function () {
        var _event = this.serverMessages.restartUserContext();
        if (this.supportsWebSockets) {
            this.transport.send(JSON.stringify(_event));
        }
        else {
            try {
                this.transport.send(this.urlSE, _event, this.callbackFromSendEventToServer);
            }
            catch (e) {
                
            }
        }
    };
    ConnectionManager.prototype.sendDesktopTalk = function (text) {
        var _event = this.serverMessages.desktopTalk(text);
        if (this.supportsWebSockets) {
            this.transport.send(JSON.stringify(_event));
        }
        else {
            try {
                this.transport.send(this.urlSE, _event, this.callbackFromSendEventToServer);
            }
            catch (e) {
                
            }
        }
    };
    ConnectionManager.prototype.sendUtterance = function (text, language) {
        var _event = this.serverMessages.sendUtterance(text, language);
        this.transport.send(JSON.stringify(_event));
    };
    ConnectionManager.prototype.noUnderstood = function () {
        var _event = this.serverMessages.noUnderstood(this.language);
        this.transport.send(JSON.stringify(_event));
    };
    ConnectionManager.prototype.openTscWebSocket = function (callback) {
        var _this = this;
        this.transport.tscWS = new WebSocketHandler({
            seatId: this.seatId,
            apikey: this.apiKey,
            wsUrl: this.tscWs,
            channel: this.channel,
            entryPoint: this.entryPoint,
            url: this.currentLocation,
            device: this.currentDevice
        });
        this.transport.tscWS.onopen(function () {
            _this.transport.tscWS.sendInitialTsc(_this.language, 44000);
            return callback(true);
        });
        this.transport.tscWS.onmessage(function (ws) {
            var msg;
            var text;
            try {
                msg = JSON.parse(ws.data);
                text = msg.userEntry.text;
                _this.sendUtterance(text, _this.language);
                _this.dispatch(_this.serverMessages.streamingTranscription('', 'onEnd'));
            }
            catch (error) {
                
            }
            _this.transport.tscWS = undefined;
        });
        this.transport.tscWS.onerror(function (error) {
            _this.dispatch(_this.serverMessages.streamingTranscription(error, 'onError'));
        });
        this.transport.tscWS.onclose(function (event) {
            _this.dispatch(_this.serverMessages.streamingTranscription(event, 'onClose'));
        });
    };
    ConnectionManager.prototype.callbackFromSendEventToServer = function () {
        return void 0;
    };
    ConnectionManager.prototype.syncWithDesktop = function () {
        try {
            this.transport.send('http://127.0.0.1:3333/config', null, this.syncDataReceived.bind(this));
        }
        catch (error) {
            
        }
    };
    ConnectionManager.prototype.syncDataReceived = function (data) {
        this.syncConfig = data;
        CookiesManager.setConfigCookie(data);
        this.whenDOMisReady();
    };
    ConnectionManager.prototype.whenDOMisReady = function () {
        if (this.syncConfig) {
            this.seatId = this.seatId || this.syncConfig.seatId;
            this.urlLP = this.urlLP + "?seatId=" + this.seatId + "&events=" + this.events;
            this.serverMessages = new Events(this.seatId, this.channel, this.apiKey, this.entryPoint, this.currentLocation, this.currentDevice);
            this.transport.lp(this.urlLP, {
                onSuccess: this.receivedEventFromLongPolling.bind(this),
                onTimeout: this.onTimeOutLongPolling.bind(this),
                timeout: this.TIMEOUT
            });
        }
        else {
            this.syncWithDesktop();
        }
    };
    ConnectionManager.prototype.createConnection = function () {
        if (!this.seatId)
            this.seatId = this.syncConfig.seatId ? this.syncConfig.seatId : makeid();
        if (!this.channel)
            this.channel = 'desktop';
        this.wsHandler = new WebSocketHandler({
            seatId: this.seatId,
            apikey: this.apiKey,
            wsUrl: this.wsUrl,
            channel: this.channel,
            entryPoint: this.entryPoint,
            url: this.currentLocation,
            device: this.currentDevice
        });
        var newTransport = this.wsHandler;
        this.connectWithWebSockets();
        if (!this.reconnectorAcive) {
            this.reconnector();
        }
        this.serverMessages = new Events(this.seatId, this.channel, this.apiKey, this.entryPoint, this.currentLocation, this.currentDevice);
        if (!this.syncConfig.seatId) {
            CookiesManager.setConfigCookie({ seatId: this.seatId });
        }
        this.transport = newTransport.createTransport();
    };
    ConnectionManager.prototype.connectWithWebSockets = function () {
        this.wsHandler.onmessage(this.msgFromWS.bind(this));
        this.wsHandler.onerror(this.onErrorWS.bind(this));
        this.wsHandler.onclose(this.onCloseWS.bind(this));
        this.wsHandler.onopen(this.onOpen.bind(this));
    };
    ConnectionManager.prototype.onOpen = function (event) {
        this.wsIsAlive = true;
        this.wsHandler.sendInitial();
        if (this.connectionCallback) {
            this.connectionCallback();
        }
        this.dispatch(this.serverMessages.connectedToTalkServer());
    };
    ConnectionManager.prototype.msgFromWS = function (event) {
        var _this = this;
        var parsedData;
        try {
            parsedData = JSON.parse(event.data);
            if (parsedData.messages) {
                parsedData.messages.map(function (msg) { return _this.dispatch(msg); });
            }
            else {
                this.dispatch(this.serverMessages.remoteConfig(parsedData));
            }
        }
        catch (error) {
            
        }
    };
    ConnectionManager.prototype.onCloseWS = function (event) {
        if (!this.autoReconnect) {
            return;
        }
        
        this.wsIsAlive = false;
        if (event.code !== 1014) {
            this.retriesCounter = 0;
            this.reconnecting = false;
        }
        throw new Error('Woice | connection fail code: ' + JSON.stringify(event.code));
    };
    ConnectionManager.prototype.onErrorWS = function (event) {
        this.wsIsAlive = false;
        
        
        throw new Error(JSON.stringify(event.error));
    };
    ConnectionManager.prototype.reconnector = function () {
        var _this = this;
        if (!this.autoReconnect) {
            return;
        }
        var self = this;
        this.reconnectorAcive = true;
        this.reconnectTimer = setInterval(function () {
            if (!_this.wsIsAlive && !_this.reconnecting) {
                if (_this.retriesCounter === _this.maxRetries) {
                    _this.reconnecting = true;
                    setTimeout(_this.createConnection, _this.timeAfterMaxRetries);
                }
                else {
                    _this.reconnecting = true;
                    var currentTimeRetry = _this.retriesCounter === 0 ? 1 : _this.timeBtwRetries;
                    if (_this.retriesCounter === 0) {
                        _this.createConnection();
                    }
                    else {
                        setTimeout(_this.createConnection.bind(self), currentTimeRetry);
                    }
                    _this.retriesCounter += 1;
                }
            }
        }, 10000);
    };
    return ConnectionManager;
}());

function keyBoardController(keys, runtime) {
    var event = new Events('.', '.', '.', ',', '', '');
    document.addEventListener('keydown', function (zEvent) {
        keys.map(function (k) {
            var capitalize = k.charAt(0).toUpperCase() + k.slice(1);
            var completeKey = 'Key' + capitalize;
            if (zEvent.ctrlKey && zEvent.code === completeKey) {
                runtime.dispatch(event.keyboard());
            }
        });
    });
}

var SpeechRecognition = (function () {
    function SpeechRecognition(dispatch, language) {
        if (!language) {
            throw new Error('Language is mandatory to initialize SpeechRecognition');
        }
        this.recognition = false;
        this.dispatch = dispatch;
        this.libEvents = new Events('.', '.', '', '.', '', '');
        this.state = {
            active: false,
            lang: language,
            recognizing: false,
            started: false,
            currentTranscription: ''
        };
    }
    SpeechRecognition.isSupported = function () {
        return 'webkitSpeechRecognition' in window;
    };
    SpeechRecognition.prototype.start = function () {
        var _this = this;
        var recognizing = this.state.recognizing;
        if (!recognizing) {
            this.recognition = false;
            this.initialize(this.state, function () {
                _this.recognition.start();
            });
        }
    };
    SpeechRecognition.prototype.stop = function () {
        var recognizing = this.state.recognizing;
        if (recognizing) {
            this.recognition.stop();
        }
    };
    SpeechRecognition.prototype.initialize = function (options, callback) {
        if (options === void 0) { options = { interimResults: true }; }
        if (options.lang) {
            this.state.lang = options.lang;
        }
        this.sr = window.SpeechRecognition || window.webkitSpeechRecognition;
        this.recognition = new this.sr();
        this.recognition.continuous = options.continuous || false;
        this.recognition.interimResults = options.interimResults || true;
        this.recognition.onstart = this.onStart.bind(this);
        this.recognition.onerror = this.onError.bind(this);
        this.recognition.onend = this.onEnd.bind(this);
        this.recognition.onresult = this.onResult.bind(this);
        this.recognition.lang = this.state.lang;
        if (callback) {
            return callback();
        }
    };
    SpeechRecognition.prototype.onStart = function () {
        var msg = this.libEvents.speechRecognition('', 'onStart');
        this.dispatch(msg);
        this.state.recognizing = true;
        this.state.currentTranscription = '';
    };
    SpeechRecognition.prototype.onError = function (event) {
        var msg = this.libEvents.speechRecognition(event.error, 'onError');
        this.dispatch(msg);
    };
    SpeechRecognition.prototype.onEnd = function () {
        this.state.recognizing = false;
        this.recognition.stop();
        var msg = this.libEvents.speechRecognition(this.state.currentTranscription, 'onEnd');
        this.dispatch(msg);
    };
    SpeechRecognition.prototype.onResult = function () {
        var finalTranscript = '';
        var interimTranscript = '';
        for (var i = event.resultIndex; i < event.results.length; ++i) {
            if (event.results[i].isFinal) {
                finalTranscript += event.results[i][0].transcript;
            }
            else {
                interimTranscript += event.results[i][0].transcript;
            }
        }
        if (finalTranscript) {
            finalTranscript = this.capitalize(finalTranscript);
            var msg = this.libEvents.speechRecognition(finalTranscript, 'onResult_finalTranscript');
            this.state.currentTranscription = finalTranscript;
            this.dispatch(msg);
            this.recognition.stop();
        }
        if (interimTranscript) {
            var msg = this.libEvents.speechRecognition(interimTranscript, 'onResult_interimTranscript');
            this.dispatch(msg);
        }
    };
    SpeechRecognition.prototype.capitalize = function (s) {
        var firstChar = /\S/;
        return s.replace(firstChar, function (m) { return m.toUpperCase(); });
    };
    return SpeechRecognition;
}());

var SpeechSynthesis = (function () {
    function SpeechSynthesis(lang) {
        var _this = this;
        this.lang = lang || navigator.language || navigator.userLanguage;
        this.Speech = window.speechSynthesis;
        this.voices = [];
        window.speechSynthesis.onvoiceschanged = function (e) {
            _this.allVoices = window.speechSynthesis.getVoices();
            _this.changeLangVoices();
        };
        window.speechSynthesis.getVoices();
    }
    SpeechSynthesis.isSupported = function () {
        return !!window.speechSynthesis;
    };
    SpeechSynthesis.prototype.speak = function (text) {
        var utterThis = new SpeechSynthesisUtterance(text);
        utterThis.voice = this.voices[0];
        if (this.voices.length === 0) {
            utterThis.lang = this.lang;
        }
        this.Speech.speak(utterThis);
        utterThis.onend = function () { return void 0; };
        utterThis.onpause = function (_event) {
        };
    };
    SpeechSynthesis.prototype.changeLangVoices = function () {
        for (var i = 0; i < this.allVoices.length; i += 1) {
            if (this.allVoices[i].lang === this.lang) {
                this.voices.push(this.allVoices[i]);
            }
        }
    };
    return SpeechSynthesis;
}());

var MicImage = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB3aWR0aD0iNzkycHgiIGhlaWdodD0iNzkycHgiIHZpZXdCb3g9IjAgMCA3OTIgNzkyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA3OTIgNzkyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PGc+PHBhdGggZD0iTTM5Ni4wMzYsNTE0Ljg4MWM2Mi4xNzksMCwxMTIuNzA0LTUwLjU1LDExMi43MDQtMTEyLjY4VjExMi43MDRDNTA4Ljc0LDUwLjU1LDQ1OC4yMTUsMCwzOTYuMDM2LDBDMzMzLjkwNiwwLDI4My4zOCw1MC41NSwyODMuMzgsMTEyLjcwNHYyODkuNTIxQzI4My4zNTYsNDY0LjMzMSwzMzMuODgyLDUxNC44ODEsMzk2LjAzNiw1MTQuODgxeiIvPjxwYXRoIGQ9Ik02MTMuOTc1LDQwMi42ODVjMC0xNi4zMTgtMTMuMjI0LTI5LjU0Mi0yOS41NjYtMjkuNTQyYy0xNi4zNDIsMC0yOS41NjUsMTMuMjI0LTI5LjU2NSwyOS41NDJjMCw4Ny41ODYtNzEuMjQ0LDE1OC44NTQtMTU4LjgzMSwxNTguODU0Yy04Ny41MzgsMC0xNTguODMxLTcxLjI2OS0xNTguODMxLTE1OC44NTRjMC0xNi4zMTgtMTMuMjcyLTI5LjU0Mi0yOS42MTQtMjkuNTQycy0yOS41NDIsMTMuMjI0LTI5LjU0MiwyOS41NDJjMCwxMTAuMDY5LDgyLjI5MiwyMDAuNDExLDE4OC40NDUsMjE0Ljk4OXYxNDQuNzZjMCwxNi4zNDMsMTMuMjI0LDI5LjU2NiwyOS41NjYsMjkuNTY2YzE2LjM0MywwLDI5LjYxNC0xMy4yMjQsMjkuNjE0LTI5LjU2NnYtMTQ0Ljc2QzUzMS43MzEsNjAzLjA5Niw2MTMuOTc1LDUxMi43NTQsNjEzLjk3NSw0MDIuNjg1eiIvPjwvZz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PC9zdmc+";

var WindowState = (function () {
    function WindowState() {
        this.micButtonIdConstant = 'woice_mic_bttn_0';
        this.windowVisibility = 'visible';
        this.mainWin = true;
        this.allowVisibilityHandlers = true;
        this.startCtrlWindow();
        this.execBeforeLeaving();
    }
    WindowState.prototype.watch = function () {
        this.activeNoActiveWatcher();
    };
    WindowState.prototype.stop = function () {
    };
    WindowState.prototype.insertTranscription = function (input, cb) {
        var el = this.selectedElementToTranscript;
        if (el) {
            var text = input.content.properties.value;
            if (el.nodeName === 'INPUT' &&
                (el.type === 'text' || el.type === 'search')) {
                this.selectedElementToTranscript.value = text;
            }
            else if (el.nodeName === 'TEXTAREA') {
                this.selectedElementToTranscript.value += ' ' + text;
            }
            return cb(true);
        }
        else {
            return cb(false);
        }
    };
    WindowState.prototype.analyzeDOMForInputs = function (cb) {
        var inputsListCol;
        var textsAreaListCol;
        if (window.$) {
            inputsListCol = $('input');
            textsAreaListCol = $('textarea');
        }
        else {
            inputsListCol = document.getElementsByTagName('input');
            textsAreaListCol = document.querySelectorAll('textarea');
        }
        this.processInputsAndTxtsAreas(inputsListCol, textsAreaListCol, cb);
        return { inputsListCol: inputsListCol, textsAreaListCol: textsAreaListCol };
    };
    WindowState.prototype.setOnCloseRestartInNextWindow = function () {
        return CookiesManager.setRuntimeCookie(true);
    };
    WindowState.prototype.noRestartContext = function () {
        CookiesManager.delRuntimeCookie();
        CookiesManager.setRuntimeCookie(false);
    };
    WindowState.prototype.checkRuntimeCookie = function (next) {
        var runtimeData = CookiesManager.getRuntimeCookie();
        if (runtimeData) {
            return next(null, runtimeData.restart_on_close);
        }
        else {
            return next(null, false);
        }
    };
    WindowState.prototype.execBeforeLeaving = function (connectionManager) {
        var _this = this;
        var beforeClose = function (event) {
            _this.allowVisibilityHandlers = false;
            if (connectionManager) {
                connectionManager.sendRestartUserContext();
            }
            _this.removeWinFromStack();
            return undefined;
        };
        window.onbeforeunload = beforeClose;
    };
    WindowState.prototype.isMain = function () {
        this.updateCurrentWinStack();
        if (this.currentWinStack.winStack[this.currentWinStack.winStack.length - 1] === this.windowName) {
            this.mainWin = true;
            return true;
        }
        return false;
    };
    WindowState.prototype.clearAnimation = function () {
        var el = document.getElementById(this.micButtonIdConstant);
        if (el) {
            var styles = el.getAttribute('style');
            var noAnim = "-webkit-animation: none !important;\n    -moz-animation: none !important;\n    animation: none !important";
            el.setAttribute('style', styles + noAnim);
        }
    };
    WindowState.prototype.processInputsAndTxtsAreas = function (inputsListCol, textsAreaListCol, cb) {
        this.addMicIconStyleToHeader();
        for (var _i = 0, inputsListCol_1 = inputsListCol; _i < inputsListCol_1.length; _i++) {
            var input = inputsListCol_1[_i];
            if (window.$) {
                $(input).click(this.ElementOnClick.bind(this, cb));
            }
            else {
                input.addEventListener('click', this.ElementOnClick.bind(this, cb));
            }
        }
        for (var _a = 0, textsAreaListCol_1 = textsAreaListCol; _a < textsAreaListCol_1.length; _a++) {
            var txtarea = textsAreaListCol_1[_a];
            if (window.$) {
                $(txtarea).click(this.ElementOnClick.bind(this, cb));
            }
            else {
                txtarea.addEventListener('click', this.ElementOnClick.bind(this, cb));
            }
        }
    };
    WindowState.prototype.ElementOnClick = function (cb, event) {
        this.selectedElementToTranscript = event.target;
        this.removeLastMicButton();
        var _a = this.getElementCoordinates(event), positionX = _a.positionX, positionY = _a.positionY;
        this.createMicImage("" + positionX, "" + positionY, cb);
    };
    WindowState.prototype.removeLastMicButton = function () {
        var elem = document.getElementById(this.micButtonIdConstant);
        if (elem) {
            elem.parentNode.removeChild(elem);
        }
    };
    WindowState.prototype.getElementCoordinates = function (event) {
        var rect = event.target.getBoundingClientRect();
        var positionY = rect.y + rect.height - 32;
        var positionX = rect.x + rect.width - 32;
        return { positionY: positionY, positionX: positionX };
    };
    WindowState.prototype.createMicImage = function (positionX, positionY, cb) {
        var img =  document.createElement('img');
        img.src = MicImage;
        var alt = 'Woice Voice Search';
        var title = 'Click and start talk to transcript';
        img.id = this.micButtonIdConstant;
        {
            img.alt = alt;
        }
        {
            img.title = title;
        }
        img.setAttribute('style', "position:absolute; top:" + positionY + "px;left:" + positionX + "px;width:24px;height:24px;cursor:pointer;");
        img.onclick = function () {
            var styles = img.getAttribute('style');
            var animations = "-webkit-animation:flickerAnimation 2s infinite;\n      -moz-animation:flickerAnimation 2s infinite;\n      animation:flickerAnimation 2s infinite;\n      ";
            img.setAttribute('style', styles + animations);
            return cb();
        };
        document.body.appendChild(img);
    };
    WindowState.prototype.addMicIconStyleToHeader = function () {
        var cssAnimation = document.createElement('style');
        cssAnimation.type = 'text/css';
        var rules = document.createTextNode("\n      @-moz-keyframes flickerAnimation {\n        0%   { opacity:1; }\n        50%  { opacity:0; }\n        100% { opacity:1; }\n      }\n      @-webkit-keyframes flickerAnimation {\n        0%   { opacity:1; }\n        50%  { opacity:0; }\n        100% { opacity:1; }\n      }\n      @keyframes flickerAnimation {\n        0%   { opacity:1; }\n        50%  { opacity:0; }\n        100% { opacity:1; }\n      };\n    ");
        cssAnimation.appendChild(rules);
        document.getElementsByTagName('head')[0].appendChild(cssAnimation);
    };
    WindowState.prototype.activeNoActiveWatcher = function () {
        var _this = this;
        if (window.addEventListener) {
            window.addEventListener('focus', function () {
                if (_this.allowVisibilityHandlers) {
                    _this.changeVisibility('visible');
                }
            }, false);
            window.addEventListener('blur', function () {
                if (_this.allowVisibilityHandlers) {
                    _this.changeVisibility('hidden');
                }
            }, false);
        }
        else {
            window.attachEvent('focus', function (event) {
                _this.changeVisibility('visible');
            });
            window.attachEvent('focusin', function (event) {
                _this.changeVisibility('visible');
            });
            window.attachEvent('blur', function (event) {
                _this.changeVisibility('hidden');
            });
            document.onfocusin = function () {
                _this.changeVisibility('visible');
            };
            document.onfocusout = function () {
                _this.changeVisibility('hidden');
            };
        }
    };
    WindowState.prototype.changeVisibility = function (state) {
        this.windowVisibility = state;
        this.mainWin = state === 'visible' ? true : false;
        if (state === 'visible') {
            this.updateCurrentWinStack();
            this.claimMainWin();
        }
        if (typeof this.onChangeVisibility === 'function') {
            return this.onChangeVisibility(this.windowVisibility);
        }
    };
    WindowState.prototype.startCtrlWindow = function () {
        this.updateCurrentWinStack();
        this.windowName = makeid();
        this.claimMainWin();
    };
    WindowState.prototype.updateCurrentWinStack = function () {
        this.currentWinStack = CookiesManager.getWinCtrlCookie();
    };
    WindowState.prototype.removeWinFromStack = function () {
        var _this = this;
        this.updateCurrentWinStack();
        var newWinStack = this.currentWinStack.winStack.filter(function (winName) { return winName !== _this.windowName; });
        CookiesManager.delWinControlCookie();
        CookiesManager.setWinControlCookie({ winStack: newWinStack });
    };
    WindowState.prototype.claimMainWin = function () {
        var _this = this;
        var newWinStack = this.currentWinStack.winStack.filter(function (winName) { return winName !== _this.windowName; });
        newWinStack.push(this.windowName);
        this.mainWin = true;
        CookiesManager.delWinControlCookie();
        CookiesManager.setWinControlCookie({ winStack: newWinStack });
        this.currentWinStack = { winStack: newWinStack };
    };
    return WindowState;
}());

function Pipeline(input, runtime, callback) {
    if (typeof input !== 'object') {
        return;
    }
    var visibility = runtime.windowState.windowVisibility;
    var isMain = runtime.windowState.isMain();
    var speechSynthesisActivated = runtime.speechSynthesisActivated, speechSynthSupport = runtime.speechSynthSupport;
    if (input.type === 'StreamingTranscription' && input.content.event === 'onEnd') {
        runtime.audioStreaming.closeStreaming();
    }
    if (input.type === 'SpeechRecognition' && input.content.event === 'onEnd') {
        if (input.content.text) {
            runtime.connectionManager.sendUtterance(input.content.text, runtime.language);
            runtime.windowState.clearAnimation();
        }
    }
    if (input.type === 'TargetKeyDown') {
        runtime.startSpeechRecognition();
        return;
    }
    if (input.type === 'user' && speechSynthSupport && isMain && speechSynthesisActivated) {
        runtime.speechSynthesizer.speak(input.text);
        return;
    }
    if (visibility === 'visible') {
        if (input.type === 'application') {
            if (input.content.properties.entity === 'CURRENT') {
                runtime.windowState.insertTranscription(input, function (success) {
                    if (!success) {
                        runtime.connectionManager.noUnderstood();
                    }
                });
            }
        }
        return callback(input);
    }
}

var WoiceRuntime = (function () {
    function WoiceRuntime(dispatcherReference) {
        this.dispatcher = dispatcherReference;
        this.windowState = new WindowState();
        this.windowState.watch();
        this.onChangeToVisibleWindow();
        this.speechSynthSupport = SpeechSynthesis.isSupported();
        this.speechRecognitionSupport = SpeechRecognition.isSupported();
        this.language = navigator.language;
        this.speechSynthesisActivated = true;
        this.speechRecognitionActive = false;
        this.currentLocation = document.location.pathname;
        this.currentDevice = this.detectDevice();
    }
    WoiceRuntime.prototype.start = function () {
        this.checkStorage();
    };
    WoiceRuntime.prototype.setLanguage = function (lang) {
        if (typeof lang === 'string') {
            this.language = lang;
            if (this.speechSynthSupport && this.speechSynthesisActivated) {
                this.speechSynthesizer = new SpeechSynthesis(this.language);
            }
            else if (this.speechRecognitionSupport) {
                this.speechRecognition = new SpeechRecognition(this.dispatch.bind(this), this.language);
            }
        }
    };
    WoiceRuntime.prototype.closeStreaming = function () {
        this.audioStreaming.closeStreaming();
    };
    WoiceRuntime.prototype.dispatch = function (input, cb) {
        this.currentInput = input;
        this.executionPipeline(input, cb);
    };
    WoiceRuntime.prototype.createConnectionManager = function (apikey, channel, entryPoint, seatId) {
        if (channel === void 0) { channel = false; }
        if (entryPoint === void 0) { entryPoint = false; }
        if (seatId === void 0) { seatId = false; }
        this.connectionManager = new ConnectionManager(this.dispatch.bind(this), this.language, this.stageEnv, this.currentLocation, this.currentDevice);
        this.connectionManager.connect(apikey, channel, entryPoint, seatId);
    };
    WoiceRuntime.prototype.runAutoTranscription = function (elementSelector) {
        var _this = this;
        this.windowState.analyzeDOMForInputs(function () {
            _this.startSpeechRecognition();
        });
    };
    WoiceRuntime.prototype.activeSpeechRecognition = function (options) {
        if (!this.language) {
            throw new Error('Language is mandatory to initialize driver');
        }
        this.speechRecognitionActive = true;
        if (this.speechRecognitionSupport) {
            var opts = options || {};
            this.speechRecognition = new SpeechRecognition(this.dispatch.bind(this), this.language);
            this.speechRecognition.initialize(opts);
        }
        else {
            this.audioStreaming = new AudioStreaming(this.dispatch.bind(this), options);
        }
    };
    WoiceRuntime.prototype.startSpeechRecognition = function (callback) {
        var _this = this;
        if (!this.connectionManager.wsIsAlive) {
            this.connectionManager.connect(null, null, null, null, function () {
                setTimeout(function () {
                    if (_this.connectionManager.wsIsAlive) {
                        _this.startAudioInput(callback);
                    }
                }, 300);
            });
        }
        else {
            this.startAudioInput(callback);
        }
    };
    WoiceRuntime.prototype.disableSpeechSynth = function () {
        this.speechSynthesisActivated = false;
    };
    WoiceRuntime.prototype.sendUserUtterance = function (text) {
        this.connectionManager.sendUtterance(text, this.language);
    };
    WoiceRuntime.prototype.sendRestartUserContext = function () {
        this.connectionManager.sendRestartUserContext();
    };
    WoiceRuntime.prototype.getSeatId = function () {
        return this.connectionManager.seatId;
    };
    WoiceRuntime.prototype.setTriggerToKeys = function (keys) {
        keyBoardController(keys, this);
    };
    WoiceRuntime.prototype.closeWebSocket = function () {
        return this.connectionManager.disconnect();
    };
    WoiceRuntime.prototype.setStage = function (env) {
        this.stageEnv = env || 'dev';
    };
    WoiceRuntime.prototype.stopRecognition = function () {
        this.speechRecognition.stop();
    };
    WoiceRuntime.prototype.isNativeSpeechRecognition = function () {
        return this.speechRecognitionSupport;
    };
    WoiceRuntime.prototype.isConnected = function () {
        return this.connectionManager.wsIsAlive;
    };
    WoiceRuntime.prototype.startAudioInput = function (callback) {
        if (this.speechRecognitionSupport && this.speechRecognitionActive) {
            this.speechRecognition.start();
        }
        else if (this.audioStreaming.isSupported && this.speechRecognitionActive) {
            this.audioStreaming.start(this.connectionManager, callback);
        }
    };
    WoiceRuntime.prototype.checkStorage = function () {
        var _this = this;
        if (typeof window !== 'undefined') {
            this.windowState.checkRuntimeCookie(function (error, runtimeData) {
                if (runtimeData) {
                    _this.windowState.execBeforeLeaving(_this.connectionManager);
                }
            });
            var actionsFromStorage = CookiesManager.getActions();
            if (actionsFromStorage.length > 0) {
                for (var _i = 0, actionsFromStorage_1 = actionsFromStorage; _i < actionsFromStorage_1.length; _i++) {
                    var event_1 = actionsFromStorage_1[_i];
                    this.dispatch(event_1);
                }
            }
        }
    };
    WoiceRuntime.prototype.onChangeToVisibleWindow = function () {
        var _this = this;
        this.windowState.onChangeVisibility = function (error, windowVisibility) {
            if (windowVisibility === 'visible') {
                _this.checkStorage();
            }
        };
    };
    WoiceRuntime.prototype.executionPipeline = function (input, cb) {
        var _this = this;
        Pipeline(input, this, function (_input) {
            _this.setMethodsAndExec(_input, cb);
        });
    };
    WoiceRuntime.prototype.isIntent = function (intentName) {
        return this.isStart(intentName);
    };
    WoiceRuntime.prototype.isStart = function (intentName) {
        if (this.currentInput.type === 'application') {
            var ev = this.currentInput.content;
            if (ev.event === 'startUserIntent' && ev.properties.userIntent === intentName) {
                this.windowState.setOnCloseRestartInNextWindow();
                return true;
            }
            else {
                return false;
            }
        }
    };
    WoiceRuntime.prototype.isFinish = function (intentName) {
        if (this.currentInput.type === 'application') {
            var ev = this.currentInput.content;
            if (ev.event === 'finishUserIntent' && ev.properties.userIntent === intentName) {
                this.windowState.setOnCloseRestartInNextWindow();
                return true;
            }
            else {
                return false;
            }
        }
    };
    WoiceRuntime.prototype.isEntity = function (entityName, intentName) {
        if (this.currentInput.type === 'application') {
            var ev = this.currentInput.content;
            if (ev.event === 'entity' &&
                ev.properties.entity === entityName &&
                ev.properties.userIntent === intentName) {
                return true;
            }
            else {
                return false;
            }
        }
    };
    WoiceRuntime.prototype.isAction = function (actionName, intentName) {
        if (this.currentInput.type === 'application') {
            var ev = this.currentInput.content.properties;
            if (ev.action === actionName) {
                return true;
            }
            else {
                return false;
            }
        }
    };
    WoiceRuntime.prototype.noRestartContext = function () {
        this.windowState.noRestartContext();
    };
    WoiceRuntime.prototype.setMethodsAndExec = function (input, cb) {
        var _this = this;
        input.startIntent = this.connectionManager.sendStartIntent.bind(this.connectionManager);
        input.restartUserContext = this.connectionManager.sendRestartUserContext.bind(this.connectionManager);
        input.talk = this.connectionManager.sendDesktopTalk.bind(this.connectionManager);
        this.injectToHandlerInput(input);
        this.dispatcher.dispatchAction(input, function (error, result) {
            if (error) {
                return _this.dispatcher.dispatchError(input, error);
            }
            if (cb) {
                return cb(null, result);
            }
        });
    };
    WoiceRuntime.prototype.injectToHandlerInput = function (input) {
        input.isIntent = this.isIntent.bind(this);
        input.isEntity = this.isEntity.bind(this);
        input.isAction = this.isAction.bind(this);
        input.isStart = this.isStart.bind(this);
        input.isFinish = this.isFinish.bind(this);
        input.noRestartContext = this.noRestartContext.bind(this);
        if (this.speechRecognitionSupport && this.speechRecognitionActive) {
            input.startSpeechRecognition = this.speechRecognition.start;
        }
        input.sendUserUtterance = this.connectionManager.sendUtterance;
    };
    WoiceRuntime.prototype.detectDevice = function () {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            return 'mobile';
        }
        else {
            return 'desktop';
        }
    };
    return WoiceRuntime;
}());

var ConfigDriverFactory = (function () {
    function ConfigDriverFactory() {
    }
    ConfigDriverFactory.init = function () {
        var runtimeConfigurationBuilder = new RuntimeConfigurationBuilder();
        var genericEventDispatcher = new GenericEventDispatcher(runtimeConfigurationBuilder.getRuntimeConfiguration());
        var woiceRuntime = new WoiceRuntime(genericEventDispatcher);
        return {
            addActionHandlers: function () {
                var actionHandlers = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    actionHandlers[_i] = arguments[_i];
                }
                runtimeConfigurationBuilder.addActionHandlers.apply(runtimeConfigurationBuilder, actionHandlers);
                return this;
            },
            addErrorHandlers: function () {
                var errorHandlers = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    errorHandlers[_i] = arguments[_i];
                }
                runtimeConfigurationBuilder.addErrorHandlers.apply(runtimeConfigurationBuilder, errorHandlers);
                return this;
            },
            withSpeechRecognition: function (options) {
                woiceRuntime.activeSpeechRecognition(options);
                return this;
            },
            noSpeechSynthesis: function () {
                woiceRuntime.disableSpeechSynth();
                return this;
            },
            start: function () {
                woiceRuntime.start();
                return this;
            },
            dispatch: function (response) {
                woiceRuntime.dispatch(response);
                return this;
            },
            connect: function (apikey, channel, entryPoint, seatId) {
                woiceRuntime.createConnectionManager(apikey, channel, entryPoint, seatId);
                return this;
            },
            disconnect: function () {
                woiceRuntime.closeWebSocket();
                return this;
            },
            withAutoTranscription: function (elementSelector) {
                woiceRuntime.runAutoTranscription();
                return this;
            },
            startSpeechRecognition: function (callback) {
                woiceRuntime.startSpeechRecognition(callback);
                return this;
            },
            lang: function (lang) {
                woiceRuntime.setLanguage(lang);
                return this;
            },
            sendUserUtterance: function (text) {
                woiceRuntime.sendUserUtterance(text);
                return this;
            },
            restartUserContext: function () {
                woiceRuntime.sendRestartUserContext();
                return this;
            },
            _getSeatId: function () {
                return woiceRuntime.getSeatId();
            },
            withKeys: function () {
                var keys = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    keys[_i] = arguments[_i];
                }
                woiceRuntime.setTriggerToKeys(keys);
                return this;
            },
            setStage: function (env) {
                woiceRuntime.setStage(env);
                return this;
            },
            closeAudioStreaming: function () {
                woiceRuntime.closeStreaming();
                return this;
            },
            stopSpeechRecognition: function () {
                woiceRuntime.stopRecognition();
                return this;
            },
            isNativeRecognition: function () {
                return woiceRuntime.isNativeSpeechRecognition();
            },
            isConnected: function () {
                return woiceRuntime.isConnected();
            }
        };
    };
    return ConfigDriverFactory;
}());

var Polyfills = function () {
    Function.prototype.bind = function (context) {
        var fn = this;
        var args = Array.prototype.slice.call(arguments, 1);
        if (typeof (fn) !== 'function') {
            throw new TypeError('Function.prototype.bind - context must be a valid function');
        }
        return function () {
            return fn.apply(context, args.concat(Array.prototype.slice.call(arguments)));
        };
    };
    if (!document.querySelectorAll) {
        document.querySelectorAll = function (selector) {
            var doc = document;
            var head = doc.documentElement.firstChild;
            var styleTag = doc.createElement('STYLE');
            head.appendChild(styleTag);
            doc.__qsaels = [];
            styleTag.styleSheet.cssText = selector + '{x:expression(document.__qsaels.push(this))}';
            window.scrollBy(0, 0);
            return doc.__qsaels;
        };
    }
    Array.isArray = function (obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
};

var DriverBuilders = {
    config: function () {
        Polyfills();
        return ConfigDriverFactory.init();
    }
};

var SettingsPanel = /** @class */ (function (_super) {
    __extends(SettingsPanel, _super);
    function SettingsPanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SettingsPanel.prototype.render = function () {
        var _a = this.props, theme = _a.theme, handleBotSelection = _a.handleBotSelection, handleChannelSelection = _a.handleChannelSelection, handleLangSelection = _a.handleLangSelection, botList = _a.botList, handleSourceValue = _a.handleSourceValue, handleConnect = _a.handleConnect, apiKey = _a.apiKey;
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: theme.settingsContainer },
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("span", null, "Bots"),
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("select", { onChange: handleBotSelection, defaultValue: apiKey || 'de42918b-3573-45e8-85b7-f187f47f42d7' },
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("option", { value: "" }, "--- Select one ---"),
                botList.map(function (bot, i) {
                    return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("option", { value: bot.apiKey, key: i }, bot.name));
                })),
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("span", null, "Channel"),
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("select", { onChange: handleChannelSelection, defaultValue: '' },
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("option", { value: "" }, "--- Select one ---"),
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("option", { value: "voice" }, "voice"),
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("option", { value: "google" }, "google"),
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("option", { value: "alexa" }, "alexa"),
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("option", { value: "slack" }, "slack"),
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("option", { value: "desktop" }, "desktop"),
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("option", { value: "whatsapp" }, "whatsapp"),
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("option", { value: "webchat" }, "webchat")),
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("span", null, "SourceValue"),
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("input", { placeholder: "Enter your custom seatId", onChange: handleSourceValue }),
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("span", null, "Language"),
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("select", { onChange: handleLangSelection, defaultValue: 'es', disabled: true },
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("option", null, "--- Select one ---"),
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("option", { value: "es" }, "ES"),
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("option", { value: "en" }, "EN")),
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("a", { href: "#", className: theme.button, onClick: handleConnect }, "Connect")));
    };
    return SettingsPanel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var moment = createCommonjsModule$1(function (module, exports) {
(function (global, factory) {
     module.exports = factory() ;
}(commonjsGlobal, (function () {
    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            'object' !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = commonjsRequire;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));
});

var dist = createCommonjsModule$1(function (module, exports) {
!function(e,t){module.exports=t(moment,__WEBPACK_IMPORTED_MODULE_0_react___default.a);}(commonjsGlobal,function(e,t){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r});},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=6)}([function(e,t,n){e.exports=n(3)();},function(t,n){t.exports=e;},function(e,n){e.exports=t;},function(e,t,n){var r=n(4);function o(){}function i(){}i.resetWarningCache=o,e.exports=function(){function e(e,t,n,o,i,a){if(a!==r){var l=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw l.name="Invariant Violation",l}}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:i,resetWarningCache:o};return n.PropTypes=n,n};},function(e,t,n){e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";},function(e,t,n){var r,o,i,a,l;
/*! Moment Duration Format v2.2.2
 *  https://github.com/jsmreese/moment-duration-format
 *  Date: 2018-02-16
 *
 *  Duration format plugin function for the Moment.js library
 *  http://momentjs.com/
 *
 *  Copyright 2018 John Madhavan-Reese
 *  Released under the MIT license
 */
/*! Moment Duration Format v2.2.2
 *  https://github.com/jsmreese/moment-duration-format
 *  Date: 2018-02-16
 *
 *  Duration format plugin function for the Moment.js library
 *  http://momentjs.com/
 *
 *  Copyright 2018 John Madhavan-Reese
 *  Released under the MIT license
 */
a=this,l=function(e){var t=!1,n=!1,r="escape years months weeks days hours minutes seconds milliseconds general".split(" "),o=[{type:"seconds",targets:[{type:"minutes",value:60},{type:"hours",value:3600},{type:"days",value:86400},{type:"weeks",value:604800},{type:"months",value:2678400},{type:"years",value:31536e3}]},{type:"minutes",targets:[{type:"hours",value:60},{type:"days",value:1440},{type:"weeks",value:10080},{type:"months",value:44640},{type:"years",value:525600}]},{type:"hours",targets:[{type:"days",value:24},{type:"weeks",value:168},{type:"months",value:744},{type:"years",value:8760}]},{type:"days",targets:[{type:"weeks",value:7},{type:"months",value:31},{type:"years",value:365}]},{type:"months",targets:[{type:"years",value:12}]}];function i(e,t){return !(t.length>e.length)&&-1!==e.indexOf(t)}function a(e){for(var t="";e;)t+="0",e-=1;return t}function l(e,t,r){var o,i,u,s=t.useToLocaleString,c=t.useGrouping,m=c&&t.grouping.slice(),f=t.maximumSignificantDigits,p=t.minimumIntegerDigits||1,g=t.fractionDigits||0,y=t.groupingSeparator,h=t.decimalSeparator;if(s&&r){var d={minimumIntegerDigits:p,useGrouping:c};if(g&&(d.maximumFractionDigits=g,d.minimumFractionDigits=g),f&&e>0&&(d.maximumSignificantDigits=f),!n){var v=w({},t);v.useGrouping=!1,v.decimalSeparator=".",e=parseFloat(l(e,v),10);}return e.toLocaleString(r,d)}var b=(f?e.toPrecision(f+1):e.toFixed(g+1)).split("e");u=b[1]||"",i=(b=b[0].split("."))[1]||"";var S=(o=b[0]||"").length,T=i.length,_=S+T,x=o+i;(f&&_===f+1||!f&&T===g+1)&&((x=function(e){for(var t=e.split("").reverse(),n=0,r=!0;r&&n<t.length;)n?"9"===t[n]?t[n]="0":(t[n]=(parseInt(t[n],10)+1).toString(),r=!1):(parseInt(t[n],10)<5&&(r=!1),t[n]="0"),n+=1;return r&&t.push("1"),t.reverse().join("")}(x)).length===_+1&&(S+=1),T&&(x=x.slice(0,-1)),o=x.slice(0,S),i=x.slice(S)),f&&(i=i.replace(/0*$/,""));var O=parseInt(u,10);O>0?i.length<=O?(o+=i+=a(O-i.length),i=""):(o+=i.slice(0,O),i=i.slice(O)):O<0&&(i=a(Math.abs(O)-o.length)+o+i,o="0"),f||((i=i.slice(0,g)).length<g&&(i+=a(g-i.length)),o.length<p&&(o=a(p-o.length)+o));var V,D="";if(c)for(b=o;b.length;)m.length&&(V=m.shift()),D&&(D=y+D),D=b.slice(-V)+D,b=b.slice(0,-V);else D=o;return i&&(D=D+h+i),D}function u(e,t){return e.label.length>t.label.length?-1:e.label.length<t.label.length?1:0}var s,c={durationLabelsStandard:{S:"millisecond",SS:"milliseconds",s:"second",ss:"seconds",m:"minute",mm:"minutes",h:"hour",hh:"hours",d:"day",dd:"days",w:"week",ww:"weeks",M:"month",MM:"months",y:"year",yy:"years"},durationLabelsShort:{S:"msec",SS:"msecs",s:"sec",ss:"secs",m:"min",mm:"mins",h:"hr",hh:"hrs",d:"dy",dd:"dys",w:"wk",ww:"wks",M:"mo",MM:"mos",y:"yr",yy:"yrs"},durationTimeTemplates:{HMS:"h:mm:ss",HM:"h:mm",MS:"m:ss"},durationLabelTypes:[{type:"standard",string:"__"},{type:"short",string:"_"}],durationPluralKey:function(e,t,n){return 1===t&&null===n?e:e+e}};function m(e){return "[object Array]"===Object.prototype.toString.call(e)}function f(e){return "[object Object]"===Object.prototype.toString.call(e)}function p(e,t){var n,r=0,o=e&&e.length||0;for("function"!=typeof t&&(n=t,t=function(e){return e===n});r<o;){if(t(e[r]))return e[r];r+=1;}}function g(e,t){var n=0,r=e.length;if(e&&r)for(;n<r;){if(!1===t(e[n],n))return;n+=1;}}function y(e,t){var n=0,r=e.length,o=[];if(!e||!r)return o;for(;n<r;)o[n]=t(e[n],n),n+=1;return o}function h(e,t){return y(e,function(e){return e[t]})}function d(e){var t=[];return g(e,function(e){e&&t.push(e);}),t}function v(e){var t=[];return g(e,function(e){p(t,e)||t.push(e);}),t}function b(e,t){var n=[];return g(e,function(e){g(t,function(t){e===t&&n.push(e);});}),v(n)}function S(e,t){var n=[];return g(e,function(r,o){if(!t(r))return n=e.slice(o),!1}),n}function w(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n]);return e}function T(e){var t=[];for(var n in e)e.hasOwnProperty(n)&&t.push(n);return t}function _(e,t){var n=0,r=e.length;if(!e||!r)return !1;for(;n<r;){if(!0===t(e[n],n))return !0;n+=1;}return !1}function x(){var e,t=[].slice.call(arguments),n={};if(g(t,function(t,r){if(!r){if(!m(t))throw "Expected array as the first argument to durationsFormat.";e=t;}"string"!=typeof t&&"function"!=typeof t?"number"!=typeof t?f(t)&&w(n,t):n.precision=t:n.template=t;}),!e||!e.length)return [];n.returnMomentTypes=!0;var o,i=y(e,function(e){return e.format(n)}),a=b(r,v(h((o=[],g(i,function(e){o=o.concat(e);}),o),"type"))),l=n.largest;return l&&(a=a.slice(0,l)),n.returnMomentTypes=!1,n.outputTypes=a,y(e,function(e){return e.format(n)})}function O(){var n=[].slice.call(arguments),a=w({},this.format.defaults),s=this.asMilliseconds(),x=this.asMonths();"function"==typeof this.isValid&&!1===this.isValid()&&(s=0,x=0);var O=s<0,V=e.duration(Math.abs(s),"milliseconds"),D=e.duration(Math.abs(x),"months");g(n,function(e){"string"!=typeof e&&"function"!=typeof e?"number"!=typeof e?f(e)&&w(a,e):a.precision=e:a.template=e;});var L={years:"y",months:"M",weeks:"w",days:"d",hours:"h",minutes:"m",seconds:"s",milliseconds:"S"},j={escape:/\[(.+?)\]/,years:/\*?[Yy]+/,months:/\*?M+/,weeks:/\*?[Ww]+/,days:/\*?[Dd]+/,hours:/\*?[Hh]+/,minutes:/\*?m+/,seconds:/\*?s+/,milliseconds:/\*?S+/,general:/.+?/};a.types=r;var M=function(e){return p(r,function(t){return j[t].test(e)})},k=new RegExp(y(r,function(e){return j[e].source}).join("|"),"g");a.duration=this;var P="function"==typeof a.template?a.template.apply(a):a.template,E=a.outputTypes,F=a.returnMomentTypes,I=a.largest,C=[];E||(m(a.stopTrim)&&(a.stopTrim=a.stopTrim.join("")),a.stopTrim&&g(a.stopTrim.match(k),function(e){var t=M(e);"escape"!==t&&"general"!==t&&C.push(t);}));var N=e.localeData();N||(N={}),g(T(c),function(e){"function"!=typeof c[e]?N["_"+e]||(N["_"+e]=c[e]):N[e]||(N[e]=c[e]);}),g(T(N._durationTimeTemplates),function(e){P=P.replace("_"+e+"_",N._durationTimeTemplates[e]);});var G=a.userLocale||e.locale(),R=a.useLeftUnits,U=a.usePlural,q=a.precision,z=a.forceLength,H=a.useGrouping,W=a.trunc,$=a.useSignificantDigits&&q>0,A=$?a.precision:0,B=A,K=a.minValue,Y=!1,J=a.maxValue,Q=!1,X=a.useToLocaleString,Z=a.groupingSeparator,ee=a.decimalSeparator,te=a.grouping;X=X&&t;var ne=a.trim;m(ne)&&(ne=ne.join(" ")),null===ne&&(I||J||$)&&(ne="all"),null!==ne&&!0!==ne&&"left"!==ne&&"right"!==ne||(ne="large"),!1===ne&&(ne="");var re=function(e){return e.test(ne)},oe=/both/,ie=/^all|[^sm]all/,ae=I>0||_([/large/,oe,ie],re),le=_([/small/,oe,ie],re),ue=_([/mid/,ie],re),se=_([/final/,ie],re),ce=y(P.match(k),function(e,t){var n=M(e);return "*"===e.slice(0,1)&&(e=e.slice(1),"escape"!==n&&"general"!==n&&C.push(n)),{index:t,length:e.length,text:"",token:"escape"===n?e.replace(j.escape,"$1"):e,type:"escape"===n||"general"===n?null:n}}),me={index:0,length:0,token:"",text:"",type:null},fe=[];R&&ce.reverse(),g(ce,function(e){if(e.type)return (me.type||me.text)&&fe.push(me),void(me=e);R?me.text=e.token+me.text:me.text+=e.token;}),(me.type||me.text)&&fe.push(me),R&&fe.reverse();var pe=b(r,v(d(h(fe,"type"))));if(!pe.length)return h(fe,"text").join("");pe=y(pe,function(e,t){var n,r=t+1===pe.length,o=!t;n="years"===e||"months"===e?D.as(e):V.as(e);var i=Math.floor(n),l=n-i,u=p(fe,function(t){return e===t.type});return o&&J&&n>J&&(Q=!0),r&&K&&Math.abs(a.duration.as(e))<K&&(Y=!0),o&&null===z&&u.length>1&&(z=!0),V.subtract(i,e),D.subtract(i,e),{rawValue:n,wholeValue:i,decimalValue:r?l:0,isSmallest:r,isLargest:o,type:e,tokenLength:u.length}});var ge,ye=W?Math.floor:Math.round,he=function(e,t){var n=Math.pow(10,t);return ye(e*n)/n},de=!1,ve=!1,be=function(e,t){var n={useGrouping:H,groupingSeparator:Z,decimalSeparator:ee,grouping:te,useToLocaleString:X};return $&&(A<=0?(e.rawValue=0,e.wholeValue=0,e.decimalValue=0):(n.maximumSignificantDigits=A,e.significantDigits=A)),Q&&!ve&&(e.isLargest?(e.wholeValue=J,e.decimalValue=0):(e.wholeValue=0,e.decimalValue=0)),Y&&!ve&&(e.isSmallest?(e.wholeValue=K,e.decimalValue=0):(e.wholeValue=0,e.decimalValue=0)),e.isSmallest||e.significantDigits&&e.significantDigits-e.wholeValue.toString().length<=0?q<0?e.value=he(e.wholeValue,q):0===q?e.value=ye(e.wholeValue+e.decimalValue):$?(e.value=W?he(e.rawValue,A-e.wholeValue.toString().length):e.rawValue,e.wholeValue&&(A-=e.wholeValue.toString().length)):(n.fractionDigits=q,e.value=W?e.wholeValue+he(e.decimalValue,q):e.wholeValue+e.decimalValue):$&&e.wholeValue?(e.value=Math.round(he(e.wholeValue,e.significantDigits-e.wholeValue.toString().length)),A-=e.wholeValue.toString().length):e.value=e.wholeValue,e.tokenLength>1&&(z||de)&&(n.minimumIntegerDigits=e.tokenLength,ve&&n.maximumSignificantDigits<e.tokenLength&&delete n.maximumSignificantDigits),!de&&(e.value>0||""===ne||p(C,e.type)||p(E,e.type))&&(de=!0),e.formattedValue=l(e.value,n,G),n.useGrouping=!1,n.decimalSeparator=".",e.formattedValueEn=l(e.value,n,"en"),2===e.tokenLength&&"milliseconds"===e.type&&(e.formattedValueMS=l(e.value,{minimumIntegerDigits:3,useGrouping:!1},"en").slice(0,2)),e};if((pe=d(pe=y(pe,be))).length>1){var Se=function(e){return p(pe,function(t){return t.type===e})};g(o,function(e){var t=Se(e.type);t&&g(e.targets,function(e){var n=Se(e.type);n&&parseInt(t.formattedValueEn,10)===e.value&&(t.rawValue=0,t.wholeValue=0,t.decimalValue=0,n.rawValue+=1,n.wholeValue+=1,n.decimalValue=0,n.formattedValueEn=n.wholeValue.toString(),ve=!0);});});}return ve&&(de=!1,A=B,pe=d(pe=y(pe,be))),!E||Q&&!a.trim?(ae&&(pe=S(pe,function(e){return !e.isSmallest&&!e.wholeValue&&!p(C,e.type)})),I&&pe.length&&(pe=pe.slice(0,I)),le&&pe.length>1&&(ge=function(e){return !e.wholeValue&&!p(C,e.type)&&!e.isLargest},pe=S(pe.slice().reverse(),ge).reverse()),ue&&(pe=d(pe=y(pe,function(e,t){return t>0&&t<pe.length-1&&!e.wholeValue?null:e}))),!se||1!==pe.length||pe[0].wholeValue||!W&&pe[0].isSmallest&&pe[0].rawValue<K||(pe=[])):pe=d(pe=y(pe,function(e){return p(E,function(t){return e.type===t})?e:null})),F?pe:(g(fe,function(e){var t=L[e.type],n=p(pe,function(t){return t.type===e.type});if(t&&n){var r=n.formattedValueEn.split(".");r[0]=parseInt(r[0],10),r[1]?r[1]=parseFloat("0."+r[1],10):r[1]=null;var o=N.durationPluralKey(t,r[0],r[1]),a=function(e,t){var n=[];return g(T(t),function(r){if("_durationLabels"===r.slice(0,15)){var o=r.slice(15).toLowerCase();g(T(t[r]),function(i){i.slice(0,1)===e&&n.push({type:o,key:i,label:t[r][i]});});}}),n}(t,N),l=!1,s={};g(N._durationLabelTypes,function(t){var n=p(a,function(e){return e.type===t.type&&e.key===o});n&&(s[n.type]=n.label,i(e.text,t.string)&&(e.text=e.text.replace(t.string,n.label),l=!0));}),U&&!l&&(a.sort(u),g(a,function(t){return s[t.type]===t.label?!i(e.text,t.label)&&void 0:i(e.text,t.label)?(e.text=e.text.replace(t.label,s[t.type]),!1):void 0}));}}),(fe=y(fe,function(e){if(!e.type)return e.text;var t=p(pe,function(t){return t.type===e.type});if(!t)return "";var n="";return R&&(n+=e.text),(O&&Q||!O&&Y)&&(n+="< ",Q=!1,Y=!1),(O&&Y||!O&&Q)&&(n+="> ",Q=!1,Y=!1),O&&(t.value>0||""===ne||p(C,t.type)||p(E,t.type))&&(n+="-",O=!1),"milliseconds"===e.type&&t.formattedValueMS?n+=t.formattedValueMS:n+=t.formattedValue,R||(n+=e.text),n})).join("").replace(/(,| |:|\.)*$/,"").replace(/^(,| |:|\.)*/,""))}function V(){var e=this.duration,t=function(t){return e._data[t]},n=p(this.types,t),r=function(e,t){for(var n=e.length;n-=1;)if(t(e[n]))return e[n]}(this.types,t);switch(n){case"milliseconds":return "S __";case"seconds":case"minutes":return "*_MS_";case"hours":return "_HMS_";case"days":if(n===r)return "d __";case"weeks":return n===r?"w __":(null===this.trim&&(this.trim="both"),"w __, d __, h __");case"months":if(n===r)return "M __";case"years":return n===r?"y __":(null===this.trim&&(this.trim="both"),"y __, M __, d __");default:return null===this.trim&&(this.trim="both"),"y __, d __, h __, m __, s __"}}function D(e){if(!e)throw "Moment Duration Format init cannot find moment instance.";e.duration.format=x,e.duration.fn.format=O,e.duration.fn.format.defaults={trim:null,stopTrim:null,largest:null,maxValue:null,minValue:null,precision:0,trunc:!1,forceLength:null,userLocale:null,usePlural:!0,useLeftUnits:!1,useGrouping:!0,useSignificantDigits:!1,template:V,useToLocaleString:!0,groupingSeparator:",",decimalSeparator:".",grouping:[3]},e.updateLocale("en",c);}return t=!!((s=(s=!0)&&function(){try{(0).toLocaleString("i");}catch(e){return "RangeError"===e.name}return !1}())&&(s=(s=(s=s&&"1"===1..toLocaleString("en",{minimumIntegerDigits:1}))&&"01"===1..toLocaleString("en",{minimumIntegerDigits:2}))&&"001"===1..toLocaleString("en",{minimumIntegerDigits:3}))&&(s=(s=(s=(s=s&&"100"===99.99.toLocaleString("en",{maximumFractionDigits:0,minimumFractionDigits:0}))&&"100.0"===99.99.toLocaleString("en",{maximumFractionDigits:1,minimumFractionDigits:1}))&&"99.99"===99.99.toLocaleString("en",{maximumFractionDigits:2,minimumFractionDigits:2}))&&"99.990"===99.99.toLocaleString("en",{maximumFractionDigits:3,minimumFractionDigits:3}))&&(s=(s=(s=(s=(s=s&&"100"===99.99.toLocaleString("en",{maximumSignificantDigits:1}))&&"100"===99.99.toLocaleString("en",{maximumSignificantDigits:2}))&&"100"===99.99.toLocaleString("en",{maximumSignificantDigits:3}))&&"99.99"===99.99.toLocaleString("en",{maximumSignificantDigits:4}))&&"99.99"===99.99.toLocaleString("en",{maximumSignificantDigits:5}))&&(s=(s=s&&"1,000"===1e3.toLocaleString("en",{useGrouping:!0}))&&"1000"===1e3.toLocaleString("en",{useGrouping:!1}))),n=t&&"3.6"===3.55.toLocaleString("en",{useGrouping:!1,minimumIntegerDigits:1,minimumFractionDigits:1,maximumFractionDigits:1}),D(e),D},o=[n(1)],void 0===(i="function"==typeof(r=l)?r.apply(t,o):r)||(e.exports=i),a&&(a.momentDurationFormatSetup=a.moment?l(a.moment):l);},function(e,t,n){n.r(t);var r=n(2),o=n.n(r),i=n(0),a=n.n(i),l=n(1),u=n.n(l);n(5);function s(e){return (s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function c(e,t){if(null==e)return {};var n,r,o=function(e,t){if(null==e)return {};var n,r,o={},i=Object.keys(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(o[n]=e[n]);}return o}function m(e){return (m=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function f(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function p(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r);}}function g(e,t,n){return t&&p(e.prototype,t),n&&p(e,n),e}function y(e,t){return (y=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function h(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}n.d(t,"default",function(){return S});var d=[a.a.string,a.a.number,a.a.array,a.a.object],v=[a.a.string,a.a.array],b=[a.a.object,a.a.bool],S=function(e){function t(e){var n,r,o;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t),r=this,o=m(t).call(this,e),n=!o||"object"!==s(o)&&"function"!=typeof o?f(r):o,h(f(n),"setTimer",function(){var e=n.props.interval;n.clearTimer(),t.pooledTimer||0===e||(n.timer=setInterval(function(){n.update(n.props);},e));}),h(f(n),"getTitle",function(){var e=n.props.titleFormat,r=t.getDatetime(n.props),o=e||t.globalFormat;return r.format(o)}),h(f(n),"clearTimer",function(){!t.pooledTimer&&n.timer&&(clearInterval(n.timer),n.timer=null),t.pooledTimer&&!n.timer&&t.removePooledElement(f(n));}),t.globalMoment||(t.globalMoment=u.a),n.state={content:""},n.timer=null,n}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&y(e,t);}(t,o.a.Component),g(t,null,[{key:"startPooledTimer",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:6e4;t.clearPooledTimer(),t.pooledTimer=setInterval(function(){t.pooledElements.forEach(function(e){0!==e.props.interval&&e.update();});},e);}},{key:"clearPooledTimer",value:function(){t.pooledTimer&&(clearInterval(t.pooledTimer),t.pooledTimer=null,t.pooledElements=[]);}},{key:"pushPooledElement",value:function(e){e instanceof t?-1===t.pooledElements.indexOf(e)&&t.pooledElements.push(e):console.error("Element not an instance of Moment.");}},{key:"removePooledElement",value:function(e){var n=t.pooledElements.indexOf(e);-1!==n&&t.pooledElements.splice(n,1);}},{key:"getDatetime",value:function(e){var n=e.utc,r=e.unix,o=e.date,i=e.locale,a=e.parse,l=e.tz,u=e.local;o=o||e.children,a=a||t.globalParse,u=u||t.globalLocal,l=l||t.globalTimezone,i=t.globalLocale?t.globalLocale:i||t.globalMoment.locale();var s=null;return s=n?t.globalMoment.utc(o,a,i):r?t.globalMoment(1e3*o,a,i):t.globalMoment(o,a,i),l?s=s.tz(l):u&&(s=s.local()),s}},{key:"getContent",value:function(e){var n=e.fromNow,r=e.fromNowDuring,o=e.from,i=e.add,a=e.subtract,l=e.toNow,s=e.to,c=e.ago,m=e.calendar,f=e.diff,p=e.duration,g=e.durationFromNow,y=e.unit,h=e.decimal,d=e.format;d=d||t.globalFormat;var v=t.getDatetime(e);i&&v.add(i),a&&v.subtract(a);var b=Boolean(r)&&-v.diff(u()())<r,S="";return S=d&&!b?v.format(d):o?v.from(o,c):n||b?v.fromNow(c):s?v.to(s,c):l?v.toNow(c):m?v.calendar(null,m):f?v.diff(f,y,h):p?v.diff(p):g?u()().diff(v):v.toString(),(p||g)&&(S=(S=u.a.duration(S)).format(d)),S=(t.globalFilter||e.filter)(S)}}]),g(t,[{key:"componentDidMount",value:function(){this.setTimer(),t.pooledTimer&&t.pushPooledElement(this);}},{key:"componentDidUpdate",value:function(e){var t=this.props.interval;e.interval!==t&&this.setTimer();}},{key:"componentWillUnmount",value:function(){this.clearTimer();}},{key:"update",value:function(e){var n=e||this.props,r=n.onChange,o=t.getContent(n);this.setState({content:o},function(){r(o);});}},{key:"render",value:function(){var e,n,r,i,a=this.props,l=a.withTitle,u=a.element,s=c(a,["withTitle","element"]),m=this.state.content,f=(e=s,n=t.propTypes,r=Object.keys(n),i=Object.assign({},e),Object.keys(i).filter(function(e){return -1!==r.indexOf(e)}).forEach(function(e){return delete i[e]}),i);return l&&(f.title=this.getTitle()),o.a.createElement(u||t.globalElement,function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{},r=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&(r=r.concat(Object.getOwnPropertySymbols(n).filter(function(e){return Object.getOwnPropertyDescriptor(n,e).enumerable}))),r.forEach(function(t){h(e,t,n[t]);});}return e}({dateTime:t.getDatetime(this.props)},f),m)}}],[{key:"getDerivedStateFromProps",value:function(e){return {content:t.getContent(e)}}}]),t}();h(S,"propTypes",{element:a.a.any,date:a.a.oneOfType(d),parse:a.a.oneOfType(v),format:a.a.string,add:a.a.object,subtract:a.a.object,ago:a.a.bool,fromNow:a.a.bool,fromNowDuring:a.a.number,from:a.a.oneOfType(d),toNow:a.a.bool,to:a.a.oneOfType(d),calendar:a.a.oneOfType(b),unix:a.a.bool,utc:a.a.bool,local:a.a.bool,tz:a.a.string,withTitle:a.a.bool,titleFormat:a.a.string,locale:a.a.string,interval:a.a.number,diff:a.a.oneOfType(d),duration:a.a.oneOfType(d),durationFromNow:a.a.bool,unit:a.a.string,decimal:a.a.bool,filter:a.a.func,onChange:a.a.func}),h(S,"defaultProps",{element:null,fromNow:!1,toNow:!1,calendar:!1,ago:!1,unix:!1,utc:!1,local:!1,unit:null,withTitle:!1,decimal:!1,titleFormat:"",interval:6e4,filter:function(e){return e},onChange:function(){}}),h(S,"globalMoment",null),h(S,"globalLocale",null),h(S,"globalLocal",null),h(S,"globalFormat",null),h(S,"globalParse",null),h(S,"globalFilter",null),h(S,"globalElement","time"),h(S,"globalTimezone",null),h(S,"pooledElements",[]),h(S,"pooledTimer",null);}])});
});

var Moment = unwrapExports$1(dist);

var es = createCommonjsModule$1(function (module, exports) {
(function (global, factory) {
    typeof commonjsRequire === 'function' ? factory(moment) :
   
   factory(global.moment);
}(commonjsGlobal, (function (moment) {
    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
            '_'
        ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));
});

var css$3 = "\n\n@media only screen and (max-width: 768px) {\n    .styles_messagesContainer__3BTwe {\n        padding-bottom: 90px;\n    }\n}\n\n.styles_pdfBox__3P8kr {\n    background-image: url(data:image/png;base64,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);\n    width: 70px;\n    height: 80px;\n    margin: 5px 0 5px 0;\n    background-size: cover;\n    cursor: pointer;\n}\n\n.styles_clickWrapper__17pOK {\n  min-height: 100px;\n}\n\n.styles_clickWrapper__17pOK:hover {\n    cursor: pointer;\n}\n\n.styles_messagesContainer__3BTwe img {\n    width: 100%;\n    border-radius: 8px;\n    cursor: pointer;\n}\n\n.styles_messagesContainer__3BTwe img:hover {\n    box-shadow: azure 2px 3px 2px;\n}\n\n.styles_upButton__3Wn4S {\n    height: 40px;\n    width: 30px;\n    z-index: 999999999999999;\n    background: #4eaa38;\n    background-image:  url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAANCAYAAABGkiVgAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAADgSURBVDiNndExSkNBFIXhMdFOosaIKLo6wU24AU0hWAjBiIiVVdaQFCkixqiICKKNC/kskgHzmMl78cBp7r3nv8zcgFDiDbTxhQsclGWqAEfm9Y3D/0I38SCtT+wvC93CYwYY9YHdqtAmxiXAqDfslEGbeMoA3jP1l1kuCd3GJBO8Qx3nmf7Y9AZz0BaeM4Fb1P4sv8zMjdCI0BZeM4M3BWDACrqZ+SHWw4InXc8AqWPWTL8kpdOAn0TjagEwuo77RHYS0CkUOxWA0avoFfLtgD2coY+jJYDRazjGACdo/AIUdaej/xEeHAAAAABJRU5ErkJggg==');\n    background-position: center center;\n    background-repeat: no-repeat;\n    opacity: 1;\n    cursor: pointer;\n    display: inline-block;\n    box-shadow: 5px 5px 15px 5px rgba(0,0,0,0.14);\n    border-radius: 4px;\n}\n\n.styles_showLastOptions__2EyN2 {\n  font-family: 'Montserrat Light', arial;\n  font-size: 14px;\n  background-color: grey;\n  width: auto;\n  display: inline-block;\n  padding: 0.5em;\n  cursor: pointer;\n  border-radius: 4px;\n  box-shadow: 0 2px 1px rgba(0, 0, 0, 0.08);\n  display: inline-flex;\n  text-align: center;\n  flex: initial;\n  height: 30px;\n  color: white;\n}\n\n.styles_arrowOpen__2IlJ9 {\n  height: 20px;\n  width: 20px;\n  color: white;\n  background-image: url(data:image/png;base64,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);\n  background-size: contain;\n  display: flex;\n  margin-right: 10px;\n}\n";
var styles$5 = {"messagesContainer":"styles_messagesContainer__3BTwe","pdfBox":"styles_pdfBox__3P8kr","clickWrapper":"styles_clickWrapper__17pOK","upButton":"styles_upButton__3Wn4S","showLastOptions":"styles_showLastOptions__2EyN2","arrowOpen":"styles_arrowOpen__2IlJ9"};
styleInject(css$3);

function generateKey() {
    return Math.round(Math.random() * 1090390904345);
}

var Buttons = /** @class */ (function (_super) {
    __extends(Buttons, _super);
    function Buttons() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Buttons.prototype.render = function () {
        var btnList = [];
        var _a = this.props, handleClickOnCard = _a.handleClickOnCard, numberOfValuesPerItem = _a.numberOfValuesPerItem, orderedValues = _a.orderedValues, showNoneAbove = _a.showNoneAbove, noneAbove = _a.noneAbove, isH1Buttons = _a.isH1Buttons, theme = _a.theme;
        var _loop_1 = function (index) {
            var labelValues = "" + orderedValues[index].value;
            btnList.push(Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("button", { className: isH1Buttons ? theme.rtButtonEmoji : theme.rtButton, key: generateKey(), onClick: function () { return handleClickOnCard(orderedValues[index].value, false); } }, labelValues));
        };
        for (var index = 0; index < numberOfValuesPerItem; index++) {
            _loop_1(index);
        }
        var existSiorNot = false;
        var existsShowAgain = false;
        var existsNoInfo = false;
        for (var index = 0; index < numberOfValuesPerItem; index++) {
            var lowerCased = orderedValues[index].value.toLocaleLowerCase();
            if (lowerCased === "si")
                existSiorNot = true;
            if (lowerCased === 'no')
                existSiorNot = true;
            if (lowerCased === 'si, quiero volver a ver el contenido')
                existsShowAgain = true;
            if (lowerCased === 'he leído el contenido, pero no encuentro la información que busco')
                existsNoInfo = true;
        }
        if (!existSiorNot && !existsShowAgain && !existsNoInfo && showNoneAbove && noneAbove) {
            btnList.push(Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("button", { className: theme.rtButton, key: Date.now() + Math.floor(Math.random() * 1000), onClick: function () { return handleClickOnCard('Ninguna de las anteriores', true); } }, "Ninguna de las anteriores"));
        }
        if (existsShowAgain && existsNoInfo) {
            btnList = [];
            btnList.push(Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("button", { className: theme.rtButton, key: Date.now() + Math.floor(Math.random() * 1000), onClick: function () { return handleClickOnCard('Si, quiero volver a ver el contenido', false); } }, "Si, quiero volver a ver el contenido"));
            btnList.push(Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("button", { className: theme.rtButton, key: Date.now() + Math.floor(Math.random() * 1000), onClick: function () { return handleClickOnCard('He leído el contenido, pero no encuentro la información que busco', false); } }, "He le\u00EDdo el contenido, pero no encuentro la informaci\u00F3n que busco"));
        }
        return btnList;
    };
    return Buttons;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var SmallTemplate = /** @class */ (function (_super) {
    __extends(SmallTemplate, _super);
    function SmallTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SmallTemplate.prototype.createProperties = function (numberOfValuesPerItem, orderedValues) {
        var propList = [];
        for (var index = 0; index < numberOfValuesPerItem; index++) {
            if (index > orderedValues.length - 1)
                break;
            if (orderedValues[index].label !== 'displayName' && orderedValues[index].label !== 'displayOrder') {
                propList.push(Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("p", { key: index + Date.now() },
                    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("strong", null,
                        orderedValues[index].label,
                        ":"),
                    " ",
                    orderedValues[index].value));
            }
        }
        return propList;
    };
    SmallTemplate.prototype.render = function () {
        var _a = this.props, isWithPicture = _a.isWithPicture, cardDisplayName = _a.cardDisplayName, numberOfValuesPerItem = _a.numberOfValuesPerItem, orderedValues = _a.orderedValues, handleClickOnCard = _a.handleClickOnCard, cardPicture = _a.cardPicture, theme = _a.theme;
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: theme.smallCard, onClick: function () { return handleClickOnCard(cardDisplayName); } },
            isWithPicture ? (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("img", { src: cardPicture, alt: "avatar", className: theme.smallImageCard })) : (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null)),
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: theme.container },
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: theme.displayName }, cardDisplayName),
                this.createProperties(numberOfValuesPerItem, orderedValues))));
    };
    return SmallTemplate;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var BigTemplate = /** @class */ (function (_super) {
    __extends(BigTemplate, _super);
    function BigTemplate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BigTemplate.prototype.createProperties = function (numberOfValuesPerItem, orderedValues) {
        var propList = [];
        for (var index = 0; index < numberOfValuesPerItem; index++) {
            propList.push(Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("p", { key: index + Date.now() },
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("strong", null,
                    orderedValues[index].label,
                    ":"),
                " ",
                orderedValues[index].value));
        }
        return propList;
    };
    BigTemplate.prototype.render = function () {
        var _a = this.props, isWithPicture = _a.isWithPicture, cardDisplayName = _a.cardDisplayName, numberOfValuesPerItem = _a.numberOfValuesPerItem, orderedValues = _a.orderedValues, handleClickOnCard = _a.handleClickOnCard, cardPicture = _a.cardPicture, theme = _a.theme;
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: theme.card },
            (isWithPicture) ? (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("img", { src: cardPicture, alt: "avatar", className: theme.imageCard, onClick: function () { return handleClickOnCard(cardDisplayName); } })) : (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null)),
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: theme.container },
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("span", { className: theme.displayName },
                    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("b", null, cardDisplayName)),
                this.createProperties(numberOfValuesPerItem, orderedValues))));
    };
    return BigTemplate;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var sortBy = __webpack_require__(56);
var Cards = /** @class */ (function (_super) {
    __extends(Cards, _super);
    function Cards() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Cards.prototype.render = function () {
        var _a = this.props, template = _a.template, values = _a.values, handleClickOnCard = _a.handleClickOnCard, showNoneAbove = _a.showNoneAbove, noneAbove = _a.noneAbove, isH1Buttons = _a.isH1Buttons, theme = _a.theme;
        var templateName = template.split('-')[0];
        var numberOfValuesPerItem;
        var orderedValues = sortBy(values, ['displayRelevance']);
        var cardToRender;
        var listOfCardsToRender = [];
        var cardPicture;
        var cardDisplayName;
        if (templateName.indexOf('buttons:') !== -1 || templateName === 'defaultTemplate')
            numberOfValuesPerItem = values.length;
        else
            numberOfValuesPerItem = template.split('-')[1];
        if (templateName.indexOf('buttons') !== -1 || templateName === 'defaultTemplate') {
            cardToRender = (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { key: generateKey(), className: theme.buttonsContainer },
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Buttons, { numberOfValuesPerItem: numberOfValuesPerItem, orderedValues: orderedValues, handleClickOnCard: this.props.handleClickOnCard, showNoneAbove: showNoneAbove, noneAbove: noneAbove, isH1Buttons: isH1Buttons, theme: theme })));
        }
        else {
            // Entrypoint for cards:
            // ---------------------
            values.forEach(function (card) {
                orderedValues = (typeof card === 'object') ? card : sortBy(card, ['displayRelevance']);
                console.log('orderedValues: ', orderedValues);
                orderedValues.forEach(function (_value, index) {
                    if (_value.label === 'displayName') {
                        cardDisplayName = _value.value;
                    }
                    if (_value.label === 'picture') {
                        cardPicture = _value.value;
                    }
                });
                if (templateName.indexOf('small') !== -1) {
                    listOfCardsToRender.push(Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(SmallTemplate, { key: generateKey(), cardDisplayName: cardDisplayName, cardPicture: cardPicture, handleClickOnCard: handleClickOnCard, numberOfValuesPerItem: numberOfValuesPerItem, orderedValues: orderedValues, isWithPicture: (templateName === 'smallPicture'), theme: theme }));
                }
                if (templateName.indexOf('big') !== -1) {
                    listOfCardsToRender.push(Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(BigTemplate, { key: generateKey(), cardDisplayName: cardDisplayName, cardPicture: cardPicture, handleClickOnCard: handleClickOnCard, numberOfValuesPerItem: numberOfValuesPerItem, orderedValues: orderedValues, isWithPicture: (templateName === 'bigPicture'), theme: theme }));
                }
            });
        }
        var toReturn;
        if (cardToRender)
            toReturn = cardToRender;
        else if (!cardToRender && listOfCardsToRender.length)
            toReturn = listOfCardsToRender;
        else
            toReturn = (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null));
        return (toReturn);
    };
    return Cards;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var css$4 = ".styles_App-logo__yTypz {\n  animation: styles_App-logo-spin__xSyl9 infinite 20s linear;\n  height: 40vmin;\n  pointer-events: none;\n}\n\n.styles_image__1eNbx{\n  width: 100%;\n  height: 100%;\n  background: no-repeat center;\n  background-size: cover;\n  overflow: hidden;\n  padding-bottom: 100%;\n}\n\n.styles_wrapperLarge__parSo{\n  flex-direction: column;\n  width: 100%;\n  font-weight: 400;\n  hyphens: auto;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  min-height: 200px;\n  background: #fff;\n  border: 0.5px solid rgba(0, 0, 0, 0.02);\n  box-shadow: 0 2px 1px rgba(0, 0, 0, 0.08);\n  max-width: 70%;\n  display: inline-block;\n  text-align: left;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.styles_imgWrapperLarge__3DdEc{\n  height: 80%;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n\n.styles_textWrapperLarge__9Hhlh{\n  padding: 10px 10px;\n  color: #000;\n  font-size: 13px;\n}\n\n.styles_textWrapperLarge__9Hhlh p {\n  margin-top: 2em;\n}\n\n.styles_siteNameLinkWrapper__2K3Tj{\n  max-height: 2.8em;\n  color: #000;\n  font-weight: 700;\n}\n\n\n\n@media (min-width: 360px){\n  .styles_siteNameLinkWrapper__2K3Tj{\n    font-size: 14px;\n  }\n  .styles_responsiveVideo__3tsvy{\n    min-height: 202px;\n  }\n}\n\n@media (min-width: 460px){\n  .styles_textWrapperLarge__9Hhlh {\n    font-size: 14px;\n  }\n  .styles_textWrapperSmall__1FE6v {\n    font-size: 12px;\n  }\n  .styles_siteNameLinkWrapper__2K3Tj{\n    font-size: 15px;\n  }\n  .styles_wrapperLarge__parSo{\n    max-width: 400px;\n  }\n  .styles_outerWrapperSmall__VTmVK{\n    min-width: 360px;\n    width: 360px;\n  }\n  .styles_responsiveVideo__3tsvy{\n    min-height: 258px;\n  }\n}\n\n@media (min-width: 600px){\n  .styles_textWrapperLarge__9Hhlh {\n    font-size: 15px;\n  }\n  .styles_textWrapperSmall__1FE6v {\n    font-size: 13px;\n  }\n  .styles_siteNameLinkWrapper__2K3Tj{\n    font-size: 17px;\n  }\n  .styles_wrapperLarge__parSo{\n    max-width: 600px;\n  }\n  .styles_outerWrapperSmall__VTmVK{\n    min-width: 600px;\n    width: 600px;\n  }\n  .styles_responsiveVideo__3tsvy{\n    min-height: 337px;\n  }\n}\n\n\n\n.styles_responsiveImage__2wSso{\n  width: 100%;\n  height: auto;\n  border-radius: 8px 8px 0 0 !important;\n}\n\n";
var styles$6 = {"App-logo":"styles_App-logo__yTypz","App-logo-spin":"styles_App-logo-spin__xSyl9","image":"styles_image__1eNbx","wrapperLarge":"styles_wrapperLarge__parSo","imgWrapperLarge":"styles_imgWrapperLarge__3DdEc","textWrapperLarge":"styles_textWrapperLarge__9Hhlh","siteNameLinkWrapper":"styles_siteNameLinkWrapper__2K3Tj","responsiveVideo":"styles_responsiveVideo__3tsvy","textWrapperSmall":"styles_textWrapperSmall__1FE6v","outerWrapperSmall":"styles_outerWrapperSmall__VTmVK","responsiveImage":"styles_responsiveImage__2wSso"};
styleInject(css$4);

var Snippets = /** @class */ (function (_super) {
    __extends(Snippets, _super);
    function Snippets(props) {
        var _this = _super.call(this, props) || this;
        _this.renderLarge = function (resultsToUse) {
            var feature = null;
            if (resultsToUse.image !== '') {
                feature = (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: styles$6.imgWrapperLarge },
                    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("img", { className: styles$6.responsiveImage, src: resultsToUse.image, alt: 'alt' })));
            }
            else
                feature = (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null));
            return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: styles$6.wrapperLarge, onClick: function () {
                    _this.props.onClick();
                } },
                feature,
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: styles$6.textWrapperLarge },
                    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: styles$6.siteNameLinkWrapper },
                        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("a", null, resultsToUse.title)),
                    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: styles$6.titleWrapper }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("p", null, resultsToUse.title !== resultsToUse.description ? resultsToUse.description : ''))));
        };
        _this.state = {
            error: false,
            result: {
                openGraph: {
                    site_name: '',
                    title: '',
                    url: '',
                    description: '',
                    image: {
                        url: ''
                    }
                },
                htmlInferred: {
                    site_name: '',
                    title: '',
                    url: '',
                    favicon: '',
                    description: '',
                    products: '',
                    image: {
                        url: ''
                    }
                },
                hybridGraph: {
                    site_name: '',
                    title: '',
                    url: '',
                    favicon: '',
                    description: '',
                    products: '',
                    image: {
                        url: ''
                    }
                }
            }
        };
        return _this;
    }
    Snippets.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, cachedSnippetsResults = _a.cachedSnippetsResults, site = _a.site, updateCachedResults = _a.updateCachedResults;
        var acceptLang = 'auto';
        var appId = '1c9fcd26-3169-4554-9e7c-6c9f9d1831bc';
        var _site = encodeURIComponent(site);
        var url = "https://opengraph.io/api/1.1/site/" + _site + "?accept_lang" + acceptLang + "&app_id=" + appId + "&cache_ok=true&max_cache_age=7200000";
        if (cachedSnippetsResults[url]) {
            this.setState({ result: cachedSnippetsResults[url] });
        }
        else {
            fetch(url)
                .then(function (res) { return res.json(); })
                .then(function (result) {
                if (!result.error) {
                    _this.setState({ result: result });
                    updateCachedResults(url, result);
                }
                else {
                    console.error(result);
                }
            });
        }
    };
    Snippets.prototype.getResultsToUse = function () {
        var _a = this.state.result, openGraph = _a.openGraph, htmlInferred = _a.htmlInferred, hybridGraph = _a.hybridGraph;
        // protect against null values
        openGraph = openGraph || {};
        htmlInferred = htmlInferred || {};
        hybridGraph = hybridGraph || {};
        var site_name = openGraph.site_name || htmlInferred.site_name || hybridGraph.site_name;
        var title = openGraph.title || htmlInferred.title || hybridGraph.title;
        var url = openGraph.url || htmlInferred.url || hybridGraph.url;
        var favicon = htmlInferred.favicon || hybridGraph.favicon;
        var description = openGraph.description || htmlInferred.description || hybridGraph.description;
        var image;
        if (openGraph.image) {
            image = openGraph.image.url;
        }
        else {
            image = htmlInferred.image || hybridGraph.image;
        }
        return {
            site_name: site_name,
            title: title,
            url: url,
            favicon: favicon,
            image: image,
            description: description
        };
    };
    Snippets.prototype.render = function () {
        var resultsToUse = this.getResultsToUse();
        if (!resultsToUse.image)
            console.log('imagen no cargada todavia!!!');
        return this.renderLarge(resultsToUse);
    };
    return Snippets;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var Collapsable = /** @class */ (function (_super) {
    __extends(Collapsable, _super);
    function Collapsable(props) {
        var _this = _super.call(this, props) || this;
        var state = _this.readStateFromLS(props.id, {
            isOpen: false,
            show: false,
            allChildrens: props.children,
            elemToShow: [],
            groups: props.children.length / 2,
            nextGroupToShow: 1,
            lastGroup: false,
            firstIndex: 0,
            secondIndex: 1,
            elementRemaining: props.children.length / 2,
        });
        var elemToShow = [];
        if (state.nextGroupToShow > 1) {
            for (var index = 0; index < state.nextGroupToShow * 2; index++) {
                elemToShow.push(props.children[index]);
            }
        }
        _this.state = {
            nextGroupToShow: state.nextGroupToShow,
            isOpen: state.isOpen,
            show: state.show,
            groups: state.groups,
            lastGroup: state.lastGroup,
            firstIndex: state.firstIndex,
            secondIndex: state.secondIndex,
            elementRemaining: state.elementRemaining,
            allChildrens: props.children,
            elemToShow: elemToShow,
        };
        return _this;
    }
    Collapsable.prototype.saveStateLocalStorage = function (id, state) {
        window.localStorage.setItem(id + "_collapseItem_", JSON.stringify(state));
    };
    Collapsable.prototype.readStateFromLS = function (id, defaultState) {
        var state = window.localStorage.getItem(id + "_collapseItem_");
        return state ? JSON.parse(state) : defaultState;
    };
    Collapsable.prototype.viewMore = function () {
        var _a = this.state, groups = _a.groups, nextGroupToShow = _a.nextGroupToShow, elemToShow = _a.elemToShow, allChildrens = _a.allChildrens, firstIndex = _a.firstIndex, secondIndex = _a.secondIndex, elementRemaining = _a.elementRemaining;
        this.setState({
            isOpen: true,
        });
        if (nextGroupToShow <= groups) {
            var objToSave = {
                elemToShow: elemToShow.concat([allChildrens[firstIndex], allChildrens[secondIndex]]),
                nextGroupToShow: nextGroupToShow + 1,
                firstIndex: firstIndex + 2,
                secondIndex: secondIndex + 2,
                lastGroup: (nextGroupToShow + 1 > groups) ? true : false,
                elementRemaining: elementRemaining - 1,
                isOpen: true,
                show: true,
            };
            this.setState(__assign({}, objToSave));
            this.saveStateLocalStorage(this.props.id, __assign({}, objToSave));
        }
        else {
            this.setState({
                lastGroup: true,
            });
        }
    };
    Collapsable.prototype.componentDidMount = function () {
        this.setState({
            show: true
        });
    };
    Collapsable.prototype.render = function () {
        var _this = this;
        var theme = this.props.theme;
        var _a = this.state, show = _a.show, elemToShow = _a.elemToShow, lastGroup = _a.lastGroup, isOpen = _a.isOpen, elementRemaining = _a.elementRemaining;
        var moreButton;
        var contentToShow;
        if (lastGroup)
            moreButton = (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null));
        else {
            moreButton = (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { onClick: function () { _this.viewMore(); }, className: theme.buttonCloseColl },
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: theme.arrowClose }),
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: theme.textMoreInfo },
                    elementRemaining,
                    " m\u00E1s...")));
        }
        if (isOpen)
            contentToShow = elemToShow;
        else
            contentToShow = (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null));
        if (show) {
            return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: theme.wrapper },
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: theme.open }, contentToShow),
                moreButton));
        }
        else {
            return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null));
        }
    };
    return Collapsable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var css$5 = ".styles_cardPdf__36gNt {\n  background: #fff;\n  padding: 12px 18px;\n  border: 0.5px solid rgba(0, 0, 0, 0.02);\n  box-shadow: 0 2px 1px rgba(0, 0, 0, 0.08);\n  max-width: 70%;\n  display: inline-block;\n  text-align: left;\n  font-size: 14px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  border-radius: 8px;\n}\n\n.styles_cardPdf__36gNt > a > img {\n  width: 16px;\n}\n\n.styles_cardPdf__36gNt > a {\n  text-decoration: none;\n  cursor: pointer;\n}\n";
var styles$7 = {"cardPdf":"styles_cardPdf__36gNt"};
styleInject(css$5);

var PdfRenderer = function (_a) {
    var pdfUrl = _a.pdfUrl;
    var parts = pdfUrl.split('/');
    var filename = parts[parts.length - 1].replace(/_/g, ' ');
    var fileExtension = pdfUrl.toLocaleLowerCase().indexOf('.pdf') !== -1;
    return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: styles$7.cardPdf },
        fileExtension ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("embed", { src: pdfUrl + "#page=1&toolbar=0&navpanes=0&scrollbar=0&view=fitH,100", type: "application/pdf", width: "100%" }) : Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null),
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("br", null),
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("a", { href: pdfUrl, target: "_blank" },
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("img", { src: "https://img.icons8.com/small/16/000000/download.png" }),
            " ",
            fileExtension ? filename : 'Descargar pdf')));
};

var Messages = /** @class */ (function (_super) {
    __extends(Messages, _super);
    function Messages(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            userSaysRef: Object(__WEBPACK_IMPORTED_MODULE_0_react__["createRef"])(),
            cachedSnippetsResults: {},
        };
        return _this;
    }
    Messages.prototype.onClickInMsg = function (url) {
        window.open(url, '_blank');
    };
    Messages.prototype.onClickUp = function () {
        this.state.userSaysRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    };
    Messages.prototype.updateCachedResults = function (url, result) {
        var updatedCacheObj = __assign({}, this.state.cachedSnippetsResults);
        updatedCacheObj[url] = result;
        this.setState({ cachedSnippetsResults: updatedCacheObj });
    };
    Messages.prototype.componentDidMount = function () {
        for (var index = 0; index < 150; index++) {
            var key = index + "_collapseItem_";
            window.localStorage.removeItem(key);
        }
    };
    Messages.prototype.onUpdateMessages = function () {
        var _this = this;
        var msgToRender = [];
        var messagesToCollapse = [];
        var collapsableIndexes = [];
        var _a = this.props, messages = _a.messages, theme = _a.theme, lang = _a.lang, toScrollBottom = _a.toScrollBottom, lastCards = _a.lastCards, noneAbove = _a.noneAbove;
        var cachedSnippetsResults = this.state.cachedSnippetsResults;
        // Find collapsable items
        for (var index = 0; index < messages.length; index++) {
            var msg = messages[index];
            if (msg.type === 'snippet' || msg.type === 'image' || msg.type === 'pdf') {
                if (messages[index - 2]) {
                    if (messages[index - 2].type === 'snippet' || messages[index - 2].type === 'image' || messages[index - 2].type === 'pdf') {
                        collapsableIndexes.push(index - 1);
                        collapsableIndexes.push(index);
                    }
                }
            }
        }
        var _loop_1 = function (i) {
            var msg = messages[i];
            var triggerTextOne = '012_survey._start_012_survey.text.cards';
            var triggerTextTwo = '012_router.012_agent.followUp.cards';
            if (messagesToCollapse.length && (msg.key === triggerTextOne || msg.key === triggerTextTwo)) {
                msgToRender.push(Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Collapsable, { theme: theme, key: generateKey(), id: i }, messagesToCollapse));
                messagesToCollapse = [];
            }
            var placeToRender = collapsableIndexes.indexOf(i) !== -1 ? messagesToCollapse : msgToRender;
            // messages only text
            if (!msg.timestamp && msg.cardValues.length === 0 && msg.text !== "" && (msg.type == 'received' || msg.type === 'sent')) {
                placeToRender.push(Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: (msg.type === 'sent') ? theme.messageSent : theme.messageReceived, key: generateKey() },
                    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { key: generateKey(), ref: (msg.type === 'sent') ? this_1.state.userSaysRef : null, className: theme.bubble, dangerouslySetInnerHTML: { __html: msg.text } })));
            }
            // messages with text and endOfTurn
            if (msg.timestamp && msg.cardValues.length === 0 && msg.text !== "" && (msg.type == 'received' || msg.type === 'sent')) {
                placeToRender.push(Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: (msg.type === 'sent') ? theme.messageSent : theme.messageReceived, key: generateKey() },
                    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: theme.timestamp },
                        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: theme.time },
                            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Moment, { locale: "es", date: msg.timestamp, fromNow: true })))));
            }
            // cards messages with only one option, generated by rt-system-appointments (msg.cardValues.length === 1)
            if ((msg.cardValues.length > 1 || (msg.cardValues.length === 1 && msg.text !== "")) && msg.type === 'card') {
                placeToRender.push(Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Cards, { key: generateKey(), template: msg.template, values: msg.cardValues, lang: lang, handleClickOnCard: this_1.props.handleClickOnCard, showNoneAbove: msg.showNoneAbove, noneAbove: noneAbove, isH1Buttons: msg.isH1Buttons, theme: theme }));
            }
            if (msg.type === 'snippet') {
                placeToRender.push(Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Snippets, { site: msg.url, cachedSnippetsResults: cachedSnippetsResults, updateCachedResults: this_1.updateCachedResults.bind(this_1), onClick: function () { return _this.onClickInMsg(msg.url); }, key: generateKey() }));
            }
            if (msg.type === 'pdf') {
                placeToRender.push(Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(PdfRenderer, { pdfUrl: msg.url, key: generateKey() }));
            }
            if (msg.type === 'image') {
                placeToRender.push(Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("img", { src: msg.url, alt: "recurso no encontrado", onClick: function () { return _this.onClickInMsg(msg.url); }, key: generateKey() }));
            }
            if (i === messages.length - 1 && messages[i - 1]) {
                if (messages[i - 1].type === 'received' && messages[i - 1].key === triggerTextTwo && lastCards.length) {
                    placeToRender.push(Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: theme.messageSent, key: generateKey() },
                        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: styles$5.showLastOptions, onClick: function () { return _this.props.showLastOptions(); } },
                            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: styles$5.arrowOpen }),
                            " ",
                            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", null, "Ver opciones anteriores"))));
                }
            }
        };
        var this_1 = this;
        for (var i = 0; i < messages.length; i++) {
            _loop_1(i);
        }
        setTimeout(function () { return toScrollBottom(); }, 1000);
        return msgToRender;
    };
    Messages.prototype.render = function () {
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: styles$5.messagesContainer }, this.onUpdateMessages()));
    };
    return Messages;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function () {
        return { hasError: true };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        //logErrorToMyService(error, errorInfo);
        console.error(error);
        console.error(errorInfo);
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.hasError) { // You can render any custom fallback UI     
            return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("h1", null, "Something went wrong.");
        }
        return this.props.children;
    };
    return ErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var _userMessage = function (props) {
    var response = props.response, currentMessages = props.currentMessages, addMessageToList = props.addMessageToList, state = props.state, getUrlFromText = props.getUrlFromText, renderAllMessages = props.renderAllMessages, channel = props.channel;
    if (response.template !== "webSnippet") {
        var expression = /<a[^>]* href=([^"]*)/g;
        var regex = new RegExp(expression);
        var result = response.text.match(regex);
        if (result) {
            currentMessages.push({
                type: "received",
                text: response.text,
                cardValues: [],
                key: response.key
            });
            addMessageToList(currentMessages, state.forceButtons);
        }
        else {
            var url = getUrlFromText(response.text);
            if (url && url.length > 0) {
                var transfomedUrlWithText = response.text.replace(url, "");
                transfomedUrlWithText =
                    transfomedUrlWithText +
                        (" <a href=\"" + url[0] + "\" target=\"_blank\">" + url[0] + "</a>");
                currentMessages.push({
                    type: "received",
                    text: transfomedUrlWithText,
                    cardValues: [],
                    key: response.key
                });
                addMessageToList(currentMessages, state.forceButtons);
            }
            else {
                currentMessages.push({
                    type: "received",
                    text: response.text,
                    cardValues: [],
                    key: response.key,
                });
                addMessageToList(currentMessages, state.forceButtons);
            }
        }
    }
    else {
        var result = getUrlFromText(response.text);
        result.forEach(function (url) {
            var cleanedText = response.text.replace(url, "");
            if (url.toLocaleLowerCase().indexOf(".pdf") !== -1) {
                currentMessages.push({
                    type: "received",
                    text: cleanedText,
                    cardValues: [],
                    key: response.key,
                });
                currentMessages.push({ type: "pdf", url: url, cardValues: [] });
            }
            else if (cleanedText.indexOf("(pdf)") !== -1) {
                var cleanedPdfUrlTag = cleanedText.replace("(pdf)", "");
                currentMessages.push({
                    type: "received",
                    text: cleanedPdfUrlTag,
                    cardValues: [],
                    key: response.key
                });
                currentMessages.push({ type: "pdf", url: url, cardValues: [] });
            }
            else if (url.indexOf(".jpg") !== -1) {
                currentMessages.push({
                    type: "received",
                    text: cleanedText,
                    cardValues: [],
                    key: response.key
                });
                currentMessages.push({ type: "image", url: url, cardValues: [] });
            }
            else {
                currentMessages.push({
                    type: "received",
                    text: cleanedText,
                    cardValues: [],
                    key: response.key
                });
                currentMessages.push({ type: "snippet", url: url, cardValues: [] });
            }
            addMessageToList(currentMessages, state.forceButtons);
        });
    }
    // render messages if courtesy msg is received
    if (response.courtesy)
        renderAllMessages();
    var allow = ['slack', 'desktop', 'voice'];
    if (allow.indexOf(channel) !== -1)
        renderAllMessages();
};
var _buttonsMessage = function (props) {
    var response = props.response, currentMessages = props.currentMessages, addMessageToList = props.addMessageToList, state = props.state;
    if (response.cards.length) {
        // cards messages with only one option, generated by rt-system-appointments (last condition)
        if (Array.isArray(response.cards[0]) && (response.cards.length > 1 || (response.cards.length === 1 && response.text !== ""))) {
            var groupedCards_1 = [];
            var showNoneAbove_1 = false;
            var isH1Buttons_1 = false;
            response.cards.forEach(function (cardArray) {
                cardArray.forEach(function (element) {
                    if (element.label === "displayName")
                        groupedCards_1.push(element);
                    if (response.template.indexOf("buttons:noneabove") != -1)
                        showNoneAbove_1 = true;
                    if (response.template.indexOf("buttons:h1") !== -1)
                        isH1Buttons_1 = true;
                });
            });
            currentMessages.push({
                type: "card",
                cardValues: groupedCards_1,
                template: response.template,
                showNoneAbove: showNoneAbove_1,
                isH1Buttons: isH1Buttons_1,
                key: response.key,
                text: response.text,
            });
        }
        else {
            currentMessages.push({
                type: "card",
                cardValues: response.cards,
                template: response.template,
                key: response.key,
                text: response.text,
            });
        }
        addMessageToList(currentMessages, state.forceButtons);
    }
};
var _cardsMessage = function (props) {
    var response = props.response, currentMessages = props.currentMessages, addMessageToList = props.addMessageToList, state = props.state;
    if (response.cards.length) {
        var showNoneAbove = false;
        var isH1Buttons = false;
        currentMessages.push({
            type: "card",
            cardValues: response.cards,
            template: response.template,
            showNoneAbove: showNoneAbove,
            isH1Buttons: isH1Buttons,
            key: response.key
        });
        addMessageToList(currentMessages, state.forceButtons);
    }
};
var _endOfTurn = function (props) {
    var currentMessages = props.currentMessages, addMessageToList = props.addMessageToList, state = props.state, renderAllMessages = props.renderAllMessages;
    currentMessages.push({
        type: "received",
        timestamp: Date.now(),
        cardValues: [],
    });
    addMessageToList(currentMessages, state.forceButtons);
    renderAllMessages();
};
var ReceivedMessage = function (props) {
    var response = props.response, setState = props.setState;
    if (response.type === "user")
        _userMessage(props);
    if (response.cards && response.template.indexOf('buttons') !== -1)
        _buttonsMessage(props);
    if (response.cards && response.template.indexOf('defaultTemplate') !== -1)
        _buttonsMessage(props);
    if (response.cards && response.template.indexOf('small') !== -1)
        _cardsMessage(props);
    if (!response.content)
        return void 0;
    if (response.content.code === "endOfTurn")
        return _endOfTurn(props);
    if (response.content.code === "Hangup")
        return setState({ forceButtons: true });
    if (response.content.code === "webChatTextInput")
        return setState({ forceButtons: !response.content.data });
};

/**
 * @class ChatBox
 */
var styles$8 = StyleSheet$1.create({
    fadeinquick: {
        animationName: lib_56,
        animationDuration: '3s'
    }
});
var ChatBox = /** @class */ (function (_super) {
    __extends(ChatBox, _super);
    function ChatBox(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.scrollToBottom = function () {
            var node = _this.messageListRef.current;
            var scrollHeight = node.scrollHeight;
            var height = node.clientHeight;
            var maxScrollTop = scrollHeight - height;
            node.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
        };
        _this.state = {
            messages: [],
            temporalMessages: [],
            currentText: '',
            openSettings: props.testMode,
            connected: false,
            entryPoint: props.entryPoint,
            title: props.title,
            forceButtons: false,
            userScroll: false,
            userScrollTime: null,
            lastCards: [],
            clickOnStartSurvey: false,
        };
        _this.messageListRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createRef"])();
        _this.handleUserAddMessage.bind(_this);
        return _this;
    }
    ChatBox.prototype.componentDidMount = function () {
        if (!this.state.openSettings)
            this.handleConnect();
    };
    ChatBox.prototype.componentWillUnmount = function () {
        if (this.woiceDriver)
            this.woiceDriver.disconnect();
        clearInterval(this.scrollInterval);
    };
    ChatBox.prototype.getUrlFromText = function (text) {
        var expression = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi;
        var regex = new RegExp(expression);
        var result = text.match(regex) || [];
        return result;
    };
    ChatBox.prototype.receivedText = function (response) {
        return __awaiter(this, void 0, void 0, function () {
            var currentMessages;
            return __generator(this, function (_a) {
                currentMessages = this.state.temporalMessages.slice();
                if (response.type === 'Websockets' && response.content.event === 'connected') {
                    this.setState({
                        connected: true,
                    });
                }
                if (response.type === 'RemoteConfig') {
                    this.props.onRemoteConfig(response);
                }
                ReceivedMessage({
                    response: response,
                    setState: this.setState.bind(this),
                    currentMessages: currentMessages,
                    addMessageToList: this._addMessageToList.bind(this),
                    state: this.state,
                    getUrlFromText: this.getUrlFromText.bind(this),
                    renderAllMessages: this._renderAllMessages.bind(this),
                    channel: this.props.channel,
                });
                return [2 /*return*/];
            });
        });
    };
    ChatBox.prototype._addMessageToList = function (currentMessages, forceButtons) {
        this.setState({
            temporalMessages: currentMessages,
            forceButtons: forceButtons
        });
    };
    ChatBox.prototype._renderAllMessages = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, temporalMessages, messages;
            return __generator(this, function (_b) {
                try {
                    _a = this.state, temporalMessages = _a.temporalMessages, messages = _a.messages;
                    this.setState({
                        messages: messages.concat(temporalMessages),
                        temporalMessages: [],
                    });
                }
                catch (e) {
                    console.error(e);
                }
                return [2 /*return*/];
            });
        });
    };
    ChatBox.prototype.handleUserAddMessage = function (event) {
        if (event.key === "Enter" && event.target.value !== "") {
            var currentMessages = this.state.messages.slice();
            currentMessages.push({ text: event.target.value, type: 'sent', cardValues: [] });
            currentMessages.push({ type: 'sent', timestamp: Date.now(), cardValues: [] });
            this.woiceDriver.sendUserUtterance(event.target.value);
            this.setState({
                messages: currentMessages,
                currentText: "",
                lastCards: []
            });
            event.target.value = "";
        }
    };
    ChatBox.prototype.handleClickOnCard = function (textToSend, showNoneAbove) {
        this.woiceDriver.sendUserUtterance(textToSend);
        var messages = this.state.messages;
        var cleanedMessages = [];
        var templastCards = [];
        messages.forEach(function (msg) {
            if (msg.type !== "card")
                cleanedMessages.push(msg);
            else {
                var firstValue = msg.cardValues[0].value;
                if (firstValue !== 'No' && firstValue !== 'Sí' && msg.cardValues.length > 1) {
                    templastCards.push(msg);
                }
            }
        });
        cleanedMessages.push({ type: 'sent', text: textToSend, cardValues: [] });
        cleanedMessages.push({ type: 'sent', timestamp: Date.now(), cardValues: [] });
        this.setState({
            messages: cleanedMessages.slice(),
        });
        if (templastCards.length) {
            this.setState({
                lastCards: (showNoneAbove) ? [] : templastCards.slice(),
            });
        }
    };
    ChatBox.prototype.showLastOptions = function () {
        var _a = this.state, lastCards = _a.lastCards, messages = _a.messages;
        this.setState({
            messages: messages.concat(lastCards),
        });
    };
    ChatBox.prototype.onChangeInput = function (event) {
        this.setState({
            currentText: event.target.value,
        });
    };
    ChatBox.prototype.handleStartSurvey = function () {
        this.woiceDriver.sendUserUtterance('start_012_survey');
        this.setState({ clickOnStartSurvey: true });
    };
    ChatBox.prototype.handleConnect = function () {
        var _this = this;
        var _a = this.props, apiKey = _a.apiKey, channel = _a.channel, entryPoint = _a.entryPoint, lang = _a.lang, sourceValue = _a.sourceValue;
        if (apiKey === '' || channel === '') {
            return alert('No apiKey or channel or sourceValue');
        }
        var onReceiveEvent = {
            canHandle: function (handlerInput) {
                handlerInput.allow();
            },
            handle: function (handlerInput) {
                _this.receivedText(handlerInput);
            },
        };
        this.woiceDriver = DriverBuilders.config()
            .setStage(this.props.stage)
            .lang(lang)
            .addActionHandlers(onReceiveEvent)
            .connect(apiKey, channel, entryPoint, sourceValue)
            .noSpeechSynthesis()
            .start();
        this.setState({
            openSettings: false,
        });
    };
    ChatBox.prototype.handleBotSelection = function (e) {
        var _a = this.props, setChatSettings = _a.setChatSettings, botList = _a.botList;
        var botName;
        botList.forEach(function (bot) {
            if (bot.apiKey === e.target.value)
                botName = bot.name;
        });
        setChatSettings({
            sourceValue: false,
            apiKey: e.target.value,
            channel: false,
            botName: botName,
            lang: false,
        });
    };
    ChatBox.prototype.handleSourceValue = function (e) {
        var setChatSettings = this.props.setChatSettings;
        setChatSettings({
            sourceValue: e.target.value,
            apiKey: false,
            channel: false,
            lang: false,
        });
    };
    ChatBox.prototype.handleChannelSelection = function (e) {
        var setChatSettings = this.props.setChatSettings;
        setChatSettings({
            sourceValue: false,
            apiKey: false,
            channel: e.target.value,
            lang: false,
        });
    };
    ChatBox.prototype.handleGoToSettings = function () {
        var setChatSettings = this.props.setChatSettings;
        this.woiceDriver.disconnect();
        this.setState({
            connected: false,
            openSettings: true,
        });
        setChatSettings({
            sourceValue: false,
            apiKey: false,
            channel: false,
            lang: false
        });
    };
    ChatBox.prototype.handleLangSelection = function (e) {
        var setChatSettings = this.props.setChatSettings;
        setChatSettings({
            sourceValue: false,
            apiKey: false,
            channel: false,
            lang: e.target.value
        });
    };
    ChatBox.prototype.inputTextRenderer = function () {
        var _this = this;
        var forceButtons = this.state.forceButtons;
        var theme = this.props.theme;
        if (!forceButtons) {
            return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: theme.messagingArea },
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("input", { placeholder: forceButtons ? "Elija una de las opciones" : "Escriba su mensaje aquí...", onKeyPress: function (e) { return _this.handleUserAddMessage(e); }, disabled: forceButtons })));
        }
        else
            return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null));
    };
    ChatBox.prototype.mainRenderer = function () {
        var _a = this.state, openSettings = _a.openSettings, connected = _a.connected;
        var _b = this.props, botList = _b.botList, sourceValue = _b.sourceValue, lang = _b.lang, noneAbove = _b.noneAbove, theme = _b.theme;
        if (openSettings) {
            return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(SettingsPanel, { theme: theme, handleBotSelection: this.handleBotSelection.bind(this), handleChannelSelection: this.handleChannelSelection.bind(this), handleLangSelection: this.handleLangSelection.bind(this), botList: botList, sourceValue: sourceValue, handleSourceValue: this.handleSourceValue.bind(this), handleConnect: this.handleConnect.bind(this), apiKey: this.props.apiKey }));
        }
        if (connected) {
            return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", null,
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: theme.conversationWrapper, ref: this.messageListRef },
                    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Messages, { messages: this.state.messages, theme: theme, lang: lang, handleClickOnCard: this.handleClickOnCard.bind(this), toScrollBottom: this.scrollToBottom.bind(this), showLastOptions: this.showLastOptions.bind(this), lastCards: this.state.lastCards, noneAbove: noneAbove })),
                this.inputTextRenderer()));
        }
        else {
            return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { ref: this.messageListRef, className: theme.spinnerContainer },
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("svg", { className: theme.spinner, width: "65px", height: "65px", viewBox: "0 0 66 66", xmlns: "http://www.w3.org/2000/svg" },
                    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("circle", { className: theme.path, fill: "none", strokeWidth: "6", strokeLinecap: "round", cx: "33", cy: "33", r: "30" }))));
        }
    };
    ChatBox.prototype.titleRender = function () {
        var _this = this;
        var _a = this.state, openSettings = _a.openSettings, title = _a.title;
        var _b = this.props, theme = _b.theme, logo = _b.logo;
        if (openSettings) {
            return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", null));
        }
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: theme.conversationTitle },
            (title) ? (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("h1", null, title)) : (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null)),
            (logo) ? (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("img", { src: logo })) : (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null)),
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: theme.closeMobile, onClick: function () { return _this.props.switchChat(); } })));
    };
    ChatBox.prototype.render = function () {
        var _this = this;
        var theme = this.props.theme;
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ErrorBoundary, null,
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: css$1(styles$8.fadeinquick) },
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: theme.content },
                    this.titleRender(),
                    this.mainRenderer())),
            (this.props.activeSurvey && !this.state.clickOnStartSurvey) ? (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: theme.likeButton, onClick: function () { return _this.handleStartSurvey(); } },
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(FontAwesomeIcon, { icon: faThumbsUp, size: "1x" }),
                " Ay\u00FAdanos a mejorar")) : (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null))));
    };
    return ChatBox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var css$6 = ".cmadrid_content__1ulWc {\n  background: #fff;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);\n  margin: 3.2em auto;\n  border-radius: 8px 8px 0 0;\n  position: fixed;\n  width: 30vw;\n  right: 30px;\n  bottom: 45px;\n  font-family: 'Montserrat Light', arial;\n  z-index: 999;\n  min-width: 400px;\n}\n\n\n.cmadrid_conversationTitle__1x1DY {\n  text-align: center;\n  padding: 8px;\n  background:#d12000;\n  /*background-image: url('data:image/png;base64,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');*/\n  background-repeat: no-repeat;\n  background-position: center;\n  color: #fff;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  height: 1em;\n}\n\n.cmadrid_conversationTitle__1x1DY h1 {\n  font: 700 18px 'Noto Sans', sans-serif;\n  margin: 0;\n}\n.cmadrid_conversationTitle__1x1DY .cmadrid_status__2_cOQ {\n  font-size: 12px;\n  width: 50px;\n}\n\n.cmadrid_status__2_cOQ:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.cmadrid_conversationWrapper__fhYry {\n  background:#E6E6E6;\n  padding: 25px;\n  height: 60vh;\n  overflow-y: auto;\n  border: 1px solid lightgrey;\n  --scrollbarBG: lightgrey;\n  --thumbBG: #E6E6E6;\n  scrollbar-width: thin;\n  scrollbar-color: var(--thumbBG) var(--scrollbarBG);\n}\n\n.cmadrid_conversationWrapper__fhYry::-webkit-scrollbar {\n  width: 11px;\n}\n\n.cmadrid_conversationWrapper__fhYry::-webkit-scrollbar-track {\n  background: var(--scrollbarBG);\n}\n\n.cmadrid_conversationWrapper__fhYry::-webkit-scrollbar-thumb {\n  background-color: var(--thumbBG) ;\n  border-radius: 6px;\n  border: 3px solid var(--scrollbarBG);\n}\n\n /* Hide scrollbar for Chrome, Safari and Opera */\n /* .conversationWrapper::-webkit-scrollbar {\n  display: none;\n} */\n\n/* Hide scrollbar for IE and Edge */\n/* .conversationWrapper {\n  -ms-overflow-style: none;\n}  */\n\n.cmadrid_settingsContainer__2vRsL {\n  background: white;\n  border: 1px solid lightgrey;\n  padding: 25px;\n  height: 500px;\n  overflow-y: auto;\n  font-size: medium;\n}\n\n.cmadrid_settingsContainer__2vRsL select {\n  width: 100%;\n  height: 25px;\n  border: 1px solid lightgrey;\n  margin: 15px 0 15px 0;\n}\n\n.cmadrid_settingsContainer__2vRsL input {\n  width: 100%;\n  height: 25px;\n  border: 1px solid lightgrey;\n  margin: 5px 0 5px 0;\n  padding-left: 10px;\n}\n\n.cmadrid_messageSent__3aUfF, .cmadrid_messageReceived__2u_d0 {\n  padding: 0;\n}\n.cmadrid_messageReceived__2u_d0 {\n  text-align: left;\n  margin-bottom: 10px;\n}\n.cmadrid_messageSent__3aUfF {\n  text-align: right;\n}\n\n.cmadrid_messageSent__3aUfF > .cmadrid_bubble__3PuLi {\n  border-radius: 12px 12px 0px 12px;\n}\n\n.cmadrid_messageReceived__2u_d0 > .cmadrid_bubble__3PuLi {\n  border-radius: 12px 12px 12px 0px;\n}\n\n.cmadrid_bubble__3PuLi {\n  background: #fff;\n  padding: 12px 18px;\n  border: 0.5px solid rgba(0, 0, 0, 0.02);\n  box-shadow: 0 2px 1px rgba(0, 0, 0, 0.08);\n  max-width: 70%;\n  display: inline-block;\n  text-align: left;\n  font-size: 14px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n.cmadrid_timestamp__3YRAy {\n  margin: 0 0;\n}\n.cmadrid_timestamp__3YRAy .cmadrid_avatar__2SVVm {\n  border-radius: 50%;\n  background: linear-gradient(to top right, #e9e7e8, #898b8f);\n  display: inline-block;\n  width: 25px;\n  height: 20px;\n  vertical-align: top;\n  color: #fff;\n  font-size: 10px;\n  text-align: center;\n  padding-top: 5px;\n}\n.cmadrid_timestamp__3YRAy .cmadrid_time__28PLe {\n  font-size: 12px;\n  color: #999;\n  margin: 0 5px;\n}\n.cmadrid_messagingArea__1lM5Z {\n  position: relative;\n  box-shadow: 0 -2px 1px rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid lightgrey;\n  border-left: 1px solid lightgrey;\n  border-right: 1px solid lightgrey;\n  overflow: hidden;\n}\n.cmadrid_messagingArea__1lM5Z input {\n  font-size: 14px;\n  border: none;\n  padding: 20px 30px;\n  width: 100%;\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 0px;\n  line-height: normal;\n}\n.cmadrid_messagingArea__1lM5Z input:focus {\n  outline: 0;\n}\n\n.cmadrid_send__LuZXI {\n  background: linear-gradient(to top right, #e9e7e8, #898b8f);\n  color: #fff;\n  border-radius: 50%;\n  width: 25px;\n  height: 25px;\n  padding: 8px 10px 12px;\n  position: absolute;\n  font-size: 0.7em;\n  text-align: center;\n  right: 8px;\n  bottom: 8px;\n}\n\n.cmadrid_button__p1NCC {\n\t/* box-shadow:inset 0px -3px 7px 0px #898b8f; */\n\tcolor: gray;\n\tbackground-color:white;\n\tborder-radius:3px;\n\tborder: 1px solid lightgray;\n\tdisplay:inline-block;\n\tcursor:pointer;\n\tfont-size:15px;\n\tpadding:9px 23px;\n\ttext-decoration:none;\n  /* text-shadow:0px 1px 0px #263666; */\n  margin-top: 25px;\n}\n.cmadrid_button__p1NCC:hover {\n  background-color:#898b8f;\n  color: white;\n}\n.cmadrid_button__p1NCC:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.cmadrid_spinnerContainer__3E6Ym {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 500px;\n  border: 1px solid lightgrey;\n}\n\n.cmadrid_spinner__26rN- {\n  animation: cmadrid_rotator__2vFbL 1.4s linear infinite;\n}\n\n@keyframes cmadrid_rotator__2vFbL {\n  0% {\n    transform: rotate(0deg);\n }\n  100% {\n    transform: rotate(270deg);\n }\n}\n.cmadrid_path__3c7Wo {\n  stroke-dasharray: 187;\n  stroke-dashoffset: 0;\n  transform-origin: center;\n  animation: cmadrid_dash__3KL1d 1.4s ease-in-out infinite, cmadrid_colors__2H4-9 5.6s ease-in-out infinite;\n}\n@keyframes cmadrid_colors__2H4-9 {\n  0% {\n    stroke: #4285f4;\n }\n  25% {\n    stroke: #de3e35;\n }\n  50% {\n    stroke: #f7c223;\n }\n  75% {\n    stroke: #1b9a59;\n }\n  100% {\n    stroke: #4285f4;\n }\n}\n@keyframes cmadrid_dash__3KL1d {\n  0% {\n    stroke-dashoffset: 187;\n }\n  50% {\n    stroke-dashoffset: 46.75;\n    transform: rotate(135deg);\n }\n  100% {\n    stroke-dashoffset: 187;\n    transform: rotate(450deg);\n }\n}\n\n.cmadrid_closeMobile__ySUf7 {\n  display: none;\n}\n\n@media only screen and (max-width: 768px) {\n  /* For mobile phones: */\n  .cmadrid_content__1ulWc {\n    bottom: 0 !important;\n    width: 100vw !important;\n    height: 100%;\n    right: 0;\n    bottom: 0;\n    position: unset;\n    margin: 0;\n    min-width: 0;\n  }\n\n  .cmadrid_conversationTitle__1x1DY {\n    border-top-left-radius: 0px;\n    border-top-right-radius: 0px;\n  }\n\n  .cmadrid_conversationWrapper__fhYry {\n    height: 93vh;\n    padding: 20px;\n  }\n\n  .cmadrid_messagingArea__1lM5Z {\n    position: fixed;\n    bottom: 0;\n    width: 100vw;\n    background-color: lightgrey;\n  }\n\n\n\n  .cmadrid_messagingAreaHide__1teex {\n    display: none;\n  }\n\n  .cmadrid_closeMobile__ySUf7 {\n    height: 30px;\n    width: 30px;\n    display: block;\n    position: fixed;\n    right: 20px;\n    top: 0.6rem;\n    color: white;\n    background-image:url('data:image/png;base64,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');\n    background-size: contain;\n  }\n}\n\n/* IPHONE X */\n@media only screen\nand (min-device-width : 375px)\nand (max-device-width : 812px)\nand (-webkit-device-pixel-ratio : 3)\nand (orientation : portrait) {\n\n  .cmadrid_messagingArea__1lM5Z > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .cmadrid_messagingArea__1lM5Z {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n\n}\n\n@media only screen\nand (min-device-width : 375px)\nand (max-device-width : 667px)\nand (orientation : portrait) {\n  /* iPhone 6, 7, & 8 in portrait */\n  .cmadrid_messagingArea__1lM5Z > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .cmadrid_messagingArea__1lM5Z {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n}\n\n@media only screen\nand (min-device-width : 320px)\nand (max-device-width : 568px) {\n  /* Iphone 5 */\n  /* iPhone 6, 7, & 8 in portrait */\n  .cmadrid_messagingArea__1lM5Z > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .cmadrid_messagingArea__1lM5Z {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n}\n\n/* add css styles here (optional) */\n.cmadrid_chatboxContainer__jPlYh {\n  font-size: 2em;\n  position: fixed;\n  right: 0px;\n  z-index: 100000;\n}\n\n@media only screen and (max-width: 600px) {\n  .cmadrid_chatboxContainer__jPlYh {\n    top: 0px;\n    width: 100%;\n  }\n}\n\n.cmadrid_actionButton__1odk5 {\n  background-color:#d12000!important;\n  color: white!important;\n  border: 1px solid#d12000!important;\n  display: inline-block;\n  text-align: center;\n  padding: 15px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: 'Montserrat-light';\n  font-size: 1.8rem;\n}\n\n.cmadrid_actionButton__1odk5:hover {\n  text-decoration: underline;\n}\n\n/* Collapsable */\n.cmadrid_wrapper__3jSeR {\n  overflow: hidden;\n  transition: height 200ms;\n}\n\n.cmadrid_closed__2o5eP {\n  display: none;\n}\n\n.cmadrid_buttonOpenColl__35fI2 {\n  background-color:#d12000;\n  border-radius: 6px;\n  border: 1px solid lightgray;\n  display: flex;\n  cursor: pointer;\n  padding: 10px 10px;\n  text-decoration: none;\n  margin-right: 10px;\n  margin-bottom: 0.2em;\n  width: 90px;\n  font-size: 14px;\n}\n\n.cmadrid_buttonCloseColl__3iD0d {\n  background-color:#d12000;\n  border-radius: 6px;\n  border: 1px solid lightgray;\n  display: flex;\n  cursor: pointer;\n  padding: 5px 5px 10px 5px;\n  text-decoration: none;\n  margin-right: 10px;\n  margin-bottom: 0.2em;\n  width: 6em;\n  font-size: 14px;\n  flex: initial;\n  height: 10px;\n}\n\n.cmadrid_arrowOpen__1uE-e {\n  height: 20px;\n  width: 20px;\n  color: white;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAQAAAAAYLlVAAAF6npUWHRSYXcgcHJvZmlsZSB0eXBlIGV4aWYAAHja7VhZsqM4EPyvU/QRtC/H0RoxN5jjd5YkvNtg3vtsE0ZYEqUiMysBU/v/v05/8NEhOjLWBxedE/iYaKJKOAhifuLYS2HGfnzMGsLvu366DCh0abR6/vRpzU/ot9cTtjVkvu+nsEZUWIHWwBZQ88oKB/U2SfSr2S9XJhTbPHAx+NtUs5pt2VIO12/zwo9gdg7xb7rtMB4oVYuFtFJNSy3G3swM9PwmfM3Ye56H8YTfhtBIrVYmAOTu8rZWiFuA7kDejugR/cvRA/gqrX79gKVbGOHg5YC0r8EfEN8srC8ZqfsBtO3pcta39xp6b/PqknFA1C1FCdrQ4XMwMQNyPU5z2Dy+Fsd+bBFbEEkUUF5FERlbkVEqsNJJGlllkl220RZZkKJRTYETpVQBLdwXwFFUBVxJ5kgb2ZXXUVcdwFxRjbRGt7rkIse6caxXZMDKVWKqkggGdt9v9Gnwm416LwyRFOGCFfJSrCykwczxHrNAiOyLDjsA3rZFv7jRD6QKBu2AOeACk8gzRLbyqi09eNaYZ9HOEpLk6woAiLC2RTJSgwHhpLbSSeGV8lICxwCCEjJX2qgMBqS1qiJJZbR2irwKitfGOV6Oucoqp7gb3gQirHbag5uoE8gyxkI/3gRoKFltjbXWWW8D2WiT084465zzjk0uee2Nt95574OPPgUdTLDBBR9CiCFFFTU80EYXfQwxxpQUJSyUECthfkJPVllnk2122eeQY04F8imm2OKKL6HEkqqqusImqqu+hhprapIanKKZZptrvoUWW+rQWtfddNtd9z302NOFtcXq0/YFa3KxpgZTPM9fWEMveb+FkGwnljkDY8pIMO6ZAQhaMWciSGMUM8eciahQFFYhScvcUJXMGCg0TSrb5YW7K3OHeCMbDvGm9pgjpu43mCNQ98zbC9Yq3+fKYGxWIWMqNKoP4y0kUiHxTS39tP0X6AeBemYuwEkYvwwOYu6ioFva0sGWs7wvpvaejaZWe3MoqJx9tFk7NyfVrCNGalW5IKIQaSzyvqW9CUdazpcCMpwJo6A6xN1nsrq3Ipv1M9ecu2995opirLH16oLQnO1EgW6Rye0JCgZiRIaVGL1wADK3SAwcaAHRcudMdeNkc8WBcr3wnTNYr3uNvneJlFsVPfuOxRBOtdqsKzUif6rZleY9Rk1ChZ3WAH2eMHKT0a/cQkXxxpUbLioLXODMjSqKvtc+Uq0ZPqGdz93yo9slAh5OLjFgpysKUJtx+AodrSi3MeAa7Y5jPUgA7iPGJGHQm3RfFFhifkufDPAq3cmrFpkClvblCid/E/+VnwqDAWIKOL2uFwH8WHbFH5FXfm/0sZUKbbWyXyrvFcI50iaSBeJVJrciOaAROiGaO01sjNInSl8wKt7pih6F9U5XT5oQqceFE8NMW2oLJybzklmebM7IQCpc414jrNOJi3Gdvc5FXm/Ovse536mUlhYehXqvU56xo1PqV5luIl0anZltKgViH3VKZ43sUaV01sgeNUrnjOzZp+idUX3rU/SFqj9qkq6S+kZRVz1eau1LRb+9P9ALkb600j0npaNWuuekdNRK95yUjlrpnpPSUSvdUyUdufkdccqvlf1OlfQorLNOSWd0/QrGD9X/rNJPTkpHrXTPSemole45KR210j0npaNWuqdJ2nukO+qUdELVLzVJ4unme84pz977n2D77jXrg5PSUSvdc1I6aqV7CqWjVrqnUTpqpR9UOoLRN68Jn5zytLIfVUmPD5VnnZJ+outbVdLPX/qnSumole45KR210j0npZ++XW/J0SbTVY4v/gJAqJd/AnA9Xv8EoKX4l6//E70RdZURozejjjICeiPqqjV5/W/hxfkPZ/Pl3Zx/OZmqO/gvyk5L7wb0FzdHZpSeKWVCM3vEV0+W9OyHzOEk4P1r3nNF0rnXvOeKpO8eXt639Dslazv9vGRHuEzM0EshHxTi0uFv+NGvGdu/QCcC4RYaodC/O31MYktOhjIAAAEkaUNDUElDQyBwcm9maWxlAAB4nJ2Qv0rDUBTGf6nFiuhUcRCFDG5ScDGTi38wdCjUtoLRKU1SLCYxJCnFN/BN9GE6CIJP4BMoOPvd6OBgFi8cvh+Hc77v3gsNOw6SorkPSVrm7uDIu/Su7NYbTVq02WPHD4qsNzwbUXs+X7GMvnSMV/3cn2c5jIpAulClQZaXYB2KnXmZGVaxcTsanIgfxHaYpKH4SbwbJqFhsztI4lnw42lusxalF0PTV23j0qVHH5sxM6bElHSkqTqnOBxIXXJ87ikIpDGRenPNlNyICjm5HItGIt2mJm+ryusrZSyPqbxMwh2JPE0e5n+/1z7Oq01rc5H5uV+1llSNyQTeH2Hdg/YzrF7XZK38flvNjFPN/PONXwwfUHdeCSRsAAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADukAAA7pAQ4zQhwAAAAHdElNRQfkBAcTLBVj2v8hAAAA+ElEQVRo3u2Y2w7DIAxDMf//z93DLuoYFOKYTNrip6qQ+LSFELWUVCqVSqX+XTiOxwVijZ++tb0Ra38CiEQ4O9XRQIx9AxCB0DrU2YS99qWgexNh9nerGIS+C64G99u/AHYjjLNjZdI++zeAXQjXWWGZrLf/AFAjzLOBCdLZdwFUCGtZ4An22w8BvAjr0VAk8URClYiNgjIZEwHt89iBpa+U+WTQLSpuxcjWNbtnoNnZ/JaVFBdP0TIV2L6Rr2a6K3wnpSmn+ZSbIVgPLckx6zm2qVZjhMB0DbJeh+2b6H6vRWDbNlHDyTeurqb7W793UqlUKpX6Ld0AolWAFIxyajgAAAAASUVORK5CYII=');\n  background-size: contain;\n  display: flex;\n  margin-right: 10px;\n  transform: rotate(180deg);\n}\n\n.cmadrid_arrowClose__6qos1 {\n\n  height: 20px;\n  width: 20px;\n  color: white;\n  background-image: url('data:image/png;base64,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');\n  background-size: contain;\n  display: flex;\n  margin-right: 10px;\n\n}\n\n.cmadrid_textMoreInfo__2Z1K7 {\n  display: flex;\n  font-size: 1em;\n  color: #FFF;\n}\n\n.cmadrid_mainColor__1oO1c {\n  color:#d12000 !important;\n}\n\n.cmadrid_card__1QxaK {\n  /* Add shadows to create the \"card\" effect */\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  border-radius: 5px; /* 5px rounded corners */\n  margin: 20px 0px 20px 0px;\n  background-color: #f6f6f6;\n  cursor: pointer;\n}\n\n.cmadrid_smallCard__1HAmS {\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  border-radius: 5px; /* 5px rounded corners */\n  margin: 20px 0px 20px 0px;\n  background-color: #f6f6f6;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  cursor: pointer;\n}\n\n/* On mouse-over, add a deeper shadow */\n.cmadrid_smallCard__1HAmS:hover {\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n\n.cmadrid_smallImageCard__N55rl {\n  width: 45%;\n  border-radius: 5px 0 0 5px;\n}\n\n/* On mouse-over, add a deeper shadow */\n.cmadrid_card__1QxaK:hover {\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n\n.cmadrid_imageCard__OjAvv {\n  width: 100%;\n  border-radius: 5px 5px 0 0;\n}\n\n/* Add some padding inside the card container */\n.cmadrid_container__5k-qO {\n  padding: 16px;\n}\n\n.cmadrid_container__5k-qO p {\n  font-size: small;\n}\n\n.cmadrid_displayName__EBx1X {\n  font-size: 0.5em;\n}\n/*===================================\n  Buttons\n===================================*/\n.cmadrid_buttonsContainer__R9pfS {\n\tpadding-bottom: 15px;\n}\n\n.cmadrid_rtButton__18HSq {\n\tbackground-color: lightgray;\n\tborder-radius: 6px;\n\tborder: 1px solid lightgray;\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tpadding: 10px 10px;\n\ttext-decoration: none;\n\tmargin-right: 10px;\n\tmargin-bottom: 0.2em;\n  font-size: 14px;\n  min-width: 50px;\n}\n.cmadrid_rtButton__18HSq:hover {\n\tborder:1px solid #d12000;\n\tcolor: #d12000;\n}\n.cmadrid_rtButton__18HSq:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.cmadrid_rtButtonEmoji__2l75E {\n\tbackground-color: lightgray;\n\tborder-radius: 6px;\n\tborder: 1px solid lightgray;\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tpadding: 10px 10px;\n\ttext-decoration: none;\n\tmargin-right: 10px;\n\tmargin-bottom: 0.2em;\n\tfont-size: 1.7em;\n}\n.cmadrid_rtButtonEmoji__2l75E:hover {\n\tborder:1px solid #d12000;\n\tcolor: #d12000;\n}\n.cmadrid_rtButtonEmoji__2l75E:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.cmadrid_rtButtonCard__74asp {\n\tbox-shadow:inset 0px 1px 0px 0px #999999;\n\tbackground:linear-gradient(to bottom, #999999 5%, #f6f6f6 100%);\n\tbackground-color:#999999;\n\tborder-radius:6px;\n\tborder:1px solid #dcdcdc;\n\tdisplay:inline-block;\n\tcursor:pointer;\n\tcolor:#666666;\n\tfont-family:Arial;\n\tfont-size:15px;\n\tfont-weight:bold;\n\tpadding:10px 25px;\n\ttext-decoration:none;\n  text-shadow:0px 1px 0px #999999;\n  margin-right: 10px;\n}\n.cmadrid_rtButtonCard__74asp:hover {\n\tbackground:linear-gradient(to bottom, #f6f6f6 5%, #999999 100%);\n\tbackground-color:#f6f6f6;\n}\n.cmadrid_rtButtonCard__74asp:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n@media only screen and (max-width: 768px) {\n\n\t.cmadrid_rtButton__18HSq {\n\t\tmin-width: 90%;\n\t}\n}\n\n";
var cmadrid = {"content":"cmadrid_content__1ulWc","conversationTitle":"cmadrid_conversationTitle__1x1DY","status":"cmadrid_status__2_cOQ","conversationWrapper":"cmadrid_conversationWrapper__fhYry","settingsContainer":"cmadrid_settingsContainer__2vRsL","messageSent":"cmadrid_messageSent__3aUfF","messageReceived":"cmadrid_messageReceived__2u_d0","bubble":"cmadrid_bubble__3PuLi","timestamp":"cmadrid_timestamp__3YRAy","avatar":"cmadrid_avatar__2SVVm","time":"cmadrid_time__28PLe","messagingArea":"cmadrid_messagingArea__1lM5Z","send":"cmadrid_send__LuZXI","button":"cmadrid_button__p1NCC","spinnerContainer":"cmadrid_spinnerContainer__3E6Ym","spinner":"cmadrid_spinner__26rN-","rotator":"cmadrid_rotator__2vFbL","path":"cmadrid_path__3c7Wo","dash":"cmadrid_dash__3KL1d","colors":"cmadrid_colors__2H4-9","closeMobile":"cmadrid_closeMobile__ySUf7","messagingAreaHide":"cmadrid_messagingAreaHide__1teex","chatboxContainer":"cmadrid_chatboxContainer__jPlYh","actionButton":"cmadrid_actionButton__1odk5","wrapper":"cmadrid_wrapper__3jSeR","closed":"cmadrid_closed__2o5eP","buttonOpenColl":"cmadrid_buttonOpenColl__35fI2","buttonCloseColl":"cmadrid_buttonCloseColl__3iD0d","arrowOpen":"cmadrid_arrowOpen__1uE-e","arrowClose":"cmadrid_arrowClose__6qos1","textMoreInfo":"cmadrid_textMoreInfo__2Z1K7","mainColor":"cmadrid_mainColor__1oO1c","card":"cmadrid_card__1QxaK","smallCard":"cmadrid_smallCard__1HAmS","smallImageCard":"cmadrid_smallImageCard__N55rl","imageCard":"cmadrid_imageCard__OjAvv","container":"cmadrid_container__5k-qO","displayName":"cmadrid_displayName__EBx1X","buttonsContainer":"cmadrid_buttonsContainer__R9pfS","rtButton":"cmadrid_rtButton__18HSq","rtButtonEmoji":"cmadrid_rtButtonEmoji__2l75E","rtButtonCard":"cmadrid_rtButtonCard__74asp"};
styleInject(css$6);

var css$7 = "\n.dev_content__1pCT0 {\n  background: #fff;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);\n  margin: 3.2em auto;\n  border-radius: 8px 8px 0 0;\n  position: fixed;\n  width: 30vw;\n  right: 30px;\n  bottom: 45px;\n  font-family: 'Montserrat Light', arial;\n  z-index: 999;\n  min-width: 400px;\n}\n\n\n.dev_conversationTitle__1XFQ4 {\n  text-align: center;\n  padding: 8px;\n  background: #2ECC40;\n  /*background-image: url('data:image/png;base64,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');*/\n  background-repeat: no-repeat;\n  background-position: center;\n  color: #fff;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  height: 1em;\n}\n.dev_conversationTitle__1XFQ4 h1 {\n  font: 700 18px 'Noto Sans', sans-serif;\n  margin: 0;\n}\n.dev_conversationTitle__1XFQ4 .dev_status__3RTRU {\n  font-size: 12px;\n  width: 50px;\n}\n\n.dev_status__3RTRU:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.dev_conversationWrapper__2-WcO {\n  background:#E6E6E6;\n  padding: 25px;\n  height: 60vh;\n  overflow-y: auto;\n  border: 1px solid lightgrey;\n  --scrollbarBG: lightgrey;\n  --thumbBG: #E6E6E6;\n  scrollbar-width: thin;\n  scrollbar-color: var(--thumbBG) var(--scrollbarBG);\n}\n\n.dev_conversationWrapper__2-WcO::-webkit-scrollbar {\n  width: 11px;\n}\n\n.dev_conversationWrapper__2-WcO::-webkit-scrollbar-track {\n  background: var(--scrollbarBG);\n}\n\n.dev_conversationWrapper__2-WcO::-webkit-scrollbar-thumb {\n  background-color: var(--thumbBG) ;\n  border-radius: 6px;\n  border: 3px solid var(--scrollbarBG);\n}\n\n /* Hide scrollbar for Chrome, Safari and Opera */\n /* .conversationWrapper::-webkit-scrollbar {\n  display: none;\n} */\n\n/* Hide scrollbar for IE and Edge */\n/* .conversationWrapper {\n  -ms-overflow-style: none;\n}  */\n\n.dev_settingsContainer__1PSjF {\n  background: white;\n  border: 1px solid lightgrey;\n  padding: 25px;\n  height: 500px;\n  overflow-y: auto;\n  font-size: medium;\n}\n\n.dev_settingsContainer__1PSjF select {\n  width: 100%;\n  height: 25px;\n  border: 1px solid lightgrey;\n  margin: 15px 0 15px 0;\n}\n\n.dev_settingsContainer__1PSjF input {\n  width: 100%;\n  height: 25px;\n  border: 1px solid lightgrey;\n  margin: 5px 0 5px 0;\n  padding-left: 10px;\n}\n\n.dev_messageSent__2mDun, .dev_messageReceived__267Vs {\n  padding: 0;\n}\n.dev_messageReceived__267Vs {\n  text-align: left;\n  margin-bottom: 10px;\n}\n.dev_messageSent__2mDun {\n  text-align: right;\n}\n\n.dev_messageSent__2mDun > .dev_bubble__3XjRJ {\n  border-radius: 12px 12px 0px 12px;\n}\n\n.dev_messageReceived__267Vs > .dev_bubble__3XjRJ {\n  border-radius: 12px 12px 12px 0px;\n}\n\n.dev_bubble__3XjRJ {\n  background: #fff;\n  padding: 12px 18px;\n  border: 0.5px solid rgba(0, 0, 0, 0.02);\n  box-shadow: 0 2px 1px rgba(0, 0, 0, 0.08);\n  max-width: 70%;\n  display: inline-block;\n  text-align: left;\n  font-size: 14px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n.dev_timestamp__3ZdSc {\n  margin: 0 0;\n}\n.dev_timestamp__3ZdSc .dev_avatar__3ufxE {\n  border-radius: 50%;\n  background: linear-gradient(to top right, #e9e7e8, #898b8f);\n  display: inline-block;\n  width: 25px;\n  height: 20px;\n  vertical-align: top;\n  color: #fff;\n  font-size: 10px;\n  text-align: center;\n  padding-top: 5px;\n}\n.dev_timestamp__3ZdSc .dev_time__2cSB9 {\n  font-size: 12px;\n  color: #999;\n  margin: 0 5px;\n}\n.dev_messagingArea__3HumR {\n  position: relative;\n  box-shadow: 0 -2px 1px rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid lightgrey;\n  border-left: 1px solid lightgrey;\n  border-right: 1px solid lightgrey;\n  overflow: hidden;\n}\n.dev_messagingArea__3HumR input {\n  font-size: 14px;\n  border: none;\n  padding: 20px 30px;\n  width: 100%;\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 0px;\n  line-height: normal;\n}\n.dev_messagingArea__3HumR input:focus {\n  outline: 0;\n}\n\n.dev_send__15Gst {\n  background: linear-gradient(to top right, #e9e7e8, #898b8f);\n  color: #fff;\n  border-radius: 50%;\n  width: 25px;\n  height: 25px;\n  padding: 8px 10px 12px;\n  position: absolute;\n  font-size: 0.7em;\n  text-align: center;\n  right: 8px;\n  bottom: 8px;\n}\n\n.dev_button__17sgh {\n\t/* box-shadow:inset 0px -3px 7px 0px #898b8f; */\n\tcolor: gray;\n\tbackground-color:white;\n\tborder-radius:3px;\n\tborder: 1px solid lightgray;\n\tdisplay:inline-block;\n\tcursor:pointer;\n\tfont-size:15px;\n\tpadding:9px 23px;\n\ttext-decoration:none;\n  /* text-shadow:0px 1px 0px #263666; */\n  margin-top: 25px;\n}\n.dev_button__17sgh:hover {\n  background-color:#898b8f;\n  color: white;\n}\n.dev_button__17sgh:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.dev_spinnerContainer__1_b32 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 500px;\n  border: 1px solid lightgrey;\n}\n\n.dev_spinner__ZSKyF {\n  animation: dev_rotator__N6JaM 1.4s linear infinite;\n}\n\n@keyframes dev_rotator__N6JaM {\n  0% {\n    transform: rotate(0deg);\n }\n  100% {\n    transform: rotate(270deg);\n }\n}\n.dev_path__2InTA {\n  stroke-dasharray: 187;\n  stroke-dashoffset: 0;\n  transform-origin: center;\n  animation: dev_dash__26mgj 1.4s ease-in-out infinite, dev_colors__2xZBM 5.6s ease-in-out infinite;\n}\n@keyframes dev_colors__2xZBM {\n  0% {\n    stroke: #4285f4;\n }\n  25% {\n    stroke: #de3e35;\n }\n  50% {\n    stroke: #f7c223;\n }\n  75% {\n    stroke: #1b9a59;\n }\n  100% {\n    stroke: #4285f4;\n }\n}\n@keyframes dev_dash__26mgj {\n  0% {\n    stroke-dashoffset: 187;\n }\n  50% {\n    stroke-dashoffset: 46.75;\n    transform: rotate(135deg);\n }\n  100% {\n    stroke-dashoffset: 187;\n    transform: rotate(450deg);\n }\n}\n\n.dev_closeMobile__1sX-6 {\n  display: none;\n}\n\n@media only screen and (max-width: 768px) {\n  /* For mobile phones: */\n  .dev_content__1pCT0 {\n    bottom: 0 !important;\n    width: 100vw !important;\n    height: 100%;\n    right: 0;\n    bottom: 0;\n    position: unset;\n    margin: 0;\n    min-width: 0;\n  }\n\n  .dev_conversationTitle__1XFQ4 {\n    border-top-left-radius: 0px;\n    border-top-right-radius: 0px;\n  }\n\n  .dev_conversationWrapper__2-WcO {\n    height: 85vh;\n    padding: 20px;\n  }\n\n  .dev_messagingArea__3HumR {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: lightgrey;\n    height: 2em;\n  }\n\n\n\n  .dev_messagingAreaHide__yb2Rn {\n    display: none;\n  }\n\n  .dev_closeMobile__1sX-6 {\n    height: 30px;\n    width: 30px;\n    display: block;\n    position: fixed;\n    right: 20px;\n    top: 0.6rem;\n    color: white;\n    background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAQAAAAAYLlVAAAF6npUWHRSYXcgcHJvZmlsZSB0eXBlIGV4aWYAAHja7VhZsqM4EPyvU/QRtC/H0RoxN5jjd5YkvNtg3vtsE0ZYEqUiMysBU/v/v05/8NEhOjLWBxedE/iYaKJKOAhifuLYS2HGfnzMGsLvu366DCh0abR6/vRpzU/ot9cTtjVkvu+nsEZUWIHWwBZQ88oKB/U2SfSr2S9XJhTbPHAx+NtUs5pt2VIO12/zwo9gdg7xb7rtMB4oVYuFtFJNSy3G3swM9PwmfM3Ye56H8YTfhtBIrVYmAOTu8rZWiFuA7kDejugR/cvRA/gqrX79gKVbGOHg5YC0r8EfEN8srC8ZqfsBtO3pcta39xp6b/PqknFA1C1FCdrQ4XMwMQNyPU5z2Dy+Fsd+bBFbEEkUUF5FERlbkVEqsNJJGlllkl220RZZkKJRTYETpVQBLdwXwFFUBVxJ5kgb2ZXXUVcdwFxRjbRGt7rkIse6caxXZMDKVWKqkggGdt9v9Gnwm416LwyRFOGCFfJSrCykwczxHrNAiOyLDjsA3rZFv7jRD6QKBu2AOeACk8gzRLbyqi09eNaYZ9HOEpLk6woAiLC2RTJSgwHhpLbSSeGV8lICxwCCEjJX2qgMBqS1qiJJZbR2irwKitfGOV6Oucoqp7gb3gQirHbag5uoE8gyxkI/3gRoKFltjbXWWW8D2WiT084465zzjk0uee2Nt95574OPPgUdTLDBBR9CiCFFFTU80EYXfQwxxpQUJSyUECthfkJPVllnk2122eeQY04F8imm2OKKL6HEkqqqusImqqu+hhprapIanKKZZptrvoUWW+rQWtfddNtd9z302NOFtcXq0/YFa3KxpgZTPM9fWEMveb+FkGwnljkDY8pIMO6ZAQhaMWciSGMUM8eciahQFFYhScvcUJXMGCg0TSrb5YW7K3OHeCMbDvGm9pgjpu43mCNQ98zbC9Yq3+fKYGxWIWMqNKoP4y0kUiHxTS39tP0X6AeBemYuwEkYvwwOYu6ioFva0sGWs7wvpvaejaZWe3MoqJx9tFk7NyfVrCNGalW5IKIQaSzyvqW9CUdazpcCMpwJo6A6xN1nsrq3Ipv1M9ecu2995opirLH16oLQnO1EgW6Rye0JCgZiRIaVGL1wADK3SAwcaAHRcudMdeNkc8WBcr3wnTNYr3uNvneJlFsVPfuOxRBOtdqsKzUif6rZleY9Rk1ChZ3WAH2eMHKT0a/cQkXxxpUbLioLXODMjSqKvtc+Uq0ZPqGdz93yo9slAh5OLjFgpysKUJtx+AodrSi3MeAa7Y5jPUgA7iPGJGHQm3RfFFhifkufDPAq3cmrFpkClvblCid/E/+VnwqDAWIKOL2uFwH8WHbFH5FXfm/0sZUKbbWyXyrvFcI50iaSBeJVJrciOaAROiGaO01sjNInSl8wKt7pih6F9U5XT5oQqceFE8NMW2oLJybzklmebM7IQCpc414jrNOJi3Gdvc5FXm/Ovse536mUlhYehXqvU56xo1PqV5luIl0anZltKgViH3VKZ43sUaV01sgeNUrnjOzZp+idUX3rU/SFqj9qkq6S+kZRVz1eau1LRb+9P9ALkb600j0npaNWuuekdNRK95yUjlrpnpPSUSvdUyUdufkdccqvlf1OlfQorLNOSWd0/QrGD9X/rNJPTkpHrXTPSemole45KR210j0npaNWuqdJ2nukO+qUdELVLzVJ4unme84pz977n2D77jXrg5PSUSvdc1I6aqV7CqWjVrqnUTpqpR9UOoLRN68Jn5zytLIfVUmPD5VnnZJ+outbVdLPX/qnSumole45KR210j0npZ++XW/J0SbTVY4v/gJAqJd/AnA9Xv8EoKX4l6//E70RdZURozejjjICeiPqqjV5/W/hxfkPZ/Pl3Zx/OZmqO/gvyk5L7wb0FzdHZpSeKWVCM3vEV0+W9OyHzOEk4P1r3nNF0rnXvOeKpO8eXt639Dslazv9vGRHuEzM0EshHxTi0uFv+NGvGdu/QCcC4RYaodC/O31MYktOhjIAAAEkaUNDUElDQyBwcm9maWxlAAB4nJ2Qv0rDUBTGf6nFiuhUcRCFDG5ScDGTi38wdCjUtoLRKU1SLCYxJCnFN/BN9GE6CIJP4BMoOPvd6OBgFi8cvh+Hc77v3gsNOw6SorkPSVrm7uDIu/Su7NYbTVq02WPHD4qsNzwbUXs+X7GMvnSMV/3cn2c5jIpAulClQZaXYB2KnXmZGVaxcTsanIgfxHaYpKH4SbwbJqFhsztI4lnw42lusxalF0PTV23j0qVHH5sxM6bElHSkqTqnOBxIXXJ87ikIpDGRenPNlNyICjm5HItGIt2mJm+ryusrZSyPqbxMwh2JPE0e5n+/1z7Oq01rc5H5uV+1llSNyQTeH2Hdg/YzrF7XZK38flvNjFPN/PONXwwfUHdeCSRsAAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADukAAA7pAQ4zQhwAAAAHdElNRQfkBAcTLBVj2v8hAAAA+ElEQVRo3u2Y2w7DIAxDMf//z93DLuoYFOKYTNrip6qQ+LSFELWUVCqVSqX+XTiOxwVijZ++tb0Ra38CiEQ4O9XRQIx9AxCB0DrU2YS99qWgexNh9nerGIS+C64G99u/AHYjjLNjZdI++zeAXQjXWWGZrLf/AFAjzLOBCdLZdwFUCGtZ4An22w8BvAjr0VAk8URClYiNgjIZEwHt89iBpa+U+WTQLSpuxcjWNbtnoNnZ/JaVFBdP0TIV2L6Rr2a6K3wnpSmn+ZSbIVgPLckx6zm2qVZjhMB0DbJeh+2b6H6vRWDbNlHDyTeurqb7W793UqlUKpX6Ld0AolWAFIxyajgAAAAASUVORK5CYII=');\n    background-size: contain;\n  }\n}\n\n/* IPHONE X */\n@media only screen\nand (min-device-width : 375px)\nand (max-device-width : 812px)\nand (-webkit-device-pixel-ratio : 3)\nand (orientation : portrait) {\n\n  .dev_messagingArea__3HumR > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .dev_messagingArea__3HumR {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n\n}\n\n@media only screen\nand (min-device-width : 375px)\nand (max-device-width : 667px)\nand (orientation : portrait) {\n  /* iPhone 6, 7, & 8 in portrait */\n  .dev_messagingArea__3HumR > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .dev_messagingArea__3HumR {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n}\n\n@media only screen\nand (min-device-width : 320px)\nand (max-device-width : 568px) {\n  /* Iphone 5 */\n  /* iPhone 6, 7, & 8 in portrait */\n  .dev_messagingArea__3HumR > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .dev_messagingArea__3HumR {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n}\n\n/* add css styles here (optional) */\n.dev_chatboxContainer__14UTL {\n  font-size: 2em;\n  position: fixed;\n  right: 0px;\n  z-index: 100000;\n}\n\n@media only screen and (max-width: 600px) {\n  .dev_chatboxContainer__14UTL {\n    top: 0px;\n    width: 100%;\n  }\n}\n\n.dev_actionButton__3kKO6 {\n  background-color: #2ECC40!important;\n  color: white!important;\n  border: 1px solid #2ECC40!important;\n  display: inline-block;\n  text-align: center;\n  padding: 15px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: 'Montserrat-light';\n  font-size: 1.8rem;\n}\n\n.dev_actionButton__3kKO6:hover {\n  text-decoration: underline;\n}\n\n/* Collapsable */\n.dev_wrapper__36Bz- {\n  overflow: hidden;\n  transition: height 200ms;\n}\n\n.dev_closed__WI_eJ {\n  display: none;\n}\n\n.dev_buttonOpenColl__3n3xp {\n  background-color: #2ECC40;\n  border-radius: 6px;\n  border: 1px solid lightgray;\n  display: flex;\n  cursor: pointer;\n  padding: 10px 10px;\n  text-decoration: none;\n  margin-right: 10px;\n  margin-bottom: 0.2em;\n  width: 90px;\n  font-size: 14px;\n}\n\n.dev_buttonCloseColl__pyWHS {\n  background-color: #2ECC40;\n  border-radius: 6px;\n  border: 1px solid lightgray;\n  display: flex;\n  cursor: pointer;\n  padding: 5px 5px 10px 5px;\n  text-decoration: none;\n  margin-right: 10px;\n  margin-bottom: 0.2em;\n  width: 6em;\n  font-size: 14px;\n  flex: initial;\n  height: 10px;\n}\n\n.dev_arrowOpen__3HAhI {\n  height: 20px;\n  width: 20px;\n  color: white;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAQAAAAAYLlVAAAF6npUWHRSYXcgcHJvZmlsZSB0eXBlIGV4aWYAAHja7VhZsqM4EPyvU/QRtC/H0RoxN5jjd5YkvNtg3vtsE0ZYEqUiMysBU/v/v05/8NEhOjLWBxedE/iYaKJKOAhifuLYS2HGfnzMGsLvu366DCh0abR6/vRpzU/ot9cTtjVkvu+nsEZUWIHWwBZQ88oKB/U2SfSr2S9XJhTbPHAx+NtUs5pt2VIO12/zwo9gdg7xb7rtMB4oVYuFtFJNSy3G3swM9PwmfM3Ye56H8YTfhtBIrVYmAOTu8rZWiFuA7kDejugR/cvRA/gqrX79gKVbGOHg5YC0r8EfEN8srC8ZqfsBtO3pcta39xp6b/PqknFA1C1FCdrQ4XMwMQNyPU5z2Dy+Fsd+bBFbEEkUUF5FERlbkVEqsNJJGlllkl220RZZkKJRTYETpVQBLdwXwFFUBVxJ5kgb2ZXXUVcdwFxRjbRGt7rkIse6caxXZMDKVWKqkggGdt9v9Gnwm416LwyRFOGCFfJSrCykwczxHrNAiOyLDjsA3rZFv7jRD6QKBu2AOeACk8gzRLbyqi09eNaYZ9HOEpLk6woAiLC2RTJSgwHhpLbSSeGV8lICxwCCEjJX2qgMBqS1qiJJZbR2irwKitfGOV6Oucoqp7gb3gQirHbag5uoE8gyxkI/3gRoKFltjbXWWW8D2WiT084465zzjk0uee2Nt95574OPPgUdTLDBBR9CiCFFFTU80EYXfQwxxpQUJSyUECthfkJPVllnk2122eeQY04F8imm2OKKL6HEkqqqusImqqu+hhprapIanKKZZptrvoUWW+rQWtfddNtd9z302NOFtcXq0/YFa3KxpgZTPM9fWEMveb+FkGwnljkDY8pIMO6ZAQhaMWciSGMUM8eciahQFFYhScvcUJXMGCg0TSrb5YW7K3OHeCMbDvGm9pgjpu43mCNQ98zbC9Yq3+fKYGxWIWMqNKoP4y0kUiHxTS39tP0X6AeBemYuwEkYvwwOYu6ioFva0sGWs7wvpvaejaZWe3MoqJx9tFk7NyfVrCNGalW5IKIQaSzyvqW9CUdazpcCMpwJo6A6xN1nsrq3Ipv1M9ecu2995opirLH16oLQnO1EgW6Rye0JCgZiRIaVGL1wADK3SAwcaAHRcudMdeNkc8WBcr3wnTNYr3uNvneJlFsVPfuOxRBOtdqsKzUif6rZleY9Rk1ChZ3WAH2eMHKT0a/cQkXxxpUbLioLXODMjSqKvtc+Uq0ZPqGdz93yo9slAh5OLjFgpysKUJtx+AodrSi3MeAa7Y5jPUgA7iPGJGHQm3RfFFhifkufDPAq3cmrFpkClvblCid/E/+VnwqDAWIKOL2uFwH8WHbFH5FXfm/0sZUKbbWyXyrvFcI50iaSBeJVJrciOaAROiGaO01sjNInSl8wKt7pih6F9U5XT5oQqceFE8NMW2oLJybzklmebM7IQCpc414jrNOJi3Gdvc5FXm/Ovse536mUlhYehXqvU56xo1PqV5luIl0anZltKgViH3VKZ43sUaV01sgeNUrnjOzZp+idUX3rU/SFqj9qkq6S+kZRVz1eau1LRb+9P9ALkb600j0npaNWuuekdNRK95yUjlrpnpPSUSvdUyUdufkdccqvlf1OlfQorLNOSWd0/QrGD9X/rNJPTkpHrXTPSemole45KR210j0npaNWuqdJ2nukO+qUdELVLzVJ4unme84pz977n2D77jXrg5PSUSvdc1I6aqV7CqWjVrqnUTpqpR9UOoLRN68Jn5zytLIfVUmPD5VnnZJ+outbVdLPX/qnSumole45KR210j0npZ++XW/J0SbTVY4v/gJAqJd/AnA9Xv8EoKX4l6//E70RdZURozejjjICeiPqqjV5/W/hxfkPZ/Pl3Zx/OZmqO/gvyk5L7wb0FzdHZpSeKWVCM3vEV0+W9OyHzOEk4P1r3nNF0rnXvOeKpO8eXt639Dslazv9vGRHuEzM0EshHxTi0uFv+NGvGdu/QCcC4RYaodC/O31MYktOhjIAAAEkaUNDUElDQyBwcm9maWxlAAB4nJ2Qv0rDUBTGf6nFiuhUcRCFDG5ScDGTi38wdCjUtoLRKU1SLCYxJCnFN/BN9GE6CIJP4BMoOPvd6OBgFi8cvh+Hc77v3gsNOw6SorkPSVrm7uDIu/Su7NYbTVq02WPHD4qsNzwbUXs+X7GMvnSMV/3cn2c5jIpAulClQZaXYB2KnXmZGVaxcTsanIgfxHaYpKH4SbwbJqFhsztI4lnw42lusxalF0PTV23j0qVHH5sxM6bElHSkqTqnOBxIXXJ87ikIpDGRenPNlNyICjm5HItGIt2mJm+ryusrZSyPqbxMwh2JPE0e5n+/1z7Oq01rc5H5uV+1llSNyQTeH2Hdg/YzrF7XZK38flvNjFPN/PONXwwfUHdeCSRsAAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADukAAA7pAQ4zQhwAAAAHdElNRQfkBAcTLBVj2v8hAAAA+ElEQVRo3u2Y2w7DIAxDMf//z93DLuoYFOKYTNrip6qQ+LSFELWUVCqVSqX+XTiOxwVijZ++tb0Ra38CiEQ4O9XRQIx9AxCB0DrU2YS99qWgexNh9nerGIS+C64G99u/AHYjjLNjZdI++zeAXQjXWWGZrLf/AFAjzLOBCdLZdwFUCGtZ4An22w8BvAjr0VAk8URClYiNgjIZEwHt89iBpa+U+WTQLSpuxcjWNbtnoNnZ/JaVFBdP0TIV2L6Rr2a6K3wnpSmn+ZSbIVgPLckx6zm2qVZjhMB0DbJeh+2b6H6vRWDbNlHDyTeurqb7W793UqlUKpX6Ld0AolWAFIxyajgAAAAASUVORK5CYII=');\n  background-size: contain;\n  display: flex;\n  margin-right: 10px;\n  transform: rotate(180deg);\n}\n\n.dev_arrowClose__3EQ-n {\n\n  height: 20px;\n  width: 20px;\n  color: white;\n  background-image: url('data:image/png;base64,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');\n  background-size: contain;\n  display: flex;\n  margin-right: 10px;\n\n}\n\n.dev_textMoreInfo__3IuYZ {\n  display: flex;\n  font-size: 1em;\n  color: #FFF;\n}\n\n.dev_mainColor__1eAox {\n  color: #2ECC40 !important;\n}\n\n.dev_card__1jSOX {\n  /* Add shadows to create the \"card\" effect */\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  border-radius: 5px; /* 5px rounded corners */\n  margin: 20px 0px 20px 0px;\n  background-color: #f6f6f6;\n  cursor: pointer;\n}\n\n.dev_smallCard__1ZSEH {\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  border-radius: 5px; /* 5px rounded corners */\n  margin: 20px 0px 20px 0px;\n  background-color: #f6f6f6;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  cursor: pointer;\n}\n\n/* On mouse-over, add a deeper shadow */\n.dev_smallCard__1ZSEH:hover {\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n\n.dev_smallImageCard__3HnVD {\n  width: 45%;\n  border-radius: 5px 0 0 5px;\n}\n\n/* On mouse-over, add a deeper shadow */\n.dev_card__1jSOX:hover {\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n\n.dev_imageCard__3euEM {\n  width: 100%;\n  border-radius: 5px 5px 0 0;\n}\n\n/* Add some padding inside the card container */\n.dev_container__226Ui {\n  padding: 16px;\n}\n\n.dev_container__226Ui p {\n  font-size: small;\n}\n\n.dev_displayName__3JYzD {\n  font-size: 0.5em;\n}\n/*===================================\n  Buttons\n===================================*/\n.dev_buttonsContainer__cp_6x {\n\tpadding-bottom: 15px;\n}\n\n.dev_rtButton__3yXgy {\n\tbackground-color: lightgray;\n\tborder-radius: 6px;\n\tborder: 1px solid lightgray;\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tpadding: 10px 10px;\n\ttext-decoration: none;\n\tmargin-right: 10px;\n\tmargin-bottom: 0.2em;\n  font-size: 14px;\n  min-width: 50px;\n}\n.dev_rtButton__3yXgy:hover {\n\tborder:1px solid #4eaa38;\n\tcolor: #4eaa38;\n}\n.dev_rtButton__3yXgy:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.dev_rtButtonEmoji__2d6ey {\n\tbackground-color: lightgray;\n\tborder-radius: 6px;\n\tborder: 1px solid lightgray;\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tpadding: 10px 10px;\n\ttext-decoration: none;\n\tmargin-right: 10px;\n\tmargin-bottom: 0.2em;\n\tfont-size: 1.7em;\n}\n.dev_rtButtonEmoji__2d6ey:hover {\n\tborder:1px solid #4eaa38;\n\tcolor: #4eaa38;\n}\n.dev_rtButtonEmoji__2d6ey:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.dev_rtButtonCard__2nKnP {\n\tbox-shadow:inset 0px 1px 0px 0px #999999;\n\tbackground:linear-gradient(to bottom, #999999 5%, #f6f6f6 100%);\n\tbackground-color:#999999;\n\tborder-radius:6px;\n\tborder:1px solid #dcdcdc;\n\tdisplay:inline-block;\n\tcursor:pointer;\n\tcolor:#666666;\n\tfont-family:Arial;\n\tfont-size:15px;\n\tfont-weight:bold;\n\tpadding:10px 25px;\n\ttext-decoration:none;\n  text-shadow:0px 1px 0px #999999;\n  margin-right: 10px;\n}\n.dev_rtButtonCard__2nKnP:hover {\n\tbackground:linear-gradient(to bottom, #f6f6f6 5%, #999999 100%);\n\tbackground-color:#f6f6f6;\n}\n.dev_rtButtonCard__2nKnP:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n@media only screen and (max-width: 768px) {\n\n\t.dev_rtButton__3yXgy {\n\t\tmin-width: 90%;\n\t}\n}\n\n";
var dev = {"content":"dev_content__1pCT0","conversationTitle":"dev_conversationTitle__1XFQ4","status":"dev_status__3RTRU","conversationWrapper":"dev_conversationWrapper__2-WcO","settingsContainer":"dev_settingsContainer__1PSjF","messageSent":"dev_messageSent__2mDun","messageReceived":"dev_messageReceived__267Vs","bubble":"dev_bubble__3XjRJ","timestamp":"dev_timestamp__3ZdSc","avatar":"dev_avatar__3ufxE","time":"dev_time__2cSB9","messagingArea":"dev_messagingArea__3HumR","send":"dev_send__15Gst","button":"dev_button__17sgh","spinnerContainer":"dev_spinnerContainer__1_b32","spinner":"dev_spinner__ZSKyF","rotator":"dev_rotator__N6JaM","path":"dev_path__2InTA","dash":"dev_dash__26mgj","colors":"dev_colors__2xZBM","closeMobile":"dev_closeMobile__1sX-6","messagingAreaHide":"dev_messagingAreaHide__yb2Rn","chatboxContainer":"dev_chatboxContainer__14UTL","actionButton":"dev_actionButton__3kKO6","wrapper":"dev_wrapper__36Bz-","closed":"dev_closed__WI_eJ","buttonOpenColl":"dev_buttonOpenColl__3n3xp","buttonCloseColl":"dev_buttonCloseColl__pyWHS","arrowOpen":"dev_arrowOpen__3HAhI","arrowClose":"dev_arrowClose__3EQ-n","textMoreInfo":"dev_textMoreInfo__3IuYZ","mainColor":"dev_mainColor__1eAox","card":"dev_card__1jSOX","smallCard":"dev_smallCard__1ZSEH","smallImageCard":"dev_smallImageCard__3HnVD","imageCard":"dev_imageCard__3euEM","container":"dev_container__226Ui","displayName":"dev_displayName__3JYzD","buttonsContainer":"dev_buttonsContainer__cp_6x","rtButton":"dev_rtButton__3yXgy","rtButtonEmoji":"dev_rtButtonEmoji__2d6ey","rtButtonCard":"dev_rtButtonCard__2nKnP"};
styleInject(css$7);

var css$8 = ".qa_content__gm3Lm {\n  background: #fff;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);\n  margin: 3.2em auto;\n  border-radius: 8px 8px 0 0;\n  position: fixed;\n  width: 30vw;\n  right: 30px;\n  bottom: 45px;\n  font-family: 'Montserrat Light', arial;\n  z-index: 999;\n  min-width: 400px;\n}\n\n\n.qa_conversationTitle__1nVrU {\n  text-align: center;\n  padding: 8px;\n  background: #0074D9;\n  background-repeat: no-repeat;\n  background-position: center;\n  color: #FFF;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  height: 1em;\n}\n.qa_conversationTitle__1nVrU h1 {\n  font: 700 18px 'Noto Sans', sans-serif;\n  margin: 0;\n}\n.qa_conversationTitle__1nVrU .qa_status__2WcHX {\n  font-size: 12px;\n  width: 50px;\n}\n\n.qa_status__2WcHX:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.qa_conversationWrapper__1CqFS {\n  background:#E6E6E6;\n  padding: 25px;\n  height: 60vh;\n  overflow-y: auto;\n  border: 1px solid lightgrey;\n  --scrollbarBG: lightgrey;\n  --thumbBG: #E6E6E6;\n  scrollbar-width: thin;\n  scrollbar-color: var(--thumbBG) var(--scrollbarBG);\n}\n\n.qa_conversationWrapper__1CqFS::-webkit-scrollbar {\n  width: 11px;\n}\n\n.qa_conversationWrapper__1CqFS::-webkit-scrollbar-track {\n  background: var(--scrollbarBG);\n}\n\n.qa_conversationWrapper__1CqFS::-webkit-scrollbar-thumb {\n  background-color: var(--thumbBG) ;\n  border-radius: 6px;\n  border: 3px solid var(--scrollbarBG);\n}\n\n /* Hide scrollbar for Chrome, Safari and Opera */\n /* .conversationWrapper::-webkit-scrollbar {\n  display: none;\n} */\n\n/* Hide scrollbar for IE and Edge */\n/* .conversationWrapper {\n  -ms-overflow-style: none;\n}  */\n\n.qa_settingsContainer__hIOJm {\n  background: white;\n  border: 1px solid lightgrey;\n  padding: 25px;\n  height: 500px;\n  overflow-y: auto;\n  font-size: medium;\n}\n\n.qa_settingsContainer__hIOJm select {\n  width: 100%;\n  height: 25px;\n  border: 1px solid lightgrey;\n  margin: 15px 0 15px 0;\n}\n\n.qa_settingsContainer__hIOJm input {\n  width: 100%;\n  height: 25px;\n  border: 1px solid lightgrey;\n  margin: 5px 0 5px 0;\n  padding-left: 10px;\n}\n\n.qa_messageSent__Myv2I, .qa_messageReceived__2WPAd {\n  padding: 0;\n}\n.qa_messageReceived__2WPAd {\n  text-align: left;\n  margin-bottom: 10px;\n}\n.qa_messageSent__Myv2I {\n  text-align: right;\n}\n\n.qa_messageSent__Myv2I > .qa_bubble__3draw {\n  border-radius: 12px 12px 0px 12px;\n}\n\n.qa_messageReceived__2WPAd > .qa_bubble__3draw {\n  border-radius: 12px 12px 12px 0px;\n}\n\n.qa_bubble__3draw {\n  background: #fff;\n  padding: 12px 18px;\n  border: 0.5px solid rgba(0, 0, 0, 0.02);\n  box-shadow: 0 2px 1px rgba(0, 0, 0, 0.08);\n  max-width: 70%;\n  display: inline-block;\n  text-align: left;\n  font-size: 14px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n.qa_timestamp__2Uxf9 {\n  margin: 0 0;\n}\n.qa_timestamp__2Uxf9 .qa_avatar__3Fa6f {\n  border-radius: 50%;\n  background: linear-gradient(to top right, #e9e7e8, #898b8f);\n  display: inline-block;\n  width: 25px;\n  height: 20px;\n  vertical-align: top;\n  color: #fff;\n  font-size: 10px;\n  text-align: center;\n  padding-top: 5px;\n}\n.qa_timestamp__2Uxf9 .qa_time__rkbNQ {\n  font-size: 12px;\n  color: #999;\n  margin: 0 5px;\n}\n.qa_messagingArea__1A_7e {\n  position: relative;\n  box-shadow: 0 -2px 1px rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid lightgrey;\n  border-left: 1px solid lightgrey;\n  border-right: 1px solid lightgrey;\n  overflow: hidden;\n}\n.qa_messagingArea__1A_7e input {\n  font-size: 14px;\n  border: none;\n  padding: 20px 30px;\n  width: 100%;\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 0px;\n  line-height: normal;\n}\n.qa_messagingArea__1A_7e input:focus {\n  outline: 0;\n}\n\n.qa_send__2slkB {\n  background: linear-gradient(to top right, #e9e7e8, #898b8f);\n  color: #fff;\n  border-radius: 50%;\n  width: 25px;\n  height: 25px;\n  padding: 8px 10px 12px;\n  position: absolute;\n  font-size: 0.7em;\n  text-align: center;\n  right: 8px;\n  bottom: 8px;\n}\n\n.qa_button__3npq_ {\n\t/* box-shadow:inset 0px -3px 7px 0px #898b8f; */\n\tcolor: gray;\n\tbackground-color:white;\n\tborder-radius:3px;\n\tborder: 1px solid lightgray;\n\tdisplay:inline-block;\n\tcursor:pointer;\n\tfont-size:15px;\n\tpadding:9px 23px;\n\ttext-decoration:none;\n  /* text-shadow:0px 1px 0px #263666; */\n  margin-top: 25px;\n}\n.qa_button__3npq_:hover {\n  background-color:#898b8f;\n  color: white;\n}\n.qa_button__3npq_:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.qa_spinnerContainer__8mswA {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 500px;\n  border: 1px solid lightgrey;\n}\n\n.qa_spinner__1BpN6 {\n  animation: qa_rotator__CJPiN 1.4s linear infinite;\n}\n\n@keyframes qa_rotator__CJPiN {\n  0% {\n    transform: rotate(0deg);\n }\n  100% {\n    transform: rotate(270deg);\n }\n}\n.qa_path__wBQsT {\n  stroke-dasharray: 187;\n  stroke-dashoffset: 0;\n  transform-origin: center;\n  animation: qa_dash__2XkQe 1.4s ease-in-out infinite, qa_colors__1rq4O 5.6s ease-in-out infinite;\n}\n@keyframes qa_colors__1rq4O {\n  0% {\n    stroke: #4285f4;\n }\n  25% {\n    stroke: #de3e35;\n }\n  50% {\n    stroke: #f7c223;\n }\n  75% {\n    stroke: #1b9a59;\n }\n  100% {\n    stroke: #4285f4;\n }\n}\n@keyframes qa_dash__2XkQe {\n  0% {\n    stroke-dashoffset: 187;\n }\n  50% {\n    stroke-dashoffset: 46.75;\n    transform: rotate(135deg);\n }\n  100% {\n    stroke-dashoffset: 187;\n    transform: rotate(450deg);\n }\n}\n\n.qa_closeMobile__167YA {\n  display: none;\n}\n\n@media only screen and (max-width: 768px) {\n  /* For mobile phones: */\n  .qa_content__gm3Lm {\n    bottom: 0 !important;\n    width: 100vw !important;\n    height: 100%;\n    right: 0;\n    bottom: 0;\n    position: unset;\n    margin: 0;\n    min-width: 0;\n  }\n\n  .qa_conversationTitle__1nVrU {\n    border-top-left-radius: 0px;\n    border-top-right-radius: 0px;\n  }\n\n  .qa_conversationWrapper__1CqFS {\n    height: 100vh;\n    padding: 20px;\n  }\n\n  .qa_messagingArea__1A_7e {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: lightgrey;\n    height: 2em;\n  }\n\n\n\n  .qa_messagingAreaHide__rRd-Q {\n    display: none;\n  }\n\n  .qa_closeMobile__167YA {\n    height: 30px;\n    width: 30px;\n    display: block;\n    position: fixed;\n    right: 20px;\n    top: 0.6rem;\n    color: white;\n    background-image:url('data:image/png;base64,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');\n    background-size: contain;\n  }\n}\n\n/* IPHONE X */\n@media only screen\nand (min-device-width : 375px)\nand (max-device-width : 812px)\nand (-webkit-device-pixel-ratio : 3)\nand (orientation : portrait) {\n\n  .qa_messagingArea__1A_7e > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .qa_messagingArea__1A_7e {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n\n}\n\n@media only screen\nand (min-device-width : 375px)\nand (max-device-width : 667px)\nand (orientation : portrait) {\n  /* iPhone 6, 7, & 8 in portrait */\n  .qa_messagingArea__1A_7e > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .qa_messagingArea__1A_7e {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n}\n\n@media only screen\nand (min-device-width : 320px)\nand (max-device-width : 568px) {\n  /* Iphone 5 */\n  /* iPhone 6, 7, & 8 in portrait */\n  .qa_messagingArea__1A_7e > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .qa_messagingArea__1A_7e {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n}\n\n.qa_chatboxContainer__3wxPw {\n  font-size: 2em;\n  position: fixed;\n  right: 0px;\n  z-index: 100000;\n}\n\n@media only screen and (max-width: 600px) {\n  .qa_chatboxContainer__3wxPw {\n    top: 0px;\n    width: 100%;\n  }\n}\n\n.qa_actionButton__YGDfl {\n  background-color: #0074D9!important;\n  color: white!important;\n  border: 1px solid #0074D9!important;\n  display: inline-block;\n  text-align: center;\n  padding: 15px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: 'Montserrat-light';\n  font-size: 1.8rem;\n}\n\n.qa_actionButton__YGDfl:hover {\n  text-decoration: underline;\n}\n\n/* Collapsable */\n.qa_wrapper__3k-Vh {\n  overflow: hidden;\n  transition: height 200ms;\n}\n\n.qa_closed__2Dg06 {\n  display: none;\n}\n\n.qa_buttonOpenColl__1jGzp {\n  background-color: #0074D9;\n  border-radius: 6px;\n  border: 1px solid lightgray;\n  display: flex;\n  cursor: pointer;\n  padding: 10px 10px;\n  text-decoration: none;\n  margin-right: 10px;\n  margin-bottom: 0.2em;\n  width: 90px;\n  font-size: 14px;\n}\n\n.qa_buttonCloseColl__3PJJd {\n  background-color: #0074D9;\n  border-radius: 6px;\n  border: 1px solid lightgray;\n  display: flex;\n  cursor: pointer;\n  padding: 5px 5px 10px 5px;\n  text-decoration: none;\n  margin-right: 10px;\n  margin-bottom: 0.2em;\n  width: 6em;\n  font-size: 14px;\n  flex: initial;\n  height: 10px;\n}\n\n.qa_arrowOpen__3uOCX {\n  height: 20px;\n  width: 20px;\n  color: white;\n  background-image: url('data:image/png;base64,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');\n  background-size: contain;\n  display: flex;\n  margin-right: 10px;\n  transform: rotate(180deg);\n}\n\n.qa_arrowClose__Px7l4 {\n\n  height: 20px;\n  width: 20px;\n  color: white;\n  background-image: url('data:image/png;base64,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');\n  background-size: contain;\n  display: flex;\n  margin-right: 10px;\n\n}\n\n.qa_textMoreInfo__1E878 {\n  display: flex;\n  font-size: 1em;\n  color: #FFF;\n}\n\n.qa_mainColor__1RopQ {\n  color: #0074D9 !important;\n}\n\n.qa_card__3p7TU {\n  /* Add shadows to create the \"card\" effect */\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  border-radius: 5px; /* 5px rounded corners */\n  margin: 20px 0px 20px 0px;\n  background-color: #f6f6f6;\n  cursor: pointer;\n}\n\n.qa_smallCard__4MgrC {\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  border-radius: 5px; /* 5px rounded corners */\n  margin: 20px 0px 20px 0px;\n  background-color: #f6f6f6;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  cursor: pointer;\n}\n\n/* On mouse-over, add a deeper shadow */\n.qa_smallCard__4MgrC:hover {\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n\n.qa_smallImageCard__28QUe {\n  width: 45%;\n  border-radius: 5px 0 0 5px;\n}\n\n/* On mouse-over, add a deeper shadow */\n.qa_card__3p7TU:hover {\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n\n.qa_imageCard__33ZAM {\n  width: 100%;\n  border-radius: 5px 5px 0 0;\n}\n\n/* Add some padding inside the card container */\n.qa_container__1NFbc {\n  padding: 16px;\n}\n\n.qa_container__1NFbc p {\n  font-size: small;\n}\n\n.qa_displayName__24rJ_ {\n  font-size: 0.5em;\n}\n/*===================================\n  Buttons\n===================================*/\n.qa_buttonsContainer__2ujHN {\n\tpadding-bottom: 15px;\n}\n\n.qa_rtButton__Ga_4E {\n\tbackground-color: lightgray;\n\tborder-radius: 6px;\n\tborder: 1px solid lightgray;\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tpadding: 10px 10px;\n\ttext-decoration: none;\n\tmargin-right: 10px;\n\tmargin-bottom: 0.2em;\n  font-size: 14px;\n  min-width: 50px;\n}\n.qa_rtButton__Ga_4E:hover {\n\tborder:1px solid #4eaa38;\n\tcolor: #4eaa38;\n}\n.qa_rtButton__Ga_4E:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.qa_rtButtonEmoji__1uCXv {\n\tbackground-color: lightgray;\n\tborder-radius: 6px;\n\tborder: 1px solid lightgray;\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tpadding: 10px 10px;\n\ttext-decoration: none;\n\tmargin-right: 10px;\n\tmargin-bottom: 0.2em;\n\tfont-size: 1.7em;\n}\n.qa_rtButtonEmoji__1uCXv:hover {\n\tborder:1px solid #4eaa38;\n\tcolor: #4eaa38;\n}\n.qa_rtButtonEmoji__1uCXv:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.qa_rtButtonCard__nVpp7 {\n\tbox-shadow:inset 0px 1px 0px 0px #999999;\n\tbackground:linear-gradient(to bottom, #999999 5%, #f6f6f6 100%);\n\tbackground-color:#999999;\n\tborder-radius:6px;\n\tborder:1px solid #dcdcdc;\n\tdisplay:inline-block;\n\tcursor:pointer;\n\tcolor:#666666;\n\tfont-family:Arial;\n\tfont-size:15px;\n\tfont-weight:bold;\n\tpadding:10px 25px;\n\ttext-decoration:none;\n  text-shadow:0px 1px 0px #999999;\n  margin-right: 10px;\n}\n.qa_rtButtonCard__nVpp7:hover {\n\tbackground:linear-gradient(to bottom, #f6f6f6 5%, #999999 100%);\n\tbackground-color:#f6f6f6;\n}\n.qa_rtButtonCard__nVpp7:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n@media only screen and (max-width: 768px) {\n\n\t.qa_rtButton__Ga_4E {\n\t\tmin-width: 90%;\n\t}\n}\n\n";
var qa = {"content":"qa_content__gm3Lm","conversationTitle":"qa_conversationTitle__1nVrU","status":"qa_status__2WcHX","conversationWrapper":"qa_conversationWrapper__1CqFS","settingsContainer":"qa_settingsContainer__hIOJm","messageSent":"qa_messageSent__Myv2I","messageReceived":"qa_messageReceived__2WPAd","bubble":"qa_bubble__3draw","timestamp":"qa_timestamp__2Uxf9","avatar":"qa_avatar__3Fa6f","time":"qa_time__rkbNQ","messagingArea":"qa_messagingArea__1A_7e","send":"qa_send__2slkB","button":"qa_button__3npq_","spinnerContainer":"qa_spinnerContainer__8mswA","spinner":"qa_spinner__1BpN6","rotator":"qa_rotator__CJPiN","path":"qa_path__wBQsT","dash":"qa_dash__2XkQe","colors":"qa_colors__1rq4O","closeMobile":"qa_closeMobile__167YA","messagingAreaHide":"qa_messagingAreaHide__rRd-Q","chatboxContainer":"qa_chatboxContainer__3wxPw","actionButton":"qa_actionButton__YGDfl","wrapper":"qa_wrapper__3k-Vh","closed":"qa_closed__2Dg06","buttonOpenColl":"qa_buttonOpenColl__1jGzp","buttonCloseColl":"qa_buttonCloseColl__3PJJd","arrowOpen":"qa_arrowOpen__3uOCX","arrowClose":"qa_arrowClose__Px7l4","textMoreInfo":"qa_textMoreInfo__1E878","mainColor":"qa_mainColor__1RopQ","card":"qa_card__3p7TU","smallCard":"qa_smallCard__4MgrC","smallImageCard":"qa_smallImageCard__28QUe","imageCard":"qa_imageCard__33ZAM","container":"qa_container__1NFbc","displayName":"qa_displayName__24rJ_","buttonsContainer":"qa_buttonsContainer__2ujHN","rtButton":"qa_rtButton__Ga_4E","rtButtonEmoji":"qa_rtButtonEmoji__1uCXv","rtButtonCard":"qa_rtButtonCard__nVpp7"};
styleInject(css$8);

var css$9 = "\n.pro_content__3U-Yj {\n  background: #fff;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);\n  margin: 3.2em auto;\n  border-radius: 8px 8px 0 0;\n  position: fixed;\n  width: 30vw;\n  right: 30px;\n  bottom: 45px;\n  font-family: 'Montserrat Light', arial;\n  z-index: 999;\n  min-width: 400px;\n}\n\n\n.pro_conversationTitle__D71ua {\n  text-align: center;\n  padding: 8px;\n  background: #FF4136;\n  /*background-image: url('data:image/png;base64,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');*/\n  background-repeat: no-repeat;\n  background-position: center;\n  color: #FFF;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  height: 1em;\n}\n\n.pro_conversationTitle__D71ua h1 {\n  font: 700 18px 'Noto Sans', sans-serif;\n  margin: 0;\n}\n\n.pro_conversationTitle__D71ua .pro_status__3Z2ht {\n  font-size: 12px;\n  width: 50px;\n}\n\n.pro_status__3Z2ht:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.pro_conversationWrapper__2LHAp {\n  background: #E6E6E6;\n  padding: 25px;\n  height: 60vh;\n  overflow-y: auto;\n  border: 1px solid lightgrey;\n  --scrollbarBG: lightgrey;\n  --thumbBG: #E6E6E6;\n  scrollbar-width: thin;\n  scrollbar-color: var(--thumbBG) var(--scrollbarBG);\n}\n\n.pro_conversationWrapper__2LHAp::-webkit-scrollbar {\n  width: 11px;\n}\n\n.pro_conversationWrapper__2LHAp::-webkit-scrollbar-track {\n  background: var(--scrollbarBG);\n}\n\n.pro_conversationWrapper__2LHAp::-webkit-scrollbar-thumb {\n  background-color: var(--thumbBG);\n  border-radius: 6px;\n  border: 3px solid var(--scrollbarBG);\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n/* .conversationWrapper::-webkit-scrollbar {\n  display: none;\n} */\n\n/* Hide scrollbar for IE and Edge */\n/* .conversationWrapper {\n  -ms-overflow-style: none;\n}  */\n\n.pro_settingsContainer__1AW-m {\n  background: white;\n  border: 1px solid lightgrey;\n  padding: 25px;\n  height: 500px;\n  overflow-y: auto;\n  font-size: medium;\n}\n\n.pro_settingsContainer__1AW-m select {\n  width: 100%;\n  height: 25px;\n  border: 1px solid lightgrey;\n  margin: 15px 0 15px 0;\n}\n\n.pro_settingsContainer__1AW-m input {\n  width: 100%;\n  height: 25px;\n  border: 1px solid lightgrey;\n  margin: 5px 0 5px 0;\n  padding-left: 10px;\n}\n\n.pro_messageSent__1zVdy,\n.pro_messageReceived__1FlOw {\n  padding: 0;\n}\n\n.pro_messageReceived__1FlOw {\n  text-align: left;\n  margin-bottom: 10px;\n}\n\n.pro_messageSent__1zVdy {\n  text-align: right;\n}\n\n.pro_messageSent__1zVdy>.pro_bubble__3vL7M {\n  border-radius: 12px 12px 0px 12px;\n}\n\n.pro_messageReceived__1FlOw>.pro_bubble__3vL7M {\n  border-radius: 12px 12px 12px 0px;\n}\n\n.pro_bubble__3vL7M {\n  background: #fff;\n  padding: 12px 18px;\n  border: 0.5px solid rgba(0, 0, 0, 0.02);\n  box-shadow: 0 2px 1px rgba(0, 0, 0, 0.08);\n  max-width: 70%;\n  display: inline-block;\n  text-align: left;\n  font-size: 14px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n.pro_timestamp__27_wB {\n  margin: 0 0;\n}\n\n.pro_timestamp__27_wB .pro_avatar__SAyvm {\n  border-radius: 50%;\n  background: linear-gradient(to top right, #e9e7e8, #898b8f);\n  display: inline-block;\n  width: 25px;\n  height: 20px;\n  vertical-align: top;\n  color: #fff;\n  font-size: 10px;\n  text-align: center;\n  padding-top: 5px;\n}\n\n.pro_timestamp__27_wB .pro_time__xKrbs {\n  font-size: 12px;\n  color: #999;\n  margin: 0 5px;\n}\n\n.pro_messagingArea__1agCN {\n  position: relative;\n  box-shadow: 0 -2px 1px rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid lightgrey;\n  border-left: 1px solid lightgrey;\n  border-right: 1px solid lightgrey;\n  overflow: hidden;\n}\n\n.pro_messagingArea__1agCN input {\n  font-size: 14px;\n  border: none;\n  padding: 20px 30px;\n  width: 100%;\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 0px;\n  line-height: normal;\n}\n\n.pro_messagingArea__1agCN input:focus {\n  outline: 0;\n}\n\n.pro_send__gNVFc {\n  background: linear-gradient(to top right, #e9e7e8, #898b8f);\n  color: #fff;\n  border-radius: 50%;\n  width: 25px;\n  height: 25px;\n  padding: 8px 10px 12px;\n  position: absolute;\n  font-size: 0.7em;\n  text-align: center;\n  right: 8px;\n  bottom: 8px;\n}\n\n.pro_button__-YnLf {\n  /* box-shadow:inset 0px -3px 7px 0px #898b8f; */\n  color: gray;\n  background-color: white;\n  border-radius: 3px;\n  border: 1px solid lightgray;\n  display: inline-block;\n  cursor: pointer;\n  font-size: 15px;\n  padding: 9px 23px;\n  text-decoration: none;\n  /* text-shadow:0px 1px 0px #263666; */\n  margin-top: 25px;\n}\n\n.pro_button__-YnLf:hover {\n  background-color: #898b8f;\n  color: white;\n}\n\n.pro_button__-YnLf:active {\n  position: relative;\n  top: 1px;\n}\n\n.pro_spinnerContainer__1l8ER {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 500px;\n  border: 1px solid lightgrey;\n}\n\n.pro_spinner__2jrC_ {\n  animation: pro_rotator__gQCVW 1.4s linear infinite;\n}\n\n@keyframes pro_rotator__gQCVW {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(270deg);\n  }\n}\n\n.pro_path__2IY-0 {\n  stroke-dasharray: 187;\n  stroke-dashoffset: 0;\n  transform-origin: center;\n  animation: pro_dash__OOTL- 1.4s ease-in-out infinite, pro_colors__1U9_n 5.6s ease-in-out infinite;\n}\n\n@keyframes pro_colors__1U9_n {\n  0% {\n    stroke: #4285f4;\n  }\n\n  25% {\n    stroke: #de3e35;\n  }\n\n  50% {\n    stroke: #f7c223;\n  }\n\n  75% {\n    stroke: #1b9a59;\n  }\n\n  100% {\n    stroke: #4285f4;\n  }\n}\n\n@keyframes pro_dash__OOTL- {\n  0% {\n    stroke-dashoffset: 187;\n  }\n\n  50% {\n    stroke-dashoffset: 46.75;\n    transform: rotate(135deg);\n  }\n\n  100% {\n    stroke-dashoffset: 187;\n    transform: rotate(450deg);\n  }\n}\n\n.pro_closeMobile__1Q2dg {\n  display: none;\n}\n\n@media only screen and (max-width: 768px) {\n\n  /* For mobile phones: */\n  .pro_content__3U-Yj {\n    bottom: 0 !important;\n    width: 100vw !important;\n    height: 100%;\n    right: 0;\n    bottom: 0;\n    position: unset;\n    margin: 0;\n    min-width: 0;\n  }\n\n  .pro_conversationTitle__D71ua {\n    border-top-left-radius: 0px;\n    border-top-right-radius: 0px;\n  }\n\n  .pro_conversationWrapper__2LHAp {\n    height: 100vh;\n    padding: 20px;\n  }\n\n  .pro_messagingArea__1agCN {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: lightgrey;\n    height: 2em;\n  }\n\n\n\n  .pro_messagingAreaHide__1HRBx {\n    display: none;\n  }\n\n  .pro_closeMobile__1Q2dg {\n    height: 30px;\n    width: 30px;\n    display: block;\n    position: fixed;\n    right: 20px;\n    top: 0.6rem;\n    color: white;\n    background-image: url('data:image/png;base64,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');\n    background-size: contain;\n  }\n}\n\n/* IPHONE X */\n@media only screen and (min-device-width : 375px) and (max-device-width : 812px) and (-webkit-device-pixel-ratio : 3) and (orientation : portrait) {\n\n  .pro_messagingArea__1agCN>input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .pro_messagingArea__1agCN {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n\n}\n\n@media only screen and (min-device-width : 375px) and (max-device-width : 667px) and (orientation : portrait) {\n\n  /* iPhone 6, 7, & 8 in portrait */\n  .pro_messagingArea__1agCN>input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .pro_messagingArea__1agCN {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n}\n\n@media only screen and (min-device-width : 320px) and (max-device-width : 568px) {\n\n  /* Iphone 5 */\n  /* iPhone 6, 7, & 8 in portrait */\n  .pro_messagingArea__1agCN>input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .pro_messagingArea__1agCN {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n}\n\n/* add css styles here (optional) */\n.pro_chatboxContainer__10Qm2 {\n  font-size: 2em;\n  position: fixed;\n  right: 0px;\n  z-index: 100000;\n}\n\n@media only screen and (max-width: 600px) {\n  .pro_chatboxContainer__10Qm2 {\n    top: 0px;\n    width: 100%;\n  }\n}\n\n.pro_actionButton__kjVr5 {\n  background-color: #FF4136 !important;\n  color: white !important;\n  border: 1px solid #FF4136 !important;\n  display: inline-block;\n  text-align: center;\n  padding: 15px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: 'Montserrat-light';\n  font-size: 1.8rem;\n}\n\n.pro_actionButton__kjVr5:hover {\n  text-decoration: underline;\n}\n\n/* Collapsable */\n.pro_wrapper__1hNM6 {\n  overflow: hidden;\n  transition: height 200ms;\n}\n\n.pro_closed__1OQ5s {\n  display: none;\n}\n\n.pro_buttonOpenColl__1G1Kl {\n  background-color: #FF4136;\n  border-radius: 6px;\n  border: 1px solid lightgray;\n  display: flex;\n  cursor: pointer;\n  padding: 10px 10px;\n  text-decoration: none;\n  margin-right: 10px;\n  margin-bottom: 0.2em;\n  width: 90px;\n  font-size: 14px;\n}\n\n.pro_buttonCloseColl__3y-EO {\n  background-color: #FF4136;\n  border-radius: 6px;\n  border: 1px solid lightgray;\n  display: flex;\n  cursor: pointer;\n  padding: 5px 5px 10px 5px;\n  text-decoration: none;\n  margin-right: 10px;\n  margin-bottom: 0.2em;\n  width: 6em;\n  font-size: 14px;\n  flex: initial;\n  height: 10px;\n}\n\n.pro_arrowOpen__Pbq-g {\n  height: 20px;\n  width: 20px;\n  color: white;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAQAAAAAYLlVAAAF6npUWHRSYXcgcHJvZmlsZSB0eXBlIGV4aWYAAHja7VhZsqM4EPyvU/QRtC/H0RoxN5jjd5YkvNtg3vtsE0ZYEqUiMysBU/v/v05/8NEhOjLWBxedE/iYaKJKOAhifuLYS2HGfnzMGsLvu366DCh0abR6/vRpzU/ot9cTtjVkvu+nsEZUWIHWwBZQ88oKB/U2SfSr2S9XJhTbPHAx+NtUs5pt2VIO12/zwo9gdg7xb7rtMB4oVYuFtFJNSy3G3swM9PwmfM3Ye56H8YTfhtBIrVYmAOTu8rZWiFuA7kDejugR/cvRA/gqrX79gKVbGOHg5YC0r8EfEN8srC8ZqfsBtO3pcta39xp6b/PqknFA1C1FCdrQ4XMwMQNyPU5z2Dy+Fsd+bBFbEEkUUF5FERlbkVEqsNJJGlllkl220RZZkKJRTYETpVQBLdwXwFFUBVxJ5kgb2ZXXUVcdwFxRjbRGt7rkIse6caxXZMDKVWKqkggGdt9v9Gnwm416LwyRFOGCFfJSrCykwczxHrNAiOyLDjsA3rZFv7jRD6QKBu2AOeACk8gzRLbyqi09eNaYZ9HOEpLk6woAiLC2RTJSgwHhpLbSSeGV8lICxwCCEjJX2qgMBqS1qiJJZbR2irwKitfGOV6Oucoqp7gb3gQirHbag5uoE8gyxkI/3gRoKFltjbXWWW8D2WiT084465zzjk0uee2Nt95574OPPgUdTLDBBR9CiCFFFTU80EYXfQwxxpQUJSyUECthfkJPVllnk2122eeQY04F8imm2OKKL6HEkqqqusImqqu+hhprapIanKKZZptrvoUWW+rQWtfddNtd9z302NOFtcXq0/YFa3KxpgZTPM9fWEMveb+FkGwnljkDY8pIMO6ZAQhaMWciSGMUM8eciahQFFYhScvcUJXMGCg0TSrb5YW7K3OHeCMbDvGm9pgjpu43mCNQ98zbC9Yq3+fKYGxWIWMqNKoP4y0kUiHxTS39tP0X6AeBemYuwEkYvwwOYu6ioFva0sGWs7wvpvaejaZWe3MoqJx9tFk7NyfVrCNGalW5IKIQaSzyvqW9CUdazpcCMpwJo6A6xN1nsrq3Ipv1M9ecu2995opirLH16oLQnO1EgW6Rye0JCgZiRIaVGL1wADK3SAwcaAHRcudMdeNkc8WBcr3wnTNYr3uNvneJlFsVPfuOxRBOtdqsKzUif6rZleY9Rk1ChZ3WAH2eMHKT0a/cQkXxxpUbLioLXODMjSqKvtc+Uq0ZPqGdz93yo9slAh5OLjFgpysKUJtx+AodrSi3MeAa7Y5jPUgA7iPGJGHQm3RfFFhifkufDPAq3cmrFpkClvblCid/E/+VnwqDAWIKOL2uFwH8WHbFH5FXfm/0sZUKbbWyXyrvFcI50iaSBeJVJrciOaAROiGaO01sjNInSl8wKt7pih6F9U5XT5oQqceFE8NMW2oLJybzklmebM7IQCpc414jrNOJi3Gdvc5FXm/Ovse536mUlhYehXqvU56xo1PqV5luIl0anZltKgViH3VKZ43sUaV01sgeNUrnjOzZp+idUX3rU/SFqj9qkq6S+kZRVz1eau1LRb+9P9ALkb600j0npaNWuuekdNRK95yUjlrpnpPSUSvdUyUdufkdccqvlf1OlfQorLNOSWd0/QrGD9X/rNJPTkpHrXTPSemole45KR210j0npaNWuqdJ2nukO+qUdELVLzVJ4unme84pz977n2D77jXrg5PSUSvdc1I6aqV7CqWjVrqnUTpqpR9UOoLRN68Jn5zytLIfVUmPD5VnnZJ+outbVdLPX/qnSumole45KR210j0npZ++XW/J0SbTVY4v/gJAqJd/AnA9Xv8EoKX4l6//E70RdZURozejjjICeiPqqjV5/W/hxfkPZ/Pl3Zx/OZmqO/gvyk5L7wb0FzdHZpSeKWVCM3vEV0+W9OyHzOEk4P1r3nNF0rnXvOeKpO8eXt639Dslazv9vGRHuEzM0EshHxTi0uFv+NGvGdu/QCcC4RYaodC/O31MYktOhjIAAAEkaUNDUElDQyBwcm9maWxlAAB4nJ2Qv0rDUBTGf6nFiuhUcRCFDG5ScDGTi38wdCjUtoLRKU1SLCYxJCnFN/BN9GE6CIJP4BMoOPvd6OBgFi8cvh+Hc77v3gsNOw6SorkPSVrm7uDIu/Su7NYbTVq02WPHD4qsNzwbUXs+X7GMvnSMV/3cn2c5jIpAulClQZaXYB2KnXmZGVaxcTsanIgfxHaYpKH4SbwbJqFhsztI4lnw42lusxalF0PTV23j0qVHH5sxM6bElHSkqTqnOBxIXXJ87ikIpDGRenPNlNyICjm5HItGIt2mJm+ryusrZSyPqbxMwh2JPE0e5n+/1z7Oq01rc5H5uV+1llSNyQTeH2Hdg/YzrF7XZK38flvNjFPN/PONXwwfUHdeCSRsAAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADukAAA7pAQ4zQhwAAAAHdElNRQfkBAcTLBVj2v8hAAAA+ElEQVRo3u2Y2w7DIAxDMf//z93DLuoYFOKYTNrip6qQ+LSFELWUVCqVSqX+XTiOxwVijZ++tb0Ra38CiEQ4O9XRQIx9AxCB0DrU2YS99qWgexNh9nerGIS+C64G99u/AHYjjLNjZdI++zeAXQjXWWGZrLf/AFAjzLOBCdLZdwFUCGtZ4An22w8BvAjr0VAk8URClYiNgjIZEwHt89iBpa+U+WTQLSpuxcjWNbtnoNnZ/JaVFBdP0TIV2L6Rr2a6K3wnpSmn+ZSbIVgPLckx6zm2qVZjhMB0DbJeh+2b6H6vRWDbNlHDyTeurqb7W793UqlUKpX6Ld0AolWAFIxyajgAAAAASUVORK5CYII=');\n  background-size: contain;\n  display: flex;\n  margin-right: 10px;\n  transform: rotate(180deg);\n}\n\n.pro_arrowClose__1brBE {\n\n  height: 20px;\n  width: 20px;\n  color: white;\n  background-image: url('data:image/png;base64,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');\n  background-size: contain;\n  display: flex;\n  margin-right: 10px;\n\n}\n\n.pro_textMoreInfo__3fjWv {\n  display: flex;\n  font-size: 1em;\n  color: #FFF;\n}\n\n.pro_mainColor__BjDND {\n  color: #FF4136 !important;\n}\n\n.pro_card__1D9Aq {\n  /* Add shadows to create the \"card\" effect */\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  border-radius: 5px; /* 5px rounded corners */\n  margin: 20px 0px 20px 0px;\n  background-color: #f6f6f6;\n  cursor: pointer;\n}\n\n.pro_smallCard__1nBDH {\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  border-radius: 5px; /* 5px rounded corners */\n  margin: 20px 0px 20px 0px;\n  background-color: #f6f6f6;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  cursor: pointer;\n}\n\n/* On mouse-over, add a deeper shadow */\n.pro_smallCard__1nBDH:hover {\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n\n.pro_smallImageCard__26056 {\n  width: 45%;\n  border-radius: 5px 0 0 5px;\n}\n\n/* On mouse-over, add a deeper shadow */\n.pro_card__1D9Aq:hover {\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n\n.pro_imageCard__2k8yD {\n  width: 100%;\n  border-radius: 5px 5px 0 0;\n}\n\n/* Add some padding inside the card container */\n.pro_container__X8hMe {\n  padding: 16px;\n}\n\n.pro_container__X8hMe p {\n  font-size: small;\n}\n\n.pro_displayName__3cOCk {\n  font-size: 0.5em;\n}\n/*===================================\n  Buttons\n===================================*/\n.pro_buttonsContainer__27yFa {\n\tpadding-bottom: 15px;\n}\n\n.pro_rtButton__1IY3- {\n\tbackground-color: lightgray;\n\tborder-radius: 6px;\n\tborder: 1px solid lightgray;\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tpadding: 10px 10px;\n\ttext-decoration: none;\n\tmargin-right: 10px;\n\tmargin-bottom: 0.2em;\n  font-size: 14px;\n  min-width: 50px;\n}\n.pro_rtButton__1IY3-:hover {\n\tborder:1px solid #4eaa38;\n\tcolor: #4eaa38;\n}\n.pro_rtButton__1IY3-:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.pro_rtButtonEmoji__1LIoN {\n\tbackground-color: lightgray;\n\tborder-radius: 6px;\n\tborder: 1px solid lightgray;\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tpadding: 10px 10px;\n\ttext-decoration: none;\n\tmargin-right: 10px;\n\tmargin-bottom: 0.2em;\n\tfont-size: 1.7em;\n}\n.pro_rtButtonEmoji__1LIoN:hover {\n\tborder:1px solid #4eaa38;\n\tcolor: #4eaa38;\n}\n.pro_rtButtonEmoji__1LIoN:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.pro_rtButtonCard__1yHEh {\n\tbox-shadow:inset 0px 1px 0px 0px #999999;\n\tbackground:linear-gradient(to bottom, #999999 5%, #f6f6f6 100%);\n\tbackground-color:#999999;\n\tborder-radius:6px;\n\tborder:1px solid #dcdcdc;\n\tdisplay:inline-block;\n\tcursor:pointer;\n\tcolor:#666666;\n\tfont-family:Arial;\n\tfont-size:15px;\n\tfont-weight:bold;\n\tpadding:10px 25px;\n\ttext-decoration:none;\n  text-shadow:0px 1px 0px #999999;\n  margin-right: 10px;\n}\n.pro_rtButtonCard__1yHEh:hover {\n\tbackground:linear-gradient(to bottom, #f6f6f6 5%, #999999 100%);\n\tbackground-color:#f6f6f6;\n}\n.pro_rtButtonCard__1yHEh:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n@media only screen and (max-width: 768px) {\n\n\t.pro_rtButton__1IY3- {\n\t\tmin-width: 90%;\n\t}\n}\n";
var pro = {"content":"pro_content__3U-Yj","conversationTitle":"pro_conversationTitle__D71ua","status":"pro_status__3Z2ht","conversationWrapper":"pro_conversationWrapper__2LHAp","settingsContainer":"pro_settingsContainer__1AW-m","messageSent":"pro_messageSent__1zVdy","messageReceived":"pro_messageReceived__1FlOw","bubble":"pro_bubble__3vL7M","timestamp":"pro_timestamp__27_wB","avatar":"pro_avatar__SAyvm","time":"pro_time__xKrbs","messagingArea":"pro_messagingArea__1agCN","send":"pro_send__gNVFc","button":"pro_button__-YnLf","spinnerContainer":"pro_spinnerContainer__1l8ER","spinner":"pro_spinner__2jrC_","rotator":"pro_rotator__gQCVW","path":"pro_path__2IY-0","dash":"pro_dash__OOTL-","colors":"pro_colors__1U9_n","closeMobile":"pro_closeMobile__1Q2dg","messagingAreaHide":"pro_messagingAreaHide__1HRBx","chatboxContainer":"pro_chatboxContainer__10Qm2","actionButton":"pro_actionButton__kjVr5","wrapper":"pro_wrapper__1hNM6","closed":"pro_closed__1OQ5s","buttonOpenColl":"pro_buttonOpenColl__1G1Kl","buttonCloseColl":"pro_buttonCloseColl__3y-EO","arrowOpen":"pro_arrowOpen__Pbq-g","arrowClose":"pro_arrowClose__1brBE","textMoreInfo":"pro_textMoreInfo__3fjWv","mainColor":"pro_mainColor__BjDND","card":"pro_card__1D9Aq","smallCard":"pro_smallCard__1nBDH","smallImageCard":"pro_smallImageCard__26056","imageCard":"pro_imageCard__2k8yD","container":"pro_container__X8hMe","displayName":"pro_displayName__3cOCk","buttonsContainer":"pro_buttonsContainer__27yFa","rtButton":"pro_rtButton__1IY3-","rtButtonEmoji":"pro_rtButtonEmoji__1LIoN","rtButtonCard":"pro_rtButtonCard__1yHEh"};
styleInject(css$9);

var css$a = "\n.motor_pacifico_content__21UUq {\n  background: #fff;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);\n  margin: 3.2em auto;\n  border-radius: 8px 8px 0 0;\n  position: fixed;\n  width: 30vw;\n  right: 30px;\n  bottom: 45px;\n  font-family: 'Montserrat Light', arial;\n  z-index: 999;\n  min-width: 400px;\n}\n\n\n.motor_pacifico_conversationTitle__3hA_W {\n  text-align: center;\n  padding: 8px;\n  background-repeat: no-repeat;\n  background-position: center;\n  color: #4eaa38;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  background-size: contain;\n  border: 1px solid lightgrey;\n}\n.motor_pacifico_conversationTitle__3hA_W h1 {\n  font: 700 18px 'Noto Sans', sans-serif;\n  margin: 0;\n}\n.motor_pacifico_conversationTitle__3hA_W .motor_pacifico_status__ELHIG {\n  font-size: 12px;\n  width: 50px;\n}\n\n.motor_pacifico_conversationTitle__3hA_W > img {\n  width: 3em;\n}\n\n.motor_pacifico_status__ELHIG:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.motor_pacifico_conversationWrapper__32fHO {\n  background:#E6E6E6;\n  padding: 25px;\n  height: 60vh;\n  overflow-y: auto;\n  border: 1px solid lightgrey;\n  --scrollbarBG: lightgrey;\n  --thumbBG: #E6E6E6;\n  scrollbar-width: thin;\n  scrollbar-color: var(--thumbBG) var(--scrollbarBG);\n  line-height: initial;\n}\n\n.motor_pacifico_conversationWrapper__32fHO::-webkit-scrollbar {\n  width: 11px;\n}\n\n.motor_pacifico_conversationWrapper__32fHO::-webkit-scrollbar-track {\n  background: var(--scrollbarBG);\n}\n\n.motor_pacifico_conversationWrapper__32fHO::-webkit-scrollbar-thumb {\n  background-color: var(--thumbBG) ;\n  border-radius: 6px;\n  border: 3px solid var(--scrollbarBG);\n}\n\n /* Hide scrollbar for Chrome, Safari and Opera */\n /* .conversationWrapper::-webkit-scrollbar {\n  display: none;\n} */\n\n/* Hide scrollbar for IE and Edge */\n/* .conversationWrapper {\n  -ms-overflow-style: none;\n}  */\n\n.motor_pacifico_settingsContainer__y3zWc {\n  background: white;\n  border: 1px solid lightgrey;\n  padding: 25px;\n  height: 500px;\n  overflow-y: auto;\n  font-size: medium;\n}\n\n.motor_pacifico_settingsContainer__y3zWc select {\n  width: 100%;\n  height: 25px;\n  border: 1px solid lightgrey;\n  margin: 15px 0 15px 0;\n}\n\n.motor_pacifico_settingsContainer__y3zWc input {\n  width: 100%;\n  height: 25px;\n  border: 1px solid lightgrey;\n  margin: 5px 0 5px 0;\n  padding-left: 10px;\n}\n\n.motor_pacifico_messageSent__nADKl, .motor_pacifico_messageReceived__3GHPM {\n  padding: 0;\n}\n.motor_pacifico_messageReceived__3GHPM {\n  text-align: left;\n  margin-bottom: 10px;\n}\n.motor_pacifico_messageSent__nADKl {\n  text-align: right;\n}\n\n.motor_pacifico_messageSent__nADKl > .motor_pacifico_bubble__IbvPK {\n  border-radius: 12px 12px 0px 12px;\n}\n\n.motor_pacifico_messageReceived__3GHPM > .motor_pacifico_bubble__IbvPK {\n  border-radius: 12px 12px 12px 0px;\n}\n\n.motor_pacifico_bubble__IbvPK {\n  background: #fff;\n  padding: 12px 18px;\n  border: 0.5px solid rgba(0, 0, 0, 0.02);\n  box-shadow: 0 2px 1px rgba(0, 0, 0, 0.08);\n  max-width: 70%;\n  display: inline-block;\n  text-align: left;\n  font-size: 14px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n.motor_pacifico_timestamp__2up-9 {\n  margin: 0 0;\n}\n.motor_pacifico_timestamp__2up-9 .motor_pacifico_avatar__nXM-r {\n  border-radius: 50%;\n  background: linear-gradient(to top right, #e9e7e8, #898b8f);\n  display: inline-block;\n  width: 25px;\n  height: 20px;\n  vertical-align: top;\n  color: #fff;\n  font-size: 10px;\n  text-align: center;\n  padding-top: 5px;\n}\n.motor_pacifico_timestamp__2up-9 .motor_pacifico_time__1Gpn9 {\n  font-size: 12px;\n  color: #999;\n  margin: 0 5px;\n}\n.motor_pacifico_messagingArea__2c2Kb {\n  position: relative;\n  box-shadow: 0 -2px 1px rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid lightgrey;\n  border-left: 1px solid lightgrey;\n  border-right: 1px solid lightgrey;\n  overflow: hidden;\n}\n.motor_pacifico_messagingArea__2c2Kb input {\n  font-size: 14px;\n  border: none;\n  padding: 20px 30px;\n  width: 100%;\n  border-bottom-left-radius: 0px;\n  border-bottom-right-radius: 0px;\n  line-height: normal;\n}\n.motor_pacifico_messagingArea__2c2Kb input:focus {\n  outline: 0;\n}\n\n.motor_pacifico_send__v0V62 {\n  background: linear-gradient(to top right, #e9e7e8, #898b8f);\n  color: #fff;\n  border-radius: 50%;\n  width: 25px;\n  height: 25px;\n  padding: 8px 10px 12px;\n  position: absolute;\n  font-size: 0.7em;\n  text-align: center;\n  right: 8px;\n  bottom: 8px;\n}\n\n.motor_pacifico_button__3kDmM {\n\t/* box-shadow:inset 0px -3px 7px 0px #898b8f; */\n\tcolor: gray;\n\tbackground-color:white;\n\tborder-radius:3px;\n\tborder: 1px solid lightgray;\n\tdisplay:inline-block;\n\tcursor:pointer;\n\tfont-size:15px;\n\tpadding:9px 23px;\n\ttext-decoration:none;\n  /* text-shadow:0px 1px 0px #263666; */\n  margin-top: 25px;\n}\n.motor_pacifico_button__3kDmM:hover {\n  background-color:#898b8f;\n  color: white;\n}\n.motor_pacifico_button__3kDmM:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.motor_pacifico_spinnerContainer__Gfo0c {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 500px;\n  border: 1px solid lightgrey;\n}\n\n.motor_pacifico_spinner__2M3NU {\n  animation: motor_pacifico_rotator__1VD2X 1.4s linear infinite;\n}\n\n@keyframes motor_pacifico_rotator__1VD2X {\n  0% {\n    transform: rotate(0deg);\n }\n  100% {\n    transform: rotate(270deg);\n }\n}\n.motor_pacifico_path__QM0qy {\n  stroke-dasharray: 187;\n  stroke-dashoffset: 0;\n  transform-origin: center;\n  animation: motor_pacifico_dash__1sCcD 1.4s ease-in-out infinite, motor_pacifico_colors__2D0T7 5.6s ease-in-out infinite;\n}\n@keyframes motor_pacifico_colors__2D0T7 {\n  0% {\n    stroke: #4285f4;\n }\n  25% {\n    stroke: #de3e35;\n }\n  50% {\n    stroke: #f7c223;\n }\n  75% {\n    stroke: #1b9a59;\n }\n  100% {\n    stroke: #4285f4;\n }\n}\n@keyframes motor_pacifico_dash__1sCcD {\n  0% {\n    stroke-dashoffset: 187;\n }\n  50% {\n    stroke-dashoffset: 46.75;\n    transform: rotate(135deg);\n }\n  100% {\n    stroke-dashoffset: 187;\n    transform: rotate(450deg);\n }\n}\n\n.motor_pacifico_closeMobile__35Mda {\n  display: none;\n}\n\n@media only screen and (max-width: 768px) {\n  /* For mobile phones: */\n  .motor_pacifico_content__21UUq {\n    bottom: 0 !important;\n    width: 100vw !important;\n    height: 100%;\n    right: 0;\n    bottom: 0;\n    position: unset;\n    margin: 0;\n    min-width: 0;\n  }\n\n  .motor_pacifico_conversationTitle__3hA_W {\n    border-top-left-radius: 0px;\n    border-top-right-radius: 0px;\n  }\n\n  .motor_pacifico_conversationWrapper__32fHO {\n    height: 100vh;\n    padding: 20px;\n  }\n\n  .motor_pacifico_messagingArea__2c2Kb {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: lightgrey;\n    height: 2em;\n  }\n\n\n\n  .motor_pacifico_messagingAreaHide__16qFY {\n    display: none;\n  }\n\n  .motor_pacifico_closeMobile__35Mda {\n    height: 30px;\n    width: 30px;\n    display: block;\n    position: fixed;\n    right: 20px;\n    top: 0.6rem;\n    color: white;\n    background-image:url('data:image/png;base64,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');\n    background-size: contain;\n  }\n}\n\n/* IPHONE X */\n@media only screen\nand (min-device-width : 375px)\nand (max-device-width : 812px)\nand (-webkit-device-pixel-ratio : 3)\nand (orientation : portrait) {\n\n  .motor_pacifico_messagingArea__2c2Kb > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .motor_pacifico_messagingArea__2c2Kb {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n\n}\n\n@media only screen\nand (min-device-width : 375px)\nand (max-device-width : 667px)\nand (orientation : portrait) {\n  /* iPhone 6, 7, & 8 in portrait */\n  .motor_pacifico_messagingArea__2c2Kb > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .motor_pacifico_messagingArea__2c2Kb {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n}\n\n@media only screen\nand (min-device-width : 320px)\nand (max-device-width : 568px) {\n  /* Iphone 5 */\n  /* iPhone 6, 7, & 8 in portrait */\n  .motor_pacifico_messagingArea__2c2Kb > input {\n    /* enlarge by 16/12 = 133.33% */\n    border-radius: 6.666666667px;\n    font-size: 20px;\n    line-height: 26.666666667px;\n    padding: 6.666666667px;\n    width: 133.333333333%;\n\n    /* scale down by 12/16 = 75% */\n    transform: scale(0.75);\n    transform-origin: left top;\n  }\n\n  .motor_pacifico_messagingArea__2c2Kb {\n    position: fixed;\n    bottom: 0px;\n    width: 100vw;\n    background-color: white;\n    height: 1em;\n    padding: 4px;\n  }\n}\n\n/* add css styles here (optional) */\n.motor_pacifico_chatboxContainer__2Z9YN {\n  font-size: 2em;\n  position: fixed;\n  right: 0px;\n  z-index: 100000;\n}\n\n@media only screen and (max-width: 600px) {\n  .motor_pacifico_chatboxContainer__2Z9YN {\n    top: 0px;\n    width: 100%;\n  }\n}\n\n.motor_pacifico_actionButton__MwCqf {\n  background-color: #4eaa38!important;\n  color: white!important;\n  border: 1px solid #4eaa38!important;\n  display: inline-block;\n  text-align: center;\n  padding: 15px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: 'Montserrat-light';\n  font-size: 1.8rem;\n}\n\n.motor_pacifico_actionButton__MwCqf:hover {\n  text-decoration: underline;\n}\n\n/* Collapsable */\n.motor_pacifico_wrapper__2NMR6 {\n  overflow: hidden;\n  transition: height 200ms;\n}\n\n.motor_pacifico_closed__8bZp6 {\n  display: none;\n}\n\n.motor_pacifico_buttonOpenColl__2ZYKa {\n  background-color: #4eaa38;\n  border-radius: 6px;\n  border: 1px solid lightgray;\n  display: flex;\n  cursor: pointer;\n  padding: 10px 10px;\n  text-decoration: none;\n  margin-right: 10px;\n  margin-bottom: 0.2em;\n  width: 8em;\n  font-size: 14px;\n}\n\n.motor_pacifico_buttonCloseColl__Pi8R7 {\n  background-color: #4eaa38;\n  border-radius: 6px;\n  border: 1px solid lightgray;\n  display: flex;\n  cursor: pointer;\n  padding: 5px;\n  text-decoration: none;\n  margin-right: 10px;\n  margin-bottom: 0.2em;\n  width: 8em;\n  font-size: 14px;\n  flex: initial;\n  color: white;\n\n}\n\n.motor_pacifico_arrowOpen__1j3a0 {\n  height: 20px;\n  width: 20px;\n  color: white;\n  background-image: url('data:image/png;base64,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');\n  background-size: contain;\n  display: flex;\n  margin-right: 10px;\n  transform: rotate(180deg);\n}\n\n.motor_pacifico_arrowClose__1g7Ko {\n\n  height: 20px;\n  width: 20px;\n  color: white;\n  background-image: url('data:image/png;base64,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');\n  background-size: contain;\n  display: flex;\n  margin-right: 10px;\n\n}\n\n.motor_pacifico_likeButton__3jhkl {\n  width: auto;\n  height: 1em;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 16px 0px, rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px !important;\n  font-size: 14px;\n  position: fixed;\n  bottom: 7em;\n  right: 8em;\n  border-radius: 20px 0px 20px 20px;\n  padding: 0.4em;\n  text-align: center;\n  background: white;\n  font-family: 'Montserrat Light', arial;\n  cursor: pointer;\n  color: #333333;\n}\n\n.motor_pacifico_mainColor__2l_pN {\n  color: #4eaa38 !important;\n}\n\n.motor_pacifico_card__zlbPN {\n  /* Add shadows to create the \"card\" effect */\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  border-radius: 5px; /* 5px rounded corners */\n  margin: 20px 0px 20px 0px;\n  background-color: #f6f6f6;\n  cursor: pointer;\n}\n\n.motor_pacifico_smallCard__3z7Zv {\n  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n  transition: 0.3s;\n  border-radius: 5px; /* 5px rounded corners */\n  margin: 20px 0px 20px 0px;\n  background-color: #f6f6f6;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  cursor: pointer;\n}\n\n/* On mouse-over, add a deeper shadow */\n.motor_pacifico_smallCard__3z7Zv:hover {\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n\n.motor_pacifico_smallImageCard__3BLaa {\n  width: 45%;\n  border-radius: 5px 0 0 5px;\n}\n\n/* On mouse-over, add a deeper shadow */\n.motor_pacifico_card__zlbPN:hover {\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n}\n\n.motor_pacifico_imageCard__1_9Ue {\n  width: 100%;\n  border-radius: 5px 5px 0 0;\n}\n\n/* Add some padding inside the card container */\n.motor_pacifico_container__IlYj6 {\n  padding: 16px;\n}\n\n.motor_pacifico_container__IlYj6 p {\n  font-size: small;\n}\n\n.motor_pacifico_displayName__1m-FR {\n  font-size: 0.5em;\n}\n/*===================================\n  Buttons\n===================================*/\n.motor_pacifico_buttonsContainer__b5Qnq {\n\tpadding-bottom: 15px;\n}\n\n.motor_pacifico_rtButton__3xlZ_ {\n\tbackground-color: lightgray;\n\tborder-radius: 6px;\n\tborder: 1px solid lightgray;\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tpadding: 10px 10px;\n\ttext-decoration: none;\n\tmargin-right: 10px;\n\tmargin-bottom: 0.2em;\n  font-size: 14px;\n  min-width: 50px;\n}\n.motor_pacifico_rtButton__3xlZ_:hover {\n\tborder:1px solid #4eaa38;\n\tcolor: #4eaa38;\n}\n.motor_pacifico_rtButton__3xlZ_:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.motor_pacifico_rtButtonEmoji__Xupl2 {\n\tbackground-color: lightgray;\n\tborder-radius: 6px;\n\tborder: 1px solid lightgray;\n\tdisplay: inline-block;\n\tcursor: pointer;\n\tpadding: 10px 10px;\n\ttext-decoration: none;\n\tmargin-right: 10px;\n\tmargin-bottom: 0.2em;\n\tfont-size: 1.7em;\n}\n.motor_pacifico_rtButtonEmoji__Xupl2:hover {\n\tborder:1px solid #4eaa38;\n\tcolor: #4eaa38;\n}\n.motor_pacifico_rtButtonEmoji__Xupl2:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n.motor_pacifico_rtButtonCard__3J15v {\n\tbox-shadow:inset 0px 1px 0px 0px #999999;\n\tbackground:linear-gradient(to bottom, #999999 5%, #f6f6f6 100%);\n\tbackground-color:#999999;\n\tborder-radius:6px;\n\tborder:1px solid #dcdcdc;\n\tdisplay:inline-block;\n\tcursor:pointer;\n\tcolor:#666666;\n\tfont-family:Arial;\n\tfont-size:15px;\n\tfont-weight:bold;\n\tpadding:10px 25px;\n\ttext-decoration:none;\n  text-shadow:0px 1px 0px #999999;\n  margin-right: 10px;\n}\n.motor_pacifico_rtButtonCard__3J15v:hover {\n\tbackground:linear-gradient(to bottom, #f6f6f6 5%, #999999 100%);\n\tbackground-color:#f6f6f6;\n}\n.motor_pacifico_rtButtonCard__3J15v:active {\n\tposition:relative;\n\ttop:1px;\n}\n\n@media only screen and (max-width: 768px) {\n\n\t.motor_pacifico_rtButton__3xlZ_ {\n\t\tmin-width: 90%;\n\t}\n}\n\n";
var motor_pacifico = {"content":"motor_pacifico_content__21UUq","conversationTitle":"motor_pacifico_conversationTitle__3hA_W","status":"motor_pacifico_status__ELHIG","conversationWrapper":"motor_pacifico_conversationWrapper__32fHO","settingsContainer":"motor_pacifico_settingsContainer__y3zWc","messageSent":"motor_pacifico_messageSent__nADKl","messageReceived":"motor_pacifico_messageReceived__3GHPM","bubble":"motor_pacifico_bubble__IbvPK","timestamp":"motor_pacifico_timestamp__2up-9","avatar":"motor_pacifico_avatar__nXM-r","time":"motor_pacifico_time__1Gpn9","messagingArea":"motor_pacifico_messagingArea__2c2Kb","send":"motor_pacifico_send__v0V62","button":"motor_pacifico_button__3kDmM","spinnerContainer":"motor_pacifico_spinnerContainer__Gfo0c","spinner":"motor_pacifico_spinner__2M3NU","rotator":"motor_pacifico_rotator__1VD2X","path":"motor_pacifico_path__QM0qy","dash":"motor_pacifico_dash__1sCcD","colors":"motor_pacifico_colors__2D0T7","closeMobile":"motor_pacifico_closeMobile__35Mda","messagingAreaHide":"motor_pacifico_messagingAreaHide__16qFY","chatboxContainer":"motor_pacifico_chatboxContainer__2Z9YN","actionButton":"motor_pacifico_actionButton__MwCqf","wrapper":"motor_pacifico_wrapper__2NMR6","closed":"motor_pacifico_closed__8bZp6","buttonOpenColl":"motor_pacifico_buttonOpenColl__2ZYKa","buttonCloseColl":"motor_pacifico_buttonCloseColl__Pi8R7","arrowOpen":"motor_pacifico_arrowOpen__1j3a0","arrowClose":"motor_pacifico_arrowClose__1g7Ko","likeButton":"motor_pacifico_likeButton__3jhkl","mainColor":"motor_pacifico_mainColor__2l_pN","card":"motor_pacifico_card__zlbPN","smallCard":"motor_pacifico_smallCard__3z7Zv","smallImageCard":"motor_pacifico_smallImageCard__3BLaa","imageCard":"motor_pacifico_imageCard__1_9Ue","container":"motor_pacifico_container__IlYj6","displayName":"motor_pacifico_displayName__1m-FR","buttonsContainer":"motor_pacifico_buttonsContainer__b5Qnq","rtButton":"motor_pacifico_rtButton__3xlZ_","rtButtonEmoji":"motor_pacifico_rtButtonEmoji__Xupl2","rtButtonCard":"motor_pacifico_rtButtonCard__3J15v"};
styleInject(css$a);

var loadTheme = function (name) {
    switch (name) {
        case 'cmadrid':
            return cmadrid;
        case 'dev':
            return dev;
        case 'qa':
            return qa;
        case 'pro':
            return pro;
        case 'motor_pacifico':
            return motor_pacifico;
        default:
            return dev;
    }
};

var TriggerSystem = /** @class */ (function () {
    function TriggerSystem(triggers, callback) {
        this.triggers = triggers;
        this.callback = callback;
        this.claimCounter = 0;
        // is first load fire event of load
        this.fireEvent('on_load');
    }
    TriggerSystem.prototype.fireEvent = function (event) {
        switch (event) {
            case 'on_load':
                return this._onLoadTrigger();
        }
    };
    TriggerSystem.prototype._getCurrentUrl = function () {
        return window.location.href;
    };
    TriggerSystem.prototype._onLoadTrigger = function () {
        var _this = this;
        this.triggers.forEach(function (trigger) {
            if (trigger.type === 'on_load' && trigger.url === document.location.pathname) {
                var behavior_1;
                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    behavior_1 = trigger.devices[0].behaviour; // temporal only support desktop
                }
                else {
                    behavior_1 = trigger.devices[0].behaviour; // temporal only support desktop
                }
                _this.callback(null, 'initial', { entryPoint: behavior_1.entryPoint.firstBotMessage });
                if (behavior_1.proactivity.visualClaim.active) {
                    var claimTimer_1 = setInterval(function () {
                        if (_this.claimCounter < behavior_1.proactivity.visualClaim.frequency) {
                            _this.claimCounter += 1;
                            // event to active animation
                            _this.callback(null, 'visual_claim', {
                                gesture: behavior_1.proactivity.visualClaim.gesture,
                                frequency: behavior_1.proactivity.visualClaim.frequency,
                                entryPoint: behavior_1.entryPoint.firstBotMessage,
                            });
                            // event to change to default state.
                            setTimeout(function () {
                                _this.callback(null, 'visual_claim_off', {
                                    gesture: behavior_1.proactivity.visualClaim.gesture,
                                    frequency: behavior_1.proactivity.visualClaim.frequency,
                                    entryPoint: behavior_1.entryPoint.firstBotMessage,
                                });
                            }, 2500);
                        }
                        else
                            clearInterval(claimTimer_1);
                    }, 15000);
                }
                if (behavior_1.proactivity.popUpClaim.active) {
                    setTimeout(function () {
                        _this.callback(null, 'popup_claim', {
                            message: behavior_1.proactivity.popUpClaim.message,
                            entryPoint: behavior_1.entryPoint.firstBotMessage,
                        });
                    }, behavior_1.proactivity.popUpClaim.timeout * 500);
                    setTimeout(function () {
                        _this.callback(null, 'popup_claim_off', {
                            message: behavior_1.proactivity.popUpClaim.message,
                            entryPoint: behavior_1.entryPoint.firstBotMessage,
                        });
                    }, (behavior_1.proactivity.popUpClaim.timeout + 30) * 500);
                    setTimeout(function () {
                        _this.callback(null, 'close_all', {
                            entryPoint: behavior_1.entryPoint,
                        });
                    }, (behavior_1.proactivity.popUpClaim.timeout + 33) * 500);
                }
            }
        });
    };
    return TriggerSystem;
}());

/**
 * @class ChatBoxRT
 */
var ChatBoxRT = /** @class */ (function (_super) {
    __extends(ChatBoxRT, _super);
    function ChatBoxRT(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            channel: props.config.channel || '',
            lang: document.documentElement.lang,
            testMode: props.config.testMode,
            // stage: props.config.stage,// via static config
            openedChat: false,
            showCircleBtn: false,
            apiKey: '',
            title: false,
            botList: [],
            sourceValue: props.config.sourceValue,
            botName: props.config.botName,
            theme: undefined,
            currentEvent: {},
            currentEventType: '',
            entryPoint: '',
            showSettingsBtn: props.config.testMode,
            popoverActive: false,
            popoverText: '',
            logo: false,
            activeSurvey: false,
            noneAbove: false,
            actionButton: false,
            trackingConfig: false,
            trackingBeacon: false,
            maximizeOnLoad: props.config.maximizeOnLoad,
        };
        return _this;
    }
    ChatBoxRT.prototype.componentDidMount = function () {
        if (this.state.testMode) {
            this.requestBotList();
        }
        else {
            this.requestBotConfig();
        }
    };
    ChatBoxRT.prototype.onTriggerEvent = function (error, event, eventPayload) {
        if (error)
            console.log(error);
        if (eventPayload.entryPoint && event === 'initial') {
            this.setState({ entryPoint: eventPayload.entryPoint });
        }
        this.setState(function (prevState) {
            var currentEvent = __assign({}, prevState.currentEvent, eventPayload);
            return { currentEvent: currentEvent, currentEventType: event };
        });
    };
    ChatBoxRT.prototype.switchChat = function () {
        this.setState(function (prevState) { return ({
            openedChat: !prevState.openedChat
        }); });
    };
    ChatBoxRT.prototype.setChatSettings = function (_a) {
        var apiKey = _a.apiKey, channel = _a.channel, sourceValue = _a.sourceValue, botName = _a.botName, lang = _a.lang;
        if (apiKey)
            this.setState({ apiKey: apiKey });
        if (channel)
            this.setState({ channel: channel });
        if (sourceValue)
            this.setState({ sourceValue: sourceValue });
        if (botName)
            this.setState({ botName: botName });
        if (lang)
            this.setState({ lang: lang });
    };
    ChatBoxRT.prototype.onRemoteConfig = function () {
        // Todo when we´ll want config from websockets
    };
    ChatBoxRT.prototype.applyLocalConfig = function () {
        this.setState({ theme: loadTheme(this.props.config.configStage) });
        this.setState({ openedChat: this.props.config.maximizeOnLoad });
        this.setState({ title: this.props.config.configStage });
        this.setState({ actionButton: false });
        this.setState({ showCircleBtn: true });
    };
    ChatBoxRT.prototype.requestBotConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var configStage, location_1, botConfig, _a, channelConfig, triggers, botName, triggerSystem_1, tracking, trakingServiceUrl, actionName, idSite, url, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        configStage = this.props.config.configStage;
                        location_1 = this.props.config.location || document.location.hostname;
                        return [4 /*yield*/, getConfig(configStage, location_1)];
                    case 1:
                        botConfig = _b.sent();
                        _a = botConfig.data, channelConfig = _a.channelConfig, triggers = _a.triggers, botName = _a.botName;
                        triggerSystem_1 = new TriggerSystem(triggers, this.onTriggerEvent.bind(this));
                        this.setState({ apiKey: location_1 });
                        this.setState({ theme: loadTheme(channelConfig.theme) });
                        this.setState({ title: channelConfig.title });
                        this.setState({ noneAbove: channelConfig.noneAbove });
                        this.setState({ actionButton: channelConfig.actionButton });
                        this.setState({ activeSurvey: channelConfig.activeSurvey });
                        this.setState({ popoverActive: channelConfig.popoverActive });
                        this.setState({ popoverText: channelConfig.popoverText });
                        this.setState({ logo: channelConfig.logo });
                        this.setState({ botName: botName });
                        this.setState({ trackingConfig: channelConfig.tracking || false });
                        if (channelConfig.tracking) {
                            tracking = channelConfig.tracking;
                            trakingServiceUrl = tracking.trakingServiceUrl, actionName = tracking.actionName, idSite = tracking.idSite;
                            url = trakingServiceUrl + "?action_name=" + actionName + "&idsite=" + idSite + "&rec=1&url=" + location_1;
                            this.setState({ trackingBeacon: url });
                        }
                        this.setState({ openedChat: this.state.maximizeOnLoad });
                        this.setState({ showCircleBtn: !this.state.maximizeOnLoad });
                        setTimeout(function () { return triggerSystem_1.fireEvent('on_load'); }, 1500);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        console.error(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ChatBoxRT.prototype.requestBotList = function () {
        var _this = this;
        var configStage = this.props.config.configStage;
        getBotList(configStage).then(function (response) {
            var botList = response.data.filter(function (bot) {
                return bot.name.split('-')[0] !== 'shopify' && bot.name.split('-')[0] !== 'woice';
            });
            _this.setState({ botList: botList });
            _this.applyLocalConfig();
        })
            .catch(function (error) {
            console.log(error);
        });
    };
    ChatBoxRT.prototype.render = function () {
        var _this = this;
        var _a = this.state, apiKey = _a.apiKey, channel = _a.channel, botList = _a.botList, sourceValue = _a.sourceValue, botName = _a.botName, openedChat = _a.openedChat, currentEvent = _a.currentEvent, currentEventType = _a.currentEventType, lang = _a.lang, entryPoint = _a.entryPoint, showSettingsBtn = _a.showSettingsBtn, theme = _a.theme, popoverActive = _a.popoverActive, popoverText = _a.popoverText, testMode = _a.testMode, title = _a.title, actionButton = _a.actionButton, noneAbove = _a.noneAbove, activeSurvey = _a.activeSurvey, logo = _a.logo, trackingBeacon = _a.trackingBeacon, showCircleBtn = _a.showCircleBtn;
        var wsStage = this.props.config.wsStage;
        if (theme && openedChat) {
            console.log('entraaaaaa');
            return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                (trackingBeacon) ? (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("img", { src: trackingBeacon })) : (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null)),
                (actionButton) ? (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("button", { className: theme.actionButton, onClick: function () { return _this.switchChat(); } }, "Preguntar al Chatbot")) : (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null)),
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: theme.chatboxContainer },
                    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ChatBox, { apiKey: apiKey, channel: channel, setChatSettings: this.setChatSettings.bind(this), botList: botList, sourceValue: sourceValue, botName: botName, theme: theme, entryPoint: entryPoint, title: title, showSettingsBtn: showSettingsBtn, lang: lang, testMode: testMode, switchChat: this.switchChat.bind(this), stage: wsStage, noneAbove: noneAbove, activeSurvey: activeSurvey, onRemoteConfig: this.onRemoteConfig, logo: logo }),
                    (showCircleBtn) ? (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(CircleBtn, { switchChat: function () { return _this.switchChat(); }, openedChat: openedChat, theme: theme, currentEvent: currentEvent, currentEventType: currentEventType, lang: lang, popoverActive: popoverActive, popoverText: popoverText })) : (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null)))));
        }
        else {
            if (!theme)
                return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null));
            return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
                (actionButton) ? (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("button", { className: theme.actionButton, onClick: function () { return _this.switchChat(); } }, "Preguntar al Chatbot")) : (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null)),
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: theme.chatboxContainer },
                    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(CircleBtn, { switchChat: function () { return _this.switchChat(); }, openedChat: openedChat, theme: theme, currentEvent: currentEvent, currentEventType: currentEventType, lang: lang, popoverActive: popoverActive, popoverText: popoverText }))));
        }
    };
    return ChatBoxRT;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

/* harmony default export */ __webpack_exports__["a"] = (ChatBoxRT);
//# sourceMappingURL=index.es.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1), __webpack_require__(29).setImmediate, __webpack_require__(4)))

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(30);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(32);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(33),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(35)();
}


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(36);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// This file should be ES5 compatible
/* eslint prefer-spread:0, no-var:0, prefer-reflect:0, no-magic-numbers:0 */


module.exports = (function () {
	// Import Events
	var events = __webpack_require__(38)

	// Export Domain
	var domain = {}
	domain.createDomain = domain.create = function () {
		var d = new events.EventEmitter()

		function emitError (e) {
			d.emit('error', e)
		}

		d.add = function (emitter) {
			emitter.on('error', emitError)
		}
		d.remove = function (emitter) {
			emitter.removeListener('error', emitError)
		}
		d.bind = function (fn) {
			return function () {
				var args = Array.prototype.slice.call(arguments)
				try {
					fn.apply(null, args)
				}
				catch (err) {
					emitError(err)
				}
			}
		}
		d.intercept = function (fn) {
			return function (err) {
				if ( err ) {
					emitError(err)
				}
				else {
					var args = Array.prototype.slice.call(arguments, 1)
					try {
						fn.apply(null, args)
					}
					catch (err) {
						emitError(err)
					}
				}
			}
		}
		d.run = function (fn) {
			try {
				fn()
			}
			catch (err) {
				emitError(err)
			}
			return this
		}
		d.dispose = function () {
			this.removeAllListeners()
			return this
		}
		d.enter = d.exit = function () {
			return this
		}
		return d
	}
	return domain
}).call(this)


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = $getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  var args = [];
  for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    ReflectApply(this.listener, this.target, args);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(40);

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var bind = __webpack_require__(6);
var Axios = __webpack_require__(41);
var mergeConfig = __webpack_require__(12);
var defaults = __webpack_require__(9);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(13);
axios.CancelToken = __webpack_require__(54);
axios.isCancel = __webpack_require__(8);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(55);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var buildURL = __webpack_require__(7);
var InterceptorManager = __webpack_require__(42);
var dispatchRequest = __webpack_require__(43);
var mergeConfig = __webpack_require__(12);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var transformData = __webpack_require__(44);
var isCancel = __webpack_require__(8);
var defaults = __webpack_require__(9);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(11);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(49);
var combineURLs = __webpack_require__(50);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(13);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, function(o) { return o.user; });
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 *
 * _.sortBy(users, 'user', function(o) {
 *   return Math.floor(o.age / 10);
 * });
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = sortBy;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(57)(module)))

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var config={wsStage:'pro',configStage:'pro',lang:'es',channel:'webchat',testMode:true,maximizeOnLoad:false};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.7670323d.js